/**
 * Created by Benjamin Qin on 5/23/2017.
 */
(function() {
    'use strict';

    angular
        .module('app.core', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria',
            'ngResource', 'ngStorage', 'ngCacheBuster', 'ngFileUpload', 'ui.router', 'ui.bootstrap',
            'ui.bootstrap.datetimepicker', 'infinite-scroll', 'angular-loading-bar', 'tmh.dynamicLocale',
            'pascalprecht.translate', 'oc.lazyLoad','angularFileUpload','textAngular']);
})();

/**
 * Created by troy.zhao on 2017/6/20.
 */
(function () {
    "use strict";
    angular.module("app.core")
        .factory("SweetAlert",["$rootScope",function($rootScope){
            var swal=window.swal,self={
                swal:function(arg1,arg2,arg3){
                    $rootScope.$evalAsync(function(){
                        "function"==typeof arg2?swal(arg1,function(isConfirm){
                            $rootScope.$evalAsync(function(){arg2(isConfirm)})},arg3):swal(arg1,arg2,arg3)
                    })
                },
                success:function(title,message){
                        $rootScope.$evalAsync(function(){swal(title,message,"success")
                        })
                    },
                error:function(title,message){
                        $rootScope.$evalAsync(function(){
                            swal(title,message,"error")
                        })
                    },
                warning:function(title,message){
                            $rootScope.$evalAsync(function(){
                                swal(title,message,"warning")
                            })
                    },
                info:function(title,message){
                        $rootScope.$evalAsync(function(){
                            swal(title,message,"info")
                        })
                    }
            };
            return self
        }]
        );
})();



/**
 * Created by troy.zhao on 2017/7/10.
 */
(function () {
    'use strict';
    angular.module('myApp',
        [
            "ngSanitize",
            "com.2fdevs.videogular",
            "com.2fdevs.videogular.plugins.controls",
            "com.2fdevs.videogular.plugins.overlayplay",
            "com.2fdevs.videogular.plugins.poster"
        ]
    )
        .controller('HomeCtrl',
            ["$sce", function ($sce) {
                this.config = {
                    sources: [
                        {src: $sce.trustAsResourceUrl("http://static.videogular.com/assets/videos/videogular.mp4"), type: "video/mp4"},
                        {src: $sce.trustAsResourceUrl("http://static.videogular.com/assets/videos/videogular.webm"), type: "video/webm"},
                        {src: $sce.trustAsResourceUrl("http://static.videogular.com/assets/videos/videogular.ogg"), type: "video/ogg"}
                    ],
                    tracks: [
                        {
                            src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
                            kind: "subtitles",
                            srclang: "en",
                            label: "English",
                            default: ""
                        }
                    ],
                    theme: "bower_components/videogular-themes-default/videogular.css",
                    plugins: {
                        poster: "http://www.videogular.com/assets/images/videogular.png"
                    }
                };
            }]
        );
})();
(function() {
    'use strict';
    angular
        .module('ui.swiper',[]) //对应项目的module 请换成自己的模块名称
        .directive('swipers',swipers);
    swipers.$inject = ['$timeout'];
    function swipers($timeout) {
        return {
            restrict: "EA",
            scope: {
                data:"="
            },
            template: '<div ng-transclude></div> ',
            transclude : true,
            link: function(scope, element, attrs) {
                attrs.$observe('id',function (id) {
                    if(id>0){
                        $timeout(function(){
                            var swiper = new Swiper('.swiper-container', { //轮播图绑定样式名
                                autoplay: 4000,//可选选项，自动滑动
                                speed : 1000,
                                slidesPerView : 4,
                                loop : false,
                                spaceBetween : 20,
                                breakpoints: {
                                    //当宽度小于等于768
                                    768: {
                                        slidesPerView: 1,
                                        spaceBetween: 10
                                    },
                                    //当宽度小于等于1024
                                    1024: {
                                        slidesPerView: 2,
                                        spaceBetween: 20
                                    }
                                }
                            });
                            var swiper2 = new Swiper('.swiper-container2', { //轮播图绑定样式名
                                autoplay: 4000,//可选选项，自动滑动
                                speed : 1000,
                                slidesPerView : 2,
                                loop : false,
                                spaceBetween : 20,
                                breakpoints: {
                                    //当宽度小于等于768
                                    768: {
                                        slidesPerView: 1,
                                        spaceBetween: 10
                                    },
                                    //当宽度小于等于1024
                                    1024: {
                                        slidesPerView: 2,
                                        spaceBetween: 20
                                    }
                                }
                            });
                        },1000);
                        $timeout(function(){
                            var newswiper = new Swiper('.swiperContainer', { //轮播图绑定样式名
                                autoplay: 4000,//可选选项，自动滑动
                                speed : 1000,
                                pagination: '.swiper-pagination',
                                nextButton: '.swiper-button-next',
                                prevButton: '.swiper-button-prev'
                            });
                        },1000);
                    }
                });

            }
        };
    }
})();

/**
 * Created by troy.zhao on 2017/6/11.
 */
(function() {
    'use strict';
    angular
        .module('ui.dotdotdot',[]) //对应项目的module 请换成自己的模块名称
        .directive('truncate', truncate)
        .directive('filter', filter);
    function truncate($timeout){
        return {
            restrict: 'C',
            scope: {
                truncateOptions: '='
            },
            link: function(scope, element) {
                $timeout(function(){
                    element.dotdotdot(scope.truncateOptions);

                });
            }
        };
    }
    function filter($timeout) {
        return {
            restrict : 'C',
            link : function (scope, element) {
                $timeout(function(){
                    angular.element("dd").click(function () {
                        angular.element(this).addClass("selected").siblings().removeClass("selected");
                    });
                });
            }
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('app.admin', ['app.core','ui.changeAdminSkin','ui.select', 'ngSanitize']);
})();

/**
 * Created by lance.lu on 2018/7/4.
 */


(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.wxCusServiceMsg.wxCusServiceMsg', {
                url: '/wxCusServiceMsg?page&sort&search',
                parent: 'admin.wxCusServiceMsg',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg.html',
                        controller: 'WxCusServiceMsgController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.wxCusServiceMsg.wxCusServiceMsg.edit', {
                url: '/wxCusServiceMsg/{id}/edit?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.wxCusServiceMsg',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg-dialog.html',
                        controller: 'WxCusServiceMsgDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'WxCusServiceMsg', function ($stateParams, WxCusServiceMsg) {
                        return WxCusServiceMsg.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.wxCusServiceMsg.wxCusServiceMsg.new', {
                url: '/wxCusServiceMsg/new?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.wxCusServiceMsg',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg-dialog.html',
                        controller: 'WxCusServiceMsgDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }], entity: function () {
                        return {
                            id: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            //.state('admin.wxCusServiceMsg.wxCusServiceMsg.edit', {
            //    url: '/{id}/edit',
            //    parent: 'admin.wxCusServiceMsg.wxCusServiceMsg',
            //    data: {
            //        authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
            //    },
            //    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
            //        $uibModal.open({
            //            templateUrl: 'app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg-dialog.html',
            //            controller: 'wxCusServiceMsgDialogController',
            //            controllerAs: 'vm',
            //            backdrop: 'static',
            //            size: 'lg',
            //            resolve: {
            //                entity: ['wxCusServiceMsg', function (wxCusServiceMsg) {
            //                    return wxCusServiceMsg.get({id: $stateParams.id}).$promise;
            //                }]
            //            }
            //        }).result.then(function () {
            //            $state.go('admin.wxCusServiceMsg.wxCusServiceMsg', null, {reload: 'admin.wxCusServiceMsg.wxCusServiceMsg'});
            //        }, function () {
            //            $state.go('^');
            //        });
            //    }]
            //})

            .state('admin.wxCusServiceMsg.wxCusServiceMsg.detail', {
                url: '/wxCusServiceMsg/detail/{id}',
                parent: 'admin.wxCusServiceMsg',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg-detail.html',
                        controller: 'WxCusServiceMsgDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'WxCusServiceMsg', function ($stateParams, WxCusServiceMsg) {
                        return WxCusServiceMsg.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'wxCusServiceMsg',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })

            .state('admin.wxCusServiceMsg.wxCusServiceMsg.delete', {
                url: '/{id}/delete',
                parent: 'admin.wxCusServiceMsg.wxCusServiceMsg',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg-delete.html',
                        controller: 'WxCusServiceMsgDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['WxCusServiceMsg', function (WxCusServiceMsg) {
                                return WxCusServiceMsg.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.wxCusServiceMsg.wxCusServiceMsg', null, {reload: 'admin.wxCusServiceMsg.wxCusServiceMsg'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }
})
();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('WxCusServiceMsg', WxCusServiceMsg);

    WxCusServiceMsg.$inject = ['$resource', 'DateUtils'];

    function WxCusServiceMsg($resource, DateUtils) {
        var resourceUrl = 'api/wx-cus-service-msgs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('WxCusServiceMsgController', WxCusServiceMsgController);

    WxCusServiceMsgController.$inject = ['$state', '$resource', 'WxCusServiceMsg', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal', '$document', '$stateParams', 'SweetAlert'];

    function WxCusServiceMsgController($state, $resource, WxCusServiceMsg, ParseLinks, AlertService, paginationConstants, pagingParams, Principal, $document, $stateParams, SweetAlert) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.year = [];
        vm.condition = {};

        Principal.identity().then(function (account) {
            vm.account = account;
            loadAll();
        });

        function loadAll() {
            WxCusServiceMsg.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function sort() {
            if (vm.predicate == 'id') {
                vm.predicate = 'id';
            }
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.wxCusServiceMsg = data;
            //for (var i = 0; i < vm.wxCusServiceMsg.length; i++) {
            //    if (vm.wxCusServiceMsg[i].status == "INFORCE") {
            //        vm.wxCusServiceMsg[i].status = "已生效"
            //    }
            //    if (vm.wxCusServiceMsg[i].status == "PENDEFFECTIVE") {
            //        vm.wxCusServiceMsg[i].status = "待生效"
            //    }
            //    if (vm.wxCusServiceMsg[i].status == "DELETED") {
            //        vm.wxCusServiceMsg[i].status = "已删除"
            //    }
            //}
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        vm.search = function () {
            loadAll()
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        //
        //vm.delete = function (id) {
        //    wxCusServiceMsgDelete.update({id: id}, {}, onSaveSuccess, onSaveError);
        //    function onSaveSuccess(result) {
        //        SweetAlert.swal({
        //            title: "操作成功",
        //            text: "",
        //            type: "success",
        //            allowOutsideClick: true
        //        });
        //        $state.reload()
        //    }
        //
        //    function onSaveError(error) {
        //        SweetAlert.swal({
        //            title: "操作失败",
        //            text: error.data.title,
        //            type: "error",
        //            allowOutsideClick: true
        //        })
        //    }
        //}

        vm.newDate = new Date();
        vm.newyear = vm.newDate.getFullYear();
        //console.log(vm.newyear)
        for (var i = 0; vm.newyear - i >= 2018; i++) {
            vm.year.push(vm.newyear - i);
        }


        vm.search = function () {
            if (vm.condition.month == 0) {
                vm.fromTime = vm.condition.year + '-01-01';
                vm.toTime = vm.condition.year + '-12-31';
            } else if (vm.condition.month == 12) {
                vm.fromTime = vm.condition.year + '-' + vm.condition.month + '-01';
                vm.toTime = (parseInt(vm.condition.year) + 1) + '-01-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else if (vm.condition.month == 10 || vm.condition.month == 11) {
                vm.fromTime = vm.condition.year + '-' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else if (vm.condition.month == 9) {
                vm.fromTime = vm.condition.year + '-0' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else {
                vm.fromTime = vm.condition.year + '-0' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-0' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            }
            //vm.fromTime = new Date(vm.fromTime);
            //vm.toTime = new Date(vm.toTime);
            console.log(vm.fromTime + '-' + vm.toTime);
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('WxCusServiceMsgDialogController', WxCusServiceMsgDialogController);

    WxCusServiceMsgDialogController.$inject = ['$timeout', '$scope', 'Principal', '$stateParams', 'entity', 'WxCusServiceMsg', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', 'SweetAlert', '$location', '$state', '$document'];

    function WxCusServiceMsgDialogController($timeout, $scope, Principal, $stateParams, entity, WxCusServiceMsg, FileUploader, $localStorage, $sessionStorage, $resource, SweetAlert, $location, $state, $document) {
        var vm = this;
        vm.save = save;
        vm.wxCusServiceMsg = entity;
        if(!vm.wxCusServiceMsg.id){
            vm.wxCusServiceMsg.msgType = "text"
        }
        vm.datePickerOpenStatus = {};
        vm.condition = {};
        vm.openCalendar = openCalendar;
        Principal.identity().then(function (account) {
            vm.account = account;
        });

        //
        //$timeout(function () {
        //    angular.element('.form-group:eq(0)>input').focus();
        //});

        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        if ($location.host() == "localhost") {
            vm.url = "https://ydd.baodanservice.com:8080"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }

        vm.uploaderImg = new FileUploader({
            url: vm.url + "/api/wx/media-upload/",
            headers: {
                "Authorization": 'Bearer ' + token
            }
        });

        vm.uploaderImg.onProgressAll = function (progress) {
            vm.uploadProgress = progress;
        };

        vm.uploaderImg.onSuccessItem = function (item, response, status, headers) {
            vm.wxCusServiceMsg.fileUrl = response.fileUrl;
            vm.wxCusServiceMsg.mediaId = response.mediaId;
        };

        vm.uploadImg = function () {
            vm.uploaderImg.uploadAll();
        };

        vm.clearImg = function () {
            vm.wxCusServiceMsg.fileUrl = "";
        };

        vm.showImgDialog = function () {
            angular.element("#browse-img").click();
        };

        vm.thumbImg = new FileUploader({
            url: vm.url + "/api/upload/",
            headers: {
                "Authorization": 'Bearer ' + token
            }
        });

        vm.thumbImg.onProgressAll = function (progress) {
            vm.uploadProgress = progress;
        };

        vm.thumbImg.onSuccessItem = function (item, response, status, headers) {
            //vm.wxCusServiceMsg.topicCover = response.fileUrl;
            vm.wxCusServiceMsg.thumbUrl = vm.url+ response.fileUrl;
        };

        vm.uploadImg1 = function () {
            vm.thumbImg.uploadAll();
        };

        vm.clearImg1 = function () {
            vm.wxCusServiceMsg.thumbUrl = "";
        };

        vm.showImgDialog1 = function () {
            angular.element("#thumb-img").click();
        };

        vm.miniprogrampageImg = new FileUploader({
            url: vm.url + "/api/wx/media-upload/",
            headers: {
                "Authorization": 'Bearer ' + token
            }
        });

        vm.miniprogrampageImg.onProgressAll = function (progress) {
            vm.uploadProgress = progress;
        };

        vm.miniprogrampageImg.onSuccessItem = function (item, response, status, headers) {
            vm.wxCusServiceMsg.fileUrl = response.fileUrl;
            vm.wxCusServiceMsg.thumbMediaId = response.mediaId;
        };

        vm.uploadImg2 = function () {
            vm.miniprogrampageImg.uploadAll();
        };

        vm.clearImg2 = function () {
            vm.wxCusServiceMsg.fileUrl = "";
        };

        vm.showImgDialog2 = function () {
            angular.element("#miniprogrampage-img").click();
        };

        function save() {
            if (!vm.wxCusServiceMsg.id) {
                WxCusServiceMsg.save(vm.wxCusServiceMsg, onSaveSuccess, onSaveError);
            } else {
                WxCusServiceMsg.update(vm.wxCusServiceMsg, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            //$uibModalInstance.close(result);
            if (vm.wxCusServiceMsg.id == null) {
                SweetAlert.swal({
                    title: "新增成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
                $state.go('admin.wxCusServiceMsg.wxCusServiceMsg')
            } else {
                SweetAlert.swal({
                    title: "编辑成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
            }
            $state.go('admin.wxCusServiceMsg.wxCusServiceMsg')
        }

        function onSaveError(error) {
            SweetAlert.swal({
                title: "编辑失败",
                text: error.data.title,
                type: "error",
                allowOutsideClick: true
            })
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('WxCusServiceMsgDetailController', WxCusServiceMsgDetailController);

    WxCusServiceMsgDetailController.$inject = ['$scope', '$rootScope', '$stateParams','entity','previousState'];

    function WxCusServiceMsgDetailController($scope, $rootScope, $stateParams ,entity,previousState) {
        var vm = this;
        vm.wxCusServiceMsg = entity;

        var unsubscribe = $rootScope.$on('hseApp:courseUpdate', function(event, result) {
            vm.wxCusServiceMsg = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('WxCusServiceMsgDeleteController',WxCusServiceMsgDeleteController);

    WxCusServiceMsgDeleteController.$inject = ['$uibModalInstance', 'entity', 'WxCusServiceMsg','SweetAlert'];

    function WxCusServiceMsgDeleteController($uibModalInstance, entity, WxCusServiceMsg,SweetAlert) {
        var vm = this;

        vm.wxCusServiceMsg = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            WxCusServiceMsg.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    SweetAlert.swal({
                        title:"删除成功",
                        text:"",
                        type:"success",
                        allowOutsideClick: true
                    });
                });
        }
    }
})();

/**
 * Created by troy.zhao on 2017/9/14.
 */
(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.sys-admin.user-management', {
                parent: 'admin.sys-admin',
                url: '/user-management?page&sort&loginName&fullName&orgName&orgId&authorityName',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
                },
                templateUrl: 'app/admin/sys-admin/user-management/user-management.html',
                controller: 'UserManagementController',
                controllerAs: 'vm',
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        $translatePartialLoader.addPart('gender');
                        $translatePartialLoader.addPart('userType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.sys-admin.user-management.new', {
                url: '/new',
                parent: 'admin.sys-admin.user-management',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/sys-admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null, login: null, firstName: null, lastName: null, fullName: null, email: null,
                                    userType: 'EMPLOYEE', gender: 'MALE', nationality: '汉', orgId: null, deptId: null,
                                    activated: true, langKey: null, createdBy: null, createdDate: null,
                                    lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                    resetKey: null, authorities: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('admin.sys-admin.user-management', null, {reload: true});
                    }, function () {
                        $state.go('admin.sys-admin.user-management');
                    });
                }]
            })
            .state('admin.sys-admin.user-management.import', {
                parent: 'admin.sys-admin.user-management',
                url: '/import/{id}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/sys-admin/user-management/user-management-import.html',
                        controller: 'UserManagementImportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.sys-admin.user-management', null, {reload: 'admin.sys-admin.user-management'});
                    }, function () {
                        $state.go('admin.sys-admin.user-management');
                    });
                }]
            })
            .state('admin.sys-admin.user-management.edit', {
                url: '/{login}/edit',
                parent: 'admin.sys-admin.user-management',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/sys-admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({login: $stateParams.login}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.sys-admin.user-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('admin.sys-admin.user-management-detail', {
                parent: 'admin.sys-admin',
                url: '/user-management/{id}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/sys-admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'User', function ($stateParams, User) {
                        return User.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'user-management',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('admin.sys-admin.user-management-bonusPoint', {
                parent: 'admin.sys-admin',
                url: '/user-management/bonusPoint/{id}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/sys-admin/user-management/user-management-bonusPoint.html',
                        controller: 'UserManagementBonusPointController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        $translatePartialLoader.addPart('userType');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.sys-admin.user-management.delete', {
                url: '/{login}/delete',
                parent: 'admin.sys-admin.user-management',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/sys-admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({login: $stateParams.login}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.sys-admin.user-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['$resource', 'Principal', 'User', 'ParseLinks', 'AlertService', '$state', '$stateParams', 'pagingParams', 'paginationConstants', 'JhiLanguageService', "$uibModal", "$timeout", "SweetAlert", "PlaceAdminUser", "Organization"];

    function UserManagementController($resource, Principal, User, ParseLinks, AlertService, $state, $stateParams, pagingParams, paginationConstants, JhiLanguageService, $uibModal, $timeout, SweetAlert, PlaceAdminUser, Organization) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_USER', 'ROLE_TEACHER', 'ROLE_CONSULTANT'];
        vm.authArray = {};
        vm.authArray.ROLE_ADMIN = '总部管理员';
        vm.authArray.ROLE_PLACE_ADMIN = '教学点管理员';
        vm.authArray.ROLE_TEACHER = '教学老师';
        vm.authArray.ROLE_CONSULTANT = '咨询老师';
        vm.authArray.ROLE_USER = '普通用户';
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.condition = {};
        vm.condition.loginName = $stateParams.loginName;
        vm.condition.fullName = $stateParams.fullName;
        vm.condition.orgName = $stateParams.orgName;
        vm.condition.orgId = $stateParams.orgId;
        vm.condition.authorities = $stateParams.authorities;
        vm.role = $state.current.data.role;
        console.log(vm.role);
        var UserSearch = $resource("api/users", {}, {
            'query': {method: 'GET', isArray: true}
        });
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
            vm.accountAuthorities = account.authorities;
            vm.account = account;
            if (vm.accountAuthorities.indexOf("ROLE_ADMIN") > -1) {
                vm.ROLE_ADMIN = true
            } else if (vm.accountAuthorities.indexOf("ROLE_PLACE_ADMIN") > -1) {
                vm.ROLE_PLACE_ADMIN = true
            }
            vm.loadAll();
        });

        vm.organization = Organization.query();

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll() {
                    User.query({
                        page: pagingParams.page - 1,
                        size: vm.itemsPerPage,
                        sort: sort(),
                        name: vm.condition.name
                    }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                name: vm.condition.name
            });
        }

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        vm.changePassword = function (user) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/password/password.html',
                controller: 'UserManagementPasswordController',
                controllerAs: 'vm',
                resolve: {
                    user: ['User', function (User) {
                        return user;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('password');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        };

        vm.search = function () {
            loadAll();

        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$state', '$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService', '$document', 'TeacherSearchService','OrganizationStations','Organization','Principal'];

    function UserManagementDialogController($state, $stateParams, $uibModalInstance, entity, User, JhiLanguageService, $document, TeacherSearchService,OrganizationStations,Organization,Principal) {
        var vm = this;
        var searchParams = {};
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.place = {};
        if (entity.id === null && entity.orgId === null) {
            var company = localStorage.CreateUserLastCompanyID;
            if (!isNaN(company)) {
                entity.orgId = parseInt(company);
            }
        }
        Principal.identity().then(function (account) {
            vm.accountAuthorities = account.authorities;
            vm.account =account;

            if (vm.accountAuthorities.indexOf("ROLE_ADMIN") > -1) {
                vm.ROLE_ADMIN = true
            } else if (vm.accountAuthorities.indexOf("ROLE_PLACE_ADMIN") > -1) {
                vm.ROLE_PLACE_ADMIN = true
            }
            if(vm.ROLE_ADMIN){
                vm.authorities = [{'key': 'ROLE_ADMIN', 'value': '总部管理员'},
                    {'key': 'ROLE_PLACE_ADMIN', 'value': '教学点管理员'},
                    {'key': 'ROLE_TEACHER', 'value': '教学老师'},
                    {'key': 'ROLE_CONSULTANT', 'value': '咨询老师'},
                    {'key': 'ROLE_USER', 'value': '普通用户'}];
            }else{
                vm.authorities = [
                    {'key': 'ROLE_TEACHER', 'value': '教学老师'},
                    {'key': 'ROLE_CONSULTANT', 'value': '咨询老师'}];
            }
        });



        vm.organizationUsers = OrganizationStations.query();
       vm.Organization = Organization.query();

        vm.user = entity;
        if (entity.id != null) {
            for (var i = 0; i < vm.user.authorities.length; i++) {
                if (vm.user.authorities[i] == "ROLE_PLACE_ADMIN") {
                    vm.org = true;
                }
                if (vm.user.authorities[i] == "ROLE_TEACHER") {
                    vm.teacher = true;
                }
                if (vm.user.authorities[i] == "ROLE_CONSULTANT") {
                    vm.consultant = true;
                }
                vm.place.value = [];
                vm.place.value[0] = {};
                vm.place.value[0].id = vm.user.teacherId;
                vm.place.value[0].fullName = vm.user.teacherFullName;
            }
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.getAuthorities = function () {
            //alert("1")

            vm.org = false;
            vm.teacher = false;
            vm.consultant = false;
            for (var i = 0; i < vm.user.authorities.length; i++) {
                if (vm.user.authorities[i] == "ROLE_PLACE_ADMIN") {
                    vm.org = true;
                }
                if (vm.user.authorities[i] == "ROLE_TEACHER") {
                    vm.teacher = true;
                }
                if (vm.user.authorities[i] == "ROLE_CONSULTANT") {
                    vm.consultant = true;
                }
            }
        }

        vm.selectTeacher = function () {
            var module = $state.current.data.module;
            var parent;
            if (module === 'front') {
                parent = angular.element($document[0].getElementById('front-content'));
            } else {
                parent = angular.element($document[0].getElementById('page-wrapper'));
            }
            // var parent = angular.element($document[0].getElementById( 'editForm'));
            TeacherSearchService.open(parent, searchParams, function (result) {
                vm.place.value = [];
                vm.place.value.push(result);
                vm.user.teacherId = vm.place.value[0].id;
            });
        };

        function save() {
            vm.isSaving = true;
            if(!vm.ROLE_ADMIN){
                vm.user.orgId = vm.account.orgId;
            }
            vm.user.gender = vm.user.gender === '' ? null : vm.user.gender;
            if (vm.langKey === null) {
                vm.langKey = "zh-cn";
            }

            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
                if (vm.user.orgId !== null) {
                    localStorage.CreateUserLastCompanyID = vm.user.orgId;
                    localStorage.CreateUserLastDepartmentID = vm.user.deptId;
                }
            }
            JSON.parse(vm.user)
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$scope', '$stateParams', 'previousState', 'BonusPoint','entity', '$rootScope'];

    function UserManagementDetailController($scope, $stateParams, previousState, BonusPoint, entity, $rootScope) {
        var vm = this;
        vm.previousState = previousState.name;
        vm.user = entity;
        var unsubscribe = $rootScope.$on('hseApp:userUpdate', function(event, result) {
            vm.user = result;
        });
        $scope.$on('$destroy', unsubscribe);
        // vm.load($stateParams.login);
        //
        // function load(login) {
        BonusPoint.query({id: vm.user.id}, function(result) {
                 vm.bonusPoint = result[0].bonusPoint;
             });
        // }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserManagementBonusPointController', UserManagementBonusPointController);

    UserManagementBonusPointController.$inject = ['$scope', '$stateParams', 'bonusPointLog','BonusPoint','User', '$rootScope', 'pagingParams', 'paginationConstants', 'ParseLinks','Principal','$state'];

    function UserManagementBonusPointController($scope, $stateParams, bonusPointLog,BonusPoint,User, $rootScope, pagingParams, paginationConstants, ParseLinks,Principal,$state) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.loadAll = loadAll;
        Principal.identity().then(function (account) {
            vm.account = account;
            vm.loadAll();
        });
        var unsubscribe = $rootScope.$on('hseApp:userUpdate', function (event, result) {
            vm.bonusPoint = result;
        });
        $scope.$on('$destroy', unsubscribe);
        function loadAll() {
            bonusPointLog.query({
                id: $stateParams.id,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.bonusPointlog = data;
        }

        function onError(error) {
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        BonusPoint.query({id: $stateParams.id}, function(result) {
            vm.bonusPoint = result[0].bonusPoint;
        });

        User.get({id: $stateParams.id}, function(result) {
            vm.user = result;
        });
        // vm.load($stateParams.login);
        //
        // function load(login) {
        //     User.get({login: login}, function(result) {
        //         vm.user = result;
        //     });
        // }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('bonusPointLog', bonusPointLog);

    bonusPointLog.$inject = ['$resource', 'DateUtils'];

    function bonusPointLog($resource, DateUtils) {
        var resourceUrl = 'api/bonus-point-logs/customer/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('BonusPoint', BonusPoint);

    BonusPoint.$inject = ['$resource', 'DateUtils'];

    function BonusPoint($resource, DateUtils) {
        var resourceUrl = 'api/bonus-points/customer/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin.sys-admin.public-announcement', {
            parent: 'admin.sys-admin',
            url: '/public-announcement?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_PLACE_ADMIN', 'ROLE_TEACHER','ROLE_CONSULTANT']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/public-announcement/public-announcements.html',
                    controller: 'PublicAnnouncementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.public-announcement-detail', {
            parent: 'admin.sys-admin',
            url: '/public-announcement/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_TEACHER','ROLE_CONSULTANT'],
                pageTitle: 'hseApp.publicAnnouncement.detail.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/public-announcement/public-announcement-detail.html',
                    controller: 'PublicAnnouncementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicAnnouncement', function($stateParams, PublicAnnouncement) {
                    return PublicAnnouncement.get({ moduleId:1, id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-announcement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('admin.sys-admin.public-announcement-detail.edit', {
            parent: 'admin.sys-admin.public-announcement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_PLACE_ADMIN']
            },views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/public-announcement/public-announcement-detail.html',
                    controller: 'PublicAnnouncementDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    } ;
                        entity: ['$stateParams', 'PublicAnnouncement', function($stateParams, PublicAnnouncement) {
                        return PublicAnnouncement.get({ moduleId:1, id : $stateParams.id}).$promise;
                    }]
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.public-announcement.new', {
            parent: 'admin.sys-admin',
            url: '/public-announcement/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_PLACE_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/public-announcement/public-announcement-dialog.html',
                    controller: 'PublicAnnouncementDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        subject: null,
                        content: null,
                        senderId: null,
                        senderName: null,
                        sentDate: null,
                        id: null,
                        attachments: [],
                        moduleId: 1
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.public-announcement.edit', {
            parent: 'admin.sys-admin',
            url: '/public-announcement/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_PLACE_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/public-announcement/public-announcement-dialog.html',
                    controller: 'PublicAnnouncementDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['PublicAnnouncement', '$stateParams', '$state', function(PublicAnnouncement, $stateParams, $state) {
                    return PublicAnnouncement.get({moduleId:1, id : $stateParams.id}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-announcement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('admin.sys-admin.public-announcement.delete', {
            parent: 'admin.sys-admin.public-announcement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_PLACE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/public-announcement/public-announcement-delete-dialog.html',
                    controller: 'PublicAnnouncementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicAnnouncement', function(PublicAnnouncement) {
                            return PublicAnnouncement.get({ moduleId: 1, id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.public-announcement', null, { reload: 'admin.sys-admin.public-announcement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('app.admin')
        .factory('PublicAnnouncement', PublicAnnouncement);

    PublicAnnouncement.$inject = ['$resource', 'DateUtils'];

    function PublicAnnouncement ($resource, DateUtils) {
        var resourceUrl =  'api/public-announcements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.sentDate = DateUtils.convertDateTimeFromServer(data.sentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('PublicAnnouncementController', PublicAnnouncementController);

    PublicAnnouncementController.$inject = ['$state', 'PublicAnnouncement', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','Principal'];

    function PublicAnnouncementController($state, PublicAnnouncement, ParseLinks, AlertService, paginationConstants, pagingParams,Principal) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        Principal.identity().then(function (account) {

            vm.authorities = account.authorities;
            if (vm.authorities.indexOf("ROLE_ADMIN") > -1) {
                vm.ROLE_ADMIN = true
            } else if (vm.authorities.indexOf("ROLE_PLACE_ADMIN") > -1) {
                vm.ROLE_PLACE_ADMIN = true
            } else {
                if (vm.authorities.indexOf("ROLE_CONSULTANT") > -1) {
                    vm.ROLE_CONSULTANT = true
                }
                if (vm.authorities.indexOf("ROLE_TEACHER") > -1) {
                    vm.ROLE_TEACHER = true
                }
            }

            loadAll();
        })
        function loadAll() {
            PublicAnnouncement.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicAnnouncements = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        vm.goTo = function (id) {
            $state.go("^.public-announcement-detail", {id: id});
        };
        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('PublicAnnouncementDialogController', PublicAnnouncementDialogController);

    PublicAnnouncementDialogController.$inject = ['$state', '$timeout', 'Principal', 'entity', 'PublicAnnouncement', 'Upload', 'FileUploader', '$localStorage', '$sessionStorage', 'SweetAlert', '$location','$scope'];

    function PublicAnnouncementDialogController($state, $timeout, Principal, entity, PublicAnnouncement, Upload, FileUploader, $localStorage, $sessionStorage, SweetAlert, $location,$scope) {
        var vm = this;
        vm.publicAnnouncement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        var dateNow = new Date();
        dateNow.toLocaleDateString();
        vm.account = null;
        Principal.identity().then(function (account) {
            vm.account = account;
        });
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go("^.public-announcement");
        }

        if ($location.host() == "localhost") {
            vm.url = "https://demo.ienwu.com"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }


        function onSaveSuccess(result) {
            SweetAlert.swal({title: "提交成功", type: "success"});
            vm.isSaving = false;
            $state.go("^.public-announcement");
        }

        function onSaveError(error) {
            SweetAlert.swal({title: "提交失败", text: error.data.message, type: "error"});
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.sentDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        $scope.$on('$viewContentLoaded', function() {

            vm.save = save;
            var E, editor;
            E = window.wangEditor;
            editor = new E('#editor'); //id一定要一致
            editor.customConfig.menus = [
                'head',  // 标题
                'bold',  // 粗体
                'fontSize',  // 字号
                'fontName',  // 字体
                'italic',  // 斜体
                'underline',  // 下划线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'link',  // 插入链接
                'list',  // 列表
                'justify',  // 对齐方式
                'image',  // 插入图片
                //'table',  // 表格
                'video',  // 插入视频
                'code',  // 插入代码
                'undo'  // 撤销
            ];
            //如果需要使用 base64 编码直接将图片插入到内容中，可参考一下示例配置
            editor.customConfig.uploadImgShowBase64 = false;
            editor.customConfig.uploadImgServer = vm.url + "/api/upload/";
            editor.customConfig.uploadFileName = 'file';
            // 将图片大小限制为 10M
            editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024;
            //获取内容的方式
            editor.customConfig.uploadImgHooks = {
                //before: function (xhr, editor, files) {
                //    // 图片上传之前触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
                //
                //    // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
                //    // return {
                //    //     prevent: true,
                //    //     msg: '放弃上传'
                //    // }
                //},
                //success: function (xhr, editor, result) {
                //    // 图片上传并返回结果，图片插入成功之后触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //fail: function (xhr, editor, result) {
                //    // 图片上传并返回结果，但图片插入错误时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //error: function (xhr, editor) {
                //    // 图片上传出错时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},
                //timeout: function (xhr, editor) {
                //    // 图片上传超时时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},

                // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
                // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
                customInsert: function (insertImg, result, editor) {
                    // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
                    // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

                    // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
                    //console.log(result)
                    var url = result.fileUrl
                    //console.log(url)
                    insertImg(url)
                    // result 必须是一个 JSON 格式字符串！！！否则报错
                }
            }

            editor.create();
            editor.txt.html(vm.publicAnnouncement.content);

            function save() {
                vm.isSaving = true;
                vm.publicAnnouncement.content = editor.txt.html();
                if (vm.publicAnnouncement.content.toString().length <= 15) {
                    vm.isSaving = false;
                    SweetAlert.swal({title: "通知公告内容不能为空或者少于10个字符", text: "", type: "error"});
                } else {
                    if (vm.publicAnnouncement.id !== null) {
                        PublicAnnouncement.update(vm.publicAnnouncement, onSaveSuccess, onSaveError);
                    } else {
                        vm.publicAnnouncement.senderId = vm.account.id;
                        vm.publicAnnouncement.senderName = vm.account.fullName;
                        vm.publicAnnouncement.sentDate = dateNow;
                        PublicAnnouncement.save(vm.publicAnnouncement, onSaveSuccess, onSaveError);
                    }
                }
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('PublicAnnouncementDetailController', PublicAnnouncementDetailController);

    PublicAnnouncementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicAnnouncement'];

    function PublicAnnouncementDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicAnnouncement) {
        var vm = this;

        vm.publicAnnouncement = entity;
        angular.element("#mail-content").html(vm.publicAnnouncement.content);
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('hseApp:publicAnnouncementUpdate', function(event, result) {
            vm.publicAnnouncement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('PublicAnnouncementDeleteController',PublicAnnouncementDeleteController);

    PublicAnnouncementDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicAnnouncement'];

    function PublicAnnouncementDeleteController($uibModalInstance, entity, PublicAnnouncement) {
        var vm = this;

        vm.publicAnnouncement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicAnnouncement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin.sys-admin.news', {
            parent: 'admin.sys-admin',
            url: '/news?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_GROUPCORP_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/news/news.html',
                    controller: 'NewsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.news-detail', {
            parent: 'admin.sys-admin',
            url: '/news/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_GROUPCORP_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/news/news-detail.html',
                    controller: 'NewsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'News', function($stateParams, News) {
                    return News.get({ moduleId:1, id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'news',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('admin.sys-admin.news-detail.edit', {
            parent: 'admin.sys-admin.news-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_GROUPCORP_ADMIN']
            },views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/news/news-detail.html',
                    controller: 'NewsDetailController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                entity: ['$stateParams', 'News', function($stateParams, News) {
                    return News.get({ moduleId:1, id : $stateParams.id}).$promise;
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    } ;

                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.news.new', {
            parent: 'admin.sys-admin',
            url: '/news/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_GROUPCORP_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        subject: null,
                        content: null,
                        senderId: null,
                        senderName: null,
                        sentDate: null,
                        id: null,
                        attachments: [],
                        moduleId: 1
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.news.edit', {
            parent: 'admin.sys-admin',
            url: '/news/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_GROUPCORP_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/news/news-dialog.html',
                    controller: 'NewsDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['News', '$stateParams', '$state', function(News, $stateParams, $state) {
                    return News.get({moduleId:1, id : $stateParams.id}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicAnnouncement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'news',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('admin.sys-admin.news.delete', {
            parent: 'admin.sys-admin.news',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_GROUPCORP_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/news/news-delete-dialog.html',
                    controller: 'NewsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['News', function(News) {
                            return News.get({ moduleId: 1, id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.news', null, { reload: 'admin.sys-admin.news' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('app.admin')
        .factory('News', News);

    News.$inject = ['$resource', 'DateUtils'];

    function News ($resource, DateUtils) {
        var resourceUrl =  'api/news/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.sentDate = DateUtils.convertDateTimeFromServer(data.sentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('NewsController', NewsController);

    NewsController.$inject = ['$state', 'News', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function NewsController($state, News, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            News.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicAnnouncements = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }
        vm.goTo = function(id){
            $state.go("^.news",{id:id});
        };
        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('NewsDialogController', NewsDialogController);

    NewsDialogController.$inject = ['$state', '$timeout', 'Principal', 'entity', 'News', 'Upload', 'FileUploader', '$localStorage', '$sessionStorage', 'SweetAlert', '$location','$scope'];

    function NewsDialogController($state, $timeout, Principal, entity, News, Upload, FileUploader, $localStorage, $sessionStorage, SweetAlert, $location,$scope) {
        var vm = this;
        vm.publicAnnouncement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        var dateNow = new Date();
        dateNow.toLocaleDateString();
        vm.account = null;
        Principal.identity().then(function (account) {
            vm.account = account;
        });
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $state.go("^.news");
        }

        if ($location.host() == "localhost") {
            vm.url = "https://demo.ienwu.com"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }


        function onSaveSuccess(result) {
            SweetAlert.swal({title: "提交成功", type: "success"});
            vm.isSaving = false;
            $state.go("^.news");
        }

        function onSaveError(error) {
            SweetAlert.swal({title: "提交失败", text: error.data.message, type: "error"});
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.sentDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        $scope.$on('$viewContentLoaded', function() {

            vm.save = save;
            var E, editor;
            E = window.wangEditor;
            editor = new E('#editor'); //id一定要一致
            editor.customConfig.menus = [
                'head',  // 标题
                'bold',  // 粗体
                'fontSize',  // 字号
                'fontName',  // 字体
                'italic',  // 斜体
                'underline',  // 下划线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'link',  // 插入链接
                'list',  // 列表
                'justify',  // 对齐方式
                'image',  // 插入图片
                //'table',  // 表格
                'video',  // 插入视频
                'code',  // 插入代码
                'undo'  // 撤销
            ];
            //如果需要使用 base64 编码直接将图片插入到内容中，可参考一下示例配置
            editor.customConfig.uploadImgShowBase64 = false;
            editor.customConfig.uploadImgServer = vm.url + "/api/upload/";
            editor.customConfig.uploadFileName = 'file';
            // 将图片大小限制为 10M
            editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024;
            //获取内容的方式
            editor.customConfig.uploadImgHooks = {
                //before: function (xhr, editor, files) {
                //    // 图片上传之前触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
                //
                //    // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
                //    // return {
                //    //     prevent: true,
                //    //     msg: '放弃上传'
                //    // }
                //},
                //success: function (xhr, editor, result) {
                //    // 图片上传并返回结果，图片插入成功之后触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //fail: function (xhr, editor, result) {
                //    // 图片上传并返回结果，但图片插入错误时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //error: function (xhr, editor) {
                //    // 图片上传出错时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},
                //timeout: function (xhr, editor) {
                //    // 图片上传超时时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},

                // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
                // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
                customInsert: function (insertImg, result, editor) {
                    // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
                    // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

                    // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
                    //console.log(result)
                    var url = result.fileUrl
                    //console.log(url)
                    insertImg(url)
                    // result 必须是一个 JSON 格式字符串！！！否则报错
                }
            }

            editor.create();
            editor.txt.html(vm.publicAnnouncement.content);

            function save() {
                vm.isSaving = true;
                vm.publicAnnouncement.content = editor.txt.html();
                if (vm.publicAnnouncement.content.toString().length <= 15) {
                    vm.isSaving = false;
                    SweetAlert.swal({title: "新闻资讯内容不能为空或者少于10个字符", text: "", type: "error"});
                } else {
                    if (vm.publicAnnouncement.id !== null) {
                        News.update(vm.publicAnnouncement, onSaveSuccess, onSaveError);
                    } else {
                        vm.publicAnnouncement.senderId = vm.account.id;
                        vm.publicAnnouncement.senderName = vm.account.fullName;
                        vm.publicAnnouncement.sentDate = dateNow;
                        News.save(vm.publicAnnouncement, onSaveSuccess, onSaveError);
                    }
                }
            }
        })

        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        if ($location.host() == "localhost") {
            vm.url = "https://demo.ienwu.com"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }
        vm.uploaderImg = new FileUploader({
            url: vm.url + "/api/upload/",
            headers: {
                "Authorization": 'Bearer ' + token
            }
        });

        vm.uploaderImg.onProgressAll = function (progress) {
            vm.uploadProgress = progress;
        };

        vm.uploaderImg.onSuccessItem = function (item, response, status, headers) {
            vm.publicAnnouncement.imgUrl = response.fileUrl;
        };

        vm.uploadImg = function () {
            vm.uploaderImg.uploadAll();
        };

        vm.clearImg = function () {
            vm.publicAnnouncement.imgUrl = "";
        };

        vm.showImgDialog = function () {
            angular.element("#browse-img").click();
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('NewsDetailController', NewsDetailController);

    NewsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'News'];

    function NewsDetailController($scope, $rootScope, $stateParams, previousState, entity, News) {
        var vm = this;

        vm.publicAnnouncement = entity;
        angular.element("#mail-content").html(vm.publicAnnouncement.content);
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('hseApp:publicAnnouncementUpdate', function(event, result) {
            vm.publicAnnouncement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('NewsDeleteController',NewsDeleteController);

    NewsDeleteController.$inject = ['$uibModalInstance', 'entity', 'News'];

    function NewsDeleteController($uibModalInstance, entity, News) {
        var vm = this;

        vm.publicAnnouncement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            News.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.sys-admin.file-upload-log', {
                parent: 'admin.sys-admin',
                url: '/file-upload-log?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/sys-admin/file-upload-log/file-upload-logs.html',
                        controller: 'FileUploadLogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fileUploadLog');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.sys-admin.file-upload-log.edit', {
                url: '/{id}/edit',
                parent: 'admin.sys-admin.file-upload-log',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/sys-admin/file-upload-log/file-upload-log.detail.html',
                        controller: 'FileUploadLogDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['FileUploadLog', function (FileUploadLog) {
                                return FileUploadLog.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.sys-admin.file-upload-log', null, {reload: 'admin.sys-admin.file-upload-log'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }

})();

(function() {
    'use strict';
    angular
        .module('app.admin')
        .factory('FileUploadLog', FileUploadLog);

    FileUploadLog.$inject = ['$resource', 'DateUtils'];

    function FileUploadLog ($resource, DateUtils) {
        var resourceUrl =  'api/upload/file-upload-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('FileUploadLogDialogController', FileUploadLogDialogController);

    FileUploadLogDialogController.$inject = ['$state', 'FileUploadLog', 'ParseLinks', 'AlertService', 'paginationConstants','$location','entity','$uibModalInstance'];

    function FileUploadLogDialogController($state, FileUploadLog, ParseLinks, AlertService, paginationConstants,$location,entity,$uibModalInstance) {

        var vm = this;
        vm.FileUploadLog = entity;
        vm.clear = clear;
        if ($location.host() == "localhost") {
            vm.url = "https://demo.ienwu.com"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }

        vm.imgUrl = vm.url + vm.FileUploadLog.fileUrl;
        //vm.changePic=function($event){
        //    var img=$event.srcElement || $event.target;
        //    angular.element("#bigimage")[0].src=img.src;
        //    angular.element("#js-imgview")[0].style.display="block";
        //    angular.element("#js-imgview-mask")[0].style.display="block";
        //}
        ////点击图片时放小显示图片
        //vm.closePic =function(){
        //    angular.element("#js-imgview")[0].style.display="none";
        //    angular.element("#js-imgview-mask")[0].style.display="none";
        //
        //}

        vm.FileUploadLog.fileType = vm.FileUploadLog.fileUrl.split(".").pop().toUpperCase();
        console.log(vm.FileUploadLog.fileType)
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('FileUploadLogController', FileUploadLogController);

    FileUploadLogController.$inject = ['$state', 'FileUploadLog', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', '$location'];

    function FileUploadLogController($state, FileUploadLog, ParseLinks, AlertService, paginationConstants, pagingParams, $location) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            FileUploadLog.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fileUploadLogs = data;
                vm.page = pagingParams.page;
                for (var i = 0; i < vm.fileUploadLogs.length; i++) {
                    //vm.fileUploadLogs[i].fileType = vm.fileUploadLogs[i].fileUrl.split(".").pop().toUpperCase();
                    //console.log(vm.fileUploadLogs[i].fileType)

                    if (vm.fileUploadLogs[i].size < 0.1 * 1024) {                            //小于0.1KB，则转化成B
                        vm.fileUploadLogs[i].size = vm.fileUploadLogs[i].size.toFixed(2) + "B"
                    } else if (vm.fileUploadLogs[i].size < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
                        vm.fileUploadLogs[i].size = (vm.fileUploadLogs[i].size / 1024).toFixed(2) + "KB"
                    } else if (vm.fileUploadLogs[i].size < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
                        vm.fileUploadLogs[i].size = (vm.fileUploadLogs[i].size / (1024 * 1024)).toFixed(2) + "MB"
                    } else {                                            //其他转化成GB
                        vm.fileUploadLogs[i].size = (vm.fileUploadLogs[i].size / (1024 * 1024 * 1024)).toFixed(2) + "GB"
                    }
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        if ($location.host() == "localhost") {
            vm.url = "https://demo.ienwu.com"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }


        //vm.changePic=function($event){
        //    var img=$event.srcElement || $event.target;
        //    angular.element("#bigimage")[0].src=img.src;
        //    angular.element("#js-imgview")[0].style.display="block";
        //    angular.element("#js-imgview-mask")[0].style.display="block";
        //}
        ////点击图片时放小显示图片
        //vm.closePic =function(){
        //    angular.element("#js-imgview")[0].style.display="none";
        //    angular.element("#js-imgview-mask")[0].style.display="none";
        //
        //}
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin.sys-admin.feed-back', {
            parent: 'admin.sys-admin',
            url: '/feed-back?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/feed-back/feed-backs.html',
                    controller: 'FeedBackController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feedBack');
                    $translatePartialLoader.addPart('feedBackType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.feed-back-detail', {
            parent: 'admin.sys-admin',
            url: '/feed-back/feed-back/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN'],
                pageTitle: 'slmsApp.feedBack.detail.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/feed-back/feed-back-detail.html',
                    controller: 'FeedBackDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feedBack');
                    $translatePartialLoader.addPart('feedBackType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FeedBack', function($stateParams, FeedBack) {
                    return FeedBack.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'feed-back',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('admin.sys-admin.feed-back-detail.edit', {
            parent: 'admin.sys-admin.feed-back-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/feed-back/feed-back-dialog.html',
                    controller: 'FeedBackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeedBack', function(FeedBack) {
                            return FeedBack.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('admin.sys-admin.feed-back.new', {
            parent: 'admin.sys-admin.feed-back',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/feed-back/feed-back-dialog.html',
                    controller: 'FeedBackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                feedBackType: null,
                                content: null,
                                customerId: null,
                                customerFullName: null,
                                customerPhoneNumber: null,
                                customerCity: null,
                                sentDate: null,
                                receiverId: null,
                                receiverFullName: null,
                                handled: null,
                                handleResult: null,
                                remark: null,
                                createdBy: null,
                                createdDate: null,
                                lastModifiedBy: null,
                                lastModifiedDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('feed-back', null, { reload: 'feed-back' });
                }, function() {
                    $state.go('feed-back');
                });
            }]
        })
        .state('admin.sys-admin.feed-back.edit', {
            parent: 'admin.sys-admin.feed-back',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/feed-back/feed-back-dialog.html',
                    controller: 'FeedBackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeedBack', function(FeedBack) {
                            return FeedBack.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.feed-back', null, { reload: 'admin.sys-admin.feed-back' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('admin.sys-admin.feed-back.delete', {
            parent: 'admin.sys-admin.feed-back',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/feed-back/feed-back-delete-dialog.html',
                    controller: 'FeedBackDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FeedBack', function(FeedBack) {
                            return FeedBack.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.feed-back', null, { reload: 'admin.sys-admin.feed-back' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('app.admin')
        .factory('FeedBack', FeedBack);

    FeedBack.$inject = ['$resource', 'DateUtils'];

    function FeedBack ($resource, DateUtils) {
        var resourceUrl =  'api/feed-backs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.sentDate = DateUtils.convertDateTimeFromServer(data.sentDate);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('FeedBackController', FeedBackController);

    FeedBackController.$inject = ['$state', 'FeedBack', 'ParseLinks', 'AlertService', '$resource', 'Principal', 'OrganizationStations', 'paginationConstants', 'pagingParams'];

    function FeedBackController($state, FeedBack, ParseLinks, AlertService, $resource, Principal, OrganizationStations, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.condition = {};

        Principal.identity().then(function (account) {
            vm.authorities = account.authorities;
            vm.account = account;
            if (vm.authorities.indexOf("ROLE_ADMIN") > -1) {
                vm.ROLE_ADMIN = true
            } else if (vm.authorities.indexOf("ROLE_PLACE_ADMIN") > -1){
                vm.ROLE_PLACE_ADMIN = true;
                vm.condition.organizationId = account.orgId;
            }
            loadAll();
        });

        function loadAll () {

            FeedBack.query({
                organizationId: vm.condition.organizationId,
                receiverPhoneNumber:vm.condition.receiverPhoneNumber,
                content:vm.condition.content,
                handled: vm.condition.handled,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            OrganizationStations.query({}, organizationSuccess, organizationError);
            function organizationSuccess(data) {
                vm.organizations = data;
            }

            function organizationError() {
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.feedBacks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                customerPhoneNumber:vm.condition.customerPhoneNumber,
                content:vm.condition.content,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        vm.search =function(){
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('FeedBackDialogController', FeedBackDialogController);

    FeedBackDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FeedBack'];

    function FeedBackDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FeedBack) {
        var vm = this;

        vm.feedBack = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        ifHandle();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.feedBack.id !== null) {
                FeedBack.update(vm.feedBack, onSaveSuccess, onSaveError);
            } else {
                FeedBack.save(vm.feedBack, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('hseApp:feedBackUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.sentDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function ifHandle() {
            if (!vm.feedBack.handled) {
                vm.feedBack.handled = true;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('FeedBackDetailController', FeedBackDetailController);

    FeedBackDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FeedBack'];

    function FeedBackDetailController($scope, $rootScope, $stateParams, previousState, entity, FeedBack) {
        var vm = this;

        vm.feedBack = entity;
        //vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('slmsApp:feedBackUpdate', function(event, result) {
            vm.feedBack = result;
        });
        if(vm.feedBack.handled == true){
            vm.feedBack.handled = '已处理'
        }
        if(vm.feedBack.handled == false){
            vm.feedBack.handled = '待处理'
        }
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('FeedBackDeleteController',FeedBackDeleteController);

    FeedBackDeleteController.$inject = ['$uibModalInstance', 'entity', 'FeedBack'];

    function FeedBackDeleteController($uibModalInstance, entity, FeedBack) {
        var vm = this;

        vm.feedBack = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FeedBack.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin.sys-admin.carousel-item', {
            parent: 'admin.sys-admin',
            url: '/carousel/{carouselId}/carousel-item?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/carousel-item/carousel-items.html',
                    controller: 'CarouselItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null,
                carouselId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carouselItem');
                    $translatePartialLoader.addPart('linkTargetType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.carousel-item-detail', {
            parent: 'admin.sys-admin',
            url: '/carousel-item/{id}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content': {
                    templateUrl: 'app/admin/sys-admin/carousel-item/carousel-item-detail.html',
                    controller: 'CarouselItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carouselItem');
                    $translatePartialLoader.addPart('linkTargetType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CarouselItem', function($stateParams, CarouselItem) {
                    return CarouselItem.get({carouselId: 1,id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'carousel-item',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('admin.sys-admin.carousel-item-detail.edit', {
            parent: 'admin.sys-admin.carousel-item-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/carousel-item/carousel-item-dialog.html',
                    controller: 'CarouselItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CarouselItem', function(CarouselItem) {
                            return CarouselItem.get({carouselId: 1,id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('admin.sys-admin.carousel-item.new', {
            parent: 'admin.sys-admin.carousel-item',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/carousel-item/carousel-item-dialog.html',
                    controller: 'CarouselItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                itemUrl: null,
                                targetType: 'ENTITY',
                                targetUrl: null,
                                targetEntityType: 'Course',
                                targetEntityId: null,
                                caption: null,
                                effectiveTime: null,
                                neverExpire: null,
                                expireTime: null,
                                sequence: 0,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.carousel-item', null, { reload: 'admin.sys-admin.carousel-item' });
                }, function() {
                    $state.go('admin.sys-admin.carousel-item');
                });
            }]
        })
        .state('admin.sys-admin.carousel-item.edit', {
            parent: 'admin.sys-admin.carousel-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/carousel-item/carousel-item-dialog.html',
                    controller: 'CarouselItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CarouselItem', function(CarouselItem) {
                            return CarouselItem.get({carouselId: 1,id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.carousel-item', null, { reload: 'admin.sys-admin.carousel-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('admin.sys-admin.carousel-item.delete', {
            parent: 'admin.sys-admin.carousel-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/carousel-item/carousel-item-delete-dialog.html',
                    controller: 'CarouselItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CarouselItem', function(CarouselItem) {
                            return CarouselItem.get({carouselId: 1,id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.carousel-item', null, { reload: 'admin.sys-admin.carousel-item' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('CarouselItem', CarouselItem);

    CarouselItem.$inject = ['$resource', 'DateUtils'];

    function CarouselItem ($resource, DateUtils) {
        var resourceUrl =  'api/carousels/:carouselId/carousel-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveTime = DateUtils.convertDateTimeFromServer(data.effectiveTime);
                        data.expireTime = DateUtils.convertDateTimeFromServer(data.expireTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('CarouselItemController', CarouselItemController);

    CarouselItemController.$inject = ['$state', '$stateParams', 'CarouselItem', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'CarouselItemById', 'Carousel'];

    function CarouselItemController($state, $stateParams, CarouselItem, ParseLinks, AlertService, paginationConstants, pagingParams, CarouselItemById, Carousel) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.carouselId = $stateParams.carouselId;
        vm.carousel = Carousel.get({id:vm.carouselId});
        loadAll();

        function loadAll () {
            if(vm.carouselId){
                CarouselItemById.query({
                    carouselId: vm.carouselId
                }, onQuerySuccess, onError);
            }else{
                CarouselItem.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.carouselItems = data;
                vm.page = pagingParams.page;
            }
            function onQuerySuccess(data, headers) {
                vm.carouselItems = data;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('CarouselItemDialogController', CarouselItemDialogController);

    CarouselItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', 'Principal','$uibModalInstance', 'entity', 'Carousel', 'Course', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', '$location'];

    function CarouselItemDialogController ($timeout, $scope, $stateParams, Principal, $uibModalInstance, entity, Carousel, Course, FileUploader, $localStorage, $sessionStorage, $resource, $location) {
        var vm = this;

        vm.carouselItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.carousels = Carousel.query();
        vm.carouselId = parseInt($stateParams.carouselId);
        vm.selected = {value: []};
        if(vm.carouselId){
            vm.carousel = Carousel.get({id:vm.carouselId});
        }
        if(vm.carouselItem.targetEntityId){
            vm.carouselItem.targetEntityId = parseInt(vm.carouselItem.targetEntityId)
        }
        vm.carouselItem.carouselId = vm.carouselId;
        var CarouselItemById = $resource("api/carousels/"+vm.carouselId+"/carousel-items",{},{
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveTime = DateUtils.convertDateTimeFromServer(data.effectiveTime);
                        data.expireTime = DateUtils.convertDateTimeFromServer(data.expireTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
        var dateNow = new Date();
        dateNow.toLocaleDateString();
        vm.account = null;
        Principal.identity().then(function(account) {
            vm.account = account;
            vm.changeEntity();
        });
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.carouselItem.effectiveTime = new Date();
            vm.carouselItem.neverExpire = true;
            vm.carouselItem.targetEntityId = vm.selected.value.id;
            vm.carouselItem.targetEntityName = vm.selected.value.name;
            if (vm.carouselItem.targetType === 'ENTITY') {
                vm.carouselItem.targetEntityType = "Course";
                vm.carouselItem.targetUrl = null;
            }else if (vm.carouselItem.targetType === 'URL') {
                vm.carouselItem.targetEntityType = null;
                vm.carouselItem.targetEntityId = null;
            }

            if (vm.carouselItem.id !== null) {
                CarouselItemById.update(vm.carouselItem, onSaveSuccess, onSaveError);
            } else {
                CarouselItemById.save(vm.carouselItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('hseApp:carouselItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.effectiveTime = false;
        vm.datePickerOpenStatus.expireTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        if ($location.host() == "127.0.0.1") {
            vm.url = "https://demo.ienwu.com"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }
        vm.uploader = new FileUploader({
            url: vm.url + "/api/upload/",
            headers: {
                "Authorization" : 'Bearer ' + token
            }
        });

        vm.uploader.onProgressAll = function(progress) {
            vm.uploadProgress = progress;
        };

        vm.uploader.onSuccessItem = function(item, response){
            vm.carouselItem.itemUrl = response.fileUrl;
        };

        vm.uploadFile = function () {
            vm.uploader.uploadAll();
        };

        vm.clearFile = function () {
            vm.carouselItem.itemUrl = "";
        };

        vm.showFileDialog = function () {
            angular.element("#browse-file").click();
        };

        vm.changeEntity = function () {
            if(vm.carouselItem.targetType==='ENTITY'){
                Course.query({size: 9999}, courseSuccess);
            }
        };

        function courseSuccess(data) {
            vm.course = data;
            for (var i = 0; i < vm.course.length; i++) {
                if (vm.course[i].id == entity.targetEntityId) {
                    vm.selected.value = vm.course[i]
                }
            }
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('CarouselItemDetailController', CarouselItemDetailController);

    CarouselItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CarouselItem', 'Carousel'];

    function CarouselItemDetailController($scope, $rootScope, $stateParams, previousState, entity, CarouselItem, Carousel) {
        var vm = this;

        vm.carouselItem = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('hseApp:carouselItemUpdate', function(event, result) {
            vm.carouselItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('CarouselItemDeleteController',CarouselItemDeleteController);

    CarouselItemDeleteController.$inject = ['$uibModalInstance', '$stateParams', 'entity', '$resource'];

    function CarouselItemDeleteController($uibModalInstance, $stateParams, entity, $resource) {
        var vm = this;

        vm.carouselItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.carouselId = $stateParams.carouselId;
        var CarouselItemById = $resource("api/carousels/"+vm.carouselId+"/carousel-items/:id",{});
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CarouselItemById.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('CarouselItemById', CarouselItemById);

    CarouselItemById.$inject = ['$resource', 'DateUtils'];

    function CarouselItemById ($resource, DateUtils) {
        var resourceUrl =  'api/carousels/:carouselId/carousel-items';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveTime = DateUtils.convertDateTimeFromServer(data.effectiveTime);
                        data.expireTime = DateUtils.convertDateTimeFromServer(data.expireTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin.sys-admin.carousel', {
            parent: 'admin.sys-admin',
            url: '/carousel?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'hseApp.carousel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/sys-admin/carousel/carousels.html',
                    controller: 'CarouselController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carousel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('admin.sys-admin.carousel-detail', {
            parent: 'admin.sys-admin',
            url: '/carousel/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'hseApp.carousel.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/sys-admin/carousel/carousel-detail.html',
                    controller: 'CarouselDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('carousel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Carousel', function($stateParams, Carousel) {
                    return Carousel.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'carousel',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('admin.sys-admin.carousel-detail.edit', {
            parent: 'admin.sys-admin.carousel-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/carousel/carousel-dialog.html',
                    controller: 'CarouselDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Carousel', function(Carousel) {
                            return Carousel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('admin.sys-admin.carousel.new', {
            parent: 'admin.sys-admin.carousel',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/carousel/carousel-dialog.html',
                    controller: 'CarouselDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                suggestedWidth: null,
                                suggestedHeight: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.carousel', null, { reload: 'admin.sys-admin.carousel' });
                }, function() {
                    $state.go('admin.sys-admin.carousel');
                });
            }]
        })
        .state('admin.sys-admin.carousel.edit', {
            parent: 'admin.sys-admin.carousel',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/carousel/carousel-dialog.html',
                    controller: 'CarouselDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Carousel', function(Carousel) {
                            return Carousel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.carousel', null, { reload: 'admin.sys-admin.carousel' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('admin.sys-admin.carousel.delete', {
            parent: 'admin.sys-admin.carousel',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/sys-admin/carousel/carousel-delete-dialog.html',
                    controller: 'CarouselDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Carousel', function(Carousel) {
                            return Carousel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.sys-admin.carousel', null, { reload: 'admin.sys-admin.carousel' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('Carousel', Carousel);

    Carousel.$inject = ['$resource'];

    function Carousel ($resource) {
        var resourceUrl =  'api/carousels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('CarouselController', CarouselController);

    CarouselController.$inject = ['$state', 'Carousel', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function CarouselController($state, Carousel, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Carousel.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.carousels = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('CarouselDialogController', CarouselDialogController);

    CarouselDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Carousel', 'CarouselItem'];

    function CarouselDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Carousel, CarouselItem) {
        var vm = this;

        vm.carousel = entity;
        vm.clear = clear;
        vm.save = save;
        vm.carouselitems = CarouselItem.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.carousel.id !== null) {
                Carousel.update(vm.carousel, onSaveSuccess, onSaveError);
            } else {
                Carousel.save(vm.carousel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('hseApp:carouselUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('CarouselDetailController', CarouselDetailController);

    CarouselDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Carousel', 'CarouselItem'];

    function CarouselDetailController($scope, $rootScope, $stateParams, previousState, entity, Carousel, CarouselItem) {
        var vm = this;

        vm.carousel = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('hseApp:carouselUpdate', function(event, result) {
            vm.carousel = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('CarouselDeleteController',CarouselDeleteController);

    CarouselDeleteController.$inject = ['$uibModalInstance', 'entity', 'Carousel'];

    function CarouselDeleteController($uibModalInstance, entity, Carousel) {
        var vm = this;

        vm.carousel = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Carousel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.sys-admin.aboutUs', {
                url: '/aboutUs/{id}',
                parent: 'admin.sys-admin',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/sys-admin/aboutUs/aboutUs-dialog.html',
                        controller: 'AboutUsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'AboutUs', function ($stateParams, AboutUs) {
                        return AboutUs.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})
();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('AboutUs', AboutUs);

    AboutUs.$inject = ['$resource'];

    function AboutUs ($resource) {
        var resourceUrl =  'api/sys-abouts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('AboutUsController', AboutUsController);

    AboutUsController.$inject = ['$timeout', '$scope', '$stateParams', 'entity','AboutUs','SweetAlert','$location'];

    function AboutUsController ($timeout, $scope, $stateParams, entity,AboutUs,SweetAlert,$location) {
        var vm = this;

        vm.aboutUs = entity;
        vm.clear = clear;

        $timeout(function (){
            angular.element('.form-group:eq(0)>input').focus();
        });

        function clear () {
        }

        function onSaveSuccess (result) {
            $scope.$emit('hseApp:carouselUpdate', result);
            vm.isSaving = false;
            SweetAlert.swal({
                title: "修改成功",
                text: "",
                type: "success",
                allowOutsideClick: true
            })
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        if ($location.host() == "localhost") {
            vm.url = "https://demo.ienwu.com"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }

        $scope.$on('$viewContentLoaded', function() {

            vm.save = save;
            var E, editor;
            E = window.wangEditor;
            editor = new E('#editor'); //id一定要一致
            editor.customConfig.menus = [
                'head',  // 标题
                'bold',  // 粗体
                'fontSize',  // 字号
                'fontName',  // 字体
                'italic',  // 斜体
                'underline',  // 下划线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'link',  // 插入链接
                'list',  // 列表
                'justify',  // 对齐方式
                'image',  // 插入图片
                'table',  // 表格
                'video',  // 插入视频
                'code',  // 插入代码
                'undo'  // 撤销
            ];
            //如果需要使用 base64 编码直接将图片插入到内容中，可参考一下示例配置
            editor.customConfig.uploadImgShowBase64 = false;
            editor.customConfig.uploadImgServer = vm.url + "/api/upload/";
            editor.customConfig.uploadFileName = 'file';
            // 将图片大小限制为 10M
            editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024;
            //获取内容的方式
            editor.customConfig.uploadImgHooks = {
                //before: function (xhr, editor, files) {
                //    // 图片上传之前触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
                //
                //    // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
                //    // return {
                //    //     prevent: true,
                //    //     msg: '放弃上传'
                //    // }
                //},
                //success: function (xhr, editor, result) {
                //    // 图片上传并返回结果，图片插入成功之后触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //fail: function (xhr, editor, result) {
                //    // 图片上传并返回结果，但图片插入错误时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //error: function (xhr, editor) {
                //    // 图片上传出错时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},
                //timeout: function (xhr, editor) {
                //    // 图片上传超时时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},

                // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
                // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
                customInsert: function (insertImg, result, editor) {
                    // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
                    // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

                    // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
                    //console.log(result)
                    var url = result.fileUrl
                    //console.log(url)
                    insertImg(url)
                    // result 必须是一个 JSON 格式字符串！！！否则报错
                }
            }

            editor.create();
            editor.txt.html(vm.aboutUs.description);

            function save () {
                vm.isSaving = true;
                vm.aboutUs.description = editor.txt.html();
                AboutUs.update(vm.aboutUs, onSaveSuccess, onSaveError);
            }
        });


    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('UserSearchService', UserSearchService);

    UserSearchService.$inject = ['$uibModal'];

    function UserSearchService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open (appendTo, params,onResult) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/admin/search/user-search/user-search.html',
                controller: 'UserSearchController',
                controllerAs: 'vm',
                appendTo: appendTo,
                size: 'lg',
                resolve: {
                    entity: function () {
                        return params;
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                function(result){
                    onResult(result);
                    resetModal();
                },resetModal);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('UserSearchController', UserSearchController);

    //UserSearchController.$inject = ['$state', '$timeout', '$uibModalInstance', '$resource', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function UserSearchController ($state, $timeout, $uibModalInstance, $resource, ParseLinks, AlertService, $stateParams, PaginationUtil, paginationConstants, entity) {
        var vm = this;
        vm.cancel = cancel;
        vm.login = '';
        vm.fullName = '';
        vm.org = '';
        vm.dept = '';
        vm.authorityName = '';
        if(entity.login){
            vm.login = entity.login;
        }
        if(entity.fullName){
            vm.fullName = entity.fullName;
        }
        if(entity.org){
            vm.org = entity.org;
        }
        if(entity.dept){
            vm.dept = entity.dept;
        }
        if(entity.authorityName){
            vm.authorityName = entity.authorityName;
        }
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = 'id';
        vm.reverse = true;
        vm.itemsPerPage = 10; //paginationConstants.itemsPerPage;

        var service = $resource("api/users/search", {}, {
            'query': {method: 'GET', isArray: true}
        });

        vm.search = search;

        $timeout(function (){angular.element('#login').focus();});

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            service.query({
                login: '%' + vm.login + '%',
                fullName: '%' + vm.fullName + '%',
                orgName: '%' + vm.org + '%',
                deptName: '%' + vm.dept + '%',
                authorityName: vm.authorityName,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            // vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.search();
        }

        vm.onSelect = function (entity) {
            $uibModalInstance.close(entity);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('ProductSearchService', ProductSearchService);

    ProductSearchService.$inject = ['$uibModal'];

    function ProductSearchService($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open(appendTo, params,onResult) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/admin/search/productSearch/product.html',
                controller: 'ProductSearchController',
                controllerAs: 'vm',
                appendTo: appendTo,
                size: 'lg',
                resolve: {
                    entity: function () {
                        return params;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                function (result) {
                    onResult(result);
                    resetModal();
                }, resetModal);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('ProductSearchController', ProductSearchController);

    //UserSearchController.$inject = ['$state', '$timeout', '$uibModalInstance', '$resource', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductSearchController ($state, $timeout, $uibModalInstance, $resource, ParseLinks, AlertService, $stateParams, PaginationUtil, paginationConstants, entity,Principal,Product) {
        var vm = this;
        vm.cancel = cancel;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = 'id';
        vm.reverse = true;
        vm.itemsPerPage = 10; //paginationConstants.itemsPerPage;
        vm.selected = {value: []};
        vm.condition = {};

        Principal.identity().then(function (account) {
            vm.account =account;
            search()
        })

        vm.search = search;
        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            Product.query({
                status:'INFORCE',
                    page: vm.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.product = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.search();
        }

        vm.onSelect = function (entity) {
            $uibModalInstance.close(entity);
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('GuaTopicSearchService', GuaTopicSearchService);

    GuaTopicSearchService.$inject = ['$uibModal'];

    function GuaTopicSearchService($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open(appendTo, params,onResult) {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/admin/search/guaTopicSearch/guaTopic.html',
                controller: 'GuaTopicSearchController',
                controllerAs: 'vm',
                appendTo: appendTo,
                size: 'lg',
                resolve: {
                    entity: function () {
                        return params;
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                function (result) {
                    onResult(result);
                    resetModal();
                }, resetModal);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('GuaTopicSearchController', GuaTopicSearchController);

    //UserSearchController.$inject = ['$state', '$timeout', '$uibModalInstance', '$resource', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function GuaTopicSearchController ($state, $timeout, $uibModalInstance, $resource, ParseLinks, AlertService, $stateParams, PaginationUtil, paginationConstants, entity,Principal,GuaTopicQiGua) {
        var vm = this;
        vm.cancel = cancel;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = 'id';
        vm.reverse = true;
        vm.itemsPerPage = 10; //paginationConstants.itemsPerPage;
        vm.selected = {value: []};
        vm.condition = {};

        Principal.identity().then(function (account) {
            vm.account =account;
            search()
        })

        vm.search = search;
        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
                GuaTopicQiGua.query({
                    page: vm.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.guaTopicQiGua = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.search();
        }

        vm.onSelect = function (entity) {
            $uibModalInstance.close(entity);
        }
    }
})();


(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('OssServiceUpload', OssServiceUpload);

    OssServiceUpload.$inject = ['$resource', 'DateUtils'];

    function OssServiceUpload ($resource, DateUtils) {
        // var resourceUrl =  'api/oss-logs/:id';
        var resourceUrl =  'api/oss/sign-callback?bucketName=:bucketName';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
        });
    }
})();

/**
 * Created by troy.zhao on 2017/8/19.
 */
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('OssServiceUpload', OssServiceUpload);

    OssServiceUpload.$inject = ['$state', '$timeout', '$resource', 'Principal', '$stateParams', '$uibModalInstance', 'FileUploader', 'SweetAlert'];

    function OssServiceUpload($state, $timeout, $resource, Principal, $stateParams, $uibModalInstance, FileUploader, SweetAlert) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        // vm.getSignMsg = getSignMsg;
        vm.uploadFile = uploadFile;
        var dateNow = new Date();
        dateNow.toLocaleDateString();
        vm.role = $state.current.data.role;
        vm.bucketName = $stateParams.bucketName;
        vm.account = null;
        vm.callback = '';
        vm.expire = 0;
        vm.host='';
        vm.policyBase64 = '';
        vm.signature = '';
        vm.key = '';
        vm.success_action_status = 200;


        Principal.identity().then(function (account) {
            vm.account = account;
            loadAll();
        });

        function loadAll() {
            getOssSignMessage.query({
            }, onSuccess, onError())

        }

        var getOssSignMessage = $resource("/api/oss/sign-callback?bucketName=" + vm.bucketName, {}, {
            'query': {method: 'GET'}
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();

        });
        vm.showFileDialog = function () {
            angular.element("#browse-file").click();
        };

        vm.uploader = new FileUploader({
        });


        function uploadFile() {
            vm.isSaving = true;
            vm.uploader.uploadAll()
        }

        vm.uploader.onAfterAddingFile = function (fileItem) {
            fileItem.url = vm.host;
            fileItem.formData.push({
                'name' : fileItem._file.name,
                'key' : vm.key + fileItem._file.name,
                'policy': vm.policyBase64,
                'OSSAccessKeyId': vm.accessid,
                'success_action_status' : vm.success_action_status, //让服务端返回200,不然，默认会返回204
                'callback' : vm.callback,
                'signature': vm.signature,
            });
        };

        vm.uploader.onCompleteAll = function (item, response) {
            SweetAlert.swal({title:"上传成功" , type: 'success'});
            $uibModalInstance.close();
            vm.isSaving = false;
        };

        vm.uploader.onErrorItem = function (item, response, status, headers) {
            if (status == 403){
                SweetAlert.swal({title:"签名过期，请刷新页面后重新提交" , type: 'error'});
                $uibModalInstance.close();
                vm.isSaving = false;
            }
        };

        function onSuccess(data) {
            vm.signMsg = data;
            vm.accessid = data.accessid;
            vm.callback = data.callback;
            vm.expire = data.expire;
            vm.host = data.host;
            vm.policyBase64 = data.policy;
            vm.signature = data.signature;
            vm.key = data.dir;
        };

        function onError(error) {
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
            // $state.go('admin.oss-service.oss-service', null, { reload: true });
        }

        function save() {
            $uibModalInstance.close();
            vm.isSaving = false;
        }

        vm.clearFile = function () {
            vm.poolId = "";
        };
    }
})();

/**
 * Created by lance.lu on 2018/7/4.
 */


(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.guaTopicQiGua.guaTopicQiGua', {
                url: '/guaTopicQiGua?page&sort&search',
                parent: 'admin.guaTopicQiGua',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua.html',
                        controller: 'GuaTopicQiGuaController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.guaTopicQiGua.guaTopicQiGua.edit', {
                url: '/guaTopicQiGua/{id}/edit?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.guaTopicQiGua',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua-dialog.html',
                        controller: 'GuaTopicQiGuaDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'GuaTopicQiGua', function ($stateParams, GuaTopicQiGua) {
                        return GuaTopicQiGua.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.guaTopicQiGua.guaTopicQiGua.new', {
                url: '/guaTopicQiGua/new?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.guaTopicQiGua',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua-dialog.html',
                        controller: 'GuaTopicQiGuaDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }], entity: function () {
                        return {
                            id: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.guaTopicQiGua.guaTopicQiGua.detail', {
                url: '/guaTopicQiGua/detail/{id}',
                parent: 'admin.guaTopicQiGua',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua-detail.html',
                        controller: 'GuaTopicQiGuaDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'guaTopicQiGua', function ($stateParams, guaTopicQiGua) {
                        return guaTopicQiGua.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'guaTopicQiGua',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })

            .state('admin.guaTopicQiGua.guaTopicQiGua.delete', {
                url: '/{id}/delete',
                parent: 'admin.guaTopicQiGua.guaTopicQiGua',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua-delete.html',
                        controller: 'GuaTopicQiGuaDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['guaTopicQiGua', function (guaTopicQiGua) {
                                return guaTopicQiGua.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.guaTopicQiGua.guaTopicQiGua', null, {reload: 'admin.guaTopicQiGua.guaTopicQiGua'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }
})
();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('GuaTopicQiGua', GuaTopicQiGua);

    GuaTopicQiGua.$inject = ['$resource', 'DateUtils'];

    function GuaTopicQiGua($resource, DateUtils) {
        var resourceUrl = 'api/gua-topic-qi-guas/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('GuaTopicQiGuaController', GuaTopicQiGuaController);

    GuaTopicQiGuaController.$inject = ['$state', '$resource', 'GuaTopicQiGua', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal', '$document', '$stateParams', 'SweetAlert'];

    function GuaTopicQiGuaController($state, $resource, GuaTopicQiGua, ParseLinks, AlertService, paginationConstants, pagingParams, Principal, $document, $stateParams, SweetAlert) {
        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.year = [];
        vm.condition = {};

        Principal.identity().then(function (account) {
            vm.condition.userFullName = $stateParams.userFullName;
            vm.condition.title = $stateParams.title;
            vm.condition.startRecordDate = $stateParams.startRecordDate;
            vm.condition.endRecordDate = $stateParams.endRecordDate;
            vm.account = account;
            vm.account.login = account.login;
            vm.organizationId = vm.account.orgId;
            vm.authorities = account.authorities;
            loadAll();
        })

        function loadAll() {
            GuaTopicQiGua.query({
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function sort() {
            if (vm.predicate == 'id') {
                vm.predicate = 'createdDate';
            }
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.guaTopicQiGua = data;
            vm.page = pagingParams.page;
            //for(var i=0;i<vm.guaCalendar.length;i++){
            //    if(vm.guaCalendar[i].status == "INFORCE"){
            //        vm.guaCalendar[i].status = "已生效"
            //    }else if(vm.guaCalendar[i].status == "PENDEFFECTIVE"){
            //        vm.guaCalendar[i].status = "待生效"
            //    }else if(vm.guaCalendar[i].status == "DELETED"){
            //        vm.guaCalendar[i].status = "已删除"
            //    }
            //}
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.search = function () {
            loadAll()
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.newDate = new Date();
        vm.newyear = vm.newDate.getFullYear();
        //console.log(vm.newyear)
        for (var i = 0; vm.newyear - i >= 2018; i++) {
            vm.year.push(vm.newyear - i);
            console.log(vm.year)
        }
        //vm.month = [1]
        vm.delete = function (id, valid) {
            GuaTopicQiGua.get({id: id}, onSuccess);
            function onSuccess(result) {
                vm.guaTopicQiGuaDetail = result;
                if (valid == true) {
                    vm.guaTopicQiGuaDetail.valid = false
                }
                if (valid == false) {
                    vm.guaTopicQiGuaDetail.valid = true
                }
                GuaTopicQiGua.update(vm.guaTopicQiGuaDetail, onSaveSuccess, onSaveError);

                function onSaveSuccess(result) {
                    SweetAlert.swal({
                        title: "操作成功",
                        text: "",
                        type: "success",
                        allowOutsideClick: true
                    });
                    $state.reload()
                }

                function onSaveError(error) {
                    SweetAlert.swal({
                        title: "操作失败",
                        text: error.data.title,
                        type: "error",
                        allowOutsideClick: true
                    })
                }
            }
        };

        vm.search = function () {
            if (vm.condition.month == 0) {
                vm.fromTime = vm.condition.year + '-01-01 00:00:00';
                vm.toTime = vm.condition.year + '-12-31 00:00:00';
            } else if (vm.condition.month == 12) {
                vm.fromTime = vm.condition.year + '-' + vm.condition.month + '-01 00:00:00';
                vm.toTime = (parseInt(vm.condition.year) + 1) + '-01-01 00:00:00';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else {
                vm.fromTime = vm.condition.year + '-' + vm.condition.month + '-01 00:00:00';
                vm.toTime = vm.condition.year + '-' + (parseInt(vm.condition.month) + 1) + '-01 00:00:00';
                //console.log(vm.fromTime + '-' + vm.toTime)
            }
            vm.fromTime = new Date(vm.fromTime);
            vm.toTime = new Date(vm.toTime);
            loadAll();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('GuaTopicQiGuaDialogController', GuaTopicQiGuaDialogController);

    GuaTopicQiGuaDialogController.$inject = ['$timeout', '$scope', 'Principal', '$stateParams', 'entity', 'GuaTopicQiGua', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', 'SweetAlert', '$location', '$state'];

    function GuaTopicQiGuaDialogController($timeout, $scope, Principal, $stateParams, entity, GuaTopicQiGua, FileUploader, $localStorage, $sessionStorage, $resource, SweetAlert, $location, $state) {
        var vm = this;
        vm.guaTopicQiGua = entity;
        if(vm.guaTopicQiGua.id){
            vm.guaTopicQiGua.qigua6 = vm.guaTopicQiGua.qigua.substr(0,1);
            vm.guaTopicQiGua.qigua5 = vm.guaTopicQiGua.qigua.substr(1,1);
            vm.guaTopicQiGua.qigua4 = vm.guaTopicQiGua.qigua.substr(2,1);
            vm.guaTopicQiGua.qigua3 = vm.guaTopicQiGua.qigua.substr(3,1);
            vm.guaTopicQiGua.qigua2 = vm.guaTopicQiGua.qigua.substr(4,1);
            vm.guaTopicQiGua.qigua1 = vm.guaTopicQiGua.qigua.substr(5,1);

        }
        vm.setCurrent1= function (param) {
            vm.guaTopicQiGua.qigua1 = param
        }
        vm.setCurrent2= function (param) {
            vm.guaTopicQiGua.qigua2 = param
        }
        vm.setCurrent3= function (param) {
            vm.guaTopicQiGua.qigua3 = param
        }
        vm.setCurrent4= function (param) {
            vm.guaTopicQiGua.qigua4 = param
        }
        vm.setCurrent5= function (param) {
            vm.guaTopicQiGua.qigua5 = param
        }
        vm.setCurrent6= function (param) {
            vm.guaTopicQiGua.qigua6 = param
        }
        Principal.identity().then(function (account) {
            vm.account = account;
        });


        if ($location.host() == "localhost") {
            vm.url = "https://ydd.baodanservice.com:8080"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }
        $scope.$on('$viewContentLoaded', function () {
            vm.save = save;
            var E, editor;
            E = window.wangEditor;
            editor = new E('#editor'); //id一定要一致
            editor.customConfig.menus = [
                'head',  // 标题
                'bold',  // 粗体
                'fontSize',  // 字号
                'fontName',  // 字体
                'italic',  // 斜体
                'underline',  // 下划线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'link',  // 插入链接
                'list',  // 列表
                'justify',  // 对齐方式
                'image',  // 插入图片
                'table',  // 表格
                'video',  // 插入视频
                'code',  // 插入代码
                'undo'  // 撤销
            ];
            //如果需要使用 base64 编码直接将图片插入到内容中，可参考一下示例配置
            editor.customConfig.uploadImgShowBase64 = false;
            editor.customConfig.uploadImgServer = vm.url + "/api/upload/";
            editor.customConfig.uploadFileName = 'file';
            // 将图片大小限制为 10M
            editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024;
            //获取内容的方式
            editor.customConfig.uploadImgHooks = {
                //before: function (xhr, editor, files) {
                //    // 图片上传之前触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
                //
                //    // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
                //    // return {
                //    //     prevent: true,
                //    //     msg: '放弃上传'
                //    // }
                //},
                //success: function (xhr, editor, result) {
                //    // 图片上传并返回结果，图片插入成功之后触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //fail: function (xhr, editor, result) {
                //    // 图片上传并返回结果，但图片插入错误时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //error: function (xhr, editor) {
                //    // 图片上传出错时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},
                //timeout: function (xhr, editor) {
                //    // 图片上传超时时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},

                // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
                // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
                customInsert: function (insertImg, result, editor) {
                    // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
                    // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

                    // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
                    //console.log(result)
                    var url = result.fileUrl
                    //console.log(url)
                    insertImg(url)
                    // result 必须是一个 JSON 格式字符串！！！否则报错
                }
            }

            editor.create();
            editor.txt.html(vm.guaTopicQiGua.jieguaDetail);
            function save() {
                vm.isSaving = true;
                vm.guaTopicQiGua.jieguaDetail = editor.txt.html();
                vm.guaTopicQiGua.qigua = vm.guaTopicQiGua.qigua6 + "" +vm.guaTopicQiGua.qigua5 + "" +vm.guaTopicQiGua.qigua4 + "" +vm.guaTopicQiGua.qigua3 + "" +vm.guaTopicQiGua.qigua2 + "" +vm.guaTopicQiGua.qigua1;
                vm.guaTopicQiGua.qiguaName = qiGua(vm.guaTopicQiGua.qigua).qiguaName;

                //console.log(qiGua(vm.guaTopicQiGua.qigua).benGua)
                //console.log(qiGua(vm.guaTopicQiGua.qigua).(gua-fullName))
                //console.log(qiGua(vm.guaTopicQiGua.qigua).gua-fullName)
                vm.guaTopicQiGua.benguaName = qiGua(vm.guaTopicQiGua.qigua).benGua['gua-fullName'];
                vm.guaTopicQiGua.zhiguaName = qiGua(vm.guaTopicQiGua.qigua).zhiGua['gua-fullName'];
                //console.log(qiGua(vm.guaTopicQiGua.qigua))
                if (vm.guaTopicQiGua.id !== null) {
                    GuaTopicQiGua.update(vm.guaTopicQiGua, onSaveSuccess, onSaveError);
                } else {
                    GuaTopicQiGua.save(vm.guaTopicQiGua, onSaveSuccess, onSaveError);
                }
            }
        });

        function onSaveSuccess(result) {
            //$uibModalInstance.close(result);
            if (vm.guaTopicQiGua.id == null) {
                vm.isSaving = false;
                SweetAlert.swal({
                    title: "新增成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
            } else {
                vm.isSaving = false;
                SweetAlert.swal({
                    title: "编辑成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
            }
            $state.go('admin.guaTopicQiGua.guaTopicQiGua')
        }

        function onSaveError(error) {
            vm.isSaving = false;
            SweetAlert.swal({
                title: "编辑失败",
                text: error.data.title,
                type: "error",
                allowOutsideClick: true
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('TeacherExperienceDetailController', TeacherExperienceDetailController);

    TeacherExperienceDetailController.$inject = ['$scope', '$rootScope', '$stateParams','entity','previousState'];

    function TeacherExperienceDetailController($scope, $rootScope, $stateParams ,entity,previousState) {
        var vm = this;
        vm.teacherExperience = entity;
        vm.previousState = previousState.name;

        angular.element("#teacherExperience").html(vm.teacherExperience.content);
        var unsubscribe = $rootScope.$on('hseApp:courseUpdate', function(event, result) {
            vm.teacherExperience = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('TeacherExperienceDeleteController',TeacherExperienceDeleteController);

    TeacherExperienceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Student','SweetAlert'];

    function TeacherExperienceDeleteController($uibModalInstance, entity, Student,SweetAlert) {
        var vm = this;

        vm.teacherExperience = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Student.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    SweetAlert.swal({
                        title:"删除成功",
                        text:"",
                        type:"success",
                        allowOutsideClick: true
                    });
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('GuaTopicDelete', GuaTopicDelete);

    GuaTopicDelete.$inject = ['$resource', 'DateUtils'];

    function GuaTopicDelete($resource, DateUtils) {
        var resourceUrl = 'api/gua-topics/logic/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

/**
 * Created by lance.lu on 2018/7/4.
 */


(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.guaTopic.guaTopic', {
                url: '/guaTopic?page&sort&search',
                parent: 'admin.guaTopic',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaTopic/guaTopic/guaTopic.html',
                        controller: 'GuaTopicController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.guaTopic.guaTopic.edit', {
                url: '/guaTopic/{id}/edit?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.guaTopic',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaTopic/guaTopic/guaTopic-dialog.html',
                        controller: 'GuaTopicDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'GuaTopic', function ($stateParams, GuaTopic) {
                        return GuaTopic.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.guaTopic.guaTopic.new', {
                url: '/guaTopic/new?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.guaTopic',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaTopic/guaTopic/guaTopic-dialog.html',
                        controller: 'GuaTopicDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }], entity: function () {
                        return {
                            id: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            //.state('admin.guaTopic.guaTopic.edit', {
            //    url: '/{id}/edit',
            //    parent: 'admin.guaTopic.guaTopic',
            //    data: {
            //        authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
            //    },
            //    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
            //        $uibModal.open({
            //            templateUrl: 'app/admin/guaTopic/guaTopic/guaTopic-dialog.html',
            //            controller: 'guaTopicDialogController',
            //            controllerAs: 'vm',
            //            backdrop: 'static',
            //            size: 'lg',
            //            resolve: {
            //                entity: ['guaTopic', function (guaTopic) {
            //                    return guaTopic.get({id: $stateParams.id}).$promise;
            //                }]
            //            }
            //        }).result.then(function () {
            //            $state.go('admin.guaTopic.guaTopic', null, {reload: 'admin.guaTopic.guaTopic'});
            //        }, function () {
            //            $state.go('^');
            //        });
            //    }]
            //})

            .state('admin.guaTopic.guaTopic.detail', {
                url: '/guaTopic/detail/{id}',
                parent: 'admin.guaTopic',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaTopic/guaTopic/guaTopic-detail.html',
                        controller: 'GuaTopicDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'guaTopic', function ($stateParams, guaTopic) {
                        return guaTopic.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'guaTopic',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })

            .state('admin.guaTopic.guaTopic.delete', {
                url: '/{id}/delete',
                parent: 'admin.guaTopic.guaTopic',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/guaTopic/guaTopic/guaTopic-delete.html',
                        controller: 'GuaTopicDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['guaTopic', function (guaTopic) {
                                return guaTopic.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.guaTopic.guaTopic', null, {reload: 'admin.guaTopic.guaTopic'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }
})
();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('GuaTopic', GuaTopic);

    GuaTopic.$inject = ['$resource', 'DateUtils'];

    function GuaTopic($resource, DateUtils) {
        var resourceUrl = 'api/gua-topics/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('GuaTopicController', GuaTopicController);

    GuaTopicController.$inject = ['$state', '$resource', 'GuaTopic', 'GuaTopicDelete', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal', '$document', '$stateParams', 'SweetAlert'];

    function GuaTopicController($state, $resource, GuaTopic, GuaTopicDelete, ParseLinks, AlertService, paginationConstants, pagingParams, Principal, $document, $stateParams, SweetAlert) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.year = [];
        vm.condition = {};

        Principal.identity().then(function (account) {
            vm.account = account;
            loadAll();
        })

        function loadAll() {
            GuaTopic.query({
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function sort() {
            if (vm.predicate == 'id') {
                vm.predicate = 'effectiveDate';
            }
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.guaTopic = data;
            //for (var i = 0; i < vm.guaTopic.length; i++) {
            //    if (vm.guaTopic[i].status == "INFORCE") {
            //        vm.guaTopic[i].status = "已生效"
            //    }
            //    if (vm.guaTopic[i].status == "PENDEFFECTIVE") {
            //        vm.guaTopic[i].status = "待生效"
            //    }
            //    if (vm.guaTopic[i].status == "DELETED") {
            //        vm.guaTopic[i].status = "已删除"
            //    }
            //}
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        vm.search = function () {
            loadAll()
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.delete = function (id) {
            GuaTopicDelete.update({id: id}, {}, onSaveSuccess, onSaveError);
            function onSaveSuccess(result) {
                SweetAlert.swal({
                    title: "操作成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                });
                $state.reload()
            }

            function onSaveError(error) {
                SweetAlert.swal({
                    title: "操作失败",
                    text: error.data.title,
                    type: "error",
                    allowOutsideClick: true
                })
            }
        }

        vm.newDate = new Date();
        vm.newyear = vm.newDate.getFullYear();
        //console.log(vm.newyear)
        for (var i = 0; vm.newyear - i >= 2018; i++) {
            vm.year.push(vm.newyear - i);
        }


        vm.search = function () {
            if (vm.condition.month == 0) {
                vm.fromTime = vm.condition.year + '-01-01';
                vm.toTime = vm.condition.year + '-12-31';
            } else if (vm.condition.month == 12) {
                vm.fromTime = vm.condition.year + '-' + vm.condition.month + '-01';
                vm.toTime = (parseInt(vm.condition.year) + 1) + '-01-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else if (vm.condition.month == 10 || vm.condition.month == 11) {
                vm.fromTime = vm.condition.year + '-' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else if (vm.condition.month == 9) {
                vm.fromTime = vm.condition.year + '-0' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else {
                vm.fromTime = vm.condition.year + '-0' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-0' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            }
            //vm.fromTime = new Date(vm.fromTime);
            //vm.toTime = new Date(vm.toTime);
            console.log(vm.fromTime + '-' + vm.toTime);
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('GuaTopicDialogController', GuaTopicDialogController);

    GuaTopicDialogController.$inject = ['$timeout', '$scope', 'Principal', '$stateParams', 'entity', 'GuaTopic', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', 'SweetAlert', '$location', '$state','$document','GuaTopicSearchService'];

    function GuaTopicDialogController($timeout, $scope, Principal, $stateParams, entity, GuaTopic, FileUploader, $localStorage, $sessionStorage, $resource, SweetAlert, $location, $state,$document,GuaTopicSearchService) {
        var vm = this;
        vm.clear = clear;
        var searchParams = {};
        vm.guaTopic = entity;
        vm.datePickerOpenStatus = {};
        vm.condition = {};
        vm.openCalendar = openCalendar;
        var dateNow = new Date();
        dateNow.toLocaleDateString();
        vm.account = null;
        Principal.identity().then(function (account) {
            vm.account = account;
            vm.newDate = new Date();
            if(!vm.guaTopic.id){
            vm.guaTopic.setDate = new Date();
            }
            if(vm.guaTopic.id){
                vm.condition.value = [vm.guaTopic.guaTopicQiGuaDTO]
            }

        });

        //
        //$timeout(function () {
        //    angular.element('.form-group:eq(0)>input').focus();
        //});

        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        if ($location.host() == "localhost") {
            vm.url = "https://ydd.baodanservice.com:8080"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }
        vm.uploaderImg = new FileUploader({
            url: vm.url + "/api/upload/",
            headers: {
                "Authorization": 'Bearer ' + token
            }
        });

        vm.uploaderImg.onProgressAll = function (progress) {
            vm.uploadProgress = progress;
        };

        vm.uploaderImg.onSuccessItem = function (item, response, status, headers) {
            vm.guaTopic.topicCover = response.fileUrl;
            console.log(response.fileUrl);
            console.log(response);
        };

        vm.uploadImg = function () {
            vm.uploaderImg.uploadAll();
        };

        vm.clearImg = function () {
            vm.guaTopic.topicCover = "";
        };

        vm.showImgDialog = function () {
            angular.element("#browse-img").click();
        };

        $scope.$on('$viewContentLoaded', function () {
            vm.save = save;
            var E, editor;
            E = window.wangEditor;
            editor = new E('#editor'); //id一定要一致
            editor.customConfig.menus = [
                'head',  // 标题
                'bold',  // 粗体
                'fontSize',  // 字号
                'fontName',  // 字体
                'italic',  // 斜体
                'underline',  // 下划线
                'foreColor',  // 文字颜色
                'backColor',  // 背景颜色
                'link',  // 插入链接
                'list',  // 列表
                'justify',  // 对齐方式
                'image',  // 插入图片
                'table',  // 表格
                'video',  // 插入视频
                'code',  // 插入代码
                'undo'  // 撤销
            ];
            //如果需要使用 base64 编码直接将图片插入到内容中，可参考一下示例配置
            editor.customConfig.uploadImgShowBase64 = false;
            editor.customConfig.uploadImgServer = vm.url + "/api/upload/";
            editor.customConfig.uploadFileName = 'file';
            // 将图片大小限制为 10M
            editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024;
            //获取内容的方式
            editor.customConfig.uploadImgHooks = {
                //before: function (xhr, editor, files) {
                //    // 图片上传之前触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件
                //
                //    // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
                //    // return {
                //    //     prevent: true,
                //    //     msg: '放弃上传'
                //    // }
                //},
                //success: function (xhr, editor, result) {
                //    // 图片上传并返回结果，图片插入成功之后触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //fail: function (xhr, editor, result) {
                //    // 图片上传并返回结果，但图片插入错误时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
                //},
                //error: function (xhr, editor) {
                //    // 图片上传出错时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},
                //timeout: function (xhr, editor) {
                //    // 图片上传超时时触发
                //    // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
                //},

                // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
                // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
                customInsert: function (insertImg, result, editor) {
                    // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
                    // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

                    // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
                    //console.log(result)
                    var url = result.fileUrl
                    //console.log(url)
                    insertImg(url)
                    // result 必须是一个 JSON 格式字符串！！！否则报错
                }
            }

            editor.create();
            editor.txt.html(vm.guaTopic.guaTopicDetail);
            function save(){
                vm.guaTopic.guaTopicDetail = editor.txt.html();
                if(!vm.guaTopic.id){
                    if (vm.guaTopic.effectiveDate){
                        vm.guaTopic.effectiveDate = fromTime(vm.guaTopic.effectiveDate)
                    }
                    GuaTopic.save(vm.guaTopic, onSaveSuccess, onSaveError);
                }else {
                    if (vm.guaTopic.effectiveDate){
                        vm.guaTopic.effectiveDate = fromTime(vm.guaTopic.effectiveDate)
                    }
                    GuaTopic.update(vm.guaTopic, onSaveSuccess, onSaveError);
                }
            }
        });



        function onSaveSuccess(result) {
            //$uibModalInstance.close(result);
            if (vm.guaTopic.id == null) {
                SweetAlert.swal({
                    title: "新增成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
            } else {
                SweetAlert.swal({
                    title: "编辑成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
            }
            $state.go('admin.guaTopic.guaTopic')
        }

        function onSaveError(error) {
                SweetAlert.swal({
                    title: "编辑失败",
                    text: error.data.title,
                    type: "error",
                    allowOutsideClick: true
                })
        }

        function clear() {
            $state.go('admin.guaTopic.guaTopic')
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        vm.selectGuaTopic = function () {
            var module = $state.current.data.module;
            var parent;
            if (module === 'front') {
                parent = angular.element($document[0].getElementById('front-content'));
            } else {
                parent = angular.element($document[0].getElementById('page-wrapper'));
            }
            // var parent = angular.element($document[0].getElementById( 'editForm'));
            GuaTopicSearchService.open(parent, searchParams, function (result) {
                vm.condition.value = [];
                vm.condition.value.push(result);
                console.log(result);
                vm.guaTopic.qiguaId = vm.condition.value[0].id;
            });
        };

        vm.getDate = function(){
            console.log(vm.guaTopic.effectiveDate)
        }


        var fromTime = function (date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('TeacherExperienceDetailController', TeacherExperienceDetailController);

    TeacherExperienceDetailController.$inject = ['$scope', '$rootScope', '$stateParams','entity','previousState'];

    function TeacherExperienceDetailController($scope, $rootScope, $stateParams ,entity,previousState) {
        var vm = this;
        vm.teacherExperience = entity;
        vm.previousState = previousState.name;

        angular.element("#teacherExperience").html(vm.teacherExperience.content);
        var unsubscribe = $rootScope.$on('hseApp:courseUpdate', function(event, result) {
            vm.teacherExperience = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('TeacherExperienceDeleteController',TeacherExperienceDeleteController);

    TeacherExperienceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Student','SweetAlert'];

    function TeacherExperienceDeleteController($uibModalInstance, entity, Student,SweetAlert) {
        var vm = this;

        vm.teacherExperience = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Student.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    SweetAlert.swal({
                        title:"删除成功",
                        text:"",
                        type:"success",
                        allowOutsideClick: true
                    });
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('ShareImage', ShareImage);

    ShareImage.$inject = ['$resource', 'DateUtils'];

    function ShareImage($resource, DateUtils) {
        var resourceUrl = 'api/wx/share-image/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

/**
 * Created by lance.lu on 2018/7/4.
 */


(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.guaCalendar.guaCalendar', {
                url: '/guaCalendar?page&sort&search',
                parent: 'admin.guaCalendar',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaCalendar/guaCalendar/guaCalendar.html',
                        controller: 'GuaCalendarController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.guaCalendar.guaCalendar.edit', {
                url: '/guaCalendar/{id}/edit?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.guaCalendar',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaCalendar/guaCalendar/guaCalendar-dialog.html',
                        controller: 'GuaCalendarDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'GuaCalendar', function ($stateParams, GuaCalendar) {
                        return GuaCalendar.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.guaCalendar.guaCalendar.new', {
                url: '/guaCalendar/new?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.guaCalendar',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaCalendar/guaCalendar/guaCalendar-dialog.html',
                        controller: 'GuaCalendarDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }], entity: function () {
                        return {
                            id: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            //.state('admin.guaCalendar.guaCalendar.edit', {
            //    url: '/{id}/edit',
            //    parent: 'admin.guaCalendar.guaCalendar',
            //    data: {
            //        authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
            //    },
            //    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
            //        $uibModal.open({
            //            templateUrl: 'app/admin/guaCalendar/guaCalendar/guaCalendar-dialog.html',
            //            controller: 'guaCalendarDialogController',
            //            controllerAs: 'vm',
            //            backdrop: 'static',
            //            size: 'lg',
            //            resolve: {
            //                entity: ['guaCalendar', function (guaCalendar) {
            //                    return guaCalendar.get({id: $stateParams.id}).$promise;
            //                }]
            //            }
            //        }).result.then(function () {
            //            $state.go('admin.guaCalendar.guaCalendar', null, {reload: 'admin.guaCalendar.guaCalendar'});
            //        }, function () {
            //            $state.go('^');
            //        });
            //    }]
            //})

            .state('admin.guaCalendar.guaCalendar.detail', {
                url: '/guaCalendar/detail/{id}',
                parent: 'admin.guaCalendar',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaCalendar/guaCalendar/guaCalendar-detail.html',
                        controller: 'GuaCalendarDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'guaCalendar', function ($stateParams, guaCalendar) {
                        return guaCalendar.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'guaCalendar',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })

            .state('admin.guaCalendar.guaCalendar.delete', {
                url: '/{id}/delete',
                parent: 'admin.guaCalendar.guaCalendar',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/guaCalendar/guaCalendar/guaCalendar-delete.html',
                        controller: 'GuaCalendarDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['guaCalendar', function (guaCalendar) {
                                return guaCalendar.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.guaCalendar.guaCalendar', null, {reload: 'admin.guaCalendar.guaCalendar'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }
})
();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('GuaCalendar', GuaCalendar);

    GuaCalendar.$inject = ['$resource', 'DateUtils'];

    function GuaCalendar($resource, DateUtils) {
        var resourceUrl = 'api/gua-calendars/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('GuaCalendarController', GuaCalendarController);

    GuaCalendarController.$inject = ['$state', '$resource', 'GuaCalendar', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal', '$document', '$stateParams','SweetAlert','ShareImage'];

    function GuaCalendarController($state, $resource, GuaCalendar, ParseLinks, AlertService, paginationConstants, pagingParams, Principal, $document, $stateParams,SweetAlert,ShareImage) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.year = [];
        vm.condition = {};

        Principal.identity().then(function (account) {
            vm.condition.userFullName = $stateParams.userFullName;
            vm.condition.title = $stateParams.title;
            vm.condition.startRecordDate = $stateParams.startRecordDate;
            vm.condition.endRecordDate = $stateParams.endRecordDate;
            vm.account = account;
            vm.account.login = account.login;
            vm.organizationId = vm.account.orgId;
            vm.authorities = account.authorities;
            if (vm.authorities.indexOf("ROLE_TEACHER") > -1) {
                vm.ROLE_TEACHER = true
            }
            if (vm.authorities.indexOf("ROLE_ADMIN") > -1) {
                vm.ROLE_ADMIN = true
            }
            if (vm.authorities.indexOf("ROLE_PLACE_ADMIN") > -1) {
                vm.ROLE_PLACE_ADMIN = true
            }
            if (vm.authorities.indexOf("ROLE_CONSULTANT") > -1) {
                vm.ROLE_CONSULTANT = true
            }
            loadAll();
        });

        function loadAll() {
            GuaCalendar.query({
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                source:'pc',
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function sort() {
            if (vm.predicate == 'id') {
                vm.predicate = 'effectiveDate';
            }
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.guaCalendar = data;
            vm.page = pagingParams.page;
            //for(var i=0;i<vm.guaCalendar.length;i++){
            //    if(vm.guaCalendar[i].status == "INFORCE"){
            //        vm.guaCalendar[i].status = "已生效"
            //    }else if(vm.guaCalendar[i].status == "PENDEFFECTIVE"){
            //        vm.guaCalendar[i].status = "待生效"
            //    }else if(vm.guaCalendar[i].status == "DELETED"){
            //        vm.guaCalendar[i].status = "已删除"
            //    }
            //}
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        vm.search = function () {
            loadAll()
        };

        vm.download = function (id) {
            ShareImage.get({id:id}, onSaveSuccess, onSaveError);
        };

        function onSaveSuccess(result) {
            window.location = result.fileUrl
        }

        function onSaveError(error) {
            SweetAlert.swal({
                title: "下载失败",
                text: error.data.title,
                type: "error",
                allowOutsideClick: true
            })
        }
        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                fromTime: vm.fromTime,
                toTime: vm.toTime,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.newDate = new Date();
        vm.newyear = vm.newDate.getFullYear();
        //console.log(vm.newyear)
        for (var i = 0; vm.newyear - i >= 2018; i++) {
            vm.year.push(vm.newyear - i);
        }

        vm.search = function () {
            if (vm.condition.month == 0) {
                vm.fromTime = vm.condition.year + '-01-01';
                vm.toTime = vm.condition.year + '-12-31';
            } else if (vm.condition.month == 12) {
                vm.fromTime = vm.condition.year + '-' + vm.condition.month + '-01';
                vm.toTime = (parseInt(vm.condition.year) + 1) + '-01-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else if (vm.condition.month == 10 || vm.condition.month == 11) {
                vm.fromTime = vm.condition.year + '-' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else if (vm.condition.month == 9) {
                vm.fromTime = vm.condition.year + '-0' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            } else {
                vm.fromTime = vm.condition.year + '-0' + vm.condition.month + '-01';
                vm.toTime = vm.condition.year + '-0' + (parseInt(vm.condition.month) + 1) + '-01';
                //console.log(vm.fromTime + '-' + vm.toTime)
            }
            //vm.fromTime = new Date(vm.fromTime);
            //vm.toTime = new Date(vm.toTime);
            console.log(vm.fromTime + '-' + vm.toTime);
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('GuaCalendarDialogController', GuaCalendarDialogController);

    GuaCalendarDialogController.$inject = ['$timeout', '$scope', 'Principal', '$stateParams', 'entity', 'GuaCalendar', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', 'SweetAlert', '$location', '$state'];

    function GuaCalendarDialogController($timeout, $scope, Principal, $stateParams, entity, GuaCalendar, FileUploader, $localStorage, $sessionStorage, $resource, SweetAlert, $location, $state) {
        var vm = this;
        vm.clear = clear;
        vm.guaCalendar = entity;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        var dateNow = new Date();
        dateNow.toLocaleDateString();
        vm.account = null;
        Principal.identity().then(function (account) {
            vm.account = account;
            vm.newDate = new Date();
            if(!vm.guaCalendar.id){
            vm.guaCalendar.setDate = new Date();
            }

        });

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        if ($location.host() == "localhost") {
            vm.url = "http://192.168.0.100:8080"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }
        vm.uploaderImg = new FileUploader({
            url: vm.url + "/api/upload/",
            headers: {
                "Authorization": 'Bearer ' + token
            }
        });

        vm.uploaderImg.onProgressAll = function (progress) {
            vm.uploadProgress = progress;
        };

        vm.uploaderImg.onSuccessItem = function (item, response, status, headers) {
            vm.guaCalendar.contentPic = response.fileUrl;
        };

        vm.uploadImg = function () {
            vm.uploaderImg.uploadAll();
            console.info(vm.uploaderImg.data)
        };

        vm.clearImg = function () {
            vm.guaCalendar.contentPic = "";
        };

        vm.showImgDialog = function () {
            angular.element("#browse-img").click();
        };

        vm.save = function(){

            if(!vm.guaCalendar.id){
                if (vm.guaCalendar.effectiveDate){
                    vm.guaCalendar.effectiveDate = fromTime(vm.guaCalendar.effectiveDate)
                }
                GuaCalendar.save(vm.guaCalendar, onSaveSuccess, onSaveError);
            }else {
                if (vm.guaCalendar.effectiveDate){
                    vm.guaCalendar.effectiveDate = fromTime(vm.guaCalendar.effectiveDate)
                }
                GuaCalendar.update(vm.guaCalendar, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            //$uibModalInstance.close(result);
            if (vm.guaCalendar.id == null) {
                SweetAlert.swal({
                    title: "新增成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
            } else {
                SweetAlert.swal({
                    title: "编辑成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
            }
            history.back()
        }

        function onSaveError(error) {
                SweetAlert.swal({
                    title: "编辑失败",
                    text: error.data.title,
                    type: "error",
                    allowOutsideClick: true
                })
        }

        function clear() {
            $state.go('admin.guaCalendar.guaCalendar')
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        vm.getDate = function(){
            console.log(vm.guaCalendar.effectiveDate)
        }


        var fromTime = function (date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('TeacherExperienceDetailController', TeacherExperienceDetailController);

    TeacherExperienceDetailController.$inject = ['$scope', '$rootScope', '$stateParams','entity','previousState'];

    function TeacherExperienceDetailController($scope, $rootScope, $stateParams ,entity,previousState) {
        var vm = this;
        vm.teacherExperience = entity;
        vm.previousState = previousState.name;

        angular.element("#teacherExperience").html(vm.teacherExperience.content);
        var unsubscribe = $rootScope.$on('hseApp:courseUpdate', function(event, result) {
            vm.teacherExperience = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('TeacherExperienceDeleteController',TeacherExperienceDeleteController);

    TeacherExperienceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Student','SweetAlert'];

    function TeacherExperienceDeleteController($uibModalInstance, entity, Student,SweetAlert) {
        var vm = this;

        vm.teacherExperience = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Student.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    SweetAlert.swal({
                        title:"删除成功",
                        text:"",
                        type:"success",
                        allowOutsideClick: true
                    });
                });
        }
    }
})();

/**
 * Created by lance.lu on 2018/7/4.
 */


(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.guaCalendar.effectivePeriod', {
                url: '/effectivePeriod?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.guaCalendar',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/guaCalendar/effectivePeriod/effectivePeriod-dialog.html',
                        controller: 'EffectivePeriodDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'EffectivePeriod', function ($stateParams, EffectivePeriod) {
                        return EffectivePeriod.query().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})
();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('EffectivePeriod', EffectivePeriod);

    EffectivePeriod.$inject = ['$resource', 'DateUtils'];

    function EffectivePeriod($resource, DateUtils) {
        var resourceUrl = 'api/calendar-effective-periods/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('EffectivePeriodDialogController', EffectivePeriodDialogController);

    EffectivePeriodDialogController.$inject = ['$timeout', '$scope', 'Principal', '$stateParams', 'entity', 'EffectivePeriod', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', 'SweetAlert', '$location', '$state'];

    function EffectivePeriodDialogController($timeout, $scope, Principal, $stateParams, entity, EffectivePeriod, FileUploader, $localStorage, $sessionStorage, $resource, SweetAlert, $location, $state) {
        var vm = this;
        vm.guaCalendar = entity[0];
        console.log(entity[0])
        vm.account = null;
        vm.change = false;
        Principal.identity().then(function (account) {
            vm.account = account;
        });

        vm.changed = function () {
            vm.change = true;
        }

        vm.save = function () {
            vm.change = false;
            EffectivePeriod.update(vm.guaCalendar, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            SweetAlert.swal({
                title: "修改成功",
                text: "",
                type: "success",
                allowOutsideClick: true
            })
        }

        function onSaveError(error) {
            SweetAlert.swal({
                title: "修改失败",
                text: error.data.title,
                type: "error",
                allowOutsideClick: true
            })
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('Shelves', Shelves);

    Shelves.$inject = ['$resource', 'DateUtils'];

    function Shelves($resource, DateUtils) {
        var resourceUrl = 'api/products/pull-of-shelves/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('RedeemCode', RedeemCode);

    RedeemCode.$inject = ['$resource', 'DateUtils'];

    function RedeemCode($resource, DateUtils) {
        var resourceUrl = '/api/pro-redeem-code-libs/product/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('RedeemCodeController', RedeemCodeController);

    RedeemCodeController.$inject = ['$state', '$resource', 'RedeemCode', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal', '$document', '$stateParams', 'SweetAlert', 'Shelves'];

    function RedeemCodeController($state, $resource, RedeemCode, ParseLinks, AlertService, paginationConstants, pagingParams, Principal, $document, $stateParams, SweetAlert, Shelves) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.year = [];
        vm.condition = {};
        vm.productId = $stateParams.productId;

        Principal.identity().then(function (account) {
            vm.account = account;
            loadAll();
        });

        function loadAll() {
            RedeemCode.query({
                productId:vm.productId,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.redeemCode = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        vm.search = function () {
            loadAll()
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                productId:vm.productId,
                page: vm.page,
                search: vm.currentSearch
            });
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.delete = function (id) {
            Shelves.update({id: id},{}, onSuccess, onError);
            function onSuccess(result) {
                SweetAlert.swal({
                    title: "操作成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                });
                $state.reload()
            }

            function onError(error) {
                SweetAlert.swal({
                    title: "操作失败",
                    text: error.data.title,
                    type: "error",
                    allowOutsideClick: true
                })
            }
        }

        vm.newDate = new Date();
        vm.newyear = vm.newDate.getFullYear();
        //console.log(vm.newyear)
        for (var i = 0; vm.newyear - i >= 2018; i++) {
            vm.year.push(vm.newyear - i);
        }
    }
})();

/**
 * Created by troy.zhao on 2017/8/19.
 */
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('RedeemCodeUploadController', RedeemCodeUploadController);

    RedeemCodeUploadController.$inject = ['$state', '$timeout', '$resource', 'Principal', '$stateParams', '$uibModalInstance', 'FileUploader', '$localStorage', '$sessionStorage', 'SweetAlert', '$location', '$http'];

    function RedeemCodeUploadController($state, $timeout, $resource, Principal, $stateParams, $uibModalInstance, FileUploader, $localStorage, $sessionStorage, SweetAlert, $location, $http) {
        var vm = this;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.role = $state.current.data.role;
        vm.poolId = "";
        var dateNow = new Date();
        dateNow.toLocaleDateString();
        vm.account = null;
        vm.productId = $stateParams.productId;
        Principal.identity().then(function (account) {
            vm.account = account;
            loadAll();
        });
        function loadAll() {
            //if(vm.role!=="selfstudy_admin"){
            //    TestPool.query({size:9999},function (data) {
            //        vm.testPool = data;
            //    });
            //}else{
            //    var TestPoolByModuleId = $resource("api/modules/2/test-pools");
            //    TestPoolByModuleId.query({size: 9999}, function (data) {
            //        vm.testPool = data;
            //    });
            //}

        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


        function save() {
            $uibModalInstance.close();
            vm.isSaving = false;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.url = "";
        if ($location.host() == "localhost") {
            vm.url = "https://ydd.baodanservice.com:8080"
        } else {
            vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        }

        var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

        vm.uploader = new FileUploader({
            url: vm.url + '/api/pro-redeem-code-libs/'+vm.productId+'/import',
            headers: {
                "Authorization": 'Bearer ' + token
            }
        });

        vm.poolChange = function () {
            vm.uploader.url = vm.url + '/api/group-policy/import';
            var items = vm.uploader.getNotUploadedItems();
            for (var i = 0; i < items.length; i++) {
                items[i].url = vm.uploader.url;
            }
        };
        vm.uploader.onProgressAll = function (progress) {
            vm.uploadProgress = progress;
        };

        vm.uploader.onSuccessItem = function (item, response, status, headers) {
            vm.count = response;
            SweetAlert.swal({title: "成功上传" + response + "个兑换码", type: 'success'});
            $uibModalInstance.close();
            vm.isSaving = false;
        };
        vm.uploader.onErrorItem = function (item, response, status, headers) {
            SweetAlert.swal({title: response.title, type: 'error',allowOutsideClick:true});
            vm.uploader.clearQueue();
            vm.isSaving = false;
        };

        vm.uploadFile = function () {
            vm.isSaving = true;
            SweetAlert.swal({
                    title: "提交中，请勿刷新页面",
                    type: "info",
                    inputOptions: vm.uploader.uploadAll(),
                    showConfirmButton: false
                })
        };

        vm.clearFile = function () {
            vm.poolId = "";
        };

        vm.showFileDialog = function () {
            angular.element("#browse-file").click();
        };


        vm.downloadFile = function () {
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            $http({
                url: '/api/group-policy/export-template',
                method: "GET",//接口方法
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': 'Bearer ' + token
                    // 'Origin':'https://localhost:9090/'
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                var blob = new Blob([data], {type: "application/vnd.ms-excel"});
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = "兑换码导入模板.xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
            }).error(function (data, status, headers, config) {
            });

        }
        function getFileName(o) {
            var pos = o.lastIndexOf("\\");
            return o.substring(pos + 1);
        }

        function getExtName(o) {
            var pos = o.lastIndexOf(".");
            if (pos == -1) {
                return "";
            } else {
                return o.substring(pos + 1);
            }
        }

        function getPrefixName(o) {
            var pos = o.lastIndexOf(".");
            if (pos == -1) {
                return o;
            } else {
                return o.substring(0, pos);
            }
        }

    }
})();

/**
 * Created by lance.lu on 2018/7/4.
 */


(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.checkInRewardAndProduct.product', {
                url: '/product?page&sort&search',
                parent: 'admin.checkInRewardAndProduct',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/checkInRewardAndProduct/product/product.html',
                        controller: 'ProductController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.checkInRewardAndProduct.product.edit', {
                url: '/product/{id}/edit?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.checkInRewardAndProduct',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/checkInRewardAndProduct/product/product-dialog.html',
                        controller: 'ProductDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'Product', function ($stateParams, Product) {
                        return Product.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.checkInRewardAndProduct.product.new', {
                url: '/product/new?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.checkInRewardAndProduct',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/checkInRewardAndProduct/product/product-dialog.html',
                        controller: 'ProductDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }], entity: function () {
                        return {
                            id: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            //.state('admin.product.product.edit', {
            //    url: '/{id}/edit',
            //    parent: 'admin.product.product',
            //    data: {
            //        authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
            //    },
            //    onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
            //        $uibModal.open({
            //            templateUrl: 'app/admin/product/product/product-dialog.html',
            //            controller: 'productDialogController',
            //            controllerAs: 'vm',
            //            backdrop: 'static',
            //            size: 'lg',
            //            resolve: {
            //                entity: ['product', function (product) {
            //                    return product.get({id: $stateParams.id}).$promise;
            //                }]
            //            }
            //        }).result.then(function () {
            //            $state.go('admin.product.product', null, {reload: 'admin.product.product'});
            //        }, function () {
            //            $state.go('^');
            //        });
            //    }]
            //})

            .state('admin.checkInRewardAndProduct.product.detail', {
                url: '/product/detail/{id}',
                parent: 'admin.checkInRewardAndProduct',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/checkInRewardAndProduct/product/product-detail.html',
                        controller: 'productDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Product', function ($stateParams, Product) {
                        return Product.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'product',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })

            .state('admin.checkInRewardAndProduct.product.delete', {
                url: '/{id}/delete',
                parent: 'admin.checkInRewardAndProduct.product',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/checkInRewardAndProduct/product/product-delete.html',
                        controller: 'productDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Product', function (Product) {
                                return Product.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.checkInRewardAndProduct.product', null, {reload: 'admin.checkInRewardAndProduct.product'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('admin.checkInRewardAndProduct.redeemCode', {
                url: '/redeemCode/{productId}?page&sort&search',
                parent: 'admin.checkInRewardAndProduct',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/checkInRewardAndProduct/product/redeemCode.html',
                        controller: 'RedeemCodeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'redeemDate,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('admin.checkInRewardAndProduct.redeemCode.upload', {
                parent: 'admin.checkInRewardAndProduct.redeemCode',
                url: '/upload/{id}',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_SERVICE']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/checkInRewardAndProduct/product/redeemCode-upload.html',
                        controller: 'RedeemCodeUploadController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function () {
                        $state.go('admin.checkInRewardAndProduct.redeemCode', null, {reload: 'admin.checkInRewardAndProduct.redeemCode'});
                    }, function () {
                        $state.go('admin.checkInRewardAndProduct.redeemCode');
                    });
                }]
            })
    }
})
();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('Product', Product);

    Product.$inject = ['$resource', 'DateUtils'];

    function Product($resource, DateUtils) {
        var resourceUrl = 'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                        data.expirationDate = DateUtils.convertDateTimeFromServer(data.expirationDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$state', '$resource', 'Product', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal', '$document', '$stateParams', 'SweetAlert', 'Shelves'];

    function ProductController($state, $resource, Product, ParseLinks, AlertService, paginationConstants, pagingParams, Principal, $document, $stateParams, SweetAlert, Shelves) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.year = [];
        vm.condition = {};

        Principal.identity().then(function (account) {
            vm.account = account;
            loadAll();
        })

        function loadAll() {
            Product.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
            if (vm.predicate !== 'status') {
                result.push('status');
            }
            return result;
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.product = data;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        vm.search = function () {
            loadAll()
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                userFullName: vm.condition.userFullName,
                title: vm.condition.title,
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc'),
                search: vm.currentSearch
            });
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.delete = function (id) {
            Shelves.update({id: id},{}, onSuccess, onError);
            function onSuccess(result) {
                SweetAlert.swal({
                    title: "操作成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                });
                $state.reload()
            }

            function onError(error) {
                SweetAlert.swal({
                    title: "操作失败",
                    text: error.data.title,
                    type: "error",
                    allowOutsideClick: true
                })
            }
        }

        vm.newDate = new Date();
        vm.newyear = vm.newDate.getFullYear();
        //console.log(vm.newyear)
        for (var i = 0; vm.newyear - i >= 2018; i++) {
            vm.year.push(vm.newyear - i);
        }
        vm.month = [1]
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', 'Principal', '$stateParams', 'entity', 'Product', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', 'SweetAlert', '$location', '$state', '$document', 'GuaTopicSearchService'];

    function ProductDialogController($timeout, $scope, Principal, $stateParams, entity, Product, FileUploader, $localStorage, $sessionStorage, $resource, SweetAlert, $location, $state, $document, GuaTopicSearchService) {
        var vm = this;
        vm.clear = clear;
        var searchParams = {};
        vm.product = entity;
        console.log(vm.product)
        vm.datePickerOpenStatus = {};
        vm.condition = {};
        vm.openCalendar = openCalendar;
        var dateNow = new Date();
        dateNow.toLocaleDateString();
        vm.account = null;
        Principal.identity().then(function (account) {
            vm.account = account;
            vm.newDate = new Date();
            if (!vm.product.id) {
                vm.product.setDate = new Date();
            }

            if (vm.product.id) {
                vm.requiredPoints = vm.product.productPrice.requiredPoints;
                vm.productStock = vm.product.stocks[0].quantity;
            }
        });

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });
        //
        //var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        //if ($location.host() == "localhost") {
        //    vm.url = "https://ydd.baodanservice.com:8080"
        //} else {
        //    vm.url = $location.protocol() + '://' + $location.host() + ( ($location.port() == 80 || $location.port() == 443) ? '' : (':' + $location.port()) )
        //}
        //vm.uploaderImg = new FileUploader({
        //    url: vm.url + "/api/upload/",
        //    headers: {
        //        "Authorization": 'Bearer ' + token
        //    }
        //});
        //
        //vm.uploaderImg.onProgressAll = function (progress) {
        //    vm.uploadProgress = progress;
        //};
        //
        //vm.uploaderImg.onSuccessItem = function (item, response, status, headers) {
        //    vm.product.topicCover = response.fileUrl;
        //};
        //
        //vm.uploadImg = function () {
        //    vm.uploaderImg.uploadAll();
        //};
        //
        //vm.clearImg = function () {
        //    vm.product.topicCover = "";
        //};
        //
        //vm.showImgDialog = function () {
        //    angular.element("#browse-img").click();
        //};

        vm.save = function () {
            if (!vm.product.id) {

                vm.product.stocks = [];
                vm.product.productPrice = [];
                vm.product.stocks.push({"quantity": vm.productStock});
                vm.product.productPrice = {"requiredPoints": vm.requiredPoints};
                //if (vm.product.effectiveDate){
                //    vm.product.effectiveDate = fromTime(vm.product.effectiveDate)
                //}
                Product.save(vm.product, onSaveSuccess, onSaveError);
            } else {
                //if (vm.product.effectiveDate){
                //    vm.product.effectiveDate = fromTime(vm.product.effectiveDate)
                //}
                vm.product.productPrice.requiredPoints = vm.requiredPoints;
                vm.product.stocks[0].quantity = vm.productStock;
                Product.update(vm.product, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            //$uibModalInstance.close(result);
            //
            //console.log(result.id)
            if (vm.product.id == null) {
                SweetAlert.swal({
                    title: "新增成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
                $state.go('admin.checkInRewardAndProduct.redeemCode.upload',{productId:result.id})
            } else {
                SweetAlert.swal({
                    title: "编辑成功",
                    text: "",
                    type: "success",
                    allowOutsideClick: true
                })
                $state.go('admin.checkInRewardAndProduct.product')
            }
        }

        function onSaveError(error) {
            SweetAlert.swal({
                title: "编辑失败",
                text: error.data.title,
                type: "error",
                allowOutsideClick: true
            })
        }

        function clear() {
            $state.go('admin.checkInRewardAndProduct.product')
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        var fromTime = function (date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('TeacherExperienceDetailController', TeacherExperienceDetailController);

    TeacherExperienceDetailController.$inject = ['$scope', '$rootScope', '$stateParams','entity','previousState'];

    function TeacherExperienceDetailController($scope, $rootScope, $stateParams ,entity,previousState) {
        var vm = this;
        vm.teacherExperience = entity;
        vm.previousState = previousState.name;

        angular.element("#teacherExperience").html(vm.teacherExperience.content);
        var unsubscribe = $rootScope.$on('hseApp:courseUpdate', function(event, result) {
            vm.teacherExperience = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('TeacherExperienceDeleteController',TeacherExperienceDeleteController);

    TeacherExperienceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Student','SweetAlert'];

    function TeacherExperienceDeleteController($uibModalInstance, entity, Student,SweetAlert) {
        var vm = this;

        vm.teacherExperience = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Student.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                    SweetAlert.swal({
                        title:"删除成功",
                        text:"",
                        type:"success",
                        allowOutsideClick: true
                    });
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('Message', Message);

    Message.$inject = ['$resource', 'DateUtils'];

    function Message($resource, DateUtils) {
        var resourceUrl = 'api/messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

/**
 * Created by lance.lu on 2018/7/4.
 */


(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.checkInRewardAndProduct.checkInReward', {
                url: '/checkInReward?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.checkInRewardAndProduct',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/checkInRewardAndProduct/checkInReward/checkInReward-dialog.html',
                        controller: 'CheckInRewardDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'CheckInReward', function ($stateParams, CheckInReward) {
                        return CheckInReward.query().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})
();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('CheckInReward', CheckInReward);

    CheckInReward.$inject = ['$resource', 'DateUtils'];

    function CheckInReward($resource, DateUtils) {
        var resourceUrl = 'api/check-in-rewards/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT', isArray: true},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('CheckInRewardDialogController', CheckInRewardDialogController);

    CheckInRewardDialogController.$inject = ['$timeout', '$scope', 'Principal', '$stateParams', 'entity', 'CheckInReward', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', 'SweetAlert', '$location', '$state', 'Product', 'ProductSearchService', '$document', 'Message'];

    function CheckInRewardDialogController($timeout, $scope, Principal, $stateParams, entity, CheckInReward, FileUploader, $localStorage, $sessionStorage, $resource, SweetAlert, $location, $state, Product, ProductSearchService, $document, Message) {
        var vm = this;
        vm.checkInReward = entity;
        //vm.checkInRewardType = vm.checkInReward

        vm.condition = {};
        vm.condition.value = [];
        var searchParams = {};
        vm.account = null;
        vm.change = false;
        vm.count = 7;
        vm.parts = [];
        Principal.identity().then(function (account) {
            vm.account = account;
            for (var i = 0; i < vm.count; i++) {
                vm.parts.push({number: i, pool: null})
            }

        });

        Product.query({
            status: 'INFORCE',
            size: 999
        }, onSuccess, onError);

        function onSuccess(data, headers) {
            vm.product = data;
            for (var i = 0; i < vm.count; i++) {
                //    if (vm.checkInReward[i].rewardType == "PRODUCT") {
                for (var j = 0; j < vm.product.length; j++) {
                    if (vm.product[j].id == vm.checkInReward[i].productId) {
                        vm.condition.value[i] = [vm.product[j]]
                    }
                }
                //    }
            }
        }

        function onError(error) {
        }

        Message.query({
            param: 'checkIn',
            size: 999
        }, productSuccess, productError);

        function productSuccess(data, headers) {
            vm.message = data[0];
            console.log(vm.message)
        }

        function productError(error) {

        }

        vm.changed = function () {
            vm.change = true;
        }

        vm.selectProduct = function (number) {
            var module = $state.current.data.module;
            var parent;
            if (module === 'front') {
                parent = angular.element($document[0].getElementById('front-content'));
            } else {
                parent = angular.element($document[0].getElementById('page-wrapper'));
            }
            // var parent = angular.element($document[0].getElementById( 'editForm'));
            ProductSearchService.open(parent, searchParams, function (result) {
                vm.condition.value[number] = [];
                vm.condition.value[number].push(result);
                vm.checkInReward[number].productId = vm.condition.value[number][0].id;
                vm.checkInReward[number].productName = vm.condition.value[number][0].productName;
            });
        };

        vm.save = function () {
            //if (!vm.checkInReward) {
            //    console.log(vm.checkInReward);
            //    //CheckInReward.save(vm.checkInReward, onSaveSuccess, onSaveError);
            //} else {
            //
            //    console.log(vm.checkInReward);
            //
            //}
            vm.checkInReward[0].checkInDate = 1;
            vm.checkInReward[1].checkInDate = 2;
            vm.checkInReward[2].checkInDate = 3;
            vm.checkInReward[3].checkInDate = 4;
            vm.checkInReward[4].checkInDate = 5;
            vm.checkInReward[5].checkInDate = 6;
            vm.checkInReward[6].checkInDate = 7;
            vm.checkInReward[7].checkInDate = 8;
            for (var i = 0; i < vm.count; i++) {
                if (vm.checkInReward[i].rewardType == "BONUSPOINT") {
                    vm.checkInReward[i].productUrl = ""
                }
                if (vm.checkInReward[i].rewardType == "PRODUCT") {
                    vm.checkInReward[i].bonusPoint = ""
                }
            }
            CheckInReward.update(vm.checkInReward, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            Message.update(vm.message, messageSuccess, messageSaveError);
        }

        function onSaveError(error) {
            SweetAlert.swal({
                title: "修改失败",
                text: error.data.title,
                type: "error",
                allowOutsideClick: true
            })
        }

        function messageSuccess(result) {
            SweetAlert.swal({
                title: "修改成功",
                text: "",
                type: "success",
                allowOutsideClick: true
            })
        }

        function messageSaveError(error) {
            SweetAlert.swal({
                title: "修改失败",
                text: error.data.title,
                type: "error",
                allowOutsideClick: true
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account.requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants'];

    function RequestResetController ($timeout, Auth, errorConstants) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_NOT_FOUND_TYPE) {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account.finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                content: {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('Teacher', Teacher);

    Teacher.$inject = ['$resource', 'DateUtils'];

    function Teacher ($resource, DateUtils) {
        var resourceUrl =  'api/teachers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('OrgTeacher', OrgTeacher);

    OrgTeacher.$inject = ['$resource', 'DateUtils'];

    function OrgTeacher ($resource, DateUtils) {
        var resourceUrl =  'api/org-teachers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('ChangeCourseClasses', ChangeCourseClasses);

    ChangeCourseClasses.$inject = ['$resource', 'DateUtils'];

    function ChangeCourseClasses ($resource, DateUtils) {
        var resourceUrl =  'api/course-classes/set-teacher';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('Student', Student);

    Student.$inject = ['$resource', 'DateUtils'];

    function Student($resource, DateUtils) {
        var resourceUrl = 'api/students/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertDateTimeFromServer(data.birthDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('PaymentStatistics', PaymentStatistics);

    PaymentStatistics.$inject = ['$resource', 'DateUtils'];

    function PaymentStatistics ($resource, DateUtils) {
        var resourceUrl =  'api/course-payment-orders/stats/org-order-fee/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        //data.signupStartTime = DateUtils.convertLocalDateFromServer(data.signupStartTime);
                        data.signupStartTime = DateUtils.convertDateTimeFromServer(data.signupStartTime);
                        data.signupEndTime = DateUtils.convertDateTimeFromServer(data.signupEndTime);
                        data.courseStartTime = DateUtils.convertDateTimeFromServer(data.courseStartTime);
                        data.courseEndTime = DateUtils.convertDateTimeFromServer(data.courseEndTime);
                        //console.log(data)
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('PaymentAllStatistics', PaymentAllStatistics);

    PaymentAllStatistics.$inject = ['$resource', 'DateUtils'];

    function PaymentAllStatistics ($resource, DateUtils) {
        var resourceUrl =  'api/course-payment-orders/stats/order-fee/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        //data.signupStartTime = DateUtils.convertLocalDateFromServer(data.signupStartTime);
                        data.signupStartTime = DateUtils.convertDateTimeFromServer(data.signupStartTime);
                        data.signupEndTime = DateUtils.convertDateTimeFromServer(data.signupEndTime);
                        data.courseStartTime = DateUtils.convertDateTimeFromServer(data.courseStartTime);
                        data.courseEndTime = DateUtils.convertDateTimeFromServer(data.courseEndTime);
                        //console.log(data)
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('Organization', Organization);

    Organization.$inject = ['$resource', 'DateUtils'];

    function Organization ($resource, DateUtils) {
        var resourceUrl =  'api/organizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('OrganizationStations', OrganizationStations);

    OrganizationStations.$inject = ['$resource', 'DateUtils'];

    function OrganizationStations ($resource, DateUtils) {
        var resourceUrl =  'api/organizations/stations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('FileUrl', FileUrl);

    FileUrl.$inject = ['$location', 'DateUtils'];

    function FileUrl ($location, DateUtils) {
        var host = "";
        var port = "";
        if(!$location.host()){
            host = "https://idemo.ienwu.com";
            if(!$location.port()){
                port = "8080"
            }
            return {
                "getLocation": host+":"+port+"/"
            };
        }else{
            return {
                "getLocation": ""
            };
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('CourseStudentLessons', CourseStudentLessons);

    CourseStudentLessons.$inject = ['$resource', 'DateUtils'];

    function CourseStudentLessons($resource, DateUtils) {
        var resourceUrl = 'api/course-student-lessons/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertDateTimeFromServer(data.birthDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('CourseStudent', CourseStudent);

    CourseStudent.$inject = ['$resource', 'DateUtils'];

    function CourseStudent($resource, DateUtils) {
        var resourceUrl = 'api/course-students/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertDateTimeFromServer(data.birthDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('Course', Course);

    Course.$inject = ['$resource', 'DateUtils'];

    function Course ($resource, DateUtils) {
        var resourceUrl =  'api/courses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        //data.signupStartTime = DateUtils.convertLocalDateFromServer(data.signupStartTime);
                        data.signupStartTime = DateUtils.convertDateTimeFromServer(data.signupStartTime);
                        data.signupEndTime = DateUtils.convertDateTimeFromServer(data.signupEndTime);
                        data.courseStartTime = DateUtils.convertDateTimeFromServer(data.courseStartTime);
                        data.courseEndTime = DateUtils.convertDateTimeFromServer(data.courseEndTime);
                        //console.log(data)
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.reviewedDate = DateUtils.convertLocalDateToServer(copy.reviewedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            console.log('prepare to login');
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
              console.log('login succeeded');
              console.log('headers are ' + JSON.stringify(headers));
                var bearerToken = headers('Authorization');
              console.log('bearerToken in header is ' + bearerToken);
              console.log('angular.isDefined(bearerToken) is ' + angular.isDefined(bearerToken));
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
              console.log('$localStorage is ' + $localStorage.authenticationToken) + ' before saving';
                $localStorage.authenticationToken = jwt;
              console.log('$localStorage is ' + $localStorage.authenticationToken) + ' after saving';
            } else {
              console.log('$sessionStorage is ' + $sessionStorage.authenticationToken) + ' before saving';
                $sessionStorage.authenticationToken = jwt;
              console.log('$sessionStorage is ' + $sessionStorage.authenticationToken) + ' after saving';
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/customers/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

/**
 * Created by troy.zhao on 2017/7/13.
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('SubordinatesUser', SubordinatesUser);

    SubordinatesUser.$inject = ['$resource'];

    function SubordinatesUser ($resource) {
        var service = $resource('api/users/:superiorId/subordinates', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('PlaceAdminUser', PlaceAdminUser);

    PlaceAdminUser.$inject = ['$resource'];

    function PlaceAdminUser ($resource) {
        var service = $resource('api/place-admin/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('OrganizationUser', OrganizationUser);

    OrganizationUser.$inject = ['$resource'];

    function OrganizationUser ($resource) {
        var service = $resource('api/organizations/:orgId/users/', {}, {
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('app.core')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('app.core')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('app.core')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('RegisterDialogController', RegisterDialogController);


    RegisterDialogController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants', 'entity', 'User', '$uibModalInstance'];

    function RegisterDialogController ($translate, $timeout, Auth, LoginService, errorConstants, entity, User, $uibModalInstance) {
        var vm = this;
        vm.user = entity;
        vm.cancel = cancel;
        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.guessFullName = guessFullName;

        function guessFullName(){
            //make sure this function is only for new user, with no value in fullName
            if(vm.user.id !==null || vm.user.fullName !== null){
                return;
            }
            if(vm.user.langKey === 'zh-cn' || vm.user.langKey ===null ){
                vm.user.fullName = vm.user.lastName.toString() + vm.user.firstName.toString();
            }
            else {
                vm.user.fullName = vm.user.firstName.toString() + ' ' + vm.user.lastName.toString();
            }
        }

        function register () {
            vm.isSaving = true;
            vm.user.gender = vm.user.gender === '' ? null : vm.user.gender;
            vm.user.authorities = ["ROLE_SELFSTUDY_STUDENT"];
            if(vm.user.langKey === null){
                vm.user.langKey = "zh-cn";
            }
            Auth.createAccount(vm.user).then(function () {
                vm.isSaving = false;
                alert("注册成功，请到邮箱中激活账号");
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                    vm.errorUserExists = 'ERROR';
                    vm.registerFail = "userexists"
                } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                    vm.errorEmailExists = 'ERROR';
                    vm.registerFail = "emailexists"
                } else {
                    vm.error = 'ERROR';
                    vm.registerFail = "fail"
                }
            });
        }

        function cancel () {
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

/**
 * Created by Benjamin Qin on 7/6/2017.
 */
(function() {
  'use strict';

  angular
    .module('app.core')
    .factory('PasswordService', PasswordService);

  PasswordService.$inject = ['$uibModal'];

  function PasswordService ($uibModal) {
    var service = {
      open: open
    };

    var modalInstance = null;
    var resetModal = function () {
      modalInstance = null;
    };

    return service;

    function open () {
      if (modalInstance !== null) return;
      modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/password/password.html',
        controller: 'PasswordController',
        controllerAs: 'vm',
        resolve: {
          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart('password');
            return $translate.refresh();
          }]
        }
      });
      modalInstance.result.then(
        resetModal,
        resetModal
      );
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$uibModalInstance'];

    function PasswordController (Auth, Principal, $uibModalInstance) {
        var vm = this;

        vm.clear = clear;
        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.isSaving = true;
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.isSaving = false;
                    vm.error = null;
                    vm.success = 'OK';
                    clear();
                }).catch(function () {
                    vm.isSaving = false;
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', '$uibModal'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance, $uibModal) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: false
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                  $state.go('front.homepage');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $uibModal.open({
                animation: true,
                templateUrl: 'app/components/register/register.html',
                controller: 'RegisterDialogController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null, login: null, firstName: null, lastName: null, fullName: null, email: null,
                            userType: 'EMPLOYEE', gender: 'MALE', nationality: '汉',orgId: null, deptId: null,
                            activated: true, langKey: null, createdBy: null, createdDate: null,
                            lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                            resetKey: null, authorities: null
                        };
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('register');
                        $translatePartialLoader.addPart('gender');
                        return $translate.refresh();
                    }]
                }
            });
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'hy': 'Հայերեն',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'th': 'ไทย',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'zh-cn',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('app.core')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('app.core')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('hseApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('hseApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('hseApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

// (function() {
//     'use strict';
//
//     angular
//         .module('app.core')
//         .factory('changeUrlInterceptor', changeUrlInterceptor);
//
//     changeUrlInterceptor.$inject = ['$q', 'AlertService', '$location'];
//
//     function changeUrlInterceptor ($q, AlertService, $location) {
//         return {
//             // optional method
//             'request': function(config) {
//                 var originUrl = "localhost:3000/";
//
//                 var resultUrl = "https://ydd.baodanservice.com:8080/";
//                 if($location.host().indexOf('ydd.baodanservice.com')>=0){
//                     resultUrl = "https://ydd.baodanservice.com:8080/"
//                 }else{
//                     resultUrl = "https://ydd.baodanservice.com:8080/"
//                 }
//                 // config.url.replace(originUrl, resultUrl);
//                 if(config.url.indexOf("api/")>=0){
//                     config.url = resultUrl+config.url;
//                 }
//                 return config;
//             }
//         };
//     }
// })();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if ( angular.isDefined(toState.data.pageTitle) && toState.data.pageTitle !== null) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('zh-cn');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "zh-cn"');
                $cookies.putObject(name, 'zh-cn');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // $httpProvider.interceptors.push('changeUrlInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admin.oss-service.oss-service', {
            parent: 'admin.oss-service',
            url: '/oss-service?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            // views: {
            //     'content': {
                    templateUrl: 'app/admin/oss-service/oss-service.html',
                    controller: 'OssLogController',
                    controllerAs: 'vm',
                    params: {
                        page: {
                            value: '1',
                            squash: true
                        },
                        sort: {
                            value: 'id,asc',
                            squash: true
                        }
                    },
            //     }
            // },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    // $translatePartialLoader.addPart('OssFile');
                    // $translatePartialLoader.addPart('Bucket');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        // .state('oss-service-detail', {
        //     parent: 'admin.oss-service',
        //     url: '/oss-log/{id}',
        //     data: {
        //         authorities: ['ROLE_ADMIN'],
        //         pageTitle: 'easyDayApp.ossLog.detail.title'
        //     },
        //     views: {
        //         'content@': {
        //             templateUrl: 'app/admin/oss-service/oss-service-detail.html',
        //             controller: 'OssLogDetailController',
        //             controllerAs: 'vm'
        //         }
        //     },
        //     resolve: {
        //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
        //             $translatePartialLoader.addPart('ossLog');
        //             return $translate.refresh();
        //         }],
        //         entity: ['$stateParams', 'OssLog', function($stateParams, OssLog) {
        //             return OssLog.get({id : $stateParams.id}).$promise;
        //         }],
        //         previousState: ["$state", function ($state) {
        //             var currentStateData = {
        //                 name: $state.current.name || 'oss-log',
        //                 params: $state.params,
        //                 url: $state.href($state.current.name, $state.params)
        //             };
        //             return currentStateData;
        //         }]
        //     }
        // })
        .state('admin.oss-service.oss-service-detail.edit', {
            parent: 'admin.oss-service',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/oss-service/oss-service-dialog.html',
                    controller: 'OssLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OssLog', function(OssLog) {
                            return OssLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('admin.oss-service.oss-service.new', {
            parent: 'admin.oss-service.oss-service',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/oss-service/oss-service-dialog.html',
                    controller: 'OssLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                operationType: null,
                                bucketName: null,
                                fileName: null,
                                fileType: null,
                                fileSize: null,
                                createdDate: null,
                                createdBy: null,
                                lastModifiedDate: null,
                                lastModifiedBy: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('admin.oss-service.oss-service', null, { reload: 'admin.oss-service.oss-service' });
                }, function() {
                    $state.go('admin.oss-service.oss-service');
                });
            }]
        })
        .state('admin.oss-service.oss-service.edit', {
            parent: 'admin.oss-service.oss-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/oss-service/oss-service-dialog.html',
                    controller: 'OssLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OssLog', function(OssLog) {
                            return OssLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admin.oss-service.oss-service', null, { reload: 'admin.oss-service.oss-service' });
                }, function() {
                    $state.go('admin.oss-service.oss-service');
                });
            }]
        })
        .state('admin.oss-service.oss-service.delete', {
            parent: 'admin.oss-service.oss-service',
            url: '/delete?bucketName&fileName',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/oss-service/oss-service-delete-dialog.html',
                    controller: 'OssLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md'
                    // resolve: {
                    //     entity: ['OssLog', function(OssLog) {
                    //         return OssLog.get({id : $stateParams.id}).$promise;
                    //     }]
                    // }
                }).result.then(function() {
                    $state.go('admin.oss-service.oss-service', null, { reload: 'admin.oss-service.oss-service' });
                }, function() {
                    $state.go('admin.oss-service.oss-service');
                });
            }]
        })
        .state('admin.oss-service.oss-service.upload', {
                parent: 'admin.oss-service.oss-service',
                url: '/oss-service/upload/{bucketName}',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/oss-service/oss-service-upload/oss-service-upload.html',
                        controller: 'OssServiceUpload',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    operationType: null,
                                    bucketName: null,
                                    fileName: null,
                                    fileType: null,
                                    fileSize: null,
                                    createdDate: null,
                                    createdBy: null,
                                    lastModifiedDate: null,
                                    lastModifiedBy: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function() {
                        $state.go('admin.oss-service.oss-service', null, { reload: 'admin.oss-service.oss-service' });
                    }, function() {
                        $state.go('admin.oss-service.oss-service');
                    });
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('OssFile', OssFile);

    OssFile.$inject = ['$resource', 'DateUtils'];

    function OssFile ($resource, DateUtils) {
        // var resourceUrl =  'api/oss-logs/:id';
        var resourceUrl =  'api/oss/bucket-files?bucketName=:bucketName';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
        });
    }
})();

(function() {
        'use strict';

        angular
            .module('app.admin')
            .controller('OssLogController', OssLogController);

        OssLogController.$inject = ['$state', '$resource', 'OssFile', 'Bucket', 'SweetAlert', 'pagingParams', 'paginationConstants'];

        function OssLogController($state, $resource, OssFile, Bucket, SweetAlert, pagingParams, paginationConstants) {

        var vm = this;

        vm.copyUrl = copyUrl;
        vm.transition = transition;
        vm.ossBuckets = [];
        vm.bucketName='ytt-audio';
        vm.ossFiles = [];
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        getBuckets();
        loadAll();

        function loadAll() {
            OssFile.query({
                    bucketName: vm.bucketName,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage
                },onSuccess, onError)
        }

        function getBuckets() {
            Bucket.query(function (result) {
                vm.ossBuckets = result;
            })
        }

        function copyUrl(ossFileUrl) {
            SweetAlert.swal({
                title: "",
                text: ossFileUrl,
                buttons : [false, '复制'],
            })
        }

        function onSuccess(data, headers) {
            vm.ossFiles = data;
            vm.searchQuery = null;
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.search = function () {
            pagingParams.page = 1;
            console.log(vm.bucketName)
            loadAll();
        };

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('OssLogDialogController', OssLogDialogController);

    OssLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OssFile'];

    function OssLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OssFile) {
        var vm = this;

        vm.ossLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ossLog.id !== null) {
                OssFile.update(vm.ossLog, onSaveSuccess, onSaveError);
            } else {
                OssFile.save(vm.ossLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('easyDayApp:ossLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('OssLogDetailController', OssLogDetailController);

    OssLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OssFile'];

    function OssLogDetailController($scope, $rootScope, $stateParams, previousState, entity, OssFile) {
        var vm = this;

        vm.ossLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('easyDayApp:ossLogUpdate', function(event, result) {
            vm.ossLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .controller('OssLogDeleteController',OssLogDeleteController);

    OssLogDeleteController.$inject = ['$uibModalInstance', '$stateParams', '$resource', 'SweetAlert' ];

    function OssLogDeleteController($uibModalInstance, $stateParams, $resource, SweetAlert) {
        var vm = this;

        vm.bucketName = $stateParams.bucketName;
        vm.fileName = $stateParams.fileName;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        var deleteOSSFile = $resource("/api/oss/bucket-files", {}, {
            'delete': { method: 'DELETE' }
        });

        function confirmDelete () {
            console.info(vm.fileName)
            console.info(vm.bucketName)
            deleteOSSFile.delete({
                fileName : vm.fileName,
                bucketName: vm.bucketName
            },function () {
                $uibModalInstance.close(true);
                SweetAlert.swal({
                    title:"删除成功",
                    text:"",
                    type:"success",
                    allowOutsideClick: true
                });
            })
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('Bucket', Bucket);

    Bucket.$inject = ['$resource', 'DateUtils'];

    function Bucket ($resource, DateUtils) {
        var resourceUrl =  '/api/oss/buckets';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('Messages', Messages);

    Messages.$inject = ['$resource', 'DateUtils'];

    function Messages($resource, DateUtils) {
        var resourceUrl = 'api/messages';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.effectiveDate = DateUtils.convertDateTimeFromServer(data.effectiveDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('MessagesDialogController', MessagesDialogController);

    MessagesDialogController.$inject = ['$timeout', '$scope', 'Principal', '$stateParams', 'entity', 'Message', 'FileUploader', '$localStorage', '$sessionStorage', '$resource', 'SweetAlert', '$location', '$state'];

    function MessagesDialogController($timeout, $scope, Principal, $stateParams, entity, Message, FileUploader, $localStorage, $sessionStorage, $resource, SweetAlert, $location, $state) {
        var vm = this;
        vm.messages = entity;
        vm.account = null;
        vm.change = {};
        Principal.identity().then(function (account) {
            vm.account = account;
        });


        vm.save = function (id,page,content,title) {
            vm.change.id = id;
            vm.change.page = page;
            vm.change.content = content;
            vm.change.title = title;
            Message.update(vm.change, onSaveSuccess, onSaveError);
        };

        function onSaveSuccess(result) {
            SweetAlert.swal({
                title: "修改成功",
                text: "",
                type: "success",
                allowOutsideClick: true
            })
        }

        function onSaveError(error) {
            SweetAlert.swal({
                title: "修改失败",
                text: error.data.title,
                type: "error",
                allowOutsideClick: true
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        // .state('message', {
        //     parent: 'admin.message',
        //     url: '/message?page&sort&search',
        //     data: {
        //         authorities: ['ROLE_USER'],
        //     },
        //     views: {
        //         'content@': {
        //             templateUrl: 'app/entities/message/messages.html',
        //             controller: 'MessageController',
        //             controllerAs: 'vm'
        //         }
        //     },
        //     params: {
        //         page: {
        //             value: '1',
        //             squash: true
        //         },
        //         sort: {
        //             value: 'id,asc',
        //             squash: true
        //         },
        //         search: null
        //     },
        //     resolve: {
        //         pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
        //             return {
        //                 page: PaginationUtil.parsePage($stateParams.page),
        //                 sort: $stateParams.sort,
        //                 predicate: PaginationUtil.parsePredicate($stateParams.sort),
        //                 ascending: PaginationUtil.parseAscending($stateParams.sort),
        //                 search: $stateParams.search
        //             };
        //         }],
        //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
        //             $translatePartialLoader.addPart('message');
        //             $translatePartialLoader.addPart('global');
        //             return $translate.refresh();
        //         }]
        //     }
        // })
        // .state('message-detail', {
        //     parent: 'admin.message',
        //     url: '/message/{id}',
        //     data: {
        //         authorities: ['ROLE_USER'],
        //     },
        //     views: {
        //         'content@': {
        //             templateUrl: 'app/entities/message/message-detail.html',
        //             controller: 'MessageDetailController',
        //             controllerAs: 'vm'
        //         }
        //     },
        //     resolve: {
        //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
        //             $translatePartialLoader.addPart('message');
        //             return $translate.refresh();
        //         }],
        //         entity: ['$stateParams', 'Message', function($stateParams, Message) {
        //             return Message.get({id : $stateParams.id}).$promise;
        //         }],
        //         previousState: ["$state", function ($state) {
        //             var currentStateData = {
        //                 name: $state.current.name || 'message',
        //                 params: $state.params,
        //                 url: $state.href($state.current.name, $state.params)
        //             };
        //             return currentStateData;
        //         }]
        //     }
        // })
        // .state('message-detail.edit', {
        //     parent: 'admin.message',
        //     url: '/detail/edit',
        //     data: {
        //         authorities: ['ROLE_USER']
        //     },
        //     onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        //         $uibModal.open({
        //             templateUrl: 'app/entities/message/message-dialog.html',
        //             controller: 'MessageDialogController',
        //             controllerAs: 'vm',
        //             backdrop: 'static',
        //             size: 'lg',
        //             resolve: {
        //                 entity: ['Message', function(Message) {
        //                     return Message.get({id : $stateParams.id}).$promise;
        //                 }]
        //             }
        //         }).result.then(function() {
        //             $state.go('^', {}, { reload: false });
        //         }, function() {
        //             $state.go('^');
        //         });
        //     }]
        // })
        // .state('message.new', {
        //     parent: 'admin.message',
        //     url: '/new',
        //     data: {
        //         authorities: ['ROLE_USER']
        //     },
        //     onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        //         $uibModal.open({
        //             templateUrl: 'app/entities/message/message-dialog.html',
        //             controller: 'MessageDialogController',
        //             controllerAs: 'vm',
        //             backdrop: 'static',
        //             size: 'lg',
        //             resolve: {
        //                 entity: function () {
        //                     return {
        //                         title: null,
        //                         content: null,
        //                         createdBy: null,
        //                         createdDate: null,
        //                         lastModifiedBy: null,
        //                         lastModifiedDate: null,
        //                         id: null
        //                     };
        //                 }
        //             }
        //         }).result.then(function() {
        //             $state.go('message', null, { reload: 'message' });
        //         }, function() {
        //             $state.go('message');
        //         });
        //     }]
        // })
        // .state('message.edit', {
        //     parent: 'admin.message',
        //     url: '/{id}/edit',
        //     data: {
        //         authorities: ['ROLE_USER']
        //     },
        //     onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        //         $uibModal.open({
        //             templateUrl: 'app/entities/message/message-dialog.html',
        //             controller: 'MessageDialogController',
        //             controllerAs: 'vm',
        //             backdrop: 'static',
        //             size: 'lg',
        //             resolve: {
        //                 entity: ['Message', function(Message) {
        //                     return Message.get({id : $stateParams.id}).$promise;
        //                 }]
        //             }
        //         }).result.then(function() {
        //             $state.go('message', null, { reload: 'message' });
        //         }, function() {
        //             $state.go('^');
        //         });
        //     }]
        // })
        // .state('message.delete', {
        //     parent: 'admin.message',
        //     url: '/{id}/delete',
        //     data: {
        //         authorities: ['ROLE_USER']
        //     },
        //     onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        //         $uibModal.open({
        //             templateUrl: 'app/entities/message/message-delete-dialog.html',
        //             controller: 'MessageDeleteController',
        //             controllerAs: 'vm',
        //             size: 'md',
        //             resolve: {
        //                 entity: ['Message', function(Message) {
        //                     return Message.get({id : $stateParams.id}).$promise;
        //                 }]
        //             }
        //         }).result.then(function() {
        //             $state.go('message', null, { reload: 'message' });
        //         }, function() {
        //             $state.go('^');
        //         });
        //     }]
        // })
        .state('admin.message.messages', {
                url: '/message/messages?page&sort&search&teacherFullName&startRecordDate&endRecordDate',
                parent: 'admin.message',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN','ROLE_TEACHER','ROLE_CONSULTANT']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/messages/messages-dialog.html',
                        controller: 'MessagesDialogController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    entity: ['$stateParams', 'Messages', function ($stateParams, Messages) {
                        return Messages.query().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('app.core')
        .factory('OrderApplicant', OrderApplicant);

    OrderApplicant.$inject = ['$resource'];

    function OrderApplicant ($resource) {
        var resourceUrl =  'api/course-payment-orders/stats/order-applicant/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admin.dashboard.dashboard', {
                url: '/dashboard?page&sort',
                parent: 'admin.dashboard',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_CONSULTANT', 'ROLE_TEACHER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/admin/dashboard/dashboard/dashboard.html',
                        controller: 'DashboardController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('course');
                        $translatePartialLoader.addPart('resouceVisibility');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})
();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['$state', '$resource', 'OrderApplicant', 'ParseLinks', 'AlertService', 'paginationConstants', 'Principal', '$stateParams', 'CoursePaymentOrders', '$scope','PublicAnnouncement', '$filter'];

    function DashboardController($state, $resource, OrderApplicant, ParseLinks, AlertService, paginationConstants, Principal, $stateParams, CoursePaymentOrders, $scope,PublicAnnouncement, $filter) {

        var vm = this;
        var dateNow = new Date();
        var localFromTime = $filter('date')(dateNow,'yyyy-MM-dd')
        var localToTime = $filter('date')(new Date(dateNow.getTime() + 24*60*60*1000),'yyyy-MM-dd');
        var defaultFromTime = $filter('date')(new Date(dateNow.getTime() - 24*60*60*1000),'yyyy-MM-dd')+"T16:00:00.000Z";
        var defaultToTime = $filter('date')(dateNow,'yyyy-MM-dd')+"T15:59:59.999Z";
        Principal.identity().then(function (account) {
            vm.authorities = account.authorities;
            vm.account =account;
            vm.organizationId = account.orgId;
            if (vm.authorities.indexOf("ROLE_ADMIN") > -1) {
                vm.ROLE_ADMIN = true
            } else if (vm.authorities.indexOf("ROLE_PLACE_ADMIN") > -1) {
                vm.ROLE_PLACE_ADMIN = true
            } else if (vm.authorities.indexOf("ROLE_CONSULTANT") > -1) {
                vm.ROLE_CONSULTANT = true
            } else if (vm.authorities.indexOf("ROLE_TEACHER") > -1) {
                vm.ROLE_TEACHER = true
            }
            loadCoursePaymentOrders();
            loadPublicAnnouncements();
            loadRegisterQuantity();
            loadLoginQuantity();
            loadCheckInQuantity();
        });
        function loadCoursePaymentOrders() {
            if (!vm.ROLE_ADMIN) {
                CoursePaymentOrders.query({organizationId:vm.account.orgId}, onSuccess, onError);
            } else {
                CoursePaymentOrders.query({}, onSuccess, onError);
            }

            function onSuccess(data, headers) {
                vm.coursePaymentOrders = data;
            }

            function onError(error) {
            }
        }

        function loadRegisterQuantity() {
            var RegisterQuantity = $resource("/api/customer/reg-login-qty", {});
            RegisterQuantity.query({
                fromTime: defaultFromTime,
                toTime: defaultToTime,
                dateType: 'regDate',
                size: 9999
            },function (data) {
                console.log(data);
                vm.registerQty = data.length > 0?data.length : 0;
            });
        }

        function loadLoginQuantity() {
            var RegisterQuantity = $resource("/api/customer/reg-login-qty", {});
            RegisterQuantity.query({
                fromTime: defaultFromTime,
                toTime: defaultToTime,
                dateType: 'loginDate',
                size: 9999
            },function (data) {
                console.log(data);
                vm.loginQty = data.length > 0?data.length : 0;
            });
        }

        function loadCheckInQuantity() {
            var RegisterQuantity = $resource("/api/check-in/quantity", {});
            RegisterQuantity.query({
                fromTime: localFromTime,
                toTime: localToTime,
                size: 9999
            },function (data) {
                console.log(data);
                vm.checkInQty = data.length > 0?data.length : 0;
            });
        }


        function loadPublicAnnouncements() {

            PublicAnnouncement.query({
                size: 5,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = ['id' + ',' +'desc'];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.publicAnnouncements = data;
            }

            function onError(error) {
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .factory('CoursePaymentOrders', CoursePaymentOrders);

    CoursePaymentOrders.$inject = ['$resource', 'DateUtils'];

    function CoursePaymentOrders($resource, DateUtils) {
        var resourceUrl = 'api/course-payment-orders/stats/order-applicant/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.birthDate = DateUtils.convertDateTimeFromServer(data.birthDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },

            'save': {
                method: 'POST'
            },
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

/**
 * Created by Benjamin Qin on 7/6/2017.
 */
(function() {
  'use strict';

  angular
    .module('app.core')
    .factory('SettingsService', SettingsService);

  SettingsService.$inject = ['$uibModal'];

  function SettingsService ($uibModal) {
    var service = {
      open: open
    };

    var modalInstance = null;
    var resetModal = function () {
      modalInstance = null;
    };

    return service;

    function open () {
      if (modalInstance !== null) return;
      modalInstance = $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'app/account/settings/settings.html',
        controller: 'SettingsController',
        controllerAs: 'vm',
        resolve: {
          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart('global');
            $translatePartialLoader.addPart('settings');
            $translatePartialLoader.addPart('gender');
            $translatePartialLoader.addPart('userType');
            return $translate.refresh();
          }]
        }
      });
      modalInstance.result.then(
        resetModal,
        resetModal
      );
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', '$uibModalInstance'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate, $uibModalInstance) {
        var vm = this;

        vm.error = null;
        vm.clear = clear;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                fullName: account.fullName,
                userType: account.userType,
                gender: account.gender,
                nationality: account.nationality,
                idCardNumber: account.idCardNumber,
                telephone: account.telephone,
                mobilePhone: account.mobilePhone,
                employeeNumber: account.employeeNumber,
                jobTitle: account.jobTitle,
                superiorId: account.superiorId,
                orgId: account.orgId,
                orgName: account.orgName,
                deptId: account.deptId,
                deptName: account.deptName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function clear () {
          $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.isSaving = false;
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
              $uibModalInstance.close('保存成功！');
            }).catch(function() {
                vm.isSaving = false;
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('front.account.register', {
            url: '/register',
            views: {
                'content': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService', 'errorConstants'];

    function RegisterController ($translate, $timeout, Auth, LoginService, errorConstants) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('front.account.activate', {
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

/**
 * Created by troy.zhao on 2017/7/12.
 */

(function() {
    'use strict';
    angular.
        module('app.core')
        .service('UploadedFile',UploadedFile);
    UploadedFile.$inject = ['$resource', 'DateUtils'];

    function UploadedFile ($resource, DateUtils) {
        var resourceUrl =  'api/upload/files/:filename';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            }
        });
    }

})();

(function () {
    angular.module("app.core")
        .controller('LoginPageController', LoginPageController);

    function LoginPageController($rootScope, $state, $timeout, Auth, Principal) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.$state = $state;
        vm.skinConfig = '';
        var skin = "";
        var style = "";
        // localStorage.clear();
        getLocalSkin();

        function getLocalSkin() {
            skin = localStorage.skin;
            style = localStorage.style;
        }

        if (!skin) {
            skin = "skin-a";
            localStorage.skin = "skin-a"
        }
        vm.skinConfig = skin;
        if (style) {
            vm.skinConfig = "md-" + vm.skinConfig;
        }
        angular.element("body").removeClass("skin-1 skin-2 skin-3 skin-4");
        angular.element("body").addClass(skin);
        angular.element("body").addClass(style);
        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: false
            };
            vm.authenticationError = false;
            // $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;

                $state.go('admin.dashboard');



                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register() {
            // $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword() {
            // $uibModalInstance.dismiss('cancel');
            $state.go('account.requestReset');
        }
    }

    angular.module("app.core").directive("loginContainer", function ($window) {
        return {
            restrict: 'C',
            scope: {},
            link: function ($scope, element, attrs) {
                var windowHeight = $window.innerHeight;
                var boxHeight = angular.element("#login-container").innerHeight();
                var h = (windowHeight - boxHeight) * 0.4;
                var m = (windowHeight - boxHeight) * 0.6;
                m += 5;
                element.css('padding-top', h + 'px');
                element.css('padding-bottom', m + 'px');

            }
        }
    });

})();

/**
 * Created by Benjamin Qin on 5/23/2017.
 */
(function () {
  'use strict';

  angular.module('app.core')
    .controller('NavigationController', NavigationController);

  function NavigationController ($state, $resource, Auth, Principal, ProfileService, PasswordService, SettingsService, menus, $interval, $filter, $window, $scope, $rootScope, $uibModal) {
      var vm = this;
      vm.register = register;
      vm.haveLogin = false;
      vm.privateMessageNumber = 0;
      vm.publicMessageNumber = 0;
      vm.messageNumber = 0;
      vm.menuList = angular.isDefined($state.current.data.menuList) ? $state.current.data.menuList : menus;
      vm.userAuthorities = [];
      vm.displayAdmin = false;
      Principal.identity().then(function(account) {
          vm.account = account;
          var authArray = vm.account.authorities;
          vm.haveMpickStudent=false;
          for (var i = 0; i < vm.account.authorities.length; i++) {
             if(vm.account.authorities[i]=="ROLE_USER"){
                 vm.haveMpickStudent=true;
             }
          }
          vm.displayAdmin = isInArray(authArray,"ROLE_SELFSTUDY_ADMIN");
          function isInArray(arr,value){
              for(var i = 0; i < arr.length; i++){
                  if(value === arr[i]){
                      return true;
                  }
              }
              return false;
          }
      });
      //var privateMessage = $resource("/api/my-pm/private-messages/box/INBOX/read/false/count",{},{
      //    'count':{
      //        method:'GET'
      //    }
      //});
      //$scope.getMessage = function () {
      //    privateMessage.count(function (data) {
      //        // alert(JSON.stringify(data));
      //        vm.privateMessageNumber = data.count;
      //        vm.messageNumber = vm.privateMessageNumber + vm.publicMessageNumber;
      //    });
      //    var dateNow = new Date().getTime()-7*24*60*60*1000;
      //    dateNow = $filter('date')(dateNow,'yyyy-MM-dd')+"T00:00:00.000+08:00";
      //    var publicMessage = $resource("/api/modules/1/public-announcements/time-after/"+dateNow+"/count",{},{
      //        count:{method:'GET'}
      //    });
      //    publicMessage.count(function (data) {
      //        vm.publicMessageNumber = data.count;
      //        vm.messageNumber = vm.privateMessageNumber + vm.publicMessageNumber;
      //    });
      //};
      //$scope.getMessage();
      //function startGetMessage() {
      //    if($rootScope.isGettingMessage!==true){
      //        $scope.messageTimer = $interval($scope.getMessage,30000,500);
      //        $rootScope.isGettingMessage=true;
      //    }
      //
      //}
      //// $scope.cancel = function(){
      ////     $interval.cancel($scope.messageTimer);
      //// };
      //
      //startGetMessage();
      //
      vm.getMyMenu = function () {
          var roleString = getCookie("role");
          var myMenu = [];
          if(!roleString){
              for (var i = 0; i < vm.menuList.length; i++) {
                  if (angular.isUndefined(vm.menuList[i].authorities)) {
                      myMenu.push(vm.menuList[i]);
                  }
                  else if (angular.isDefined(vm.menuList[i].authorities) && Principal.hasAnyAuthority(vm.menuList[i].authorities)) {
                      myMenu.push(vm.menuList[i]);
                  }
              }
          }else{
              for (var i = 0; i < vm.menuList.length; i++) {
                  if (angular.isUndefined(vm.menuList[i].authorities)) {
                      myMenu.push(vm.menuList[i]);
                  }
                  else if (angular.isDefined(vm.menuList[i].authorities) && Principal.hasAnyAuthority(vm.menuList[i].authorities)) {
                      if(JSON.stringify(vm.menuList[i].authorities).indexOf(roleString)>0){
                          myMenu.push(vm.menuList[i]);
                      }
                  }
              }
          }
          myMenu[myMenu.length-1].isLast = true;
          return myMenu;
      };

      vm.hasAnyAuthority = hasAnyAuthority;

      function hasAnyAuthority(authorities) {
          return Principal.hasAnyAuthority(authorities);
      }

      vm.isAuthenticated = Principal.isAuthenticated;

      ProfileService.getProfileInfo().then(function (response) {
          vm.inProduction = response.inProduction;
          vm.swaggerEnabled = response.swaggerEnabled;
      });

      vm.editSettings = SettingsService.open;
      vm.changePassword = PasswordService.open;
      vm.logout = logout;
      vm.$state = $state;

      vm.userAccount = null;
      vm.success = null;

      /**
       * Store the "user account" in a separate variable, and not in the shared "account" variable.
       */
      var copyAccount = function (account) {
          return {
              activated: account.activated,
              email: account.email,
              firstName: account.firstName,
              langKey: account.langKey,
              lastName: account.lastName,
              login: account.login
          };
      };

      function getUserAccount() {
          Principal.identity().then(function (account) {
              if(account.id>=0){
                  vm.haveLogin = true;
              }
              vm.userAccount = copyAccount(account);
              vm.userDisplayName = (account.fullName === null || account.fullName === '') ? account.firstName : account.fullName;

              var userAuthorities = account.authorities;
              for(var i=0;i<userAuthorities.length;i++){
                  var array = {};
                  switch (userAuthorities[i]){
                      case"ROLE_ADMIN":
                          array.count1=1;
                          array.name = "系统管理员";
                          array.role = userAuthorities[i];
                          vm.userAuthorities.push(array);
                          break;
                      case"ROLE_PLACE_ADMIN":
                          array.count1=2;
                          array.name = "分部管理员";
                          array.role = userAuthorities[i];
                          vm.userAuthorities.push(array);
                          break;
                      case"ROLE_TEACHER":
                          array.count1=3;
                          array.name = "教师";
                          array.role = userAuthorities[i];
                          vm.userAuthorities.push(array);
                          break;
                      case"ROLE_CONSULTANT":
                          array.count1=4;
                          array.name = "咨询老师";
                          array.role = userAuthorities[i];
                          vm.userAuthorities.push(array);
                          break;

                  }

                  if(userAuthorities.indexOf("ROLE_ADMIN") > -1){

                      setCookie("role","ROLE_ADMIN");
                  }else if(userAuthorities.indexOf("ROLE_PLACE_ADMIN") > -1) {

                      setCookie("role", "ROLE_PLACE_ADMIN");
                  }else if(userAuthorities.indexOf("ROLE_TEACHER") > -1) {

                      setCookie("role", "ROLE_TEACHER");
                  }else if(userAuthorities.indexOf("ROLE_CONSULTANT") > -1) {

                      setCookie("role", "ROLE_CONSULTANT");
                  }


              }

              var currentRole = getCookie("role");
              //console.log(currentRole)
              //if(JSON.stringify(vm.userAuthorities).indexOf(currentRole)>0){
              //}else{
              //    setCookie("role",vm.userAuthorities[0].role);
              //}
          });
      }

      getUserAccount();

      function logout() {
          $(".no-skin-config").removeClass("default-bg");
          Auth.logout();
          $state.go('login');
      }

      vm.callFunction = function (cmd) {
          if (cmd) {
              switch (cmd) {
                  case 'changePassword':
                      PasswordService.open();
                      break;
                  case 'settings':
                      SettingsService.open();
                      break;
                  case 'logout':
                      vm.logout();
                      break;
                  default:
              }
          }
      };

      vm.gotoFrontSite = function () {
          $(".no-skin-config").removeClass("default-bg");
          if(Principal.hasAnyAuthority(['ROLE_USER']) && Principal.hasAnyAuthority(['ROLE_SELFSTUDY_STUDENT']) ){
              $state.go('front.homepage');
          }else if (Principal.hasAnyAuthority(['ROLE_USER'])){
              $state.go('front.mpick.homepage');
          }else if (Principal.hasAnyAuthority(['ROLE_SELFSTUDY_STUDENT'])) {
              $state.go('front.selfstudy.homepage');
          }
      };

      vm.printContent = function () {
          // var oldstr = document.body.innerHTML;
          // var headstr = "<html><head><title></title></head><body>";
          // var footstr = "</body>";
          angular.element(".student-answer").css("display","none");
          angular.element(".actual-answer").css("display","none");
          angular.element(".teacher-mark").css("display","none");
          angular.element("button").css("display","none");
          angular.element("#admin-breadcrumb").css("display","none");
          angular.element("#page-wrapper").css("background","#fff");
          // var printData = angular.element(".wrapper-content .ibox-content").html();
          // document.body.innerHTML = headstr+printData+footstr;
          $window.print();
          angular.element(".student-answer").css("display","");
          angular.element(".actual-answer").css("display","");
          angular.element(".teacher-mark").css("display","");
          angular.element("button").css("display","");
          angular.element("#admin-breadcrumb").css("display","");
          angular.element("#page-wrapper").css("background","#f4f6fa");
      };

      function setCookie(cname,cvalue)
      {
          var d = new Date();
          d.setTime(d.getTime()+(365*24*60*60*1000));
          var expires = "expires="+d.toGMTString();
          document.cookie = cname + "=" + cvalue + ";" + expires;
      }

      function getCookie(cname)
      {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for(var i=0; i<ca.length; i++)
          {
              var c = ca[i].trim();
              if (c.indexOf(name)==0) return c.substring(name.length,c.length);
          }
          return "";
      }

        if(getCookie("role")=="ROLE_ADMIN"){
            vm.username="总部管理员"
        }else if(getCookie("role")=="ROLE_PLACE_ADMIN"){
            vm.username="教学点管理员"
        }else if(getCookie("role")=="ROLE_TEACHER"){
            vm.username="教师"
        }else if(getCookie("role")=="ROLE_USER"){
            vm.username="自助式管理员"
        }
      vm.changeRole = function (roleString) {
          setCookie("role",roleString);
          $state.go("admin.dashboard",{},{reload:true});
      };

      function register () {
          $uibModal.open({
              animation: true,
              templateUrl: 'app/components/register/register.html',
              controller: 'RegisterDialogController',
              controllerAs: 'vm',
              size: 'lg',
              resolve: {
                  entity: function () {
                      return {
                          id: null, login: null, firstName: null, lastName: null, fullName: null, email: null,
                          userType: 'EMPLOYEE', gender: 'MALE', nationality: '汉',orgId: null, deptId: null,
                          activated: true, langKey: null, createdBy: null, createdDate: null,
                          lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                          resetKey: null, authorities: null
                      };
                  },
                  translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                      $translatePartialLoader.addPart('register');
                      $translatePartialLoader.addPart('gender');
                      return $translate.refresh();
                  }]
              }
          });
      }

      $scope.isCollapsed = true;

      vm.search = function (courseName) {

          $state.go('front.selfstudy.onLineCourse',{
              courseName:vm.courses
          })
      }




  }
})();


/**
 * Created by lance.lu on 2017/10/9.
 */
(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('FooterController', FooterController);


    function FooterController (Principal) {
        var vm = this;
        vm.privateMessageNumber = 0;
        vm.publicMessageNumber = 0;
        vm.messageNumber = 0;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function (account) {
            vm.settingsAccount = copyAccount(account);
        });


        function getUserAccount() {
            Principal.identity().then(function (account) {
                vm.userAccount = copyAccount(account);
                vm.userDisplayName = (account.fullName === null || account.fullName === '') ? account.firstName : account.fullName;
            });
        }

        getUserAccount();


    }
})();

/**
 * Created by Benjamin Qin on 6/9/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('BreadCrumbController',BreadCrumbController);

  BreadCrumbController.$inject = ['$rootScope', '$state'];

  function BreadCrumbController($rootScope, $state) {
    var vm = this;
    vm.$state = $state;
  }
})();

(function() {
  'use strict';

  angular
    .module('app.front', ['app.core','ui.swiper','ui.dotdotdot','ui.changeSkin',"myApp"]);
})();

(function() {
    'use strict';

    angular
        .module('app.front')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('front', {
                abstract: true,
                url: "/front",
                templateUrl: "app/front/layout/frontLayout.html",
                resolve: {
                    // authorize: ['Auth',
                    //   function (Auth) {
                    //     return Auth.authorize();
                    //   }
                    // ],
                    // deps: ["$ocLazyLoad", function ($ocLazyLoad) {
                    //     return $ocLazyLoad.load("assets/css/front.css");
                    // }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('frontMenu');
                    }]
                }
            })
            .state('front.message_center', {
                abstract: true,
                url: '/message_center',
                templateUrl: "app/front/layout/content.html"
            })
            .state('front.message_center.system_message', {
                url: "/system_message",
                templateUrl: "app/front/message_center/system_message.html"
            })
            .state('front.message_center.insite_letter', {
                url: "/insite_letter",
                templateUrl: "app/front/message_center/insite_letter.html"
            })
            .state('front.message_center.comment', {
                url: "/comment",
                templateUrl: "app/front/message_center/comment.html"
            });

        $urlRouterProvider.otherwise('/login');
    }
})();

/**
 * Created by troy.zhao on 2017/5/25.
 */
(function () {
    'use strict';

    angular.module('app.front')
        .value('userName', '钱先生')
        .value ('title', '管理员')
})();


(function () {
  'use strict';

  angular.module('app.core')
    .constant('VERSION', "2.0")
    .constant('DEBUG_INFO_ENABLED', true)
})();

var _gua = [{
        "gua-name": "乾",
        "gua-xiang": "111111",
        "gua-detail": "乾，元亨利貞。",
        "gua-tuanText" : "《彖》曰：大哉乾元，萬物資始，乃統天。雲行雨施，品物流形，大明終始，六位時成，時乘六龍以御天。乾道變化，各正性命，保合大和，乃利貞。首出庶物，萬國咸寧。",
        "gua-xiangText" : "《象》曰：天行健，君子以自強不息。潛龍勿用，陽在下也。見龍在田，德施普也。終日乾乾，反復道也。或躍在淵，進无咎也，飛龍在天，大人造也。亢龍有悔，盈不可久也。用九，天德不可為首也。",
        "yao-detail": [
            "潛龍勿用。",
            "見龍在田，利見大人。",
            "君子終日乾乾，夕惕若，厲无咎。",
            "或躍在淵，无咎。",
            "飛龍在天，利見大人。",
            "亢龍有悔。"
        ],
        "yao-xiangText": [
            "《象》曰：潛龍勿用，陽在下也。",
            "《象》曰：見龍在田，德施普也。",
            "《象》曰：終日乾乾，反復道也。",
            "《象》曰：或躍在淵，進无咎也。",
            "《象》曰：飛龍在天，大人造也。",
            "《象》曰：亢龍有悔，盈不可久也。"
        ],
        "yao-extra-title": "用九，",
        "yao-extra-text": "見群龍无首，吉。",
        "yao-extra-xiangText": "《象》曰：用九，天德不可為首也。",
    }, {
        "gua-name": "坤",
        "gua-xiang": "000000",
        "gua-detail": "元亨，利牝馬之貞。君子有攸往，先迷，後得主利。西南得朋，東北喪朋，安貞吉。",
        "gua-tuanText" : "《彖》曰：至哉坤元，萬物資生，乃順承天。坤厚載物，德合无疆，含弘光大，品物咸亨。牝馬地類，行地无疆，柔順利貞。君子攸行，先迷失道，後順得常。西南得朋，乃與類行，東北喪朋，乃終有慶。安貞之吉，應地无疆。",
        "gua-xiangText" : "《象》曰：地勢坤，君子以厚德載物。",
        "yao-detail": [
            "履霜，堅冰至。",
            "直方大，不習无不利。",
            "含章可貞，或從王事，无成有終。",
            "括囊，无咎无譽。",
            "黃裳，元吉。",
            "龍戰于野，其血玄黃。"
        ],
        "yao-xiangText": [
            "《象》曰：履霜堅冰，陰始凝也。馴致其道，至堅冰也。",
            "《象》曰：六二之動，直以方也。不習无不利，地道光也。",
            "《象》曰：含章可貞，以時發也；或從王事，知光大也。",
            "《象》曰：括囊无咎，慎不害也。",
            "《象》曰：黃裳元吉，文在中也。",
            "《象》曰：龍戰于野，其道窮也。"
        ],
        "yao-extra-title": "用六，",
        "yao-extra-text": "利永貞。",
        "yao-extra-xiangText": "《象》曰：用六永貞，以大終也。",
    }, {
        "gua-name": "屯",
        "gua-xiang": "100010",
        "gua-detail": "元亨利貞，勿用有攸往，利建侯。",
        "gua-tuanText" : "《彖》曰：屯，剛柔始交而難生，動乎險中，大亨貞。雷雨之動滿盈，天造草昧，宜建侯而不寧。",
        "gua-xiangText" : "《象》曰：雲雷屯，君子以經綸。",
        "yao-detail": [
            "磐桓，利居貞，利建侯。",
            "屯如邅如，乘馬班如，匪寇婚媾。女子貞不字，十年乃字。",
            "即鹿无虞，惟入于林中。君子幾不如舍。往吝。",
            "乘馬班如，求婚媾，往，吉无不利。",
            "屯其膏，小貞吉，大貞凶。",
            "乘馬班如，泣血漣如。"
        ],
        "yao-xiangText": [
            "《象》曰：雖磐桓，志行正也。以貴下賤，大得民也。",
            "《象》曰：六二之難，乘剛也。十年乃字，反常也。",
            "《象》曰：即鹿无虞，以從禽也。君子舍之，往吝窮也。",
            "《象》曰：求而往，明也。",
            "《象》曰：屯其膏，施未光也。",
            "《象》曰：泣血漣如，何可長也。"
        ]
    }, {
        "gua-name": "蒙",
        "gua-xiang": "010001",
        "gua-detail": "亨。匪我求童蒙，童蒙求我。初筮告，再三瀆，瀆則不告。利貞。",
        "gua-tuanText" : "《彖》曰：蒙，山下有險，險而止，蒙。蒙，亨，以亨行，時中也。匪我求童蒙，童蒙求我，志應也。初筮告，以剛中也。再三瀆，瀆則不告，瀆蒙也。蒙以養正，聖功也。",
        "gua-xiangText" : "《象》曰：山下出泉，蒙，君子以果行育德。",
        "yao-detail": [
            "發蒙。利用刑人，用說桎梏，以往吝。",
            "包蒙，吉。納婦吉，子克家。",
            "勿用取女，見金夫，不有躬，无攸利。",
            "困蒙，吝。",
            "童蒙，吉。",
            "擊蒙，不利為寇，利禦寇。"
        ],
        "yao-xiangText": [
            "《象》曰：利用刑人，以正法也。",
            "《象》曰：子克家，剛柔接也。",
            "《象》曰：勿用取女，行不順也。",
            "《象》曰：困蒙之吝，獨遠實也。",
            "《象》曰：童蒙之吉，順以巽也。",
            "《象》曰：利用禦寇，上下順也。"
        ]
    }, {
        "gua-name": "需",
        "gua-xiang": "111010",
        "gua-detail": "需，有孚，光亨，貞吉，利涉大川。",
        "gua-tuanText" : "《彖》曰：需，須也，險在前也。剛健而不陷，其義不困窮矣。需，有孚，光亨，貞吉，位乎天位，以正中也。利涉大川，往有功也。",
        "gua-xiangText" : "《象》曰：雲上於天，需，君子以飲食宴樂。",
        "yao-detail": [
            "需于郊，利用恒，无咎。",
            "需于沙，小有言，終吉。",
            "需于泥，致寇至。",
            "需于血，出自穴。",
            "需于酒食，貞吉。",
            "入于穴，有不速之客三人來，敬之，終吉。"
        ],
        "yao-xiangText": [
            "《象》曰：需于郊，不犯難行也。利用恆，无咎，未失常也。",
            "《象》曰：需于沙，衍在中也，雖小有言，以吉終也。",
            "《象》曰：需于泥，災在外也。自我致寇，敬慎不敗也。",
            "《象》曰：需于血，順以聽也。",
            "《象》曰：酒食貞吉，以中正也。",
            "《象》曰：不速之客來，敬之終吉，雖不當位，未大失也。"
        ]
    }, {
        "gua-name": "訟",
        "gua-xiang": "010111",
        "gua-detail": "訟，有孚窒惕，中吉，終凶。利見大人，不利涉大川。",
        "gua-tuanText" : "《彖》曰：訟，上剛下險，險而健，訟。訟有孚窒惕中吉，剛來而得中也。終凶，訟不可成也。利見大人，尚中正也。不利涉大川，入于淵也。",
        "gua-xiangText" : "《象》曰：天與水違行，訟。君子以作事謀始。",
        "yao-detail": [
            "不永所事，小有言，終吉。",
            "不克訟，歸而逋其邑，人三百戶，无眚。",
            "食舊德，貞厲，終吉，或從王事，无成。",
            "不克訟，復即命渝，安貞吉。",
            "訟，元吉。",
            "或錫之鞶帶，終朝三褫之。"
        ],
        "yao-xiangText": [
            "《象》曰：不永所事，訟不可長也。雖小有言，其辯明也。",
            "《象》曰：不克訟，歸逋，竄也。自下訟上，患至掇也。",
            "《象》曰：食舊德，從上吉也。",
            "《象》曰：復即命渝，安貞不失也。",
            "《象》曰：訟元吉，以中正也。",
            "《象》曰：以訟受服，亦不足敬也。"
        ]
    }, {
        "gua-name": "師",
        "gua-xiang": "010000",
        "gua-detail": "師，貞，丈人吉，无咎。",
        "gua-tuanText" : "《彖》曰：師眾也，貞正也，能以眾正，可以王矣。剛中而應，行險而順，以此毒天下，而民從之，吉又何咎矣。",
        "gua-xiangText" : "《象》曰：地中有水，師，君子以容民畜眾。",
        "yao-detail": [
            "師出以律，否臧凶。",
            "在師中吉，无咎，王三錫命。",
            "師或輿尸，凶。",
            "師左次，无咎。",
            "田有禽，利執言，无咎。長子帥師，弟子輿尸，貞凶。",
            "大君有命，開國承家，小人勿用。"
        ],
        "yao-xiangText": [
            "《象》曰：師出以律，失律凶也。",
            "《象》曰：在師中吉，承天寵也；王三錫命，懷萬邦也。",
            "《象》曰：師或輿尸，大无功也。",
            "《象》曰：左次无咎，未失常也。",
            "《象》曰：長子帥師，以中行也；弟子輿尸，使不當也。",
            "《象》曰：大君有命，以正功也；小人勿用，必亂邦也。"
        ]
    }, {
        "gua-name": "比",
        "gua-xiang": "000010",
        "gua-detail": "比，吉，原筮，元永貞，无咎。不寧方來，後夫凶。",
        "gua-tuanText" : "《彖》曰：比，吉也。比，輔也，下順從也。原筮元永貞，无咎，以剛中也。不寧方來，上下應也。後夫凶，其道窮也。",
        "gua-xiangText" : "《象》曰：地上有水，比。先王以建萬國，親諸侯。",
        "yao-detail": [
            "有孚，比之无咎。有孚盈缶，終來，有它吉。",
            "比之自內，貞吉。",
            "比之匪人。",
            "外比之，貞吉。",
            "顯比，王用三驅，失前禽，邑人不誡，吉。",
            "比之无首，凶。"
        ],
        "yao-xiangText": [
            "《象》曰：比之初六，有它吉也。",
            "《象》曰：比之自內，不自失也。",
            "《象》曰：比之匪人，不亦傷乎。",
            "《象》曰：外比於賢，以從上也。",
            "《象》曰：顯比之吉，位正中也；舍逆取順，失前禽也；邑人不誡，上使中也。",
            "《象》曰：比之无首，无所終也。"
        ]
    }, {
        "gua-name": "小蓄",
        "gua-xiang": "111011",
        "gua-detail": "小蓄，亨。密雲不雨，自我西郊。",
        "gua-tuanText" : "《彖》曰：小畜，柔得位而上下應之，曰小畜。健而巽，剛中而志行，乃亨。密雲不雨，尚往也；自我西郊，施未行也。",
        "gua-xiangText" : "《象》曰：風行天上，小畜，君子以懿文德。",
        "yao-detail": [
            "復自道，何其咎，吉。",
            "牽復，吉。",
            "輿說輻，夫妻反目。",
            "有孚，血去惕出，无咎。",
            "有孚攣如，富以其鄰。",
            "既雨既處，尚德載，婦貞厲。月幾望，君子征凶。"
        ],
        "yao-xiangText": [
            "《象》曰：復自道，其義吉也。",
            "《象》曰：牽復在中，亦不自失也。",
            "《象》曰：夫妻反目，不能正室也。",
            "《象》曰：有孚惕出，上合志也。",
            "《象》曰：有孚攣如，不獨富也。",
            "《象》曰：既雨既處，德積載也；君子征凶，有所疑也。"
        ]
    }, {
        "gua-name": "履",
        "gua-xiang": "110111",
        "gua-detail": "履虎尾，不咥人，亨。",
        "gua-tuanText" : "《彖》曰：履，柔履剛也。說而應乎乾，是以履虎尾，不咥人，亨。剛中正，履帝位而不疚，光明也。",
        "gua-xiangText" : "《象》曰：上天下澤，履，君子以辯上下，定民志。",
        "yao-detail": [
            "素履，往无咎。",
            "履道坦坦，幽人貞吉。",
            "眇能視，跛能履，履虎尾，咥人凶。武人為于大君。",
            "履虎尾，愬愬，終吉。",
            "夬履，貞厲。",
            "視履，考祥其旋，元吉。"
        ],
        "yao-xiangText": [
            "《象》曰：素履之往，獨行願也。",
            "《象》曰：幽人貞吉，中不自亂也。",
            "《象》曰：眇能視，不足以有明也；跛能履，不足以與行也；咥人之凶，位不當也；武人為于大君，志剛也。",
            "《象》曰：愬愬終吉，志行也。",
            "《象》曰：夬履貞厲，位正當也。",
            "《象》曰：元吉在上，大有慶也。"
        ]
    }, {
        "gua-name": "泰",
        "gua-xiang": "111000",
        "gua-detail": "泰，小往大来，吉亨。",
        "gua-tuanText" : "《彖》曰：泰，小往大來，吉亨，則是天地交而萬物通也，上下交而其志同也。內陽而外陰，內健而外順，內君子而外小人。君子道長，小人道消也。",
        "gua-xiangText" : "《象》曰：天地交，泰。后以財成天地之道，輔相天地之宜，以左右民。",
        "yao-detail": [
            "拔茅茹，以其彙，征吉。",
            "包荒，用馮河，不遐遺，朋亡，得尚于中行。",
            "无平不陂，无往不復。艱貞无咎。勿恤其孚，于食有福。",
            "翩翩不富以其鄰，不戒以孚。",
            "帝乙歸妹，以祉元吉。",
            "城復于隍，勿用師。自邑告命，貞吝。"
        ],
        "yao-xiangText": [
            "《象》曰：拔茅征吉，志在外也。",
            "《象》曰：包荒，得尚于中行，以光大也。",
            "《象》曰：无往不復，天地際也。",
            "《象》曰：翩翩不富，皆失實也；不戒以孚，中心願也。",
            "《象》曰：以祉元吉，中以行願也。",
            "《象》曰：城復于隍，其命亂也。"
        ]
    }, {
        "gua-name": "否",
        "gua-xiang": "000111",
        "gua-detail": "否之匪人，不利君子貞，大往小來。",
        "gua-tuanText" : "《彖》曰：否之匪人，不利君子貞，大往小來，則是天地不交而萬物不通也，上下不交而天下无邦也。內陰而外陽，內柔而外剛，內小人而外君子，小人道長，君子道消也。",
        "gua-xiangText" : "《象》曰：天地不交，否。君子以儉德辟難，不可榮以祿。",
        "yao-detail": [
            "拔茅茹，以其彙，貞吉，亨。",
            "包承，小人吉，大人否亨。",
            "包羞。",
            "有命无咎，疇離祉。",
            "休否，大人吉。其亡其亡，繫于苞桑。",
            "傾否，先否後喜。"
        ],
        "yao-xiangText": [
            "《象》曰：拔茅貞吉，志在君也。",
            "《象》曰：大人否亨，不亂群也。",
            "《象》曰：包羞，位不當也。",
            "《象》曰：有命无咎，志行也。",
            "《象》曰：大人之吉，位正當也。",
            "《象》曰：否終則傾，何可長也。"
        ]
    }, {
        "gua-name": "同人",
        "gua-xiang": "101111",
        "gua-detail": "同人于野，亨。利涉大川，利君子貞。",
        "gua-tuanText" : "《彖》曰：同人，柔得位得中而應乎乾，曰同人。同人曰，同人于野，亨，利涉大川，乾行也。文明以健，中正而應，君子正也，唯君子為能通天下之志。",
        "gua-xiangText" : "《象》曰：天與火，同人。君子以類族辨物。",
        "yao-detail": [
            "同人于門，无咎。",
            "同人于宗，吝。",
            "伏戎于莽，升其高陵，三歲不興。",
            "乘其墉，弗克攻，吉。",
            "同人，先號咷而後笑，大師克相遇。",
            "同人于郊，无悔。"
        ],
        "yao-xiangText": [
            "《象》曰：出門同人，又誰咎也。",
            "《象》曰：同人于宗，吝道也。",
            "《象》曰：伏戎于莽，敵剛也；三歲不興，安行也。",
            "《象》曰：乘其墉，義弗克也。其吉，則困而反則也。",
            "《象》曰：同人之先，以中直也；大師相遇，言相克也。",
            "《象》曰：同人于郊，志未得也。"
        ]
    }, {
        "gua-name": "大有",
        "gua-xiang": "111101",
        "gua-detail": "大有，元亨。",
        "gua-tuanText" : "《彖》曰：大有，柔得尊位大中，而上下應之，曰大有。其德剛健而文明，應乎天而時行，是以元亨。",
        "gua-xiangText" : "《象》曰：火在天上，大有。君子以遏惡揚善，順天休命。大有，大亨通。",
        "yao-detail": [
            "无交害，匪咎，艱則无咎。",
            "大車以載，有攸往，无咎。",
            "公用亨于天子，小人弗克。",
            "匪其彭，无咎。",
            "厥孚交如，威如，吉。",
            "自天祐之，吉无不利。"
        ],
        "yao-xiangText": [
            "《象》曰：大有初九，无交害也。",
            "《象》曰：大車以載，積中不敗也。",
            "《象》曰：公用亨于天子，小人害也。",
            "《象》曰：匪其彭，无咎，明辨晢也。",
            "《象》曰：厥孚交如，信以發志也。威如之吉，易而无備也。",
            "《象》曰：大有上吉，自天祐也。"
        ]
    }, {
        "gua-name": "謙",
        "gua-xiang": "001000",
        "gua-detail": "謙，亨，君子有終。",
        "gua-tuanText" : "《彖》曰：謙亨，天道下濟而光明，地道卑而上行；天道虧盈而益謙，地道變盈而流謙；鬼神害盈而福謙，人道惡盈而好謙。謙尊而光，卑而不可踰，君子之終也。",
        "gua-xiangText" : "《象》曰：地中有山，謙，君子以裒多益寡，稱物平施。",
        "yao-detail": [
            "謙謙君子，用涉大川，吉。",
            "鳴謙，貞吉。",
            "勞謙，君子有終，吉。",
            "无不利，撝謙。",
            "不富以其鄰，利用侵伐，无不利。",
            "鳴謙，利用行師，征邑國。"
        ],
        "yao-xiangText": [
            "《象》曰：謙謙君子，卑以自牧也。",
            "《象》曰：鳴謙貞吉，中心得也。",
            "《象》曰：勞謙君子，萬民服也。",
            "《象》曰：无不利，撝謙，不違則也。",
            "《象》曰：利用侵伐，征不服也。",
            "《象》曰：鳴謙，志未得也，可用行師，征邑國也。"
        ]
    }, {
        "gua-name": "豫",
        "gua-xiang": "000100",
        "gua-detail": "豫，利建侯、行師。",
        "gua-tuanText" : "《彖》曰：豫，剛應而志行，順以動，豫。豫順以動，故天地如之，而況建侯行師乎？天地以順動，故日月不過，而四時不忒。聖人以順動，則刑罰清而民服。豫之時義大矣哉。",
        "gua-xiangText" : "《象》曰：雷出地奮，豫。先王以作樂崇德，殷薦之上帝，以配祖考。",
        "yao-detail": [
            "鳴豫，凶。",
            "介于石，不終日，貞吉。",
            "盱豫，悔遲有悔。",
            "由豫，大有得。勿疑，朋盍簪。",
            "貞疾，恒不死。",
            "冥豫，成有渝，无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：初六鳴豫，志窮凶也。",
            "《象》曰：不終日，貞吉，以中正也。",
            "《象》曰：盱豫有悔，位不當也。",
            "《象》曰：由豫，大有得，志大行也。",
            "《象》曰：六五，貞疾，乘剛也。恒不死，中未亡也。",
            "《象》曰：冥豫在上，何可長也。"
        ]
    }, {
        "gua-name": "隨",
        "gua-xiang": "100110",
        "gua-detail": "隨，元亨利貞，无咎。",
        "gua-tuanText" : "《彖》曰：隨，剛來而下柔，動而說，隨。大亨貞，无咎，而天下隨時，隨時之義大矣哉。",
        "gua-xiangText" : "《象》曰：澤中有雷，隨。君子以嚮晦入宴息。",
        "yao-detail": [
            "官有渝，貞吉。出門交有功。",
            "係小子，失丈夫。",
            "係丈夫，失小子。隨有求得，利居貞。",
            "隨有獲，貞凶。有孚，在道以明，何咎？",
            "孚于嘉，吉。",
            "拘係之，乃從維之，王用亨于西山。"
        ],
        "yao-xiangText": [
            "《象》曰：官有渝，從正吉也；出門交有功，不失也。",
            "《象》曰：係小子，弗兼與也。",
            "《象》曰：係丈夫，志舍下也。",
            "《象》曰：隨有獲，其義凶也；有孚在道，明功也。",
            "《象》曰：孚于嘉吉，位正中也。",
            "《象》曰：拘係之。上窮也。"
        ]
    }, {
        "gua-name": "蠱",
        "gua-xiang": "011001",
        "gua-detail": "蠱，元亨，利涉大川。先甲三日，後甲三日。",
        "gua-tuanText" : "《彖》曰：蠱，剛上而柔下，巽而止，蠱。蠱元亨，而天下治也；利涉大川，往有事也；先甲三日，後甲三日，終則有始，天行也。",
        "gua-xiangText" : "《象》曰：山下有風，蠱。君子以振民育德。",
        "yao-detail": [
            "幹父之蠱，有子，考无咎，厲終吉。",
            "幹母之蠱，不可貞。",
            "幹父之蠱，小有悔，无大咎。",
            "裕父之蠱，往見吝。",
            "幹父之蠱，用譽。",
            "不事王侯，高尚其事。"
        ],
        "yao-xiangText": [
            "《象》曰：幹父之蠱，意承考也。",
            "《象》曰：幹母之蠱，得中道也。",
            "《象》曰：幹父之蠱，終无咎也。",
            "《象》曰：裕父之蠱，往未得也。",
            "《象》曰：幹父用譽，承以德也。",
            "《象》曰：不事王侯，志可則也。"
        ]
    }, {
        "gua-name": "臨",
        "gua-xiang": "110000",
        "gua-detail": "臨，元亨利貞，至于八月有凶。",
        "gua-tuanText" : "《彖》曰：臨，剛浸而長，說而順，剛中而應，大亨以正，天之道也；至于八月有凶，消不久也。",
        "gua-xiangText" : "《象》曰：澤上有地，臨。君子以教思无窮，容保民无疆。",
        "yao-detail": [
            "咸臨，貞吉。",
            "咸臨，吉，无不利。",
            "甘臨，无攸利。既憂之，无咎。",
            "至臨，无咎。",
            "知臨，大君之宜，吉。",
            "敦臨，吉，无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：咸臨貞吉，志行正也。",
            "《象》曰：咸臨吉无不利，未順命也。",
            "《象》曰：甘臨，位不當也，既憂之，咎不長也。",
            "《象》曰：至臨无咎，位當也。",
            "《象》曰：大君之宜，行中之謂也。",
            "《象》曰：敦臨之吉，志在內也。"
        ]
    }, {
        "gua-name": "觀",
        "gua-xiang": "000011",
        "gua-detail": "觀，盥而不薦，有孚顒若。",
        "gua-tuanText" : "《彖》曰：大觀在上，順而巽，中正以觀天下。觀盥而不薦，有孚顒若，下觀而化也。觀天之神道，而四時不忒，聖人以神道設教，而天下服矣。",
        "gua-xiangText" : "《象》曰：風行地上，觀，先王以省方，觀民設教。",
        "yao-detail": [
            "童觀，小人无咎，君子吝。",
            "闚觀，利女貞。",
            "觀我生，進退。",
            "觀國之光，利用賓于王。",
            "觀我生，君子无咎。",
            "觀其生，君子无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：初六童觀，小人道也。",
            "《象》曰：闚觀女貞，亦可醜也。",
            "《象》曰：觀我生進退，未失道也。",
            "《象》曰：觀國之光，尚賓也。",
            "《象》曰：觀我生，觀民也。",
            "《象》曰：觀其生，志未平也。"
        ]
    }, {
        "gua-name": "噬嗑",
        "gua-xiang": "100101",
        "gua-detail": "噬嗑，亨，利用獄。",
        "gua-tuanText" : "《彖》曰：頤中有物，曰噬嗑。噬嗑而亨，剛柔分動而明，雷電合而章，柔得中而上行，雖不當位，利用獄也。",
        "gua-xiangText" : "《象》曰：雷電，噬嗑，先王以明罰敕法。",
        "yao-detail": [
            "屨校滅趾，无咎。",
            "噬膚，滅鼻，无咎。",
            "噬腊肉，遇毒。小吝无咎。",
            "噬乾胏，得金矢，利艱貞吉。",
            "噬乾肉，得黃金，貞厲无咎。",
            "何校滅耳，凶。"
        ],
        "yao-xiangText": [
            "《象》曰：屨校滅趾，不行也。",
            "《象》曰：噬膚滅鼻，乘剛也。",
            "《象》曰：遇毒，位不當也。",
            "《象》曰：利艱貞吉，未光也。",
            "《象》曰：貞厲无咎，得當也。",
            "《象》曰：何校滅耳，聰不明也。"
        ]
    }, {
        "gua-name": "賁",
        "gua-xiang": "101001",
        "gua-detail": "賁亨，小利有攸往。",
        "gua-tuanText" : "《彖》曰：賁亨。柔來而文剛，故亨。分剛上而文柔，故小利有攸往，天文也。文明以止，人文也。觀乎天文，以察時變，觀乎人文，以化成天下。",
        "gua-xiangText" : "《象》曰：山下有火，賁。君子以明庶政，无敢折獄。",
        "yao-detail": [
            "賁其趾，舍車而徒。",
            "賁其須。",
            "賁如濡如，永貞吉。",
            "賁如皤如，白馬翰如，匪寇婚媾。",
            "賁于丘園，束帛戔戔。吝，終吉。",
            "白賁，无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：舍車而徒，義弗乘也。",
            "《象》曰：賁其須，與上興也。",
            "《象》曰：永貞之吉，終莫之陵也。",
            "《象》曰：六四當位，疑也；匪寇婚媾，終无尤也。",
            "《象》曰：六五之吉，有喜也。",
            "《象》曰：白賁无咎，上得志也。"
        ]
    }, {
        "gua-name": "剝",
        "gua-xiang": "000001",
        "gua-detail": "剝，不利有攸往。",
        "gua-tuanText" : "《彖》曰：剝，剝也，柔變剛也。不利有攸往，小人長也。順而止之，觀象也。君子尚消息盈虛，天行也。",
        "gua-xiangText" : "《象》曰：山附于地，剝，上以厚下安宅。",
        "yao-detail": [
            "剝床以足，蔑貞凶。",
            "剝床以辨，蔑貞凶。",
            "剝之无咎。",
            "剝床以膚，凶。",
            "貫魚以宮人寵，无不利。",
            "碩果不食，君子得輿，小人剝廬。"
        ],
        "yao-xiangText": [
            "《象》曰：剝床以足，以滅下也。",
            "《象》曰：剝床以辨，未有與也。",
            "《象》曰：剝之无咎，失上下也。",
            "《象》曰：剝床以膚，切近災也。",
            "《象》曰：以宮人寵，終无尤也。",
            "《象》曰：君子得輿，民所載也，小人剝廬，終不可用也。"
        ]
    }, {
        "gua-name": "復",
        "gua-xiang": "100000",
        "gua-detail": "復，亨。出入无疾，朋來无咎。反復其道，七日來復，利有攸往。",
        "gua-tuanText" : "《彖》曰：復，亨。剛反，動而以順行，是以出入无疾，朋來无咎，反復其道，七日來復，天行也。利有攸往，剛長也。復，其見天地之心乎。",
        "gua-xiangText" : "《象》曰：雷在地中，復，先王以至日閉關，商旅不行，后不省方。",
        "yao-detail": [
            "不遠復，无祇悔，元吉。",
            "休復，吉。",
            "頻復，厲，无咎。",
            "中行獨復。",
            "敦復，无悔。",
            "迷復，凶，有災眚，用行師，終有大敗。以其國君，凶。至于十年不克征。"
        ],
        "yao-xiangText": [
            "《象》曰：不遠之復，以脩身也。",
            "《象》曰：休復之吉，以下仁也。",
            "《象》曰：頻復之厲，義无咎也。",
            "《象》曰：中行獨復，以從道也。",
            "《象》曰：敦復无悔，中以自考也。",
            "《象》曰：迷復之凶，反君道也。"
        ]
    }, {
        "gua-name": "無妄",
        "gua-xiang": "100111",
        "gua-detail": "无妄，元亨利貞。其匪正有眚，不利有攸往。",
        "gua-tuanText" : "《彖》曰：无妄，剛自外來而為主於內，動而健，剛中而應，大亨以正，天之命也，其匪正有眚，不利有攸往。无妄之往，何之矣。天命不祐，行矣哉。",
        "gua-xiangText" : "《象》曰：天下雷行，物與无妄。先王以茂對，時育萬物。",
        "yao-detail": [
            "无妄往，吉。",
            "不耕穫，不菑畬，則利有攸往。",
            "无妄之災，或繫之牛，行人之得，邑人之災。",
            "可貞，无咎。",
            "无妄之疾，勿藥有喜。",
            "无妄行，有眚，无攸利。"
        ],
        "yao-xiangText": [
            "《象》曰：无妄之往，得志也。",
            "《象》曰：不耕穫，未富也。",
            "《象》曰：行人得牛，邑人災也。",
            "《象》曰：可貞无咎，固有之也。",
            "《象》曰：无妄之藥，不可試也。",
            "《象》曰：无妄之行，窮之災也。"
        ]
    }, {
        "gua-name": "大蓄",
        "gua-xiang": "111001",
        "gua-detail": "大蓄，利貞，不家食吉，利涉大川。",
        "gua-tuanText" : "《彖》曰：大畜，剛健篤實，輝光日新其德，剛上而尚賢，能止健，大正也。不家食吉，養賢也；利涉大川，應乎天也。",
        "gua-xiangText" : "《象》曰：天在山中，大畜。君子以多識前言往行，以畜其德。",
        "yao-detail": [
            "有厲，利已。",
            "輿說輹。",
            "良馬逐，利艱貞。曰閑輿衛，利有攸往。",
            "童牛之牿，元吉。",
            "豶豕之牙，吉。",
            "何天之衢，亨。"
        ],
        "yao-xiangText": [
            "《象》曰：有厲利已，不犯災也。",
            "《象》曰：輿說輹，中无尤也。",
            "《象》曰：利有攸往，上合志也。",
            "《象》曰：六四元吉，有喜也。",
            "《象》曰：六五之吉，有慶也。",
            "《象》曰：何天之衢，道大行也。"
        ]
    }, {
        "gua-name": "頤",
        "gua-xiang": "100001",
        "gua-detail": "頤，貞吉，觀頤，自求口實。",
        "gua-tuanText" : "《彖》曰：頤，貞吉，養正則吉也。觀頤，觀其所養也；自求口實，觀其自養也。天地養萬物，聖人養賢以及萬民，頤之時大矣哉。",
        "gua-xiangText" : "《象》曰：山下有雷，頤，君子以慎言語，節飲食。",
        "yao-detail": [
            "舍爾靈龜，觀我朵頤，凶。",
            "顛頤，拂經。于丘頤，征凶。",
            "拂頤，貞凶。十年勿用，无攸利。",
            "顛頤，吉，虎視眈眈，其欲逐逐，无咎。",
            "拂經，居貞吉，不可涉大川。",
            "由頤，厲吉，利涉大川。"
        ],
        "yao-xiangText": [
            "《象》曰：觀我朵頤，亦不足貴也。",
            "《象》曰：六二征凶，行失類也。",
            "《象》曰：十年勿用，道大悖也。",
            "《象》曰：顛頤之吉，上施光也。",
            "《象》曰：居貞之吉，順以從上也。",
            "《象》曰：由頤厲吉，大有慶也。"
        ]
    }, {
        "gua-name": "大過",
        "gua-xiang": "011110",
        "gua-detail": "大過，棟橈。利有攸往，亨。",
        "gua-tuanText" : "《彖》曰：大過，大者過也。棟橈，本末弱也。剛過而中，巽而說行，利有攸往，乃亨，大過之時大矣哉。",
        "gua-xiangText" : "《象》曰：澤滅木，大過。君子以獨立不懼，遯世无悶。",
        "yao-detail": [
            "藉用白茅，无咎。",
            "枯楊生稊，老夫得其女妻，无不利。",
            "棟橈，凶。",
            "棟隆，吉，有它吝。",
            "枯楊生華，老婦得其士夫，无咎无譽。",
            "過涉滅頂，凶，无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：藉用白茅，柔在下也。",
            "《象》曰：老夫女妻，過以相與也。",
            "《象》曰：棟橈之凶，不可以有輔也。",
            "《象》曰：棟隆之吉，不橈乎下也。",
            "《象》曰：枯楊生華，何可久也；老婦士夫，亦可醜也。",
            "《象》曰：過涉之凶，不可咎也。"
        ]
    }, {
        "gua-name": "坎",
        "gua-xiang": "010010",
        "gua-detail": "習坎，有孚，維心亨，行有尚。",
        "gua-tuanText" : "《彖》曰：習坎，重險也。水流而不盈，行險而不失其信。維心亨，乃以剛中也；行有尚，往有功也。天險不可升也，地險山川丘陵也，王公設險以守其國，險之時用大矣哉。",
        "gua-xiangText" : "《象》曰：水洊至，習坎。君子以常德行，習教事。",
        "yao-detail": [
            "習坎，入于坎窞，凶。",
            "坎，有險，求小得。",
            "來之坎坎，險且枕，入于坎窞，勿用。",
            "樽酒，簋貳，用缶，納約自牖，終无咎。",
            "坎不盈，祗既平，无咎。",
            "係用黴纆，寘于叢棘，三歲不得，凶。"
        ],
        "yao-xiangText": [
            "《象》曰：習坎入坎，失道凶也。",
            "《象》曰：求小得，未出中也。",
            "《象》曰：來之坎坎，終无功也。",
            "《象》曰：樽酒簋貳，剛柔際也。",
            "《象》曰：坎不盈，中未大也。",
            "《象》曰：上六失道，凶三歲也。"
        ]
    }, {
        "gua-name": "離",
        "gua-xiang": "101101",
        "gua-detail": "離，利貞，亨，畜牝牛，吉。",
        "gua-tuanText" : "《彖》曰：離，麗也。日月麗乎天，百穀草木麗乎土，重明以麗乎正，乃化成天下。柔麗乎中正，故亨，是以畜牝牛吉也。",
        "gua-xiangText" : "《象》曰：明兩作，離，大人以繼明照于四方。",
        "yao-detail": [
            "履錯然，敬之，无咎。",
            "黃離，元吉。",
            "日昃之離，不鼓缶而歌，則大耋之嗟，凶。",
            "突如其來如，焚如，死如，棄如。",
            "出涕沱若，戚嗟若，吉。",
            "王用出征，有嘉折首，獲匪其醜，无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：履錯之敬，以辟咎也。",
            "《象》曰：黃離元吉，得中道也。",
            "《象》曰：日昃之離，何可久也。",
            "《象》曰：突如其來如，无所容也。",
            "《象》曰：六五之吉，離王公也。",
            "《象》曰：王用出征，以正邦也。"
        ]
    }, {
        "gua-name": "咸",
        "gua-xiang": "001110",
        "gua-detail": "咸亨，利貞，取女吉。",
        "gua-tuanText" : "《彖》曰：咸，感也。柔上而剛下，二氣感應以相與，止而說，男下女，是以亨，利貞，取女吉也。天地感而萬物化生，聖人感人心而天下和平。觀其所感，而天地萬物之情可見矣。",
        "gua-xiangText" : "《象》曰：山上有澤，咸，君子以虛受人。",
        "yao-detail": [
            "咸其拇。",
            "咸其腓，凶，居吉。",
            "咸其股，執其隨，往吝。",
            "貞吉，悔亡，憧憧往來，朋從爾思。",
            "咸其脢，无悔。",
            "咸其輔頰舌。"
        ],
        "yao-xiangText": [
            "《象》曰：咸其拇，志在外也。",
            "《象》曰：雖凶居吉，順不害也。",
            "《象》曰：咸其股，亦不處也。志在隨人，所執下也。",
            "《象》曰：貞吉悔亡，未感害也；憧憧往來，未光大也。",
            "《象》曰：咸其脢，志末也。",
            "《象》曰：咸其輔頰舌，滕口說也。"
        ]
    }, {
        "gua-name": "恒",
        "gua-xiang": "011100",
        "gua-detail": "恒，亨，无咎，利貞，利有攸往。",
        "gua-tuanText" : "《彖》曰：恒，久也。剛上而柔下，雷風相與，巽而動，剛柔皆應，恒。恒，亨，无咎，利貞，久於其道也。天地之道，恒久而不已也，利有攸往，終則有始也，日月得天而能久照，四時變化而能久成，聖人久於其道而天下化成，觀其所恒而天地萬物之情可見矣。",
        "gua-xiangText" : "《象》曰：雷風，恒，君子以立不易方。",
        "yao-detail": [
            "浚恒，貞凶，无攸利。",
            "悔亡。",
            "不恒其德，或承之羞，貞吝。",
            "田无禽。",
            "恒其德貞，婦人吉，夫子凶。",
            "振恒，凶。"
        ],
        "yao-xiangText": [
            "《象》曰：浚恒之凶，始求深也。",
            "《象》曰：九二悔亡，能久中也。",
            "《象》曰：不恒其德，无所容也。",
            "《象》曰：久非其位，安得禽也。",
            "《象》曰：婦人貞吉，從一而終也。夫子制義，從婦凶也。",
            "《象》曰：振恒在上，大无功也。"
        ]
    }, {
        "gua-name": "遯",
        "gua-xiang": "001111",
        "gua-detail": "遯亨，小利貞。",
        "gua-tuanText" : "《彖》曰：遯亨，遯而亨也。剛當位而應，與時行也。小利貞，浸而長也。遯之時義大矣哉。",
        "gua-xiangText" : "《象》曰：天下有山，遯。君子以遠小人，不惡而嚴。",
        "yao-detail": [
            "遯尾，厲。勿用有攸往。",
            "執之用黃牛之革，莫之勝說。",
            "係遯，有疾厲，畜臣妾吉。",
            "好遯，君子吉，小人否。",
            "嘉遯，貞吉。",
            "肥遯，无不利。"
        ],
        "yao-xiangText": [
            "《象》曰：遯尾之厲，不往何災也。",
            "《象》曰：執用黃牛，固志也。",
            "《象》曰：係遯之厲，有疾憊也。畜臣妾吉，不可大事也。",
            "《象》曰：君子好遯，小人否也。",
            "《象》曰：嘉遯貞吉，以正志也。",
            "《象》曰：肥遯，无不利，无所疑也。"
        ]
    }, {
        "gua-name": "大壯",
        "gua-xiang": "111100",
        "gua-detail": "大壯，利貞。",
        "gua-tuanText" : "《彖》曰：大壯，大者壯也，剛以動，故壯。大壯利貞，大者正也。正大而天地之情可見矣。",
        "gua-xiangText" : "《象》曰：雷在天上，大壯，君子以非禮弗履。",
        "yao-detail": [
            "壯于趾，征凶，有孚。",
            "貞吉。",
            "小人用壯，君子用罔。貞厲，羝羊觸藩，羸其角。",
            "貞吉，悔亡，藩決不羸，壯于大輿之輹。",
            "喪羊于易，无悔。",
            "羝羊觸藩，不能退，不能遂，无攸利，艱則吉。"
        ],
        "yao-xiangText": [
            "《象》曰：壯于趾，其孚窮也。",
            "《象》曰：九二貞吉，以中也。",
            "《象》曰：小人用壯，君子罔也。",
            "《象》曰：藩決不羸，尚往也。",
            "《象》曰：喪羊于易，位不當也。",
            "《象》曰：不能退，不能遂，不詳也。艱則吉，咎不長也。"
        ]
    }, {
        "gua-name": "晉",
        "gua-xiang": "000101",
        "gua-detail": "晉，康侯用錫馬蕃庶，晝日三接。",
        "gua-tuanText" : "《彖》曰：晉，進也。明出地上，順而麗乎大明，柔進而上行，是以康侯用錫馬蕃庶，晝日三接也。",
        "gua-xiangText" : "《象》曰：明出地上，晉。君子以自昭明德。",
        "yao-detail": [
            "晉如摧如，貞吉。罔孚裕，无咎。",
            "晉如愁如，貞吉。受茲介福，于其王母。",
            "眾允，悔亡。",
            "晉如鼫鼠，貞厲。",
            "悔亡，失得勿恤。往吉无不利。",
            "晉其角，維用伐邑。厲吉无咎，貞吝。"
        ],
        "yao-xiangText": [
            "《象》曰：晉如摧如，獨行正也；裕无咎，未受命也。",
            "《象》曰：受茲介福，以中正也。",
            "《象》曰：眾允之，志上行也。",
            "《象》曰：鼫鼠貞厲，位不當也。",
            "《象》曰：失得勿恤，往有慶也。",
            "《象》曰：維用伐邑，道未光也。"
        ]
    }, {
        "gua-name": "明夷",
        "gua-xiang": "101000",
        "gua-detail": "明夷，利艱貞。",
        "gua-tuanText" : "《彖》曰：明入地中，明夷。內文明而外柔順，以蒙大難，文王以之。利艱貞，晦其明也。內難而能正其志，箕子以之。",
        "gua-xiangText" : "《象》曰：明入地中，明夷。君子以莅眾，用晦而明。",
        "yao-detail": [
            "明夷于飛，垂其翼。君子于行，三日不食。有攸往，主人有言。",
            "明夷，夷于左股，用拯馬壯吉。",
            "明夷于南狩，得其大首，不可疾貞。",
            "入于左腹，獲明夷之心，于出門庭。",
            "箕子之明夷，利貞。",
            "不明晦，初登于天，後入于地。"
        ],
        "yao-xiangText": [
            "《象》曰：君子于行，義不食也。",
            "《象》曰：六二之吉，順以則也。",
            "《象》曰：南狩之志，乃得大也。",
            "《象》曰：入于左腹，獲心意也。",
            "《象》曰：箕子之貞，明不可息也。",
            "《象》曰：初登于天，照四國也；後入于地，失則也。"
        ]
    }, {
        "gua-name": "家人",
        "gua-xiang": "101011",
        "gua-detail": "家人，利女貞。",
        "gua-tuanText" : "《彖》曰：家人，女正位乎內，男正位乎外，男女正，天地之大義也。家人有嚴君焉，父母之謂也。父父，子子，兄兄，弟弟，夫夫，婦婦，而家道正。正家，而天下定矣。",
        "gua-xiangText" : "《象》曰：風自火出，家人，君子以言有物，而行有恆。",
        "yao-detail": [
            "閑有家，悔亡。",
            "无攸遂，在中饋，貞吉。",
            "家人嗃嗃，悔厲吉，婦子嘻嘻，終吝。",
            "富家，大吉。",
            "王假有家，勿恤，吉。",
            "有孚，威如，終吉。"
        ],
        "yao-xiangText": [
            "《象》曰：閑有家，志未變也。",
            "《象》曰：六二之吉，順以巽也。",
            "《象》曰：家人嗃嗃，未失也。婦子嘻嘻，失家節也。",
            "《象》曰：富家大吉，順在位也。",
            "《象》曰：王假有家，交相愛也。",
            "《象》曰：威如之吉，反身之謂也。"
        ]
    }, {
        "gua-name": "睽",
        "gua-xiang": "110101",
        "gua-detail": "睽，小事吉。",
        "gua-tuanText" : "《彖》曰：睽，火動而上，澤動而下，二女同居，其志不同行。說而麗乎明，柔進而上行，得中而應乎剛，是以小事吉。天地睽而其事同也，男女睽而其志通也，萬物睽而其事類也，睽之時用大矣哉。",
        "gua-xiangText" : "《象》曰：上火下澤，睽，君子以同而異。",
        "yao-detail": [
            "悔亡，喪馬勿逐，自復。見惡人，无咎。",
            "遇主于巷，无咎。",
            "見輿曳，其牛掣，其人天且劓，无初有終。",
            "睽孤，遇元夫。交孚，厲无咎。",
            "悔亡。厥宗噬膚，往何咎。",
            "睽孤，見豕負塗，載鬼一車，先張之弧，後說之弧，匪寇婚媾。往，遇雨則吉。"
        ],
        "yao-xiangText": [
            "《象》曰：見惡人，以辟咎也。",
            "《象》曰：遇主于巷，未失道也。",
            "《象》曰：見輿曳，位不當也。无初有終，遇剛也。",
            "《象》曰：交孚无咎，志行也。",
            "《象》曰：厥宗噬膚，往有慶也。",
            "《象》曰：遇雨之吉，群疑亡也。"
        ]
    }, {
        "gua-name": "蹇",
        "gua-xiang": "001010",
        "gua-detail": "蹇，利西南，不利東北，利見大人，貞吉。",
        "gua-tuanText" : "《彖》曰：蹇，難也，險在前也。見險而能止，知矣哉。蹇，利西南，往得中也；不利東北，其道窮也。利見大人，往有功也；當位貞吉，以正邦也。蹇之時用大矣哉。",
        "gua-xiangText" : "《象》曰：山上有水，蹇，君子以反身脩德。",
        "yao-detail": [
            "往蹇來譽。",
            "王臣蹇蹇，匪躬之故。",
            "往蹇來反。",
            "往蹇來連。",
            "大蹇朋來。",
            "往蹇來碩，吉，利見大人。"
        ],
        "yao-xiangText": [
            "《象》曰：往蹇來譽，宜待也。",
            "《象》曰：王臣蹇蹇，終无尤也。",
            "《象》曰：往蹇來反，內喜之也。",
            "《象》曰：往蹇來連，當位實也。",
            "《象》曰：大蹇朋來，以中節也。",
            "《象》曰：往蹇來碩，志在內也；利見大人，以從貴也。"
        ]
    }, {
        "gua-name": "解",
        "gua-xiang": "010100",
        "gua-detail": "解，利西南，无所往，其來復吉；有攸往，夙吉。",
        "gua-tuanText" : "《彖》曰：解，險以動，動而免乎險，解。解，利西南，往得眾也；其來復吉，乃得中也；有攸往夙吉，往有功也。天地解而雷雨作，雷雨作而百果草木皆甲坼，解之時大矣哉。",
        "gua-xiangText" : "《象》曰：雷雨作，解。君子以赦過宥罪。",
        "yao-detail": [
            "无咎。",
            "田獲三狐，得黃矢，貞吉。",
            "負且乘，致寇至，貞吝。",
            "解而拇，朋至斯孚。",
            "君子維有解，吉，有孚于小人。",
            "公用射隼于高墉之上，獲之，无不利。"
        ],
        "yao-xiangText": [
            "《象》曰：剛柔之際，義无咎也。",
            "《象》曰：九二貞吉，得中道也。",
            "《象》曰：負且乘，亦可醜也，自我致戎，又誰咎也。",
            "《象》曰：解而拇，未當位也。",
            "《象》曰：君子有解，小人退也。",
            "《象》曰：公用射隼，以解悖也。"
        ]
    }, {
        "gua-name": "損",
        "gua-xiang": "110001",
        "gua-detail": "損，有孚，元吉，无咎可貞，利有攸往。曷之用，二簋可用享。",
        "gua-tuanText" : "《彖》曰：損，損下益上，其道上行，損而有孚，元吉。无咎，可貞，利有攸往，曷之用，二簋可用享，二簋應有時，損剛益柔有時，損益盈虛，與時偕行。",
        "gua-xiangText" : "《象》曰：山下有澤，損，君子以懲忿窒欲。",
        "yao-detail": [
            "已事遄往，无咎，酌損之。",
            "利貞，征凶。弗損，益之。",
            "三人行，則損一人，一人行，則得其友。",
            "損其疾，使遄有喜，无咎。",
            "或益之十朋之龜，弗克違，元吉。",
            "弗損，益之，无咎，貞吉，利有攸往，得臣无家。"
        ],
        "yao-xiangText": [
            "《象》曰：已事遄往，尚合志也。",
            "《象》曰：九二利貞，中以為志也。",
            "《象》曰：一人行，三則疑也。",
            "《象》曰：損其疾，亦可喜也。",
            "《象》曰：六五元吉，自上祐也。",
            "《象》曰：弗損益之，大得志也。"
        ]
    }, {
        "gua-name": "益",
        "gua-xiang": "100011",
        "gua-detail": "益，利有攸往，利涉大川。",
        "gua-tuanText" : "《彖》曰：益，損上益下，民說无疆，自上下下，其道大光。利有攸往，中正有慶；利涉大川，木道乃行。益動而巽，日進无疆，天施地生，其益无方，凡益之道，與時偕行。",
        "gua-xiangText" : "《象》曰：風雷，益，君子以見善則遷，有過則改。",
        "yao-detail": [
            "利用為大作，元吉，无咎。",
            "或益之十朋之龜，弗克違，永貞吉。王用享于帝，吉。",
            "益之用凶事，无咎。有孚中行，告公用圭。",
            "中行，告公從，利用為依遷國。",
            "有孚惠心，勿問元吉。有孚惠我德。",
            "莫益之，或擊之，立心勿恒，凶。"
        ],
        "yao-xiangText": [
            "《象》曰：元吉无咎，下不厚事也。",
            "《象》曰：或益之，自外來也。",
            "《象》曰：益用凶事，固有之也。",
            "《象》曰：告公從，以益志也。",
            "《象》曰：有孚惠心，勿問之矣；惠我德，大得志也。",
            "《象》曰：莫益之，偏辭也；或擊之，自外來也。"
        ]
    }, {
        "gua-name": "夬",
        "gua-xiang": "111110",
        "gua-detail": "夬，揚于王庭，孚號有厲。告自邑，不利即戎，利有攸往。",
        "gua-tuanText" : "《彖》曰：夬，決也，剛決柔也。健而說，決而和。揚于王庭，柔乘五剛也；孚號有厲，其危乃光也；告自邑，不利即戎，所尚乃窮也；利有攸往，剛長乃終也。",
        "gua-xiangText" : "《象》曰：澤上於天，夬。君子以施祿及下，居德則忌。",
        "yao-detail": [
            "壯于前趾，往不勝為咎。",
            "惕號，莫夜有戎，勿恤。",
            "壯于頄，有凶。君子夬夬，獨行，遇雨若濡。有慍无咎。",
            "臀无膚，其行次且，牽羊悔亡，聞言不信。",
            "莧陸夬夬，中行无咎。",
            "无號，終有凶。"
        ],
        "yao-xiangText": [
            "《象》曰：不勝而往，咎也。",
            "《象》曰：有戎勿恤，得中道也。",
            "《象》曰：君子夬夬，終无咎也。",
            "《象》曰：其行次且，位不當也，聞言不信，聰不明也。",
            "《象》曰：中行无咎，中未光也。",
            "《象》曰：无號之凶，終不可長也。"
        ]
    }, {
        "gua-name": "姤",
        "gua-xiang": "011111",
        "gua-detail": "姤，女壯，勿用取女。",
        "gua-tuanText" : "《彖》曰：姤，遇也，柔遇剛也。勿用取女，不可與長也。天地相遇，品物咸章也；剛遇中正，天下大行也，姤之時義大矣哉。",
        "gua-xiangText" : "《象》曰：天下有風，姤，后以施命誥四方。",
        "yao-detail": [
            "繫于金柅，貞吉。有攸往，見凶。羸豕孚蹢躅。",
            "包有魚，无咎，不利賓。",
            "臀无膚，其行次且，厲，无大咎。",
            "包无魚，起凶。",
            "以杞包瓜，含章，有隕自天。",
            "姤其角，吝，无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：繫于金柅，柔道牽也。",
            "《象》曰：包有魚，義不及賓也。",
            "《象》曰：其行次且，行未牽也。",
            "《象》曰：无魚之凶，遠民也。",
            "《象》曰：九五含章，中正也。有隕自天，志不舍命也。",
            "《象》曰：姤其角，上窮吝也。"
        ]
    }, {
        "gua-name": "萃",
        "gua-xiang": "000110",
        "gua-detail": "萃亨，王假有廟，利見大人，亨，利貞。用大牲吉。利有攸往。",
        "gua-tuanText" : "《彖》曰：萃，聚也。順以說，剛中而應，故聚也。王假有廟，致孝享也；利見大人，亨，聚以正也；用大牲，吉，利有攸往，順天命也。觀其所聚，而天地萬物之情可見矣。",
        "gua-xiangText" : "《象》曰：澤上於地，萃，君子以除戎器，戒不虞。",
        "yao-detail": [
            "有孚不終，乃亂乃萃，若號。一握為笑，勿恤，往无咎。",
            "引吉，无咎，孚乃利用禴。",
            "萃如嗟如，无攸利。往无咎，小吝。",
            "大吉，无咎。",
            "萃有位，无咎，匪孚。元永貞，悔亡。",
            "齎咨涕洟，无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：乃亂乃萃，其志亂也。",
            "《象》曰：引吉无咎，中未變也。",
            "《象》曰：往无咎，上巽也。",
            "《象》曰：大吉无咎，位不當也。",
            "《象》曰：萃有位，志未光也。",
            "《象》曰：齎咨涕洟，未安上也。"
        ]
    }, {
        "gua-name": "升",
        "gua-xiang": "011000",
        "gua-detail": "升，元亨。用見大人，勿恤。南征吉。",
        "gua-tuanText" : "《彖》曰：柔以時升，巽而順，剛中而應，是以大亨；用見大人，勿恤，有慶也；南征吉，志行也。",
        "gua-xiangText" : "《象》曰：地中生木，升。君子以順德，積小以高大。",
        "yao-detail": [
            "允升，大吉。",
            "孚乃利用禴，无咎。",
            "升虛邑。",
            "王用亨于岐山，吉，无咎。",
            "貞吉，升階。",
            "冥升，利于不息之貞。"
        ],
        "yao-xiangText": [
            "《象》曰：允升大吉，上合志也。",
            "《象》曰：九二之孚，有喜也。",
            "《象》曰：升虛邑，无所疑也。",
            "《象》曰：王用亨于岐山，順事也。",
            "《象》曰：貞吉升階，大得志也。",
            "《象》曰：冥升在上，消不富也。"
        ]
    }, {
        "gua-name": "困",
        "gua-xiang": "010110",
        "gua-detail": "困，亨，貞大人吉，无咎。有言不信。",
        "gua-tuanText" : "《彖》曰：困，剛揜也。險以說，困而不失其所亨，其唯君子乎。貞大人吉，以剛中也；有言不信，尚口乃窮也。",
        "gua-xiangText" : "《象》曰：澤无水，困。君子以致命遂志。",
        "yao-detail": [
            "臀困于株木，入于幽谷，三歲不覿。",
            "困于酒食，朱紱方來，利用享祀，征凶，无咎。",
            "困于石，據于蒺蔾，入于其宮，不見其妻，凶。",
            "來徐徐，困于金車。吝，有終。",
            "劓刖，困于赤紱，乃徐有說。利用祭祀。",
            "困于葛藟，于臲卼，曰動悔有悔，征吉。"
        ],
        "yao-xiangText": [
            "《象》曰：入于幽谷，幽不明也。",
            "《象》曰：困于酒食，中有慶也。",
            "《象》曰：據于蒺蔾，乘剛也。入于其宮，不見其妻，不祥也。",
            "《象》曰：來徐徐，志在下也。雖不當位，有與也。",
            "《象》曰：劓刖，志未得也；乃徐有說，以中直也；利用祭祀，受福也。",
            "《象》曰：困于葛藟，未當也；動悔有悔，吉行也。"
        ]
    }, {
        "gua-name": "井",
        "gua-xiang": "011010",
        "gua-detail": "井，改邑不改井，无喪无得，往來井井，汔至，亦未繘井，羸其瓶，凶。",
        "gua-tuanText" : "《彖》曰：巽乎水而上水，井，井養而不窮也。改邑不改井，乃以剛中也；汔至亦未繘井，未有功也；羸其瓶，是以凶也。",
        "gua-xiangText" : "《象》曰：木上有水，井，君子以勞民勸相。",
        "yao-detail": [
            "井泥不食，舊井无禽。",
            "井谷射鮒，甕敝漏。",
            "井渫不食，為我心惻，可用汲。王明，並受其福。",
            "井甃无咎。",
            "井洌，寒泉食。",
            "井收勿幕，有孚元吉。"
        ],
        "yao-xiangText": [
            "《象》曰：井泥不食，下也；舊井无禽，時舍也。",
            "《象》曰：井谷射鮒，无與也。",
            "《象》曰：井渫不食，行惻也；求王明，受福也。",
            "《象》曰：井甃无咎，脩井也。",
            "《象》曰：寒泉之食，中正也。",
            "《象》曰：元吉在上，大成也。"
        ]
    }, {
        "gua-name": "革",
        "gua-xiang": "101110",
        "gua-detail": "革，已日乃孚，元亨利貞，悔亡。",
        "gua-tuanText" : "《彖》曰：革，水火相息，二女同居，其志不相得，曰革。已日乃孚，革而信之，文明以說，大亨以正，革而當，其悔乃亡。天地革而四時成，湯武革命，順乎天而應乎人，革之時大矣哉。",
        "gua-xiangText" : "《象》曰：澤中有火，革，君子以治曆明時。",
        "yao-detail": [
            "鞏用黃牛之革。",
            "已日乃革之，征吉，无咎。",
            "征凶，貞厲，革言三就，有孚。",
            "悔亡，有孚，改命吉。",
            "大人虎變，未占有孚。",
            "君子豹變，小人革面，征凶，居貞吉。"
        ],
        "yao-xiangText": [
            "《象》曰：鞏用黃牛，不可以有為也。",
            "《象》曰：已日革之，行有嘉也。",
            "《象》曰：革言三就，又何之矣。",
            "《象》曰：改命之吉，信志也。",
            "《象》曰：大人虎變，其文炳也。",
            "《象》曰：君子豹變，其文蔚也；小人革面，順以從君也。"
        ]
    }, {
        "gua-name": "鼎",
        "gua-xiang": "011101",
        "gua-detail": "鼎，元吉，亨。",
        "gua-tuanText" : "《彖》曰：鼎，象也。以木巽火，亨飪也。聖人亨以享上帝，而大亨以養聖賢。巽而耳目聰明，柔進而上行，得中而應乎剛，是以元亨。",
        "gua-xiangText" : "《象》曰：木上有火，鼎，君子以正位凝命。",
        "yao-detail": [
            "鼎顛趾，利出否，得妾以其子，无咎。",
            "鼎有實，我仇有疾，不我能即，吉。",
            "鼎耳革，其行塞，雉膏不食。方雨虧悔，終吉。",
            "鼎折足，覆公餗，其形渥，凶。",
            "鼎黃耳金鉉，利貞。",
            "鼎玉鉉，大吉，无不利。"
        ],
        "yao-xiangText": [
            "《象》曰：鼎顛趾，未悖也。利出否，以從貴也。",
            "《象》曰：鼎有實，慎所之也。我仇有疾，終无尤也。",
            "《象》曰：鼎耳革，失其義也。",
            "《象》曰：覆公餗，信如何也。",
            "《象》曰：鼎黃耳，中以為實也。",
            "《象》曰：玉鉉在上，剛柔節也。"
        ]
    }, {
        "gua-name": "震",
        "gua-xiang": "100100",
        "gua-detail": "震，亨。震來虩虩，笑言啞啞，震驚百里，不喪匕鬯。",
        "gua-tuanText" : "《彖》曰：震，亨。震來虩虩，恐致福也；笑言啞啞，後有則也；震驚百里，驚遠而懼邇也，出可以守宗廟社稷，以為祭主也。",
        "gua-xiangText" : "《象》曰：洊雷震，君子以恐懼脩省。",
        "yao-detail": [
            "震來虩虩，後笑言啞啞，吉。",
            "震來厲，億喪貝，躋于九陵。勿逐，七日得。",
            "震蘇蘇，震行无眚。",
            "震遂泥。",
            "震往來厲，億无喪，有事。",
            "震索索，視矍矍，征凶。震不于其躬于其鄰，无咎。婚媾有言。"
        ],
        "yao-xiangText": [
            "《象》曰：震來虩虩，恐致福也；笑言啞啞，後有則也。",
            "《象》曰：震來厲，乘剛也。",
            "《象》曰：震蘇蘇，位不當也。",
            "《象》曰：震遂泥，未光也。",
            "《象》曰：震往來厲，危行也。其事在中，大无喪也。",
            "《象》曰：震索索，中未得也；雖凶无咎，畏鄰戒也。"
        ]
    }, {
        "gua-name": "艮",
        "gua-xiang": "001001",
        "gua-detail": "艮其背，不獲其身；行其庭，不見其人。无咎。",
        "gua-tuanText" : "《彖》曰：艮，止也，時止則止，時行則行，動靜不失其時，其道光明。艮其止，止其所也。上下敵應，不相與也，是以不獲其身。行其庭不見其人，无咎也。",
        "gua-xiangText" : "《象》曰：兼山，艮，君子以思不出其位。",
        "yao-detail": [
            "艮其趾，无咎，利永貞。",
            "艮其腓，不拯其隨，其心不快。",
            "艮其限，列其夤，厲薰心。",
            "艮其身，无咎。",
            "艮其輔，言有序，悔亡。",
            "敦艮，吉。"
        ],
        "yao-xiangText": [
            "《象》曰：艮其趾，未失正也。",
            "《象》曰：不拯其隨，未退聽也。",
            "《象》曰：艮其限，危薰心也。",
            "《象》曰：艮其身，止諸躬也。",
            "《象》曰：艮其輔，以中正也。",
            "《象》曰：敦艮之吉，以厚終也。"
        ]
    }, {
        "gua-name": "漸",
        "gua-xiang": "001011",
        "gua-detail": "漸，女歸吉，利貞。",
        "gua-tuanText" : "《彖》曰：漸之進也，女歸吉也。進得位，往有功也。進以正，可以正邦也。其位剛得中也。止而巽，動不窮也。",
        "gua-xiangText" : "《象》曰：山上有木，漸，君子以居賢德善俗。",
        "yao-detail": [
            "鴻漸于干，小子厲，有言，无咎。",
            "鴻漸于磐，飲食衎衎，吉。",
            "鴻漸于陸，夫征不復，婦孕不育，凶，利禦寇。",
            "鴻漸于木，或得其桷，无咎。",
            "鴻漸于陵，婦三歲不孕，終莫之勝，吉。",
            "鴻漸于陸，其羽可用為儀，吉。"
        ],
        "yao-xiangText": [
            "《象》曰：小子之厲，義无咎也。",
            "《象》曰：飲食衎衎，不素飽也。",
            "《象》曰：夫征不復，離群醜也；婦孕不育，失其道也；利用禦寇，順相保也。",
            "《象》曰：或得其桷，順以巽也。",
            "《象》曰：終莫之勝，吉，得所願也。",
            "《象》曰：其羽可用為儀，吉，不可亂也。"
        ]
    }, {
        "gua-name": "歸妹",
        "gua-xiang": "110100",
        "gua-detail": "歸妹，征凶，无攸利。",
        "gua-tuanText" : "《彖》曰：歸妹，天地之大義也。天地不交，而萬物不興。歸妹，人之終始也，說以動，所歸妹也。征凶，位不當也；无攸利，柔乘剛也。",
        "gua-xiangText" : "《象》曰：澤上有雷，歸妹。君子以永終知敝。",
        "yao-detail": [
            "歸妹以娣，跛能履，征吉。",
            "眇能視，利幽人之貞。",
            "歸妹以須，反歸以娣。",
            "歸妹愆期，遲歸有時。",
            "帝乙歸妹，其君之袂，不如其娣之袂良。月幾望，吉。",
            "女承筐无實，士刲羊无血，无攸利。"
        ],
        "yao-xiangText": [
            "《象》曰：歸妹以娣，以恒也；跛能履，吉，相承也。",
            "《象》曰：利幽人之貞，未變常也。",
            "《象》曰：歸妹以須，未當也。",
            "《象》曰：愆期之志，有待而行也。",
            "《象》曰：帝乙歸妹，不如其娣之袂良也。其位在中，以貴行也。",
            "《象》曰：上六无實，承虛筐也。"
        ]
    }, {
        "gua-name": "豐",
        "gua-xiang": "101100",
        "gua-detail": "豐亨，王假之，勿憂，宜日中。",
        "gua-tuanText" : "《彖》曰：豐，大也。明以動，故豐。王假之，尚大也；勿憂，宜日中，宜照天下也。日中則昃，月盈則食，天地盈虛，與時消息，而況於人乎？況於鬼神乎？",
        "gua-xiangText" : "《象》曰：雷電皆至，豐，君子以折獄致刑。",
        "yao-detail": [
            "遇其配主，雖旬无咎，往有尚。",
            "豐其蔀，日中見斗。往得疑疾，有孚發若，吉。",
            "豐其沛，日中見沬。折其右肱，无咎。",
            "豐其蔀，日中見斗，遇其夷主，吉。",
            "來章，有慶譽，吉。",
            "豐其屋，蔀其家，闚其戶，闃其无人，三歲不覿，凶。"
        ],
        "yao-xiangText": [
            "《象》曰：雖旬无咎，過旬災也。",
            "《象》曰：有孚發若，信以發志也。",
            "《象》曰：豐其沛，不可大事也；折其右肱，終不可用也。",
            "《象》曰：豐其蔀，位不當也；日中見斗，幽不明也；遇其夷主，吉行也。",
            "《象》曰：六五之吉，有慶也。",
            "《象》曰：豐其屋，天際翔也；闚其戶，闃其无人，自藏也。"
        ]
    }, {
        "gua-name": "旅",
        "gua-xiang": "001101",
        "gua-detail": "旅，小亨，旅貞吉。",
        "gua-tuanText" : "《彖》曰：旅，小亨，柔得中乎外而順乎剛，止而麗乎明，是以小亨，旅貞吉也，旅之時義大矣哉。",
        "gua-xiangText" : "《象》曰：山上有火，旅，君子以明慎用刑而不留獄。",
        "yao-detail": [
            "旅瑣瑣，斯其所取災。",
            "旅即次，懷其資，得童僕貞。",
            "旅焚其次，喪其童僕，貞厲。",
            "旅于處，得其資斧，我心不快。",
            "射雉，一矢亡，終以譽命。",
            "鳥焚其巢，旅人先笑後號咷，喪牛于易，凶。"
        ],
        "yao-xiangText": [
            "《象》曰：旅瑣瑣，志窮災也。",
            "《象》曰：得童僕貞，終无尤也。",
            "《象》曰：旅焚其次，亦以傷矣。以旅與下，其義喪也。",
            "《象》曰：旅于處，未得位也；得其資斧，心未快也。",
            "《象》曰：終以譽命，上逮也。",
            "《象》曰：以旅在上，其義焚也；喪牛于易，終莫之聞也。"
        ]
    }, {
        "gua-name": "巽",
        "gua-xiang": "011011",
        "gua-detail": "巽，小亨，利有攸往，利見大人。",
        "gua-tuanText" : "《彖》曰：重巽以申命，剛巽乎中正而志行，柔皆順乎剛，是以小亨，利有攸往，利見大人。",
        "gua-xiangText" : "《象》曰：隨風，巽，君子以申命行事。",
        "yao-detail": [
            "進退，利武人之貞。",
            "巽在床下，用史巫紛若，吉无咎。",
            "頻巽，吝。",
            "悔亡，田獲三品。",
            "貞吉，悔亡，无不利。无初有終，先庚三日，後庚三日，吉。",
            "巽在床下，喪其資斧，貞凶。"
        ],
        "yao-xiangText": [
            "《象》曰：進退，志疑也；利武人之貞，志治也。",
            "《象》曰：紛若之吉，得中也。",
            "《象》曰：頻巽之吝，志窮也。",
            "《象》曰：田獲三品，有功也。",
            "《象》曰：九五之吉，位正中也。",
            "《象》曰：巽在床下，上窮也；喪其資斧，正乎凶也。"
        ]
    }, {
        "gua-name": "兌",
        "gua-xiang": "110110",
        "gua-detail": "兌，亨，利貞。",
        "gua-tuanText" : "《彖》曰：兌，說也。剛中而柔外，說以利貞，是以順乎天而應乎人。說以先民，民忘其勞，說以犯難，民忘其死，說之大，民勸矣哉。",
        "gua-xiangText" : "《象》曰：麗澤，兌。君子以朋友講習。",
        "yao-detail": [
            "和兌吉。",
            "孚兌，吉，悔亡。",
            "來兌，凶。",
            "商兌未寧，介疾有喜。",
            "孚于剝，有厲。",
            "引兌。"
        ],
        "yao-xiangText": [
            "《象》曰：和兌之吉，行未疑也。",
            "《象》曰：孚兌之吉，信志也。",
            "《象》曰：來兌之凶，位不當也。",
            "《象》曰：九四之喜，有慶也。",
            "《象》曰：孚于剝，位正當也。",
            "《象》曰：上六引兌，未光也。"
        ]
    }, {
        "gua-name": "渙",
        "gua-xiang": "010011",
        "gua-detail": "渙亨，王假有廟，利涉大川，利貞。",
        "gua-tuanText" : "《彖》曰：渙亨，剛來而不窮，柔得位乎外而上同。王假有廟，王乃在中也。利涉大川，乘木有功也。",
        "gua-xiangText" : "《象》曰：風行水上，渙，先王以享于帝，立廟。",
        "yao-detail": [
            "用拯馬壯，吉。",
            "渙奔其机，悔亡。",
            "渙其躬，无悔。",
            "渙其群，元吉。渙有丘，匪夷所思。",
            "渙其汗，大號，渙王居，无咎。",
            "渙其血，去逖出，无咎。"
        ],
        "yao-xiangText": [
            "《象》曰：初六之吉，順也。",
            "《象》曰：渙奔其机，得願也。",
            "《象》曰：渙其躬，志在外也。",
            "《象》曰：渙其群，元吉，光大也。",
            "《象》曰：王居无咎，正位也。",
            "《象》曰：渙其血，遠害也。"
        ]
    }, {
        "gua-name": "節",
        "gua-xiang": "110010",
        "gua-detail": "節亨。苦節，不可貞。",
        "gua-tuanText" : "《彖》曰：節亨，剛柔分而剛得中。苦節不可貞，其道窮也。說以行險，當位以節，中正以通。天地節而四時成，節以制度，不傷財，不害民。",
        "gua-xiangText" : "《象》曰：澤上有水，節。君子以制數度，議德行。",
        "yao-detail": [
            "不出戶庭，无咎。",
            "不出門庭，凶。",
            "不節若，則嗟若，无咎。",
            "安節，亨。",
            "甘節，吉，往有尚。",
            "苦節，貞凶，悔亡。"
        ],
        "yao-xiangText": [
            "《象》曰：不出戶庭，知通塞也。",
            "《象》曰：不出門庭凶，失時極也。",
            "《象》曰：不節之嗟，又誰咎也。",
            "《象》曰：安節之亨，承上道也。",
            "《象》曰：甘節之吉，居位中也。",
            "《象》曰：苦節貞凶，其道窮也。"
        ]
    }, {
        "gua-name": "中孚",
        "gua-xiang": "110011",
        "gua-detail": "中孚，豚魚吉，利涉大川，利貞。",
        "gua-tuanText" : "《彖》曰：中孚，柔在內而剛得中，說而巽，孚，乃化邦也。豚魚吉，信及豚魚也；利涉大川，乘木舟虛也；中孚以利貞，乃應乎天也。",
        "gua-xiangText" : "《象》曰：澤上有風，中孚，君子以議獄緩死。",
        "yao-detail": [
            "虞吉，有它不燕。",
            "鳴鶴在陰，其子和之；我有好爵，吾與爾靡之。",
            "得敵，或鼓或罷，或泣或歌。",
            "月幾望，馬匹亡，无咎。",
            "有孚攣如，无咎。",
            "翰音登于天，貞凶。"
        ],
        "yao-xiangText": [
            "《象》曰：初九虞吉，志未變也。",
            "《象》曰：其子和之，中心願也。",
            "《象》曰：或鼓或罷，位不當也。",
            "《象》曰：馬匹亡，絕類上也。",
            "《象》曰：有孚攣如，位正當也。",
            "《象》曰：翰音登于天，何可長也。"
        ]
    }, {
        "gua-name": "小過",
        "gua-xiang": "001100",
        "gua-detail": "小過，亨，利貞。可小事，不可大事。飛鳥遺之音，不宜上，宜下。大吉。",
        "gua-tuanText" : "《彖》曰：小過，小者過而亨也，過以利貞，與時行也。柔得中，是以小事吉也；剛失位而不中，是以不可大事也。有飛鳥之象焉，飛鳥遺之音，不宜上，宜下，大吉，上逆而下順也。",
        "gua-xiangText" : "《象》曰：山上有雷，小過。君子以行過乎恭，喪過乎哀，用過乎儉。",
        "yao-detail": [
            "飛鳥以凶。",
            "過其祖，遇其妣，不及其君，遇其臣，无咎。",
            "弗過防之，從或戕之，凶。",
            "无咎，弗過遇之，往厲必戒，勿用永貞。",
            "密雲不雨，自我西郊，公弋取彼在穴。",
            "弗遇過之，飛鳥離之，凶，是謂災眚。"
        ],
        "yao-xiangText": [
            "《象》曰：飛鳥以凶，不可如何也。",
            "《象》曰：不及其君，臣不可過也。",
            "《象》曰：從或戕之，凶如何也。",
            "《象》曰：弗過遇之，位不當也；往厲必戒，終不可長也。",
            "《象》曰：密雲不雨，已上也。",
            "《象》曰：弗遇過之，已亢也。"
        ]
    }, {
        "gua-name": "既濟",
        "gua-xiang": "101010",
        "gua-detail": "既濟，亨小，利貞。初吉終亂。",
        "gua-tuanText" : "《彖》曰：既濟亨，小者亨也。利貞，剛柔正而位當也。初吉，柔得中也，終止則亂，其道窮也。",
        "gua-xiangText" : "《象》曰：水在火上，既濟，君子以思患而豫防之。",
        "yao-detail": [
            "曳其輪，濡其尾，无咎。",
            "婦喪其茀，勿逐，七日得。",
            "高宗伐鬼方，三年克之，小人勿用。",
            "繻有衣袽，終日戒。",
            "東鄰殺牛，不如西鄰之禴祭，實受其福。",
            "濡其首，厲。"
        ],
        "yao-xiangText": [
            "《象》曰：曳其輪，義无咎也。",
            "《象》曰：七日得，以中道也。",
            "《象》曰：三年克之，憊也。",
            "《象》曰：終日戒，有所疑也。",
            "《象》曰：東鄰殺牛，不如西鄰之時也，實受其福，吉大來也。",
            "《象》曰：濡其首厲，何可久也。"
        ]
    }, {
        "gua-name": "未濟",
        "gua-xiang": "010101",
        "gua-detail": "未濟，亨。小狐汔濟，濡其尾，无攸利。",
        "gua-tuanText" : "《彖》曰：未濟亨，柔得中也；小狐汔濟，未出中也；濡其尾，无攸利，不續終也，雖不當位，剛柔應也。",
        "gua-xiangText" : "《象》曰：火在水上，未濟，君子以慎辨物居方。",
        "yao-detail": [
            "濡其尾，吝。",
            "曳其輪，貞吉。",
            "未濟，征凶，利涉大川。",
            "貞吉，悔亡，震用伐鬼方，三年有賞于大國。",
            "貞吉无悔，君子之光，有孚，吉。",
            "有孚于飲酒，无咎。濡其首，有孚，失是。"
        ],
        "yao-xiangText": [
            "《象》曰：濡其尾，亦不知極也。",
            "《象》曰：九二貞吉，中以行正也。",
            "《象》曰：未濟征凶，位不當也。",
            "《象》曰：貞吉悔亡，志行也。",
            "《象》曰：君子之光，其暉吉也。",
            "《象》曰：飲酒濡首，亦不知節也。"
        ]
    }]

function getFullGuaName(guaXiang, guaName) {
    var name = ['地', '雷', '水', '澤', '山', '火', '風', '天'];
    var last = parseInt(guaXiang[0]) + parseInt(guaXiang[1]) * 2
            + parseInt(guaXiang[2]) * 4;
    var first = parseInt(guaXiang[3]) + parseInt(guaXiang[4]) * 2
            + parseInt(guaXiang[5]) * 4;
    if (first === last) {
        return guaName + '为' + name[first];
    } else {
        return name[first] + name[last] + guaName;
    }
}

function getGua(guaXiang){
    if(guaXiang.length != 6){
        //alert error
        return;
    }
    //console.log(_gua.length);
    var result = null;
    for (var i = 0; i < _gua.length; i++) {
        //console.log(_gua[i]['gua-xiang']);
        if (_gua[i]['gua-xiang'] === guaXiang) {
            result = _gua[i];
        }
    }
    result['gua-fullName'] = getFullGuaName(guaXiang,result['gua-name']);
    var yaoNames=[];
    for(var i=0; i < result['gua-xiang'].length; i++){
        var yaoName = result['gua-xiang'][i] == 0 ? '六' : '九';
        switch(i){
            case 0:
                yaoName = '初' + yaoName;
                break;
            case 1:
                yaoName = yaoName + '二';
                break;
            case 2:
                yaoName = yaoName + '三';
                break;
            case 3:
                yaoName = yaoName + '四';
                break;
            case 4:
                yaoName = yaoName + '五';
                break;
            case 5:
                yaoName = '上' + yaoName;
                break;
            default:
        }
        yaoNames[i] = yaoName;
    }
    result['yao-name'] = yaoNames;
    return result;
}

function qiGua(qigua){
    if(qigua.length != 6){
        //alert error
        return;
    }
    var benGx = ''
    var zhiGx = ''
    for (var i = 0; i < qigua.length; i++) {
        var benYao = qigua[i] % 2 == 0 ? 0 : 1;
        var bianYao = '';
        if(qigua[i] == 6){
            bianYao = 1;
        }else if(qigua[i] == 9){
            bianYao = 0;
        }else{
            bianYao = benYao;
        }
        benGx = benGx + benYao;
        zhiGx = zhiGx + bianYao;
    }
    // console.log(benGx);
    // console.log(zhiGx);
    var bengua = getGua(benGx);
    var zhigua = getGua(zhiGx);
    // console.log(bengua);
    // console.log(zhigua);
    return {
        'qigua' : qigua,
        'qiguaName' : (bengua == zhigua) ? bengua['gua-fullName'] : (bengua['gua-name'] + '之' + zhigua['gua-name']),
        'benGua' : bengua,
        'zhiGua' : zhigua
    }
}

/**
 * Created by lance.lu on 2017/11/10.
 */

(function() {
    'use strict';
    angular.module('app.admin').filter('Percentage', function() { //可以注入依赖
        return function(text) {
            var newArguments= (text*100).toFixed(2)+"%";
            return newArguments
        }
    });
})();

/**
 * Created by troy.zhao on 2017/7/5.
 */
(function() {
    'use strict';
    angular
        .module('ui.changeSkin',[]) //对应项目的module 请换成自己的模块名称
        .directive('changeSkin', changeSkin)
        .directive('changeStyle',changeStyle)
    function changeSkin($timeout){
        return {
            restrict: 'C',
            scope: {
                truncateOptions: '='
            },
            link: function(scope, element ,attr) {
                $timeout(function(){
                    angular.element("body").addClass(localStorage.skin);
                    angular.element("body").removeClass("skin-1 skin-2 skin-3 skin-4");
                    angular.element(".changeSkin").click(function () {
                        var skin =angular.element(this).attr("data-value");
                        var current =localStorage.skin;
                        angular.element("body").removeClass(current);
                        angular.element("body").addClass(skin);
                        localStorage.skin = skin;
                        angular.element("body").attr("data-value",skin);
                    });
                });
            }
        };
    }
    function changeStyle($timeout) {
        return {
            restrict: 'C',
            scope: {
                truncateOptions: '='
            },
            link: function(scope, element ,attr) {
                $timeout(function(){
                    angular.element("body").addClass(localStorage.style);
                    angular.element(".changeStyle").click(function () {
                        var style =angular.element(this).attr("data-value");
                        angular.element("body").removeClass("md-skin");
                        angular.element("body").addClass(style);
                        localStorage.style = style;
                    });
                });
            }
        };
    }


    angular
        .module('ui.changeAdminSkin',[]) //对应项目的module 请换成自己的模块名称
        .directive('changeAdminStyle',changeAdminStyle);
    function changeAdminStyle($timeout) {
        return {
            restrict: 'C',
            scope: {
                truncateOptions: '='
            },
            link: function(scope, element ,attr) {
                $timeout(function(){
                    if(localStorage.style == "md-skin"){
                        angular.element(".navbar-staic-top").addClass('navbar-fixed-top').removeClass("navbar-staic-top");
                        angular.element("body").addClass("md-skin");
                        angular.element("body").addClass("fixed-nav");
                    }else{
                        angular.element(".navbar-fixed-top").addClass('navbar-staic-top').removeClass("navbar-fixed-top");
                        angular.element("body").removeClass("fixed-nav");
                        switch (localStorage.skin){
                            case "skin-a":
                                angular.element("body").addClass("skin-1").removeClass("skin-a");
                                angular.element("body").removeClass("default-bg");
                                break;
                            case "skin-b":
                                angular.element("body").addClass("skin-3").removeClass("skin-b");
                                angular.element("body").removeClass("default-bg");
                                break;
                            case "skin-c":
                                angular.element("body").addClass("").removeClass("skin-c");
                                angular.element("body").addClass("default-bg");
                                break;
                            case "skin-d":
                                angular.element("body").addClass("").removeClass("skin-d");
                                angular.element("body").addClass("default-bg");
                                break;
                        }
                    }
                    angular.element(".changeAdminStyle").click(function () {
                        var style =angular.element(this).attr("data-value");
                        if(style=="md-skin"){
                            angular.element("body").addClass("md-skin");
                            angular.element(".navbar-staic-top").addClass('navbar-fixed-top').removeClass("navbar-staic-top");
                            angular.element("body").addClass("fixed-nav");
                        }else{
                            angular.element("body").removeClass("md-skin");
                            angular.element(".navbar-fixed-top").addClass('navbar-staic-top').removeClass("navbar-fixed-top");
                            angular.element("body").removeClass("fixed-nav");
                        }

                    });
                });
            }
        };
    }
})();
/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('app.admin')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });



(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('admin', {
                abstract: true,
                url: "/admin",
                templateUrl: "app/admin/layout/adminLayout.html",
                resolve: {
                    authorize: ['Auth',
                        function (Auth) {
                            return Auth.authorize();
                        }
                    ],
                    // deps:["$ocLazyLoad",function($ocLazyLoad){
                    //     return $ocLazyLoad.load("assets/css/admin.css");
                    // }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('adminMenu');
                    }]
                }
            })
            .state('admin.dashboard', {
                url: "/dashboard",
                templateUrl: "app/admin/dashboard/dashboard.html",
                controller: 'DashboardController',
                controllerAs: 'vm',
                data: { pageTitle: 'Example view' }
            })
            .state('admin.guaCalendar', {
                url: "/guaCalendar",
                templateUrl: "app/admin/layout/common/ibox-content.html",
                data: { pageTitle: 'Example view' }
            })
            .state('admin.guaTopicQiGua', {
                url: "/guaTopicQiGua",
                templateUrl: "app/admin/layout/common/ibox-content.html",
                data: { pageTitle: 'Example view' }
            })
            .state('admin.guaTopic', {
                url: "/guaTopic",
                templateUrl: "app/admin/layout/common/ibox-content.html",
                data: { pageTitle: 'Example view' }
            })
            .state('admin.checkInRewardAndProduct', {
                url: "/checkInRewardAndProduct",
                templateUrl: "app/admin/layout/common/ibox-content.html",
                data: { pageTitle: 'Example view' }
            })
            .state('admin.wxCusServiceMsg', {
                url: "/wxCusServiceMsg",
                templateUrl: "app/admin/layout/common/ibox-content.html",
                data: { pageTitle: 'Example view' }
            })
            .state('admin.sys-admin', {
                url: "/sys-admin",
                templateUrl: "app/admin/layout/common/ibox-content.html",
                data: {pageTitle: 'Example view'}
            })
            .state('admin.oss-service', {
                url: "/oss-service",
                templateUrl: "app/admin/layout/common/ibox-content.html",
                data: {pageTitle: 'Example view'}
            })
            .state('admin.message', {
                url: "/message",
                templateUrl: "app/admin/layout/common/ibox-content.html",
                data: {pageTitle: 'Example view'}
            });
        $urlRouterProvider.otherwise('/admin/dashboard');
    }
})();

/**
 * Created by Benjamin Qin on 5/23/2017.
 */
(function () {
    'use strict';

    angular.module('app.admin')
        .value('userName', '钱先生')
        .value('title', '管理员')
        .value('menus', [
            {
                name: '概况',
                icon: 'fa fa-dashboard',
                routerLink: "/admin/dashboard",
                routeName: "admin.dashboard",
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_CONSULTANT', 'ROLE_TEACHER']
            },
            {
                name: '占卦管理',
                icon: 'fa fa-graduation-cap',
                routerLink: "#",
                routeName: "admin.guaTopicQiGua",
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_TEACHER'],
                children: [
                    {
                        name: "新增占卦",
                        routeLink: "/admin/guaTopicQiGua/guaTopicQiGua/new?page&sort&search",
                        routeName: "admin.guaTopicQiGua.guaTopicQiGua.new"
                    },
                    {
                        name: "占卦列表",
                        routeLink: "/admin/guaTopicQiGua/guaTopicQiGua?page&sort&search",
                        routeName: "admin.guaTopicQiGua.guaTopicQiGua"
                    }
                ]
            },
            {
                name: '大事先知管理',
                icon: 'fa fa-heart',
                routerLink: "#",
                routeName: "admin.guaTopic",
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_CONSULTANT'],
                children: [
                    {
                        name: "新增大事先知",
                        routeLink: "/admin/guaTopic/guaTopic/new?page&sort&search",
                        routeName: "admin.guaTopic.guaTopic.new"
                    },
                    {
                        name: "大事先知列表",
                        routeLink: "/admin/guaTopic/guaTopic?page&sort&search",
                        routeName: "admin.guaTopic.guaTopic"
                    }
                ]
            },
            {
                name: '日历管理',
                icon: 'fa fa-calendar',
                routerLink: "#",
                routeName: "admin.guaCalendar",
                authorities: ['ROLE_ADMIN'],
                children: [
                    {
                        name: "新增日历",
                        routeLink: "/admin/guaCalendar/guaCalendar-new?page&sort&search",
                        routeName: "admin.guaCalendar.guaCalendar.new"
                    },
                    {
                        name: "日历维护",
                        routeLink: "/admin/guaCalendar/guaCalendar?page&sort&search",
                        routeName: "admin.guaCalendar.guaCalendar"
                    },
                    {
                        name: "日历生效周期",
                        routeLink: "/admin/guaCalendar/effectivePeriod?page&sort&search",
                        routeName: "admin.guaCalendar.effectivePeriod"
                    }
                ]
            },
            {
                name: '客服消息管理',
                icon: 'fa fa-bank',
                routerLink: "#",
                routeName: "admin.wxCusServiceMsg",
                authorities: ['ROLE_ADMIN'],
                children: [
                    {
                        name: "新增客服消息",
                        routeLink: "/admin/wxCusServiceMsg/wxCusServiceMsg/new?page&sort&search",
                        routeName: "admin.wxCusServiceMsg.wxCusServiceMsg.new"
                    },
                    {
                        name: "客服消息管理",
                        routeLink: "/admin/wxCusServiceMsg/wxCusServiceMsg?page&sort&search",
                        routeName: "admin.wxCusServiceMsg.wxCusServiceMsg"
                    }
                ]
            },
            {
                name: '用户管理',
                icon: 'fa fa-user',
                routerLink: "#",
                routeName: "admin.sys-admin",
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_CONSULTANT'],
                children: [
                    {
                        name: "用户列表",
                        routeLink: "/admin/sys-admin/user-management?page&sort&search",
                        routeName: "admin.sys-admin.user-management"
                    }
                ]
            },
            {
                name: '签到及奖品管理',
                icon: 'fa fa-pencil-square-o',
                routerLink: "#",
                routeName: "admin.checkInRewardAndProduct",
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_CONSULTANT'],
                children: [
                    {
                        name: "签到设置",
                        routeLink: "/admin/checkInRewardAndProduct/checkInReward?page&sort&search",
                        routeName: "admin.checkInRewardAndProduct.checkInReward"
                    },
                    {
                        name: '新增奖品',
                        routerLink: "/admin/checkInRewardAndProduct/product-new?page&sort&search",
                        routeName: "admin.checkInRewardAndProduct.product.new"
                    },
                    {
                        name: "奖品列表",
                        routeLink: "/admin/checkInRewardAndProduct/product?page&sort&search",
                        routeName: "admin.checkInRewardAndProduct.product"
                    }
                ]
            },
            {
                name: 'OSS服务管理',
                icon: 'fa fa-folder-open-o',
                routerLink: "#",
                routeName: "admin.oss-service",
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_CONSULTANT'],
                children: [
                    {
                        name: "文件列表",
                        routeLink: "/admin/oss-service/oss-service?page&sort&search",
                        routeName: "admin.oss-service.oss-service"
                    }
                ]
            },
            {
                name: '提示消息管理',
                icon: 'fa fa-bell-o',
                routerLink: "#",
                routeName: "admin.message",
                authorities: ['ROLE_ADMIN', 'ROLE_PLACE_ADMIN', 'ROLE_CONSULTANT'],
                children: [
                    {
                        name: "提示消息列表",
                        routeLink: "/admin/message/messages?page&sort&search",
                        routeName: "admin.message.messages"
                    }
                ]
            },
        ]);
})();


(function() {
    'use strict';

    angular
        .module('app.core')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            data: {
                menuList: account_menu
            },
            // templateUrl: "app/front/layout/frontLayout.html",
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('frontMenu');
                }]
            },
            views: {
                '':
                {
                    templateUrl: "app/front/layout/frontLayout.html"
                },
                'topNav@account':{
                    templateUrl: 'app/front/layout/topnavbar.html',
                    controller: 'NavigationController',
                    controllerAs: 'vm'
                }
            }
        });
    }

    var account_menu = [
        {
            name: '登录',
            icon: 'fa fa-user',
            routerLink: "/login",
            routeName: "login"
        }
    ];
})();

/**
 * Created by Benjamin Qin on 5/23/2017.
 */
(function() {
  'use strict';

  angular.module('app',['app.front', 'app.admin', 'app.core']);
})();

(function() {
  'use strict';

  angular.module('app')
    .config(lazyLoadConfig)
    .config(routerConfig);


  /** @ngInject */
  function lazyLoadConfig($ocLazyLoadProvider) {
    $ocLazyLoadProvider.config({
      debug: false,
      events: false
    });
  }

  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('app', {
        abstract: true,
        resolve: {
          authorize: ['Auth',
            function (Auth) {
              return Auth.authorize();
            }
          ],
          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart('global');
          }]
        }
      })
      .state('login', {
        url: "/login",
        templateUrl: "app/login/login.html",
        controller: "LoginPageController",
        controllerAs: "vm",
        resolve:{
          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            $translatePartialLoader.addPart('login');
            return $translate.refresh();
          }]
        }
        // resolve:{
        //   deps:["$ocLazyLoad",function($ocLazyLoad){
        //     return $ocLazyLoad.load("assets/css/login.css");
        //   }]
        // }
      });


    $urlRouterProvider.otherwise('login');
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .run(runBlock);

  /** @ngInject */
  function runBlock(stateHandler, $log) {
    stateHandler.initialize();
    $log.debug('runBlock end');
  }
})();

/**
 * Created by Benjamin Qin on 5/23/2017.
 */
(function () {
  'use strict';

  angular.module('app')
    .constant('VERSION', "2.0")
    .constant('DEBUG_INFO_ENABLED', true)
})();


angular.module("app.core").run(["$templateCache", function($templateCache) {$templateCache.put("app/login/login.html","<div id=\"login\" ng-class=\"vm.$state.current.name\"><div class=\"ribbons left ribbon-holder\"><a href=\"#\" class=\"ribbon red\"><span class=\"text\">易天天</span></a></div><div id=\"brand\" class=\"row\"><div class=\"col-xs-3 col-sm-4\"></div><div class=\"col-xs-9 col-sm-8\"><div><div class=\"logo-name\">易天天后台管理平台</div></div></div></div><div id=\"login-container\" class=\"loginColumns text-center loginContainer\"><div id=\"login-box\" class=\"row animated fadeInRight\"><div class=\"col-sm-12 no-padding\"><div id=\"login-error\" class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" data-translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-xs-12 no-padding\"><div><img src=\"./assets/images/homepage.jpg\"></div></div><div class=\"col-md-4 col-xs-12\"><div id=\"input-form\"><form class=\"m-t\" role=\"form\" ng-submit=\"vm.login($event)\"><p style=\"text-align:left;font-size:16px;\">请输入账号与密码：</p><div class=\"form-group\"><input type=\"text\" id=\"username\" class=\"form-control\" placeholder=\"账号\" ng-model=\"vm.username\"></div><div class=\"form-group\"><input type=\"password\" id=\"password\" class=\"form-control\" placeholder=\"密码\" ng-model=\"vm.password\"></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\" style=\"box-shadow: 1px 1px 1px #999\">登 录&nbsp;&nbsp;<i class=\"fa fa-sign-in\"></i></button></form></div></div></div></div><div id=\"footer\"><div class=\"col-md-12 text-right\"></div></div><div id=\"canvas-container\" style=\"z-index:-100;position:absolute;top:0px;left:0px;\"></div></div>");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 data-translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" data-translate=\"activate.messages.success\" translate-compile=\"\"><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" data-translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/register/register.html","<div id=\"page-content\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 data-translate=\"register.title\">Registration</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" data-translate=\"register.messages.success\"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" data-translate=\"register.messages.error.fail\"><strong>Registration failed!</strong> Please try again later.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorUserExists\" data-translate=\"register.messages.error.userexists\"><strong>Login name already registered!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.errorEmailExists\" data-translate=\"register.messages.error.emailexists\"><strong>Email is already in use!</strong> Please choose another one.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" data-translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div></div><div class=\"col-md-8 col-md-offset-2\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate=\"\" ng-submit=\"vm.register()\" show-validation=\"\"><div class=\"form-group\"><label class=\"control-label\" for=\"login\" data-translate=\"global.form.username\">Username</label> <input type=\"text\" class=\"form-control\" id=\"login\" name=\"login\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.login\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\" required=\"\"><div ng-show=\"form.login.$dirty && form.login.$invalid\"><p class=\"help-block\" ng-show=\"form.login.$error.required\" data-translate=\"register.messages.validate.login.required\">Your username is required.</p><p class=\"help-block\" ng-show=\"form.login.$error.minlength\" data-translate=\"register.messages.validate.login.minlength\">Your username is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.login.$error.maxlength\" data-translate=\"register.messages.validate.login.maxlength\">Your username cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.login.$error.pattern\" data-translate=\"register.messages.validate.login.pattern\">Your username can only contain lower-case letters and digits.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" data-translate=\"global.form.email\">Email</label> <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required=\"\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" data-translate=\"global.messages.validate.email.required\">Your email is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" data-translate=\"global.messages.validate.email.invalid\">Your email is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" data-translate=\"global.messages.validate.email.minlength\">Your email is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" data-translate=\"global.messages.validate.email.maxlength\">Your email cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"password\" data-translate=\"global.form.newpassword\">New password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.registerAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required=\"\"><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" data-translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" data-translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" data-translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.registerAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" data-translate=\"global.form.confirmpassword\">New password confirmation</label> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required=\"\"><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" data-translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" data-translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" data-translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" data-translate=\"register.form.button\">Register</button></form><p></p><div class=\"alert alert-warning\" data-translate=\"global.messages.info.authenticated\" translate-compile=\"\">If you want to <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>, you can try the default accounts:<br>- Administrator (login=\"admin\" and password=\"admin\")<br>- User (login=\"user\" and password=\"user\").</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/account/settings/settings.html","<form name=\"form\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h2 data-translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2></div><div class=\"alert alert-success\" ng-show=\"vm.success\" data-translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"firstName\" data-translate=\"settings.form.firstname\">First Name</label> <input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required=\"\" maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" data-translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" data-translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" data-translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"lastName\" data-translate=\"settings.form.lastname\">Last Name</label> <input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required=\"\" maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" data-translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" data-translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" data-translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"fullName\" data-translate=\"settings.form.fullName\">Full Name</label> <input type=\"text\" class=\"form-control\" id=\"fullName\" name=\"fullName\" placeholder=\"{{\'settings.form.fullName.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.fullName\" ng-minlength=\"1\" ng-maxlength=\"50\" required=\"\" maxlength=\"50\"><div ng-show=\"form.fullName.$dirty && form.fullName.$invalid\"><p class=\"help-block\" ng-show=\"form.fullName.$error.required\" data-translate=\"settings.messages.validate.fullName.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.fullName.$error.minlength\" data-translate=\"settings.messages.validate.fullName.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.fullName.$error.maxlength\" data-translate=\"settings.messages.validate.fullName.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"gender\" data-translate=\"settings.form.gender\">Gender</label><select class=\"form-control\" name=\"gender\" ng-model=\"vm.settingsAccount.gender\" id=\"gender\"><option value=\"MALE\" data-translate=\"hseApp.Gender.MALE\">MALE</option><option value=\"FEMALE\" data-translate=\"hseApp.Gender.FEMALE\">FEMALE</option></select></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"nationality\" data-translate=\"settings.form.nationality\">Nationality</label> <input type=\"text\" class=\"form-control\" id=\"nationality\" name=\"nationality\" placeholder=\"{{\'settings.form.nationality.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.nationality\" ng-minlength=\"1\" ng-maxlength=\"50\" maxlength=\"50\"></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"email\" data-translate=\"global.form.email\">Email</label> <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required=\"\" maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" data-translate=\"global.messages.validate.email.required\">Your email is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" data-translate=\"global.messages.validate.email.invalid\">Your email is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" data-translate=\"global.messages.validate.email.minlength\">Your email is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" data-translate=\"global.messages.validate.email.maxlength\">Your email cannot be longer than 100 characters.</p></div></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"telephone\" data-translate=\"settings.form.telephone\">Telephone</label> <input type=\"text\" class=\"form-control\" id=\"telephone\" name=\"telephone\" ng-model=\"vm.settingsAccount.telephone\" ng-minlength=\"1\" ng-maxlength=\"50\" maxlength=\"50\"></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"mobilePhone\" data-translate=\"settings.form.mobilePhone\">MobilePhone</label> <input type=\"text\" class=\"form-control\" id=\"mobilePhone\" name=\"mobilePhone\" ng-model=\"vm.settingsAccount.mobilePhone\" ng-minlength=\"1\" ng-maxlength=\"50\" maxlength=\"50\"></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"userType\" data-translate=\"settings.form.userType\">User Type</label> <input ng-readonly=\"true\" type=\"text\" class=\"form-control\" id=\"userType\" name=\"userType\" value=\"{{\'hseApp.UserType.\'+ vm.settingsAccount.userType | translate}}\"></div><div class=\"form-group col-md-6\"><label data-translate=\"settings.form.employeeNumber\">EmployeeNumber</label> <input type=\"text\" class=\"form-control\" name=\"employeeNumber\" ng-model=\"vm.settingsAccount.employeeNumber\" ng-readonly=\"true\"></div><div class=\"form-group col-md-6\"><label class=\"control-label\" data-translate=\"settings.form.org\" for=\"field_org\">Org</label> <input ng-readonly=\"true\" type=\"text\" class=\"form-control\" id=\"field_org\" name=\"org\" ng-model=\"vm.settingsAccount.orgName\"></div><div class=\"form-group col-md-6\"><label class=\"control-label\" data-translate=\"settings.form.dept\" for=\"field_dept\">Dept</label> <input ng-readonly=\"true\" type=\"text\" class=\"form-control\" id=\"field_dept\" name=\"dept\" ng-model=\"vm.settingsAccount.deptName\"></div><div class=\"form-group col-md-6\"><label class=\"control-label\" data-translate=\"settings.form.jobTitle\" for=\"jobTitle\">Job Title</label> <input ng-readonly=\"true\" type=\"text\" class=\"form-control\" id=\"jobTitle\" name=\"jobTitle\" ng-model=\"vm.settingsAccount.jobTitle\"></div><div class=\"form-group col-md-6\"><label class=\"control-label\" data-translate=\"settings.form.superiorId\" for=\"superiorId\">Superior Id</label> <input ng-readonly=\"true\" type=\"text\" class=\"form-control\" id=\"superiorId\" name=\"superiorId\" ng-model=\"vm.settingsAccount.superiorId\"></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"form.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"settings.form.button\">Save</span></button></div></div></div></form>");
$templateCache.put("app/admin/dashboard/dashboard.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Hello</h1><small>欢迎 <i class=\"glyphicon glyphicon-pencil\"></i></small></div></div><div class=\"col-md-6\" style=\"margin-top: 20px\"><div class=\"ibox float-e-margins\" style=\"min-height: auto\"><div class=\"ibox-title\"><h5>每日数据统计</h5><label class=\"label label-primary pull-right\">今日</label></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><small class=\"stats-label\">今日注册人数</small><h3>{{vm.registerQty}}</h3></div><div class=\"col-sm-4\"><small class=\"stats-label\">今日活跃人数</small><h3>{{vm.loginQty}}</h3></div><div class=\"col-sm-4\"><small class=\"stats-label\">今日签到人数</small><h3>{{vm.checkInQty}}</h3></div></div></div></div></div></div></div>");
$templateCache.put("app/admin/layout/adminLayout.html","<div id=\"wrapper\"><div ng-include=\"\'app/admin/layout/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/admin/layout/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/admin/layout/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/admin/messages/messages-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">提示消息设置</h2></div><div class=\"modal-body\"><div class=\"row text-label-right\" ng-repeat=\"messages in vm.messages track by messages.id\"><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"content\">{{messages.page}}:</label><div class=\"col-sm-2 lineHeight34\" ng-if=\"messages.title\"><input type=\"text\" class=\"form-control\" id=\"title\" ng-model=\"messages.title\" name=\"title\"></div><div class=\"col-sm-4 lineHeight34\"><input type=\"text\" class=\"form-control\" id=\"content\" ng-model=\"messages.content\" name=\"content\"></div><button type=\"button\" ng-click=\"vm.save(messages.id,messages.page,messages.content, messages.title)\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-save\"></span> <span class=\"hidden-sm-down\">确认修改</span></button></div></div></div></form>");
$templateCache.put("app/admin/oss-service/oss-service-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"\">删除OSS文件</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"\">请问是否删除文件：{{vm.fileName}}</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"\">取消</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"\">删除</span></button></div></form>");
$templateCache.put("app/admin/oss-service/oss-service-detail.html","<div><h2><span data-translate=\"easyDayApp.ossLog.detail.title\">Oss Log</span> {{vm.ossLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"easyDayApp.ossLog.operationType\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.operationType\' | translate}}\">Operation Type</span></dt><dd><span>{{vm.ossLog.operationType}}</span></dd><dt><span data-translate=\"easyDayApp.ossLog.bucketName\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.bucketName\' | translate}}\">Bucket Name</span></dt><dd><span>{{vm.ossLog.bucketName}}</span></dd><dt><span data-translate=\"easyDayApp.ossLog.fileName\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.fileName\' | translate}}\">File Name</span></dt><dd><span>{{vm.ossLog.fileName}}</span></dd><dt><span data-translate=\"easyDayApp.ossLog.fileType\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.fileType\' | translate}}\">File Type</span></dt><dd><span>{{vm.ossLog.fileType}}</span></dd><dt><span data-translate=\"easyDayApp.ossLog.fileSize\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.fileSize\' | translate}}\">File Size</span></dt><dd><span>{{vm.ossLog.fileSize}}</span></dd><dt><span data-translate=\"easyDayApp.ossLog.createdDate\">Created Date</span></dt><dd><span>{{vm.ossLog.createdDate | date:\'medium\'}}</span></dd><dt><span data-translate=\"easyDayApp.ossLog.createdBy\">Created By</span></dt><dd><span>{{vm.ossLog.createdBy}}</span></dd><dt><span data-translate=\"easyDayApp.ossLog.lastModifiedDate\">Last Modified Date</span></dt><dd><span>{{vm.ossLog.lastModifiedDate | date:\'medium\'}}</span></dd><dt><span data-translate=\"easyDayApp.ossLog.lastModifiedBy\">Last Modified By</span></dt><dd><span>{{vm.ossLog.lastModifiedBy}}</span></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button> <button type=\"button\" ui-sref=\"oss-log-detail.edit({id:vm.ossLog.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/admin/oss-service/oss-service-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOssLogLabel\" data-translate=\"easyDayApp.ossLog.home.createOrEditLabel\">Create or edit a Oss Log</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.ossLog.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.ossLog.id\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.operationType\" for=\"field_operationType\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.operationType\' | translate}}\">Operation Type</label> <input type=\"text\" class=\"form-control\" name=\"operationType\" id=\"field_operationType\" ng-model=\"vm.ossLog.operationType\" required=\"\" ng-maxlength=\"50\"><div ng-show=\"editForm.operationType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.operationType.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.operationType.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.bucketName\" for=\"field_bucketName\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.bucketName\' | translate}}\">Bucket Name</label> <input type=\"text\" class=\"form-control\" name=\"bucketName\" id=\"field_bucketName\" ng-model=\"vm.ossLog.bucketName\" ng-maxlength=\"255\"><div ng-show=\"editForm.bucketName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.bucketName.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.fileName\" for=\"field_fileName\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.fileName\' | translate}}\">File Name</label> <input type=\"text\" class=\"form-control\" name=\"fileName\" id=\"field_fileName\" ng-model=\"vm.ossLog.fileName\" ng-maxlength=\"255\"><div ng-show=\"editForm.fileName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.fileName.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.fileType\" for=\"field_fileType\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.fileType\' | translate}}\">File Type</label> <input type=\"text\" class=\"form-control\" name=\"fileType\" id=\"field_fileType\" ng-model=\"vm.ossLog.fileType\" ng-maxlength=\"255\"><div ng-show=\"editForm.fileType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.fileType.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.fileSize\" for=\"field_fileSize\" uib-tooltip=\"{{\'easyDayApp.ossLog.help.fileSize\' | translate}}\">File Size</label> <input type=\"number\" class=\"form-control\" name=\"fileSize\" id=\"field_fileSize\" ng-model=\"vm.ossLog.fileSize\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.createdDate\" for=\"field_createdDate\">Created Date</label><div class=\"input-group\"><input id=\"field_createdDate\" type=\"text\" class=\"form-control\" name=\"createdDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.ossLog.createdDate\" is-open=\"vm.datePickerOpenStatus.createdDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'createdDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.createdBy\" for=\"field_createdBy\">Created By</label> <input type=\"text\" class=\"form-control\" name=\"createdBy\" id=\"field_createdBy\" ng-model=\"vm.ossLog.createdBy\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.lastModifiedDate\" for=\"field_lastModifiedDate\">Last Modified Date</label><div class=\"input-group\"><input id=\"field_lastModifiedDate\" type=\"text\" class=\"form-control\" name=\"lastModifiedDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.ossLog.lastModifiedDate\" is-open=\"vm.datePickerOpenStatus.lastModifiedDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastModifiedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"easyDayApp.ossLog.lastModifiedBy\" for=\"field_lastModifiedBy\">Last Modified By</label> <input type=\"text\" class=\"form-control\" name=\"lastModifiedBy\" id=\"field_lastModifiedBy\" ng-model=\"vm.ossLog.lastModifiedBy\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/oss-service/oss-service.html","<div><h2 data-translate=\"\">OSS文件列表</h2><jhi-alert></jhi-alert><div class=\"form-group col-md-1\"><span style=\"float: right;line-height: 34px\">当前存储空间:</span></div><div class=\"form-group col-md-2\"><select class=\"form-control\" id=\"month\" ng-model=\"vm.bucketName\" ng-change=\"vm.search()\" ng-options=\"bucket.name as bucket.name for bucket in vm.ossBuckets\" ng-init=\"(vm.bucketName) ? vm.bucketName : vm.bucketName = \'ytt-audio\'\"><option value=\"bucketName\"></option></select></div><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"admin.oss-service.oss-service.upload({bucketName:vm.bucketName})\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"上传文件\">Create new Oss Log</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span data-translate=\"\">Bucket名称</span></th><th><span data-translate=\"\">文件名</span></th><th><span data-translate=\"\">文件大小（KB）</span></th><th><span data-translate=\"\">更新时间</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"ossFile in vm.ossFiles track by ossFile.key\"><td>{{ossFile.bucketName}}</td><td>{{ossFile.key}}</td><td>{{ossFile.size}}</td><td>{{ossFile.lastModified | date:\'medium\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ng-click=\"vm.copyUrl(ossFile.url)\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"\">复制链接</span></button> <button type=\"submit\" ui-sref=\"admin.oss-service.oss-service.delete({bucketName:ossFile.bucketName, fileName:ossFile.key})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center form-group\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" data-translate=\"login.title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 data-translate=\"login.title\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" data-translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" data-translate=\"global.form.username\">Login</label> <input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" data-translate=\"login.form.password\">Password</label> <input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\" ng-show=\"false\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"\"> <span data-translate=\"login.form.rememberme\">Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\" data-translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"alert alert-warning\"><a class=\"alert-link\" href=\"\" ng-click=\"vm.requestResetPassword()\" data-translate=\"login.password.forgot\">Did you forget your password?</a></div><div class=\"alert alert-warning\" data-translate=\"global.messages.info.register\" translate-compile=\"\">You don\'t have an account yet? <a class=\"alert-link\" ng-click=\"vm.register()\">Register a new account</a></div></div></div></div>");
$templateCache.put("app/components/password/password.html","<form name=\"form\" role=\"form\" novalidate=\"\" ng-submit=\"vm.changePassword()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h4></div><div class=\"alert alert-success\" ng-show=\"vm.success\" data-translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" data-translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" data-translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div class=\"modal-body\"><div class=\"row\"><div class=\"form-group\"><label class=\"control-label\" for=\"password\" data-translate=\"global.form.newpassword\">New password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-pattern=\"/^(?![0-9]+$)(?![a-zA-Z]+$)/\" ng-minlength=\"6\" ng-maxlength=\"50\" required=\"\"><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" data-translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\">密码长度至少要有6个字符</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" data-translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error\" data-translate=\"\">密码必须是数字和字母组合</p></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" data-translate=\"global.form.confirmpassword\">New password confirmation</label> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-pattern=\"/^(?![0-9]+$)(?![a-zA-Z]+$)/\" ng-minlength=\"6\" ng-maxlength=\"50\" required=\"\"><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" data-translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" data-translate=\"\">确认密码长度至少要有6个字符</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" data-translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error\" data-translate=\"\">确认密码必须是数字和字母组合</p></div></div></div></div><div class=\"modal-footer\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"form.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"password.form.button\">Save</span></button></div></div></form>");
$templateCache.put("app/components/register/register.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" data-translate=\"register.title\">Register</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.registerFail===\'fail\'\" data-translate=\"register.messages.error.fail\"></div><div class=\"alert alert-danger\" ng-show=\"vm.registerFail===\'userexists\'\" data-translate=\"register.messages.error.userexists\"></div><div class=\"alert alert-danger\" ng-show=\"vm.registerFail===\'emailexists\'\" data-translate=\"register.messages.error.emailexists\"></div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form row\" role=\"form\" ng-submit=\"vm.register($event)\"><div class=\"form-group col-md-12\"><label class=\"control-label\" data-translate=\"register.login\">Login</label> <input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-12\"><label class=\"control-label\" for=\"password\" data-translate=\"register.password\">New password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.user.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required=\"\"><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" data-translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" data-translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" data-translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-12\"><label class=\"control-label\" for=\"confirmPassword\" data-translate=\"register.confirmpassword\">New password confirmation</label> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required=\"\"><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" data-translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" data-translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" data-translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label class=\"control-label\" data-translate=\"register.firstName\">First Name</label> <input type=\"text\" class=\"form-control\" name=\"firstName\" ng-focus=\"vm.guessFirstLastNames();\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"register.lastName\">Last Name</label> <input type=\"text\" class=\"form-control\" name=\"lastName\" ng-focus=\"vm.guessFirstLastNames();\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"register.fullName\">Full Name</label> <input type=\"text\" class=\"form-control\" name=\"fullName\" ng-focus=\"vm.guessFullName();\" ng-model=\"vm.user.fullName\" ng-required=\"vm.user.fullName == null || vm.user.fullName == \'\'\" ng-maxlength=\"50\"><div ng-show=\"editForm.fullName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.fullName.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.fullName.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"register.gender\" for=\"gender\">Gender</label><select class=\"form-control\" name=\"gender\" ng-model=\"vm.user.gender\" id=\"gender\"><option value=\"\" data-translate=\"hseApp.Gender.null\"></option><option value=\"MALE\" data-translate=\"hseApp.Gender.MALE\">MALE</option><option value=\"FEMALE\" data-translate=\"hseApp.Gender.FEMALE\">FEMALE</option></select></div><div class=\"form-group col-md-4\"><label data-translate=\"register.nationality\">Nationality</label> <input type=\"text\" class=\"form-control\" name=\"nationality\" ng-model=\"vm.user.nationality\" ng-maxlength=\"50\"><div ng-show=\"editForm.nationality.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nationality.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"register.idCardNumber\">IdCardNumber</label> <input type=\"text\" class=\"form-control\" name=\"idCardNumber\" ng-model=\"vm.user.idCardNumber\" ng-maxlength=\"50\"><div ng-show=\"editForm.idCardNumber.$invalid\"><p class=\"help-block\" ng-show=\"editForm.idCardNumber.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"register.telephone\">Telephone</label> <input type=\"text\" class=\"form-control\" name=\"telephone\" ng-model=\"vm.user.telephone\" ng-maxlength=\"50\"><div ng-show=\"editForm.telephone.$invalid\"><p class=\"help-block\" ng-show=\"editForm.telephone.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"register.mobilePhone\">MobilePhone</label> <input type=\"text\" class=\"form-control\" name=\"mobilePhone\" ng-model=\"vm.user.mobilePhone\" ng-maxlength=\"50\"><div ng-show=\"editForm.mobilePhone.$invalid\"><p class=\"help-block\" ng-show=\"editForm.mobilePhone.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label class=\"control-label\" data-translate=\"register.email\">Email</label> <input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required=\"\" ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" data-translate=\"global.messages.validate.email.invalid\">Your email is invalid.</p></div></div><div class=\"form-group col-md-4\" style=\"display:none;\"><label data-translate=\"userManagement.langKey\">Lang Key</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><div class=\"form-group col-md-4\"><button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"editForm.$invalid || vm.isSaving\" data-translate=\"register.form.button\">register</button></div></form><p></p></div></div></div>");
$templateCache.put("app/front/layout/breadcrumb.html","<div id=\"breadcrumb\" class=\"row wrapper border-bottom white-bg page-heading\" ng-controller=\"BreadCrumbController as vm\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12\"><ol class=\"breadcrumb\"><li><a ui-sref=\"front.homepage\">首页</a></li><li><span ng-if=\"vm.$state.current.name.indexOf(\'mpick\') != -1\">点餐式培训</span> <span ng-if=\"vm.$state.current.name.indexOf(\'selfstudy\') != -1\">自助式培训</span></li><li data-translate=\"front-menu.{{vm.$state.current.parent}}\" ng-if=\"vm.$state.current.parent\">{{vm.$state.current.parent}}</li><li class=\"active\"><strong data-translate=\"front-menu.{{vm.$state.current.name}}\">{{vm.$state.current.name}}</strong></li></ol></div></div></div></div>");
$templateCache.put("app/front/layout/content.html","<div ng-include=\"\'app/front/layout/breadcrumb.html\'\"></div><div ui-view=\"\"></div><div ui-view=\"content\"></div><div ui-view=\"ibox-content\"></div>");
$templateCache.put("app/front/layout/footer.html","<section id=\"footer\" class=\"white-section footer\" ng-controller=\"FooterController as vm\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-4 changeStyle\"><div>当前登录:{{vm.userDisplayName}}</div></div><div class=\"col-md-4 changeSkin\" style=\"display: none\"></div></div></div></section>");
$templateCache.put("app/front/layout/frontLayout.html","<div class=\"landing-page {{$state.$current.name}} front-page\"><div ui-view=\"topNav\"></div><div id=\"front-content\" class=\"front-content\" ui-view=\"content\"></div><div ng-include=\"\'app/front/layout/footer.html\'\"></div></div>");
$templateCache.put("app/front/layout/no-ibox-content.html","<div id=\"page-content\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\" ui-view=\"private-message-content\"></div></div></div></div>");
$templateCache.put("app/front/layout/topnavbar.html","<div class=\"navbar-wrapper\"><nav class=\"navbar navbar-default navbar-fixed-top\" role=\"navigation\"><div class=\"container\"><div class=\"navbar-left navbar-logo\"><div class=\"row\"><img src=\"assets/images/logo_small.png\"><span>易天天后台管理平台</span></div></div><div class=\"navbar-header page-scroll\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\" ng-click=\"isCollapsed = !isCollapsed\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div id=\"navbar\" class=\"navbar-collapse collapse\" uib-collapse=\"isCollapsed\"><ul class=\"nav navbar-nav navbar-right\"><li ng-repeat=\"menu in vm.getMyMenu()\" ng-class=\"{active: $state.includes(menu.routeName),\'mobile-undisplay\': menu.name==\'管理入口\'}\" class=\"dropdown iconmenu\" ng-mouseover=\"opendropdown()\" ui-sref-active=\"active\"><a ng-class=\"{\'count-info\':menu.name==\'个人中心\'&&vm.messageNumber}\" ui-sref=\"{{menu.routeName}}\" ng-click=\"vm.callFunction(menu.clickFunction);\" class=\"dropdown-toggle\" data-toggle=\"dropdown\"><i class=\"{{menu.icon}} menu_icon\"></i>{{menu.name}}<span class=\"label label-danger\" ng-if=\"menu.name==\'个人中心\'&&vm.messageNumber\">{{vm.messageNumber}}</span></a><ul ng-if=\"menu.children\" class=\"dropdown-menu second-level\" role=\"menu\"><li ng-repeat=\"subMenu in menu.children\"><a ui-sref=\"{{subMenu.routeName}}\" ng-click=\"vm.callFunction(subMenu.clickFunction);\"><i class=\"{{subMenu.icon}}\"></i>{{subMenu.name}} <span class=\"label label-danger pull-right\" ng-if=\"subMenu.name==\'站内信\'&&vm.privateMessageNumber\">{{vm.privateMessageNumber}}</span> <span class=\"label label-danger pull-right\" ng-if=\"subMenu.name==\'通知公告\'&&vm.publicMessageNumber\">{{vm.publicMessageNumber}}</span></a></li></ul></li></ul></div></div></nav></div>");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak=\"\"><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 data-translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" data-translate=\"error.403\">You are not authorized to access the page.</div></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak=\"\"><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 data-translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div id=\"page-content\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 data-translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" data-translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p data-translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p data-translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p data-translate=\"reset.finish.messages.success\" translate-compile=\"\"><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" data-translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate=\"\" ng-submit=\"vm.finishReset()\" show-validation=\"\"><div class=\"form-group\"><label class=\"control-label\" for=\"password\" data-translate=\"global.form.newpassword\">New password</label> <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required=\"\"><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" data-translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" data-translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" data-translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" data-translate=\"global.form.confirmpassword\">New password confirmation</label> <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required=\"\"><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" data-translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" data-translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" data-translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" data-translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/account/reset/request/reset.request.html","<div id=\"page-content\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 data-translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" data-translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p data-translate=\"reset.request.messages.info\">Enter the email address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p data-translate=\"reset.request.messages.success\">Check your emails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate=\"\" ng-submit=\"vm.requestReset()\" show-validation=\"\"><div class=\"form-group\"><label class=\"control-label\" for=\"email\" data-translate=\"global.form.email\">Email</label> <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required=\"\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" data-translate=\"global.messages.validate.email.required\">Your email is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" data-translate=\"global.messages.validate.email.invalid\">Your email is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" data-translate=\"global.messages.validate.email.minlength\">Your email is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" data-translate=\"global.messages.validate.email.maxlength\">Your email cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" data-translate=\"reset.request.form.button\">Reset</button></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/admin/checkInRewardAndProduct/checkInReward/checkInReward-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">签到设置</h2></div><div class=\"modal-body\"><div class=\"row text-label-right\"><div ng-repeat=\"parts in vm.parts track by parts.number\"><div class=\"form-group col-sm-12\"><label class=\"col-sm-2 lineHeight34 control-label\" for=\"rewardType\">第{{ parts.number+1}}天签到</label><div class=\"col-md-2\"><select class=\"form-control\" id=\"rewardType\" ng-model=\"vm.checkInReward[parts.number].rewardType\" name=\"rewardType\" ng-init=\"(vm.checkInReward[parts.number].rewardType) ? vm.checkInReward[parts.number].rewardType : vm.checkInReward[parts.number].rewardType = \'BONUSPOINT\'\"><option value=\"BONUSPOINT\">积分</option><option value=\"PRODUCT\">奖品链接</option></select></div><div class=\"col-md-2\" ng-if=\"vm.checkInReward[parts.number].rewardType == \'BONUSPOINT\'\"><input type=\"text\" class=\"form-control\" id=\"bonusPoint\" ng-model=\"vm.checkInReward[parts.number].bonusPoint\" name=\"bonusPoint\"></div><div class=\"col-md-2 lineHeight34\" ng-if=\"vm.checkInReward[parts.number].rewardType == \'BONUSPOINT\'\"><span>积分</span></div><div class=\"col-md-4\" ng-if=\"vm.checkInReward[parts.number].rewardType == \'PRODUCT\'\"><div class=\"input-group col-sm-4\"><span class=\"input-group-btn\"><ui-select multiple=\"\" ng-model=\"vm.condition.value[parts.number]\" name=\"qiguaId\" theme=\"bootstrap\" sortable=\"true\" close-on-select=\"false\" disabled=\"\"><ui-select-match>{{$item.productName}} <span ng-bind=\"vm.condition[parts.number].value.productName\"></span></ui-select-match><ui-select-choices repeat=\"product in vm.condition.value[parts.number] track by $index\" disabled=\"\"><h5><span ng-bind=\"product.id\"></span></h5></ui-select-choices></ui-select><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.selectProduct(parts.number)\">选取商品</button></span></div></div></div></div><div class=\"form-group col-sm-12\"><label class=\"col-sm-2 lineHeight34 control-label\" for=\"rewardType\">第8天及以后签到</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.checkInReward[7].bonusPoint\" name=\"bonusPoint\"></div><div class=\"col-md-2 lineHeight34\"><span>积分</span></div></div><div class=\"form-group\"><div class=\"col-md-2 control-label\"></div><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"\">确认</span></button></div></div></div></form>");
$templateCache.put("app/admin/checkInRewardAndProduct/product/product-delete.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.teacherExperience.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"\">删除心得</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"\">你确认要删除id为{{vm.teacherExperience.id}}的心得？</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"\">取消</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"\">删除</span></button></div></form>");
$templateCache.put("app/admin/checkInRewardAndProduct/product/product-detail.html","<div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5><span data-translate=\"\">心得详情</span></h5></div><div class=\"ibox-content\"><div class=\"pull-right\"><span class=\"text-muted\"><i class=\"fa fa-clock-o\"></i> {{vm.teacherExperience.createdDate| date:\'yyyy-MM-dd\'}}</span></div><div class=\"text-center article-title\"><h1>{{vm.teacherExperience.title}}</h1></div><p id=\"teacherExperience\" class=\"editor\"></p><hr><div class=\"row\"><div class=\"col-md-6\"><p>{{vm.teacherExperience.remark}}</p></div><div class=\"col-md-6\"><div class=\"text-right\"><p>{{vm.teacherExperience.teacherFullname}}</p></div></div></div><button type=\"submit\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div></div></div></div></div></div>");
$templateCache.put("app/admin/checkInRewardAndProduct/product/product-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">新增或编辑奖品</h2></div><div class=\"modal-body\"><div class=\"row text-label-right\"><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\">* 奖品名称</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"productName\" placeholder=\"请输入奖品名称\" ng-model=\"vm.product.productName\" name=\"productName\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\">* 所需积分</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"requiredPoints\" placeholder=\"请输入兑换所需积分\" ng-model=\"vm.requiredPoints\" name=\"requiredPoints\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\">* 库存数量</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"productStock\" placeholder=\"请输入可兑换库存总数\" ng-model=\"vm.productStock\" name=\"productStock\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\">* 每人可兑换数量</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"maxRedeemQty\" placeholder=\"请输入每人最多可兑换的数量\" ng-model=\"vm.product.maxRedeemQty\" name=\"maxRedeemQty\" required=\"\"></div></div><div class=\"form-group\" ng-if=\"vm.product.type ==\'URL\'\"><label class=\"col-md-2 control-label lineHeight34\" for=\"productUrl\">*事件链接:</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"productUrl\" placeholder=\"请输入对应的URL,比如http://www.anrrzh.com\" ng-model=\"vm.product.productUrl\" name=\"productUrl\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"effectiveDate\">* 生效日期</label><div class=\"input-group col-sm-2\"><input type=\"text\" class=\"form-control\" id=\"effectiveDate\" name=\"effectiveDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.product.effectiveDate\" ng-change=\"vm.getDate()\" is-open=\"vm.datePickerOpenStatus.effectiveDate\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'effectiveDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"expirationDate\">* 失效日期</label><div class=\"input-group col-sm-2\"><input type=\"text\" class=\"form-control\" id=\"expirationDate\" name=\"expirationDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.product.expirationDate\" ng-change=\"vm.getDate()\" is-open=\"vm.datePickerOpenStatus.expirationDate\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'expirationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><div class=\"col-md-2 control-label\"></div><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"\">确认</span></button></div></div></div><button type=\"button\" ng-if=\"vm.product.id\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span>返回</span></button></form>");
$templateCache.put("app/admin/checkInRewardAndProduct/product/product.html","<div><h2 data-translate=\"\">奖品列表</h2><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"^.product.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"\">新增奖品</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span data-translate=\"\">奖品名称</span></th><th><span data-translate=\"\">所需积分</span></th><th jh-sort-by=\"status\"><span data-translate=\"\">状态</span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"\">有效期</span></th><th><span data-translate=\"\">库存</span></th><th><span data-translate=\"\">已领取数量</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"product in vm.product track by product.id\"><td>{{product.productName}}</td><td>{{product.productPrice.requiredPoints}}</td><td><button class=\"btn btn-success btn-xs\" ng-show=\"product.status == \'INFORCE\'\">已生效</button> <button class=\"btn btn-default btn-xs\" ng-show=\"product.status == \'PENDEFFECTIVE\'\">未生效</button></td><td>{{product.effectiveDate | date:\'yyyy年MM月dd日\'}}&nbsp;-&nbsp;{{product.expirationDate | date:\'yyyy年MM月dd日\'}}</td><td>{{product.stocks[0].quantity}}</td><td>{{product.stocks[0].redeemQty}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.redeemCode({productId:product.id})\" class=\"btn btn-success btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"\">码库</span></button> <button type=\"submit\" ui-sref=\"^.product.edit({id:product.id})\" ng-disabled=\"product.onShelves\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\">修改</span></button> <button type=\"submit\" ng-click=\"vm.delete(product.id,product.onShelves)\" ng-if=\"!product.onShelves\" class=\"btn btn-info btn-sm\"><span class=\"fa fa-long-arrow-up\"></span> <span class=\"hidden-sm-down\">上架</span></button> <button type=\"submit\" ng-click=\"vm.delete(product.id,product.onShelves)\" ng-if=\"product.onShelves\" class=\"btn btn-danger btn-sm\"><span class=\"fa fa-long-arrow-down\"></span> <span class=\"hidden-sm-down\">下架</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/checkInRewardAndProduct/product/redeemCode-upload.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"itemUploadTitle\">导入兑换码</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-6\"><label class=\"control-label\">兑换码文件</label><div ng-show=\"!vm.count\"><div ng-if=\"vm.uploader.queue.length == 0\"><div ng-show=\"vm.uploader.isHTML5\"><div class=\"well my-drop-zone\" nv-file-drop=\"\" uploader=\"vm.uploader\" ng-click=\"vm.showFileDialog();\">拖动Excel兑换码文件到此，或点击选择文件。</div></div><div ng-show=\"!vm.uploader.isHTML5\"><input type=\"file\" id=\"browse-file\" nv-file-select=\"\" uploader=\"vm.uploader\"></div></div><div class=\"well\" ng-show=\"vm.uploader.queue.length > 0\"><div class=\"row\"><div class=\"col-md-8\">{{vm.uploader.queue[0].file.name}} <span ng-if=\"vm.uploader.queue[0].file.size < 1024\">({{vm.uploader.queue[0].file.size}}Bytes)</span> <span ng-if=\"vm.uploader.queue[0].file.size >= 1024 && vm.uploader.queue[0].file.size < 1048576\">({{(vm.uploader.queue[0].file.size/1024).toFixed(2)}}KB)</span> <span ng-if=\"vm.uploader.queue[0].file.size >= 1048576 && vm.uploader.queue[0].file.size < 1073741824\">({{(vm.uploader.queue[0].file.size/1048576).toFixed(2)}}MB)</span> <span ng-if=\"vm.uploader.queue[0].file.size >= 1073741824\">({{(vm.uploader.queue[0].file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.uploader.clearQueue();\">取消</button></div><span class=\"progress\" ng-show=\"vm.uploadProgress >= 0\"><div style=\"width:{{vm.uploadProgress}}%\" ng-bind=\"vm.uploadProgress + \'%\'\"></div></span></div></div></div><div ng-show=\"vm.count\"><div class=\"well\"><div class=\"row\"><div class=\"col-md-8\">上传兑换码数量：{{vm.count}} <input type=\"hidden\" class=\"form-control\" name=\"count\" id=\"count\" ng-model=\"vm.count\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearFile();\">删除</button></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"button\" ng-disabled=\"vm.isSaving || vm.uploader.queue.length == 0\" class=\"btn btn-primary\" ng-click=\"vm.uploadFile()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;确定</button></div></form>");
$templateCache.put("app/admin/checkInRewardAndProduct/product/redeemCode.html","<div><h2 data-translate=\"\">兑换码库</h2><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"^.redeemCode.upload\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"\">导入兑换码</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span data-translate=\"\">兑换码</span></th><th jh-sort-by=\"status\"><span data-translate=\"\">状态</span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"\">创建时间</span></th><th><span data-translate=\"\">领取时间</span></th><th><span data-translate=\"\">领取人</span></th></tr></thead><tbody><tr ng-repeat=\"redeemCode in vm.redeemCode track by redeemCode.id\"><td>{{redeemCode.redeemCode}}</td><td><button class=\"btn btn-success btn-xs\" ng-show=\"redeemCode.status == \'EXCHANGED\'\">已领取</button> <button class=\"btn btn-default btn-xs\" ng-show=\"redeemCode.status == \'UNEXCHANGED\'\">未领取</button></td><td>{{redeemCode.redeemCodeCreatedDate | date:\'yyyy年MM月dd日\'}}</td><td>{{redeemCode.redeemDate | date:\'yyyy年MM月dd日\'}}</td><td>{{redeemCode.redeemCustomerName}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div><button type=\"button\" ui-sref=\"admin.checkInRewardAndProduct.product\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span>返回</span></button></div>");
$templateCache.put("app/admin/guaCalendar/effectivePeriod/effectivePeriod-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">日历生效周期</h2></div><div class=\"modal-body\"><div class=\"row text-label-right\"><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"effectivePeriod\">生效周期:</label><div class=\"col-sm-1 lineHeight34\" ng-show=\"vm.change\"><input type=\"text\" class=\"form-control\" id=\"effectivePeriod\" ng-model=\"vm.guaCalendar.effectivePeriod\" name=\"effectivePeriod\"></div><div ng-if=\"vm.change\">天 <button type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-save\"></span> <span class=\"hidden-sm-down\">确认</span></button></div><div class=\"col-sm-1 lineHeight34\" ng-if=\"!vm.change\"><span>{{vm.guaCalendar.effectivePeriod}}天</span></div><div ng-if=\"!vm.change\"><button type=\"button\" ng-click=\"vm.changed()\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\">修改</span></button></div></div></div></div></form>");
$templateCache.put("app/admin/guaCalendar/guaCalendar/guaCalendar-delete.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.teacherExperience.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"\">删除心得</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"\">你确认要删除id为{{vm.teacherExperience.id}}的心得？</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"\">取消</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"\">删除</span></button></div></form>");
$templateCache.put("app/admin/guaCalendar/guaCalendar/guaCalendar-detail.html","<div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5><span data-translate=\"\">心得详情</span></h5></div><div class=\"ibox-content\"><div class=\"pull-right\"><span class=\"text-muted\"><i class=\"fa fa-clock-o\"></i> {{vm.teacherExperience.createdDate| date:\'yyyy-MM-dd\'}}</span></div><div class=\"text-center article-title\"><h1>{{vm.teacherExperience.title}}</h1></div><p id=\"teacherExperience\" class=\"editor\"></p><hr><div class=\"row\"><div class=\"col-md-6\"><p>{{vm.teacherExperience.remark}}</p></div><div class=\"col-md-6\"><div class=\"text-right\"><p>{{vm.teacherExperience.teacherFullname}}</p></div></div></div><button type=\"submit\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div></div></div></div></div></div>");
$templateCache.put("app/admin/guaCalendar/guaCalendar/guaCalendar-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">新增日历</h2></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"text-center\" ng-if=\"!vm.guaCalendar.id\"><h3>今天日期：{{vm.newDate | date:\'yyyy年MM月dd日\'}}</h3></div><br><div class=\"row text-label-right\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">当前设定日期:</label><div class=\"input-group col-sm-10\"><span>{{vm.guaCalendar.setDate | date:\'yyyy年MM月dd日\'}}</span></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"effectiveDate\">* 生效日期:</label><div class=\"input-group col-sm-4\"><p style=\"float:right;line-height: 34px\"><small>当天0点后用户可访问该日历&nbsp;&nbsp;&nbsp;</small></p><div class=\"input-group col-sm-6\"><input type=\"text\" class=\"form-control\" id=\"effectiveDate\" name=\"effectiveDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.guaCalendar.effectiveDate\" ng-change=\"vm.getDate()\" is-open=\"vm.datePickerOpenStatus.effectiveDate\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'effectiveDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">* 日历内容:<br><small>(推荐尺寸300*200px)</small></label><div class=\"col-sm-2 input-group\"><div ng-show=\"!vm.guaCalendar.contentPic\"><div ng-if=\"vm.uploaderImg.queue.length == 0\"><div ng-show=\"vm.uploaderImg.isHTML5\"><div class=\"well my-drop-zone\" style=\"margin-bottom: 0\" nv-file-drop=\"\" uploader=\"vm.uploaderImg\" ng-click=\"vm.showImgDialog();\">拖动图片到此，<br>或点击选择图片</div></div><div ng-show=\"!vm.uploaderImg.isHTML5\"><input type=\"file\" id=\"browse-img\" nv-file-select=\"\" uploader=\"vm.uploaderImg\"></div></div><div class=\"well\" style=\"margin-bottom: 0\" ng-show=\"vm.uploaderImg.queue.length > 0\"><div class=\"row\"><div class=\"col-md-8\">{{vm.uploaderImg.queue[0].file.name}} <span ng-if=\"vm.uploaderImg.queue[0].file.size < 1024\">({{vm.uploaderImg.queue[0].file.size}}Bytes)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1024 && vm.uploaderImg.queue[0].file.size < 1048576\">({{(vm.uploaderImg.queue[0].file.size/1024).toFixed(2)}}KB)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1048576 && vm.uploaderImg.queue[0].file.size < 1073741824\">({{(vm.uploaderImg.queue[0].file.size/1048576).toFixed(2)}}MB)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1073741824\">({{(vm.uploaderImg.queue[0].file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.uploadImg();\">上传</button> <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.uploaderImg.clearQueue();\">取消</button></div><span class=\"progress\" ng-show=\"vm.uploadProgress >= 0\"><div style=\"width:{{vm.uploadProgress}}%\" ng-bind=\"vm.uploadProgress + \'%\'\"></div></span></div></div></div><div ng-show=\"vm.guaCalendar.contentPic\"><div class=\"well\" style=\"margin-bottom: 0\"><div class=\"row\"><div class=\"col-md-8\"><img class=\"img-responsive\" width=\"400\" height=\"213\" ng-src=\"{{vm.guaCalendar.contentPic}}\" alt=\"{{vm.guaCalendar.contentPic}}\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearImg();\">删除</button></div></div></div></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"yaoci\">* 爻辞:</label><div class=\"col-sm-6 input-group\"><textarea class=\"form-control\" id=\"yaoci\" rows=\"1\" ng-model=\"vm.guaCalendar.yaoci\" name=\"yaoci\" placeholder=\"请输入当天的爻辞\" required=\"\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"yaociExplain\">白化解释:</label><div class=\"col-sm-6 input-group\"><textarea class=\"form-control\" placeholder=\"请输入爻辞对应的白话解释\" rows=\"4\" ng-model=\"vm.guaCalendar.yaociExplain\" name=\"yaociExplain\" id=\"yaociExplain\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"voiceUrl\">* 语音链接:</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"voiceUrl\" placeholder=\"请输入喜马拉雅对应的URL,比如http://www.anrrzh.com\" ng-model=\"vm.guaCalendar.voiceUrl\" name=\"voiceUrl\"></div></div><div class=\"form-group\"><div class=\"col-md-2 control-label\"></div><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"\">确认</span></button></div></div></div><button type=\"button\" ng-if=\"vm.guaCalendar.id\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span>返回</span></button></form>");
$templateCache.put("app/admin/guaCalendar/guaCalendar/guaCalendar.html","<div><h2 data-translate=\"\">日历维护</h2><form class=\"form\"><div class=\"row\"><div class=\"form-group col-md-1\"><span style=\"float: right;line-height: 34px\">筛选:</span></div><div class=\"form-group col-md-2\"><select class=\"form-control\" id=\"year\" name=\"year\" ng-init=\"(vm.condition.year) ? vm.condition.year : vm.condition.year = vm.newyear\" ng-model=\"vm.condition.year\" ng-options=\"year for year in vm.year\" ng-change=\"vm.search()\"><option value=\"\"></option></select></div><div class=\"form-group col-md-2\"><select class=\"form-control\" id=\"month\" ng-model=\"vm.condition.month\" ng-change=\"vm.search()\" ng-init=\"(vm.condition.month) ? vm.condition.month : vm.condition.month = \'0\'\"><option value=\"0\">全部</option><option value=\"1\">一月</option><option value=\"2\">二月</option><option value=\"3\">三月</option><option value=\"4\">四月</option><option value=\"5\">五月</option><option value=\"6\">六月</option><option value=\"7\">七月</option><option value=\"8\">八月</option><option value=\"9\">九月</option><option value=\"10\">十月</option><option value=\"11\">十一月</option><option value=\"12\">十二月</option></select></div></div></form><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"^.guaCalendar.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"\">新增日历</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"setDate\"><span data-translate=\"\">日期</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"effectiveDate\"><span data-translate=\"\">生效时间</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pv\"><span data-translate=\"\">PV</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"uv\"><span data-translate=\"\">UV</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"playQty\"><span data-translate=\"\">播放</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shareQty\"><span data-translate=\"\">分享</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span data-translate=\"\">状态</span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"\"></span></th></tr></thead><tbody><tr ng-repeat=\"guaCalendar in vm.guaCalendar track by guaCalendar.id\"><td>{{guaCalendar.setDate | date:\'yyyy年MM月dd日\'}}</td><td>{{guaCalendar.effectiveDate | date:\'yyyy年MM月dd日\'}}</td><td>{{guaCalendar.pv}}</td><td>{{guaCalendar.uv}}</td><td>{{guaCalendar.playQty}}</td><td>{{guaCalendar.shareQty}}</td><td><button class=\"btn btn-success btn-xs\" ng-show=\"guaCalendar.status == \'INFORCE\'\">已生效</button> <button class=\"btn btn-default btn-xs\" ng-show=\"guaCalendar.status == \'PENDEFFECTIVE\'\">未生效</button> <button class=\"btn btn-success btn-xs\" ng-show=\"guaCalendar.status == \'DELETED\'\">已删除</button></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.guaCalendar.edit({id:guaCalendar.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\">修改</span></button> <button type=\"submit\" ng-if=\"guaCalendar.contentPic\" ng-click=\"vm.download(guaCalendar.id)\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-save\"></span> <span class=\"hidden-xs hidden-sm\">下载</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/guaTopic/guaTopic/guaTopic-delete.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.teacherExperience.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"\">删除心得</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"\">你确认要删除id为{{vm.teacherExperience.id}}的心得？</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"\">取消</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"\">删除</span></button></div></form>");
$templateCache.put("app/admin/guaTopic/guaTopic/guaTopic-detail.html","<div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5><span data-translate=\"\">心得详情</span></h5></div><div class=\"ibox-content\"><div class=\"pull-right\"><span class=\"text-muted\"><i class=\"fa fa-clock-o\"></i> {{vm.teacherExperience.createdDate| date:\'yyyy-MM-dd\'}}</span></div><div class=\"text-center article-title\"><h1>{{vm.teacherExperience.title}}</h1></div><p id=\"teacherExperience\" class=\"editor\"></p><hr><div class=\"row\"><div class=\"col-md-6\"><p>{{vm.teacherExperience.remark}}</p></div><div class=\"col-md-6\"><div class=\"text-right\"><p>{{vm.teacherExperience.teacherFullname}}</p></div></div></div><button type=\"submit\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div></div></div></div></div></div>");
$templateCache.put("app/admin/guaTopic/guaTopic/guaTopic-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">新增或编辑事件</h2></div><div class=\"modal-body\"><div class=\"row text-label-right\"><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\">* 事件标题</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"请输入标题\" ng-model=\"vm.guaTopic.title\" name=\"title\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\">* 事件概要</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"outline\" placeholder=\"请输入概要描述\" ng-model=\"vm.guaTopic.outline\" name=\"outline\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\" for=\"type\">* 事件类型</label><div class=\"input-group col-md-2\"><select class=\"form-control\" id=\"type\" ng-model=\"vm.guaTopic.type\" name=\"type\" ng-init=\"(vm.guaTopic.type) ? vm.guaTopic.type : vm.guaTopic.type = \'URL\'\"><option value=\"QIGUA\">占卦</option><option value=\"URL\">事件</option></select></div></div><div class=\"form-group\" ng-show=\"vm.guaTopic.type ==\'URL\'\"><label class=\"col-md-2 control-label lineHeight34\" for=\"editor\">* 事件链接:</label><div id=\"editor\" class=\"col-md-10\" style=\"padding-left: 0;margin-bottom: 15px\" ng-model=\"vm.guaTopic.guaTopicDetail\"></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\"></label><div class=\"col-sm-6 input-group\"><xmp>注：若要添加视频，请按指定格式填写视频地址，不可直接复制。格式：<video class=\"video\" src=\"视频文件地址\" binderror=\"videoErrorCallback\"></video></xmp></div></div></div><div class=\"form-group\" ng-if=\"vm.guaTopic.type ==\'QIGUA\'\"><label class=\"col-md-2 control-label lineHeight34\">* 占卦链接:</label><div class=\"input-group col-sm-2\"><span class=\"input-group-btn\"><ui-select multiple=\"\" ng-model=\"vm.condition.value\" name=\"qiguaId\" theme=\"bootstrap\" sortable=\"true\" close-on-select=\"false\" disabled=\"\"><ui-select-match>{{$item.qiguaName}}<span ng-if=\"$item.qigua\">({{$item.qigua}})</span> <span ng-bind=\"vm.condition.value.qiguaName\"></span></ui-select-match><ui-select-choices repeat=\"guaTopic in vm.condition.value track by guaTopic.id\" disabled=\"\"><h5><span ng-bind=\"guaTopic.id\"></span></h5></ui-select-choices></ui-select><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.selectGuaTopic()\">选取占卦</button></span></div></div><br><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"effectiveDate\">* 生效日期:</label><div class=\"input-group col-sm-2\"><input type=\"text\" class=\"form-control\" id=\"effectiveDate\" name=\"effectiveDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.guaTopic.effectiveDate\" ng-change=\"vm.getDate()\" is-open=\"vm.datePickerOpenStatus.effectiveDate\" required=\"\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'effectiveDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">* 事件封面:<br><small>(推荐尺寸300*200px)</small></label><div class=\"col-sm-2 input-group\"><div ng-show=\"!vm.guaTopic.topicCover\"><div ng-if=\"vm.uploaderImg.queue.length == 0\"><div ng-show=\"vm.uploaderImg.isHTML5\"><div class=\"well my-drop-zone\" style=\"margin-bottom: 0\" nv-file-drop=\"\" uploader=\"vm.uploaderImg\" ng-click=\"vm.showImgDialog();\">拖动图片到此，<br>或点击选择图片</div></div><div ng-show=\"!vm.uploaderImg.isHTML5\"><input type=\"file\" id=\"browse-img\" nv-file-select=\"\" uploader=\"vm.uploaderImg\"></div></div><div class=\"well\" style=\"margin-bottom: 0\" ng-show=\"vm.uploaderImg.queue.length > 0\"><div class=\"row\"><div class=\"col-md-8\">{{vm.uploaderImg.queue[0].file.name}} <span ng-if=\"vm.uploaderImg.queue[0].file.size < 1024\">({{vm.uploaderImg.queue[0].file.size}}Bytes)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1024 && vm.uploaderImg.queue[0].file.size < 1048576\">({{(vm.uploaderImg.queue[0].file.size/1024).toFixed(2)}}KB)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1048576 && vm.uploaderImg.queue[0].file.size < 1073741824\">({{(vm.uploaderImg.queue[0].file.size/1048576).toFixed(2)}}MB)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1073741824\">({{(vm.uploaderImg.queue[0].file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.uploadImg();\">上传</button> <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.uploaderImg.clearQueue();\">取消</button></div><span class=\"progress\" ng-show=\"vm.uploadProgress >= 0\"><div style=\"width:{{vm.uploadProgress}}%\" ng-bind=\"vm.uploadProgress + \'%\'\"></div></span></div></div></div><div ng-show=\"vm.guaTopic.topicCover\"><div class=\"well\" style=\"margin-bottom: 0\"><div class=\"row\"><div class=\"col-md-8\"><img class=\"img-responsive\" width=\"400\" height=\"213\" ng-src=\"{{vm.guaTopic.topicCover}}\" alt=\"{{vm.guaTopic.topicCover}}\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearImg();\">删除</button></div></div></div></div></div></div><div class=\"form-group\"><div class=\"col-md-2 control-label\"></div><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"\">确认</span></button></div></div></div><button type=\"button\" ng-if=\"vm.guaTopic.id\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span>返回</span></button></form>");
$templateCache.put("app/admin/guaTopic/guaTopic/guaTopic.html","<div><h2 data-translate=\"\">事件列表</h2><form class=\"form\"><div class=\"row\"><div class=\"form-group col-md-1\"><span style=\"float: right;line-height: 34px\">筛选:</span></div><div class=\"form-group col-md-2\"><select class=\"form-control\" id=\"year\" name=\"year\" ng-init=\"(vm.condition.year) ? vm.condition.year : vm.condition.year = vm.newyear\" ng-model=\"vm.condition.year\" ng-options=\"year for year in vm.year\" ng-change=\"vm.search()\"><option value=\"\"></option></select></div><div class=\"form-group col-md-2\"><select class=\"form-control\" id=\"month\" ng-model=\"vm.condition.month\" ng-change=\"vm.search()\" ng-init=\"(vm.condition.month) ? vm.condition.month : vm.condition.month = \'0\'\"><option value=\"0\">全部</option><option value=\"1\">一月</option><option value=\"2\">二月</option><option value=\"3\">三月</option><option value=\"4\">四月</option><option value=\"5\">五月</option><option value=\"6\">六月</option><option value=\"7\">七月</option><option value=\"8\">八月</option><option value=\"9\">九月</option><option value=\"10\">十月</option><option value=\"11\">十一月</option><option value=\"12\">十二月</option></select></div></div></form><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"^.guaTopic.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"\">新增事件</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"title\"><span data-translate=\"\">标题</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"effectiveDate\"><span data-translate=\"\">生效时间</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pv\"><span data-translate=\"\">PV</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"uv\"><span data-translate=\"\">UV</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"close\"><span data-translate=\"\">Close</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"forward\"><span data-translate=\"\">转发</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span data-translate=\"\">状态</span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"\"></span></th></tr></thead><tbody><tr ng-repeat=\"guaTopic in vm.guaTopic track by guaTopic.id\"><td>{{guaTopic.title}}</td><td>{{guaTopic.effectiveDate | date:\'yyyy年MM月dd日\'}}</td><td>{{guaTopic.pv}}</td><td>{{guaTopic.uv}}</td><td>{{guaTopic.close}}</td><td>{{guaTopic.forward}}</td><td><button class=\"btn btn-success btn-xs\" ng-show=\"guaTopic.status == \'INFORCE\'\">已生效</button> <button class=\"btn btn-default btn-xs\" ng-show=\"guaTopic.status == \'PENDEFFECTIVE\'\">未生效</button> <button class=\"btn btn-default btn-xs\" ng-show=\"guaTopic.status == \'DELETED\'\">已删除</button></td><td class=\"text-right\"><span ng-if=\"!guaTopic.valid\">已删除</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.guaTopic.edit({id:guaTopic.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\">修改</span></button> <button type=\"submit\" ng-click=\"vm.delete(guaTopic.id)\" ng-if=\"guaTopic.valid\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\">删除</span></button> <button type=\"submit\" ng-click=\"vm.delete(guaTopic.id)\" ng-if=\"!guaTopic.valid\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-ban-circle\"></span> <span class=\"hidden-sm-down\">恢复</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua-delete.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.teacherExperience.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"\">删除心得</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"\">你确认要删除id为{{vm.teacherExperience.id}}的心得？</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"\">取消</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"\">删除</span></button></div></form>");
$templateCache.put("app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua-detail.html","<div><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-title\"><h5><span data-translate=\"\">心得详情</span></h5></div><div class=\"ibox-content\"><div class=\"pull-right\"><span class=\"text-muted\"><i class=\"fa fa-clock-o\"></i> {{vm.teacherExperience.createdDate| date:\'yyyy-MM-dd\'}}</span></div><div class=\"text-center article-title\"><h1>{{vm.teacherExperience.title}}</h1></div><p id=\"teacherExperience\" class=\"editor\"></p><hr><div class=\"row\"><div class=\"col-md-6\"><p>{{vm.teacherExperience.remark}}</p></div><div class=\"col-md-6\"><div class=\"text-right\"><p>{{vm.teacherExperience.teacherFullname}}</p></div></div></div><button type=\"submit\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div></div></div></div></div></div>");
$templateCache.put("app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">新增或编辑占卦</h2></div><div class=\"modal-body\"><div class=\"row text-label-right\"><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\" for=\"question\">* 起卦问题</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"question\" ng-model=\"vm.guaTopicQiGua.question\" name=\"question\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\" for=\"questionBackground\">* 起卦背景</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"questionBackground\" ng-model=\"vm.guaTopicQiGua.questionBackground\" name=\"questionBackground\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\">起卦</label><div class=\"col-md-10\"><div><button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-success\': vm.guaTopicQiGua.qigua1 == 6}\" ng-click=\"vm.setCurrent1(6)\" ng-model=\"vm.guaTopicQiGua.qigua1\" ng-init=\"(vm.guaTopicQiGua.qigua1) ? vm.guaTopicQiGua.qigua1 : vm.guaTopicQiGua.qigua1 = \'6\'\">6老阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-info\': vm.guaTopicQiGua.qigua1 == 9}\" ng-click=\"vm.setCurrent1(9)\" ng-model=\"vm.guaTopicQiGua.qigua1\">9老阳</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-primary\': vm.guaTopicQiGua.qigua1 == 8}\" ng-click=\"vm.setCurrent1(8)\" ng-model=\"vm.guaTopicQiGua.qigua1\">8少阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-warning\': vm.guaTopicQiGua.qigua1 == 7}\" ng-click=\"vm.setCurrent1(7)\" ng-model=\"vm.guaTopicQiGua.qigua1\">7少阳</button> <span>上爻</span></div><br><div><button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-success\': vm.guaTopicQiGua.qigua2 == 6}\" ng-click=\"vm.setCurrent2(6)\" ng-model=\"vm.guaTopicQiGua.qigua2\" ng-init=\"(vm.guaTopicQiGua.qigua2) ? vm.guaTopicQiGua.qigua2 : vm.guaTopicQiGua.qigua2 = \'6\'\">6老阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-info\': vm.guaTopicQiGua.qigua2 == 9}\" ng-click=\"vm.setCurrent2(9)\" ng-model=\"vm.guaTopicQiGua.qigua2\">9老阳</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-primary\': vm.guaTopicQiGua.qigua2 == 8}\" ng-click=\"vm.setCurrent2(8)\" ng-model=\"vm.guaTopicQiGua.qigua2\">8少阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-warning\': vm.guaTopicQiGua.qigua2 == 7}\" ng-click=\"vm.setCurrent2(7)\" ng-model=\"vm.guaTopicQiGua.qigua2\">7少阳</button> <span>五爻</span></div><br><div><button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-success\': vm.guaTopicQiGua.qigua3 == 6}\" ng-click=\"vm.setCurrent3(6)\" ng-model=\"vm.guaTopicQiGua.qigua3\" ng-init=\"(vm.guaTopicQiGua.qigua3) ? vm.guaTopicQiGua.qigua3 : vm.guaTopicQiGua.qigua3 = \'6\'\">6老阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-info\': vm.guaTopicQiGua.qigua3 == 9}\" ng-click=\"vm.setCurrent3(9)\" ng-model=\"vm.guaTopicQiGua.qigua3\">9老阳</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-primary\': vm.guaTopicQiGua.qigua3 == 8}\" ng-click=\"vm.setCurrent3(8)\" ng-model=\"vm.guaTopicQiGua.qigua3\">8少阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-warning\': vm.guaTopicQiGua.qigua3 == 7}\" ng-click=\"vm.setCurrent3(7)\" ng-model=\"vm.guaTopicQiGua.qigua3\">7少阳</button> <span>四爻</span></div><br><div><button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-success\': vm.guaTopicQiGua.qigua4 == 6}\" ng-click=\"vm.setCurrent4(6)\" ng-model=\"vm.guaTopicQiGua.qigua4\" ng-init=\"(vm.guaTopicQiGua.qigua4) ? vm.guaTopicQiGua.qigua4 : vm.guaTopicQiGua.qigua4 = \'6\'\">6老阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-info\': vm.guaTopicQiGua.qigua4 == 9}\" ng-click=\"vm.setCurrent4(9)\" ng-model=\"vm.guaTopicQiGua.qigua4\">9老阳</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-primary\': vm.guaTopicQiGua.qigua4 == 8}\" ng-click=\"vm.setCurrent4(8)\" ng-model=\"vm.guaTopicQiGua.qigua4\">8少阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-warning\': vm.guaTopicQiGua.qigua4 == 7}\" ng-click=\"vm.setCurrent4(7)\" ng-model=\"vm.guaTopicQiGua.qigua4\">7少阳</button> <span>三爻</span></div><br><div><button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-success\': vm.guaTopicQiGua.qigua5 == 6}\" ng-click=\"vm.setCurrent5(6)\" ng-model=\"vm.guaTopicQiGua.qigua5\" ng-init=\"(vm.guaTopicQiGua.qigua5) ? vm.guaTopicQiGua.qigua5 : vm.guaTopicQiGua.qigua5 = \'6\'\">6老阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-info\': vm.guaTopicQiGua.qigua5 == 9}\" ng-click=\"vm.setCurrent5(9)\" ng-model=\"vm.guaTopicQiGua.qigua5\">9老阳</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-primary\': vm.guaTopicQiGua.qigua5 == 8}\" ng-click=\"vm.setCurrent5(8)\" ng-model=\"vm.guaTopicQiGua.qigua5\">8少阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-warning\': vm.guaTopicQiGua.qigua5 == 7}\" ng-click=\"vm.setCurrent5(7)\" ng-model=\"vm.guaTopicQiGua.qigua5\">7少阳</button> <span>二爻</span></div><br><div><button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-success\': vm.guaTopicQiGua.qigua6 == 6}\" ng-click=\"vm.setCurrent6(6)\" ng-model=\"vm.guaTopicQiGua.qigua6\" ng-init=\"(vm.guaTopicQiGua.qigua6) ? vm.guaTopicQiGua.qigua6 : vm.guaTopicQiGua.qigua6 = \'6\'\">6老阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-info\': vm.guaTopicQiGua.qigua6 == 9}\" ng-click=\"vm.setCurrent6(9)\" ng-model=\"vm.guaTopicQiGua.qigua6\">9老阳</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-primary\': vm.guaTopicQiGua.qigua6 == 8}\" ng-click=\"vm.setCurrent6(8)\" ng-model=\"vm.guaTopicQiGua.qigua6\">8少阴</button> <button class=\"btn btn-qigua\" type=\"button\" ng-class=\"{\'btn-warning\': vm.guaTopicQiGua.qigua6 == 7}\" ng-click=\"vm.setCurrent6(7)\" ng-model=\"vm.guaTopicQiGua.qigua6\">7少阳</button> <span>初爻</span></div><br></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label lineHeight34\" for=\"editor\">* 解卦详情</label><div id=\"editor\" class=\"col-md-10\" ng-model=\"vm.guaTopicQiGua.jieguaDetail\"></div></div><br></div><div class=\"row\"><br><div class=\"form-group\"><div class=\"col-md-2 control-label\"></div><button type=\"button\" ng-click=\"vm.save()\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"\">确认</span></button></div></div></div><button type=\"button\" ng-if=\"vm.guaTopicQiGua.id\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span>返回</span></button></form>");
$templateCache.put("app/admin/guaTopicQiGua/guaTopicQiGua/guaTopicQiGua.html","<div><h2 data-translate=\"\">占卦列表</h2><form class=\"form\"><div class=\"row\"><div class=\"form-group col-md-1\"><span style=\"float: right;line-height: 34px\">筛选:</span></div><div class=\"form-group col-md-2\"><select class=\"form-control\" id=\"year\" name=\"year\" ng-init=\"(vm.condition.year) ? vm.condition.year : vm.condition.year = vm.newyear\" ng-model=\"vm.condition.year\" ng-options=\"year for year in vm.year\" ng-change=\"vm.search()\"><option value=\"\"></option></select></div><div class=\"form-group col-md-2\"><select class=\"form-control\" id=\"month\" ng-model=\"vm.condition.month\" ng-change=\"vm.search()\" ng-init=\"(vm.condition.month) ? vm.condition.month : vm.condition.month = \'0\'\"><option value=\"0\">全部</option><option value=\"1\">一月</option><option value=\"2\">二月</option><option value=\"3\">三月</option><option value=\"4\">四月</option><option value=\"5\">五月</option><option value=\"6\">六月</option><option value=\"7\">七月</option><option value=\"8\">八月</option><option value=\"9\">九月</option><option value=\"10\">十月</option><option value=\"11\">十一月</option><option value=\"12\">十二月</option></select></div></div></form><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"^.guaTopicQiGua.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"\">新增占卦</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"question\"><span data-translate=\"\">标题</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdDate\"><span data-translate=\"\">发布时间</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pv\"><span data-translate=\"\">PV</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"uv\"><span data-translate=\"\">UV</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"like\"><span data-translate=\"\">赞</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"unLike\"><span data-translate=\"\">踩</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"forward\"><span data-translate=\"\">转发</span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"\"></span></th></tr></thead><tbody><tr ng-repeat=\"guaTopicQiGua in vm.guaTopicQiGua track by guaTopicQiGua.id\"><td>{{guaTopicQiGua.question}}</td><td>{{guaTopicQiGua.createdDate | date:\'yyyy年MM月dd日\'}}</td><td>{{guaTopicQiGua.pv}}</td><td>{{guaTopicQiGua.uv}}</td><td>{{guaTopicQiGua.like}}</td><td>{{guaTopicQiGua.unLike}}</td><td>{{guaTopicQiGua.forward}}</td><td class=\"text-right\"><span ng-if=\"!guaTopicQiGua.valid\">已删除</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.guaTopicQiGua.edit({id:guaTopicQiGua.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\">修改</span></button> <button type=\"submit\" ng-click=\"vm.delete(guaTopicQiGua.id,guaTopicQiGua.valid)\" ng-if=\"guaTopicQiGua.valid\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\">删除</span></button> <button type=\"submit\" ng-click=\"vm.delete(guaTopicQiGua.id,guaTopicQiGua.valid)\" ng-if=\"!guaTopicQiGua.valid\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-ban-circle\"></span> <span class=\"hidden-sm-down\">恢复</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/layout/common/breadcrumb.html","<div id=\"admin-breadcrumb\" class=\"row wrapper border-bottom white-bg page-heading\" ng-controller=\"BreadCrumbController as vm\"><div class=\"col-lg-10\"><ol class=\"breadcrumb\"><li><a ui-sref=\"admin.dashboard\">仪表盘</a></li><li data-translate=\"admin-menu.{{vm.$state.current.parent}}\">{{vm.$state.current.parent}}</li><li class=\"active\"><strong data-translate=\"admin-menu.{{vm.$state.current.name}}\">{{vm.$state.current.name}}</strong></li></ol></div></div>");
$templateCache.put("app/admin/layout/common/content.html","<div ng-include=\"\'app/admin/layout/common/breadcrumb.html\'\"></div><div ui-view=\"\"></div><div ui-view=\"content\"></div>");
$templateCache.put("app/admin/layout/common/footer.html","<div class=\"footer admin-footer changeAdminStyle\" style=\"display:none\"><div class=\"row\"><div class=\"col-md-4\"></div><div class=\"col-md-4\"><button class=\"changeAdminStyle btn btn-primary btn-sm\" data-value=\"\">扁平式</button> <button class=\"changeAdminStyle btn btn-primary btn-sm\" data-value=\"md-skin\">md-skin</button></div></div></div>");
$templateCache.put("app/admin/layout/common/ibox-content.html","<div ng-include=\"\'app/admin/layout/common/breadcrumb.html\'\"></div><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox\"><div class=\"ibox-content\"><div ui-view=\"\"></div><div ui-view=\"content\"></div></div></div></div></div></div>");
$templateCache.put("app/admin/layout/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/admin/layout/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\" ng-controller=\"NavigationController as vm\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"dropdown profile-element\"><img alt=\"image\" class=\"img-circle\" src=\"assets/images/logo_small.png\"><div class=\"profile-element\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{vm.userDisplayName}}</strong></span> <span class=\"text-muted text-xs block\">{{nav.title}}<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a href=\"\" ng-click=\"vm.changePassword()\"><i class=\"fa fa-key\"></i> 修改密码</a></li><li><a href=\"\" ng-click=\"vm.logout()\"><i class=\"fa fa-sign-out\"></i> 退出</a></li></ul></div><div class=\"logo-element\">=</div></div></li><li ng-repeat=\"menu in vm.getMyMenu()\" ui-sref-active=\"active\"><a ui-sref=\"{{menu.routeName}}\"><i class=\"{{menu.icon}}\"></i> <span class=\"nav-label\">{{menu.name}}</span><span ng-if=\"menu.children\" class=\"fa arrow\"></span></a><ul ng-if=\"menu.children\" class=\"nav nav-second-level collapse\" ng-class=\"{in: vm.$state.includes(menu.routeName)}\"><li ng-repeat=\"subMenu in menu.children\" ui-sref-active=\"active\"><a ui-sref=\"{{subMenu.routeName}}\"><i class=\"{{subMenu.icon}}\"></i> <span class=\"nav-label\">{{subMenu.name}}</span></a></li></ul></li></ul></div></nav>");
$templateCache.put("app/admin/layout/common/no-ibox-content.html","<div ng-include=\"\'app/admin/layout/common/breadcrumb.html\'\"></div><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"col-md-12\"><div ui-view=\"\"></div><div ui-view=\"content\"></div></div></div></div>");
$templateCache.put("app/admin/layout/common/topnavbar.html","<div class=\"row border-bottom\" ng-controller=\"NavigationController as vm\"><nav class=\"navbar navbar-fixed-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div><ul class=\"nav navbar-top-links navbar-right\"><li><span class=\"m-r-sm text-muted welcome-message\">易天天后台管理平台！</span></li><li><a href=\"\" ng-click=\"vm.logout()\"><i class=\"fa fa-sign-out\"></i> 退出</a></li></ul></nav></div>");
$templateCache.put("app/admin/oss-service/oss-service-upload/oss-service-upload.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"itemUploadTitle\">OSS文件上传</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-9\"><label class=\"control-label\">待上传的文件:</label><div ng-show=\"!vm.count\"><div ng-show=\"!vm.uploader.isHTML5\"><input type=\"file\" id=\"browse-file\" nv-file-select=\"\" uploader=\"vm.uploader\" multiple=\"\"></div><div class=\"\" ng-show=\"vm.uploader.queue.length > 0\" ng-repeat=\"file in vm.uploader.queue\"><div class=\"row\" style=\"line-height: 45px\"><div class=\"col-md-6\">{{file.file.name}} <span ng-if=\"file.file.size < 1024\">({{file.file.size}}Bytes)</span> <span ng-if=\"file.file.size >= 1024 && file.file.size < 1048576\">({{(file.file.size/1024).toFixed(2)}}KB)</span> <span ng-if=\"file.file.size >= 1048576 && file.file.size < 1073741824\">({{(file.file.size/1048576).toFixed(2)}}MB)</span> <span ng-if=\"file.file.size >= 1073741824\">({{(file.file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-5\"><div class=\"progress\" ng-show=\"file.progress >= 0\" style=\"margin-top: 12.5px\"><div class=\"progress-bar bg-success\" style=\"width:{{file.progress}}%\" ng-bind=\"file.progress + \'%\'\"></div></div></div><div class=\"col-md-1\"><button type=\"button\" class=\"btn btn-warning btn-circle btn-sm\" ng-click=\"file.remove()\"><i class=\"fa fa-times\"></i></button></div></div></div></div><div ng-show=\"vm.count\"><div class=\"well\"><div class=\"row\"><div class=\"col-md-8\">上传产品数量：{{vm.count}} <input type=\"hidden\" class=\"form-control\" name=\"count\" id=\"count\" ng-model=\"vm.count\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearFile();\">删除</button></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-md-1\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.showFileDialog(); multiple\">选择文件</button></div><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"\">取消</span></button> <button type=\"button\" ng-disabled=\"vm.isSaving || vm.uploader.queue.length == 0\" class=\"btn btn-primary\" ng-click=\"vm.uploadFile()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;确定</button></div></form>");
$templateCache.put("app/admin/search/guaTopicSearch/guaTopic.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\">选择占卦</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"question\"><span data-translate=\"\">标题</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"effectiveDate\"><span data-translate=\"\">发布时间</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"PV\"><span data-translate=\"\">PV</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"UV\"><span data-translate=\"\">UV</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"like\"><span data-translate=\"\">赞</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"unLike\"><span data-translate=\"\">踩</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"forward\"><span data-translate=\"\">转发</span><span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"guaTopicQiGua in vm.guaTopicQiGua track by guaTopicQiGua.id\" ng-click=\"vm.onSelect(guaTopicQiGua);\"><td>{{guaTopicQiGua.question}}</td><td>{{guaTopicQiGua.createdDate | date:\'yyyy年MM月dd日\'}}</td><td>{{guaTopicQiGua.PV}}</td><td>{{guaTopicQiGua.UV}}</td><td>{{guaTopicQiGua.like}}</td><td>{{guaTopicQiGua.unLike}}</td><td>{{guaTopicQiGua.forward}}</td></tr></tbody></table></div></div></div><div class=\"text-center form-group\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.loadPage()\"></uib-pagination></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button></div>");
$templateCache.put("app/admin/search/productSearch/product.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\">选择商品</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"productName\"><span data-translate=\"\">奖品名称</span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"\">所需积分</span></th><th jh-sort-by=\"status\"><span data-translate=\"\">状态</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expirationDate\"><span data-translate=\"\">有效期</span><span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"\">库存</span></th><th><span data-translate=\"\">已领取数量</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"product in vm.product track by product.id\" ng-click=\"vm.onSelect(product);\"><td>{{product.productName}}</td><td>{{product.productPrice.requiredPoints}}</td><td><button class=\"btn btn-success btn-xs\" ng-show=\"product.status == \'INFORCE\'\">已生效</button> <button class=\"btn btn-default btn-xs\" ng-show=\"product.status == \'PENDEFFECTIVE\'\">未生效</button></td><td>{{product.effectiveDate | date:\'yyyy年MM月dd日\'}}&nbsp;-&nbsp;{{product.expirationDate | date:\'yyyy年MM月dd日\'}}</td><td>{{product.stocks[0].quantity}}</td><td>{{product.stocks[0].redeemQty}}</td></tr></tbody></table></div></div></div><div class=\"text-center form-group\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.loadPage()\"></uib-pagination></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button></div>");
$templateCache.put("app/admin/search/user-search/user-search.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\">选择用户</h4></div><div class=\"modal-body\"><form class=\"form\" role=\"form\" ng-submit=\"vm.search();\"><div class=\"row\"><div class=\"form-group col-md-3\"><label for=\"login\" data-translate=\"userManagement.login\">Login</label> <input type=\"text\" class=\"form-control\" id=\"login\" ng-model=\"vm.login\"></div><div class=\"form-group col-md-3\"><label for=\"fullName\" data-translate=\"userManagement.fullName\">Full Name</label> <input type=\"text\" class=\"form-control\" id=\"fullName\" ng-model=\"vm.fullName\"></div><div class=\"form-group col-md-3\"><label for=\"org\" data-translate=\"userManagement.org\">Org</label> <input type=\"text\" class=\"form-control\" id=\"org\" ng-model=\"vm.org\"></div><div class=\"form-group col-md-3\"><label for=\"dept\" data-translate=\"userManagement.dept\">Dept</label> <input type=\"text\" class=\"form-control\" id=\"dept\" ng-model=\"vm.dept\"></div><div class=\"form-group col-md-3\"><label for=\"auth\" data-translate=\"userManagement.profiles\">Profiles</label><select class=\"form-control\" id=\"auth\" ng-model=\"vm.authorityName\"><option value=\"\"></option><option value=\"ROLE_ADMIN\">系统管理员</option><option value=\"ROLE_PLACE_ADMIN\">分部管理员</option><option value=\"ROLE_TEACHER\">老师</option><option value=\"ROLE_USER\">普通用户</option></select></div><div class=\"form-group col-md-1\"><br><button type=\"submit\" class=\"btn btn-primary\">查询</button></div></div></form><div class=\"row\"><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.search()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"login\"><span data-translate=\"userManagement.login\">Login</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fullName\"><span data-translate=\"userManagement.fullName\">Full Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"gender\"><span data-translate=\"userManagement.gender\">Gender</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"org\"><span data-translate=\"userManagement.org\">Org</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dept\"><span data-translate=\"userManagement.dept\">Dept</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"jobTitle\"><span data-translate=\"userManagement.jobTitle\">Job Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"jobTitle\"><span data-translate=\"userManagement.superior\">Superior</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\" ng-click=\"vm.onSelect(user);\"><td>{{user.id}}</td><td>{{user.login}}</td><td>{{user.fullName}}</td><td data-translate=\"hseApp.Gender.{{user.gender == null ? \'null\' : user.gender}}\">{{user.gender}}</td><td>{{user.orgName}}</td><td>{{user.deptName}}</td><td>{{user.jobTitle}}</td><td>{{user.superiorName}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.search()\"></uib-pagination></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button></div>");
$templateCache.put("app/admin/sys-admin/aboutUs/aboutUs-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"myOrganization\" data-translate=\"\">基本信息设置</h2></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-4\"><label class=\"control-label\" data-translate=\"\" for=\"wxMpNumber\">微信公众号</label> <input type=\"text\" class=\"form-control\" name=\"wxMpNumber\" id=\"wxMpNumber\" ng-model=\"vm.aboutUs.wxMpNumber\" required=\"\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\" data-translate=\"\" for=\"companyAddress\">公司地址</label> <input type=\"text\" class=\"form-control\" name=\"companyAddress\" id=\"companyAddress\" ng-model=\"vm.aboutUs.companyAddress\" required=\"\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\" data-translate=\"\" for=\"companyTelephone\">公司电话</label> <input type=\"text\" class=\"form-control\" name=\"companyTelephone\" id=\"companyTelephone\" ng-model=\"vm.aboutUs.companyTelephone\"></div><div class=\"form-group col-md-12\"><label class=\"control-label\" data-translate=\"\" for=\"editor\">描述</label><div id=\"editor\" ng-model=\"vm.aboutUs.description\"></div></div></div><div class=\"modal-footer\"><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"\">修改</span></button></div></div></form>");
$templateCache.put("app/admin/sys-admin/carousel/carousel-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.carousel.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"hseApp.carousel.delete.question\" translate-values=\"{id: \'{{vm.carousel.id}}\'}\">Are you sure you want to delete this Carousel?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/sys-admin/carousel/carousel-detail.html","<div><h2><span data-translate=\"hseApp.carousel.detail.title\">Carousel</span> {{vm.carousel.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"hseApp.carousel.name\">Name</span></dt><dd><span>{{vm.carousel.name}}</span></dd><dt><span data-translate=\"hseApp.carousel.suggestedWidth\">Suggested Width</span></dt><dd><span>{{vm.carousel.suggestedWidth}}</span></dd><dt><span data-translate=\"hseApp.carousel.suggestedHeight\">Suggested Height</span></dt><dd><span>{{vm.carousel.suggestedHeight}}</span></dd><dt><span data-translate=\"hseApp.carousel.description\">Description</span></dt><dd><span>{{vm.carousel.description}}</span></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button> <button type=\"button\" ui-sref=\"carousel-detail.edit({id:vm.carousel.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/admin/sys-admin/carousel/carousel-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCarouselLabel\" data-translate=\"hseApp.carousel.home.createOrEditLabel\">Create or edit a Carousel</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.carousel.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.carousel.id\" readonly=\"\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"hseApp.carousel.name\" for=\"field_name\">Name</label> <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.carousel.name\" ng-maxlength=\"500\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"500\">This field cannot be longer than 500 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"hseApp.carousel.suggestedWidth\" for=\"field_suggestedWidth\">Suggested Width</label> <input type=\"number\" class=\"form-control\" name=\"suggestedWidth\" id=\"field_suggestedWidth\" ng-model=\"vm.carousel.suggestedWidth\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"hseApp.carousel.suggestedHeight\" for=\"field_suggestedHeight\">Suggested Height</label> <input type=\"number\" class=\"form-control\" name=\"suggestedHeight\" id=\"field_suggestedHeight\" ng-model=\"vm.carousel.suggestedHeight\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"hseApp.carousel.description\" for=\"field_description\">Description</label> <input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.carousel.description\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/sys-admin/carousel/carousels.html","<div><h2 data-translate=\"hseApp.carousel.home.title\">Carousels</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"carousel.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"hseApp.carousel.home.createLabel\">Create new Carousel</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span data-translate=\"hseApp.carousel.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"suggestedWidth\"><span data-translate=\"hseApp.carousel.suggestedWidth\">Suggested Width</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"suggestedHeight\"><span data-translate=\"hseApp.carousel.suggestedHeight\">Suggested Height</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span data-translate=\"hseApp.carousel.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"carousel in vm.carousels track by carousel.id\"><td><a ui-sref=\"carousel-detail({id:carousel.id})\">{{carousel.id}}</a></td><td>{{carousel.name}}</td><td>{{carousel.suggestedWidth}}</td><td>{{carousel.suggestedHeight}}</td><td>{{carousel.description}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"carousel-detail({id:carousel.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"carousel.edit({id:carousel.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"carousel.delete({id:carousel.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/sys-admin/carousel-item/carousel-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.carouselItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"hseApp.carouselItem.delete.question\" translate-values=\"{id: \'{{vm.carouselItem.id}}\'}\">Are you sure you want to delete this Carousel Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/sys-admin/carousel-item/carousel-item-detail.html","<div><h2><span data-translate=\"hseApp.carouselItem.detail.title\">Carousel Item</span> {{vm.carouselItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"hseApp.carouselItem.itemUrl\">Item Url</span></dt><dd><img class=\"img-responsive\" ng-src=\"{{vm.carouselItem.itemUrl}}\" alt=\"{{vm.carouselItem.itemUrl}}\"></dd><dt><span data-translate=\"hseApp.carouselItem.targetCourseName\">Target Entity Name</span></dt><dd><span>{{vm.carouselItem.targetEntityName}}</span></dd><dt><span data-translate=\"hseApp.carouselItem.caption\">Caption</span></dt><dd><span>{{vm.carouselItem.caption}}</span></dd><dt><span data-translate=\"hseApp.carouselItem.effectiveTime\">Effective Time</span></dt><dd><span>{{vm.carouselItem.effectiveTime | date:\'medium\'}}</span></dd><dt><span data-translate=\"hseApp.carouselItem.sequence\">Sequence</span></dt><dd><span>{{vm.carouselItem.sequence}}</span></dd></dl><button type=\"submit\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div>");
$templateCache.put("app/admin/sys-admin/carousel-item/carousel-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCarouselItemLabel\" data-translate=\"hseApp.carouselItem.home.createOrEditLabel\">Create or edit a Carousel Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-6\" ng-show=\"vm.carouselItem.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.carouselItem.id\" readonly=\"\"></div><div class=\"form-group col-md-12\"><label class=\"control-label\" data-translate=\"hseApp.carouselItem.itemUrl\">Item Url</label><span>*</span><div ng-show=\"!vm.carouselItem.itemUrl\"><div ng-if=\"vm.uploader.queue.length == 0\"><div ng-show=\"vm.uploader.isHTML5\"><div class=\"well my-drop-zone\" nv-file-drop=\"\" uploader=\"vm.uploader\" ng-click=\"vm.showFileDialog();\">{{vm.carousel.description}},推荐图片尺寸{{vm.carousel.suggestedWidth}}*{{vm.carousel.suggestedHeight}}<br>拖动文件到此，或点击选择文件。</div></div><div ng-show=\"!vm.uploader.isHTML5\"><input type=\"file\" id=\"browse-file\" nv-file-select=\"\" uploader=\"vm.uploader\"></div></div><div class=\"well\" ng-show=\"vm.uploader.queue.length > 0\"><div class=\"row\"><div class=\"col-md-8\">{{vm.uploader.queue[0].file.name}} <span ng-if=\"vm.uploader.queue[0].file.size < 1024\">({{vm.uploader.queue[0].file.size}}Bytes)</span> <span ng-if=\"vm.uploader.queue[0].file.size >= 1024 && vm.uploader.queue[0].file.size < 1048576\">({{(vm.uploader.queue[0].file.size/1024).toFixed(2)}}KB)</span> <span ng-if=\"vm.uploader.queue[0].file.size >= 1048576 && vm.uploader.queue[0].file.size < 1073741824\">({{(vm.uploader.queue[0].file.size/1048576).toFixed(2)}}MB)</span> <span ng-if=\"vm.uploader.queue[0].file.size >= 1073741824\">({{(vm.uploader.queue[0].file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.uploadFile();\">上传</button> <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.uploader.clearQueue();\">取消</button></div><span class=\"progress\" ng-show=\"vm.uploadProgress >= 0\"><div style=\"width:{{vm.uploadProgress}}%\" ng-bind=\"vm.uploadProgress + \'%\'\"></div></span></div></div></div><div ng-show=\"vm.carouselItem.itemUrl\"><div class=\"well\"><div class=\"row\"><div class=\"col-md-8\"><img class=\"img-responsive\" ng-src=\"{{vm.carouselItem.itemUrl}}\" alt=\"{{vm.carouselItem.itemUrl}}\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearFile();\">删除</button></div></div></div></div></div><div class=\"form-group col-md-4\"><label class=\"control-label\" data-translate=\"hseApp.carouselItem.caption\" for=\"field_caption\">Caption</label> <input type=\"text\" class=\"form-control\" name=\"caption\" id=\"field_caption\" ng-model=\"vm.carouselItem.caption\" ng-maxlength=\"500\"><div ng-show=\"editForm.caption.$invalid\"><p class=\"help-block\" ng-show=\"editForm.caption.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"500\">This field cannot be longer than 500 characters.</p></div></div><div class=\"form-group col-md-4\" ng-if=\"vm.carouselItem.targetType===\'URL\'\"><label class=\"control-label\" data-translate=\"hseApp.carouselItem.targetUrl\" for=\"field_targetUrl\">Target Url</label> <input type=\"text\" class=\"form-control\" name=\"targetUrl\" id=\"field_targetUrl\" ng-model=\"vm.carouselItem.targetUrl\" ng-maxlength=\"2048\"><div ng-show=\"editForm.targetUrl.$invalid\"><p class=\"help-block\" ng-show=\"editForm.targetUrl.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"2048\">This field cannot be longer than 2048 characters.</p></div></div><div class=\"form-group col-md-4\" ng-if=\"vm.carouselItem.targetType===\'ENTITY\'\"><label class=\"control-label\" data-translate=\"hseApp.carouselItem.targetCourseName\" for=\"field_targetEntityId\">Target Entity Id</label><ui-select name=\"targetEntityId\" id=\"field_targetEntityId\" ng-model=\"vm.selected.value\" sortable=\"true\"><ui-select-match><span ng-bind=\"vm.selected.value.name\"></span></ui-select-match><ui-select-choices repeat=\"course in (vm.course | filter:{name: $select.search}) track by $index\"><h5><span ng-bind=\"course.name\"></span></h5><small ng-if=\"course.timingType== \'FT\'\">计时类型: 包月形式<br></small> <small ng-if=\"course.timingType== \'FL\'\">计时类型: 固定课时<br></small> <small ng-if=\"course.timingType== \'OTHER\'\">计时类型: 其他形式<br></small></ui-select-choices></ui-select></div><div class=\"form-group col-md-4\"><label class=\"control-label\" data-translate=\"hseApp.carouselItem.sequence\" for=\"field_sequence\">Sequence</label> <input type=\"number\" class=\"form-control\" name=\"sequence\" id=\"field_sequence\" ng-model=\"vm.carouselItem.sequence\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || !vm.carouselItem.itemUrl\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/sys-admin/carousel-item/carousel-items.html","<div><h2 data-translate=\"hseApp.carouselItem.home.title\">Carousel Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"^.carousel-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"hseApp.carouselItem.home.createLabel\">Create new Carousel Item</span></button> <span>（推荐图片比例：{{vm.carousel.suggestedWidth}}*{{vm.carousel.suggestedHeight}}）</span></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"itemUrl\"><span data-translate=\"hseApp.carouselItem.itemUrl\">Item Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"targetEntityName\"><span data-translate=\"hseApp.carouselItem.targetCourseName\">Target Entity Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"caption\"><span data-translate=\"hseApp.carouselItem.caption\">Caption</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"effectiveTime\"><span data-translate=\"hseApp.carouselItem.effectiveTime\">Effective Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"carouselItem in vm.carouselItems track by carouselItem.id\"><td>{{carouselItem.itemUrl}}</td><td>{{carouselItem.targetEntityName}}</td><td>{{carouselItem.caption}}</td><td>{{carouselItem.effectiveTime | date:\'medium\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.carousel-item-detail({id:carouselItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"^.carousel-item.edit({id:carouselItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"^.carousel-item.delete({id:carouselItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/sys-admin/feed-back/feed-back-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.feedBack.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"slmsApp.feedBack.delete.question\" translate-values=\"{id: \'{{vm.feedBack.id}}\'}\">Are you sure you want to delete this Feed Back?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/sys-admin/feed-back/feed-back-detail.html","<div><h2><span data-translate=\"slmsApp.feedBack.detail.title\">Feed Back</span> {{vm.feedBack.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"slmsApp.feedBack.organizationName\" uib-tooltip=\"{{\'slmsApp.feedBack.help.organizationName\' | translate}}\">Organization Name</span></dt><dd><span>{{vm.feedBack.organizationName}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.receiverFullName\" uib-tooltip=\"{{\'slmsApp.feedBack.help.receiverFullName\' | translate}}\">Receiver Full Name</span></dt><dd><span>{{vm.feedBack.receiverFullName}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.receiverPhoneNumber\" uib-tooltip=\"{{\'slmsApp.feedBack.help.receiverPhoneNumber\' | translate}}\">Receiver Phone Number</span></dt><dd><span>{{vm.feedBack.receiverPhoneNumber}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.content\" uib-tooltip=\"{{\'slmsApp.feedBack.help.content\' | translate}}\">content</span></dt><dd><span>{{vm.feedBack.content}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.sentDate\" uib-tooltip=\"{{\'slmsApp.feedBack.help.sentDate\' | translate}}\">Sent Date</span></dt><dd><span>{{vm.feedBack.sentDate | date:\'medium\'}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.handled\" uib-tooltip=\"{{\'slmsApp.feedBack.help.handled\' | translate}}\">Handled</span></dt><dd><span>{{vm.feedBack.handled}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.handlerName\" uib-tooltip=\"{{\'slmsApp.feedBack.help.handlerName\' | translate}}\">Handler Name</span></dt><dd><span>{{vm.feedBack.handlerName}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.handleResult\" uib-tooltip=\"{{\'slmsApp.feedBack.help.handleResult\' | translate}}\">Handle Result</span></dt><dd><span>{{vm.feedBack.handleResult}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.handleTime\" uib-tooltip=\"{{\'slmsApp.feedBack.help.handleTime\' | translate}}\">Handle Time</span></dt><dd><span>{{vm.feedBack.handleTime | date:\'medium\'}}</span></dd><dt><span data-translate=\"slmsApp.feedBack.remark\" uib-tooltip=\"{{\'slmsApp.feedBack.help.remark\' | translate}}\">Remark</span></dt><dd><span>{{vm.feedBack.remark}}</span></dd></dl><button type=\"submit\" ui-sref=\"admin.sys-admin.feed-back\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div>");
$templateCache.put("app/admin/sys-admin/feed-back/feed-back-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFeedBackLabel\" data-translate=\"slmsApp.feedBack.home.handleLabel\">Handle a Feed Back</h4></div><div class=\"modal-body row\"><jhi-alert-error></jhi-alert-error><div class=\"form-group col-md-3\" ng-show=\"vm.feedBack.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.feedBack.id\" readonly=\"\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.organizationName\" for=\"field_organizationName\" uib-tooltip=\"{{\'slmsApp.feedBack.help.organizationName\' | translate}}\">Organization Name</label> <input type=\"text\" class=\"form-control\" name=\"organizationName\" id=\"field_organizationName\" ng-model=\"vm.feedBack.organizationName\" readonly=\"\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.receiverFullName\" for=\"field_receiverFullName\" uib-tooltip=\"{{\'slmsApp.feedBack.help.customerFullName\' | translate}}\">Customer Full Name</label> <input type=\"text\" class=\"form-control\" name=\"receiverFullName\" id=\"field_receiverFullName\" ng-model=\"vm.feedBack.receiverFullName\" readonly=\"\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.receiverPhoneNumber\" for=\"field_receiverPhoneNumber\" uib-tooltip=\"{{\'slmsApp.feedBack.help.customerFullName\' | translate}}\">Customer Full Name</label> <input type=\"text\" class=\"form-control\" name=\"receiverPhoneNumber\" id=\"field_receiverPhoneNumber\" ng-model=\"vm.feedBack.receiverPhoneNumber\" readonly=\"\"></div><div class=\"form-group col-md-12\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.content\" for=\"field_content\" uib-tooltip=\"{{\'slmsApp.feedBack.help.content\' | translate}}\">Content</label> <textarea class=\"form-control\" name=\"content\" id=\"field_content\" ng-model=\"vm.feedBack.content\" required=\"\" ng-maxlength=\"15000\" readonly=\"\" style=\"height: 110px\"></textarea><div ng-show=\"editForm.content.$invalid\"><p class=\"help-block\" ng-show=\"editForm.content.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.content.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"15000\">This field cannot be longer than 15000 characters.</p></div></div><div class=\"form-group col-md-12\"><div class=\"form-group col-md-3\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.sentDate\" for=\"field_sentDate\" uib-tooltip=\"{{\'slmsApp.feedBack.help.sentDate\' | translate}}\">Sent Date</label><div class=\"input-group\"><input id=\"field_sentDate\" type=\"text\" class=\"form-control\" name=\"sentDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.feedBack.sentDate\" is-open=\"vm.datePickerOpenStatus.sentDate\" readonly=\"\"></div></div><div class=\"form-group col-md-3\" style=\"padding-top: 20px\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.handled\" for=\"field_handled\" uib-tooltip=\"{{\'slmsApp.feedBack.help.handled\' | translate}}\">Handled</label> <input type=\"checkbox\" name=\"handled\" id=\"field_handled\" ng-model=\"vm.feedBack.handled\"></div></div><div class=\"form-group col-md-12\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.handleResult\" for=\"field_handleResult\" uib-tooltip=\"{{\'slmsApp.feedBack.help.handleResult\' | translate}}\">Handle Result</label> <textarea class=\"form-control\" name=\"handleResult\" id=\"field_handleResult\" ng-model=\"vm.feedBack.handleResult\" ng-maxlength=\"1024\" style=\"height: 110px\"></textarea><div ng-show=\"editForm.handleResult.$invalid\"><p class=\"help-block\" ng-show=\"editForm.handleResult.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"1024\">This field cannot be longer than 1024 characters.</p></div></div><div class=\"form-group col-md-12\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.remark\" for=\"field_remark\" uib-tooltip=\"{{\'slmsApp.feedBack.help.remark\' | translate}}\">Remark</label> <input type=\"text\" class=\"form-control\" name=\"remark\" id=\"field_remark\" ng-model=\"vm.feedBack.remark\" ng-maxlength=\"255\"><div ng-show=\"editForm.remark.$invalid\"><p class=\"help-block\" ng-show=\"editForm.remark.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/sys-admin/feed-back/feed-backs.html","<div><h2 data-translate=\"slmsApp.feedBack.home.title\">Feed Backs</h2><jhi-alert></jhi-alert><form class=\"form\"><div class=\"row\"><div class=\"form-group col-md-2\" ng-if=\"vm.ROLE_ADMIN\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.organizationName\" for=\"organizationId\">Organization Name</label><select class=\"form-control\" id=\"organizationId\" name=\"organizationId\" ng-model=\"vm.condition.organizationId\" ng-options=\"organization.id as organization.name for organization in vm.organizations\"><option value=\"\"></option></select></div><div class=\"form-group col-md-2\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.receiverPhoneNumber\" for=\"receiverPhoneNumber\">Receiver Phone Number</label> <input type=\"text\" class=\"form-control\" id=\"receiverPhoneNumber\" name=\"receiverPhoneNumber\" ng-model=\"vm.condition.receiverPhoneNumber\"></div><div class=\"form-group col-md-2\"><label class=\"control-label\" data-translate=\"slmsApp.feedBack.handled\" for=\"handled\">是否被处理</label><select class=\"form-control\" id=\"handled\" name=\"handled\" ng-model=\"vm.condition.handled\"><option value=\"\"></option><option value=\"true\">已处理</option><option value=\"false\">待处理</option></select></div><div class=\"form-group col-md-1\"><br><button type=\"button\" ng-click=\"vm.search();\" class=\"btn btn-primary\">查询</button></div></div></form><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span data-translate=\"global.field.serialNumber\">Serial Number</span></th><th jh-sort-by=\"organizationName\"><span data-translate=\"slmsApp.feedBack.organizationName\">Organization Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"receiverFullName\"><span data-translate=\"slmsApp.feedBack.receiverFullName\">Receiver FullName</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"receiverPhoneNumber\"><span data-translate=\"slmsApp.feedBack.receiverPhoneNumber\">Receiver PhoneNumber</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"content\"><span data-translate=\"slmsApp.feedBack.content\">Content</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sentDate\"><span data-translate=\"slmsApp.feedBack.sentDate\">Sent Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"handled\"><span data-translate=\"slmsApp.feedBack.handled\">Handled</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"handlerName\"><span data-translate=\"slmsApp.feedBack.handlerName\">Receiver Full Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"handleResult\"><span data-translate=\"slmsApp.feedBack.handleResult\">Handle Result</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"handleTime\"><span data-translate=\"slmsApp.feedBack.handleTime\">Handle Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"feedBack in vm.feedBacks track by feedBack.id\"><td>{{($index + 1) + ((vm.page -1) * vm.itemsPerPage)}}</td><td>{{feedBack.organizationName}}</td><td>{{feedBack.receiverFullName}}</td><td>{{feedBack.receiverPhoneNumber}}</td><td>{{feedBack.content |limitTo:15}}<span ng-show=\"feedBack.content.toString().length >= 15\">...</span></td><td>{{feedBack.sentDate | date:\'medium\'}}</td><td><button class=\"btn btn-danger btn-xs\" ng-show=\"!feedBack.handled\" data-translate=\"entity.action.toHandle\">Deactivated</button> <button class=\"btn btn-success btn-xs\" ng-show=\"feedBack.handled\" data-translate=\"entity.action.handled\">Activated</button></td><td>{{feedBack.handlerName}}</td><td>{{feedBack.handleResult |limitTo:15}}<span ng-show=\"feedBack.handleResult.toString().length >= 15\">...</span></td><td>{{feedBack.handleTime | date:\'medium\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"admin.sys-admin.feed-back-detail({id:feedBack.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ng-if=\"feedBack.handled\" ui-sref=\"admin.sys-admin.feed-back.edit({id:feedBack.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-if=\"!feedBack.handled\" ui-sref=\"admin.sys-admin.feed-back.edit({id:feedBack.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\">处理</span></button> <button type=\"submit\" ui-sref=\"admin.sys-admin.feed-back.delete({id:feedBack.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/sys-admin/file-upload-log/file-upload-log.detail.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">文件图片</h4></div><div class=\"modal-body\"><div class=\"row\" ng-if=\"vm.FileUploadLog.fileType == \'PNG\' || vm.FileUploadLog.fileType == \'JPG\' || vm.FileUploadLog.fileType ==\'GIF\'\"><img ng-src=\"{{vm.imgUrl}}\" width=\"400\" height=\"213\" alt=\"\"></div><div>{{vm.FileUploadLog.fileName}}<a ng-if=\"vm.FileUploadLog.fileName\" type=\"submit\" href=\"{{vm.FileUploadLog.fileUrl}}\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-save\"></span> <span class=\"hidden-sm-down ng-scope\">下载</span></a></div></div></form>");
$templateCache.put("app/admin/sys-admin/file-upload-log/file-upload-logs.html","<div><h2 data-translate=\"hseApp.fileUploadLog.home.title\">File Upload Logs</h2><jhi-alert></jhi-alert><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"contentType\"><span data-translate=\"hseApp.fileUploadLog.contentType\">Content Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileName\"><span data-translate=\"hseApp.fileUploadLog.fileName\">File Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fileUrl\"><span data-translate=\"hseApp.fileUploadLog.fileUrl\">File Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"originalFileName\"><span data-translate=\"hseApp.fileUploadLog.originalFileName\">Original File Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"size\"><span data-translate=\"hseApp.fileUploadLog.size\">Size</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdBy\"><span data-translate=\"hseApp.fileUploadLog.createdBy\">Created By</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"createdDate\"><span data-translate=\"hseApp.fileUploadLog.createdDate\">Created Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"fileUploadLog in vm.fileUploadLogs track by fileUploadLog.id\"><td>{{fileUploadLog.id}}</td><td>{{fileUploadLog.contentType}}</td><td>{{fileUploadLog.fileName}}</td><td>{{fileUploadLog.fileUrl}}</td><td>{{fileUploadLog.originalFileName}}</td><td class=\"pull-right\">{{fileUploadLog.size}}</td><td>{{fileUploadLog.createdBy}}</td><td>{{fileUploadLog.createdDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td class=\"text-right\" ng-if=\"fileUploadLog.fileType == \'GIF\' || \'JPG\' || \'PNG\'\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.file-upload-log.edit({id:fileUploadLog.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.view\">查看</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/sys-admin/news/news-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.publicAnnouncement.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"hseApp.news.delete.question\" translate-values=\"{id: \'{{vm.publicAnnouncement.id}}\'}\">Are you sure you want to delete this Public Announcement?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/sys-admin/news/news-detail.html","<div><div class=\"mail-box-header text-center\"><h1>{{vm.publicAnnouncement.subject}}</h1><p>发布时间：{{vm.publicAnnouncement.releaseTime | date:\"yyyy-MM-dd\"}}</p></div><div class=\"mail-box\"><img class=\"img-responsive\" width=\"400\" height=\"213\" ng-src=\"{{vm.publicAnnouncement.imgUrl}}\"><div class=\"mail-body\" id=\"mail-content\"></div><div class=\"mail-body\"><p>发布人姓名：{{vm.publicAnnouncement.editorFullName}}</p></div></div><button type=\"submit\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div>");
$templateCache.put("app/admin/sys-admin/news/news-dialog.html","<div><form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><h2 class=\"modal-title\" id=\"myPublicAnnouncementLabel\" data-translate=\"hseApp.news.home.createOrEditLabel\">Create or edit a Public Announcement</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-6\" ng-show=\"vm.publicAnnouncement.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.publicAnnouncement.id\" readonly=\"\"></div><div class=\"form-group col-md-12\"><label class=\"control-label\" data-translate=\"hseApp.news.subject\" for=\"field_subject\">Subject</label><span>*</span> <input type=\"text\" class=\"form-control\" name=\"subject\" id=\"field_subject\" ng-model=\"vm.publicAnnouncement.subject\" ng-maxlength=\"50\"><div ng-show=\"editForm.subject.$invalid\"><p class=\"help-block\" ng-show=\"editForm.subject.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-3\"><label class=\"control-label\" data-translate=\"\">封面图片（图片建议尺寸：400*213）</label><div ng-show=\"!vm.publicAnnouncement.imgUrl\"><div ng-if=\"vm.uploaderImg.queue.length == 0\"><div ng-show=\"vm.uploaderImg.isHTML5\"><div class=\"well my-drop-zone\" nv-file-drop=\"\" uploader=\"vm.uploaderImg\" ng-click=\"vm.showImgDialog();\">拖动文件到此，或点击选择文件</div></div><div ng-show=\"!vm.uploaderImg.isHTML5\"><input type=\"file\" id=\"browse-img\" nv-file-select=\"\" uploader=\"vm.uploaderImg\"></div></div><div class=\"well\" ng-show=\"vm.uploaderImg.queue.length > 0\"><div class=\"row\"><div class=\"col-md-8\">{{vm.uploaderImg.queue[0].file.name}} <span ng-if=\"vm.uploaderImg.queue[0].file.size < 1024\">({{vm.uploaderImg.queue[0].file.size}}Bytes)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1024 && vm.uploaderImg.queue[0].file.size < 1048576\">({{(vm.uploaderImg.queue[0].file.size/1024).toFixed(2)}}KB)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1048576 && vm.uploaderImg.queue[0].file.size < 1073741824\">({{(vm.uploaderImg.queue[0].file.size/1048576).toFixed(2)}}MB)</span> <span ng-if=\"vm.uploaderImg.queue[0].file.size >= 1073741824\">({{(vm.uploaderImg.queue[0].file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.uploadImg();\">上传</button> <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.uploaderImg.clearQueue();\">取消</button></div><span class=\"progress\" ng-show=\"vm.uploadProgress >= 0\"><div style=\"width:{{vm.uploadProgress}}%\" ng-bind=\"vm.uploadProgress + \'%\'\"></div></span></div></div></div><div ng-show=\"vm.publicAnnouncement.imgUrl\"><div class=\"well\"><div class=\"row\"><div class=\"col-md-8\"><img class=\"img-responsive\" width=\"400\" height=\"213\" ng-src=\"{{vm.publicAnnouncement.imgUrl}}\" alt=\"{{vm.publicAnnouncement.imgUrl}}\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearImg();\">删除</button></div></div></div></div></div><div class=\"col-md-12\"><label class=\"control-label\" data-translate=\"hseApp.news.content\">Content</label><span>*</span><div id=\"editor\" ng-model=\"vm.publicAnnouncement.content\"></div><div class=\"clearfix\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ui-sref=\"^.news\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"vm.isSaving || !vm.publicAnnouncement.subject\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form></div>");
$templateCache.put("app/admin/sys-admin/news/news.html","<div><h2 data-translate=\"hseApp.news.home.title\">Public Announcements</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"^.news.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"hseApp.news.home.createLabel\">Create new Public Announcement</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span data-translate=\"global.field.serialNumber\">serial number</span></th><th jh-sort-by=\"subject\"><span data-translate=\"hseApp.news.subject\">Subject</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"editorId\"><span data-translate=\"hseApp.news.senderId\">Sender Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"editorFullName\"><span data-translate=\"hseApp.news.senderName\">Sender Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"releaseTime\"><span data-translate=\"hseApp.news.sentDate\">Sent Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"news in vm.publicAnnouncements track by news.id\"><td>{{($index + 1) + ((vm.page -1) * vm.itemsPerPage)}}</td><td>{{news.subject}}</td><td>{{news.editorId}}</td><td>{{news.editorFullName}}</td><td>{{news.releaseTime | date:\'yyyy-MM-dd HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.news-detail({id:news.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"^.news.edit({id:news.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"^.news.delete({id:news.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/sys-admin/public-announcement/public-announcement-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.publicAnnouncement.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"hseApp.publicAnnouncement.delete.question\" translate-values=\"{id: \'{{vm.publicAnnouncement.id}}\'}\">Are you sure you want to delete this Public Announcement?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/sys-admin/public-announcement/public-announcement-detail.html","<div><div class=\"mail-box-header text-center\"><h1>{{vm.publicAnnouncement.subject}}</h1><p>发布时间：{{vm.publicAnnouncement.sentDate | date:\"yyyy-MM-dd\"}}</p></div><div class=\"mail-box\"><div class=\"mail-body\" id=\"mail-content\"></div><div class=\"mail-body\"><p>发布人姓名：{{vm.publicAnnouncement.senderName}}</p></div></div><button type=\"submit\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div>");
$templateCache.put("app/admin/sys-admin/public-announcement/public-announcement-dialog.html","<div><form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><h2 class=\"modal-title\" id=\"myPublicAnnouncementLabel\" data-translate=\"hseApp.publicAnnouncement.home.createOrEditLabel\">Create or edit a Public Announcement</h2><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-6\" ng-show=\"vm.publicAnnouncement.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.publicAnnouncement.id\" readonly=\"\"></div><div class=\"form-group col-md-12\"><label class=\"control-label\" data-translate=\"hseApp.publicAnnouncement.subject\" for=\"field_subject\">Subject</label><span>*</span> <input type=\"text\" class=\"form-control\" name=\"subject\" id=\"field_subject\" ng-model=\"vm.publicAnnouncement.subject\" ng-maxlength=\"50\"><div ng-show=\"editForm.subject.$invalid\"><p class=\"help-block\" ng-show=\"editForm.subject.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"col-md-12\"><label class=\"control-label\" data-translate=\"hseApp.publicAnnouncement.content\">Content</label><span>*</span><div id=\"editor\" ng-model=\"vm.publicAnnouncement.content\"></div><div class=\"clearfix\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ui-sref=\"^.public-announcement\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"vm.isSaving || !vm.publicAnnouncement.subject\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form></div>");
$templateCache.put("app/admin/sys-admin/public-announcement/public-announcements.html","<div><h2 data-translate=\"hseApp.publicAnnouncement.home.title\">Public Announcements</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\" ng-if=\"vm.ROLE_ADMIN || vm.ROLE_PLACE_ADMIN\"><button class=\"btn btn-primary\" ui-sref=\"^.public-announcement.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"hseApp.publicAnnouncement.home.createLabel\">Create new Public Announcement</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span data-translate=\"global.field.serialNumber\">serial number</span></th><th jh-sort-by=\"subject\"><span data-translate=\"hseApp.publicAnnouncement.subject\">Subject</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"senderId\"><span data-translate=\"hseApp.publicAnnouncement.senderId\">Sender Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"senderName\"><span data-translate=\"hseApp.publicAnnouncement.senderName\">Sender Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"sentDate\"><span data-translate=\"hseApp.publicAnnouncement.sentDate\">Sent Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"publicAnnouncement in vm.publicAnnouncements track by publicAnnouncement.id\"><td>{{($index + 1) + ((vm.page -1) * vm.itemsPerPage)}}</td><td>{{publicAnnouncement.subject}}</td><td>{{publicAnnouncement.senderId}}</td><td>{{publicAnnouncement.senderName}}</td><td>{{publicAnnouncement.sentDate | date:\'yyyy-MM-dd HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.public-announcement-detail({id:publicAnnouncement.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ng-if=\"vm.ROLE_ADMIN || vm.ROLE_PLACE_ADMIN\" ui-sref=\"^.public-announcement.edit({id:publicAnnouncement.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-if=\"vm.ROLE_ADMIN || vm.ROLE_PLACE_ADMIN\" ui-sref=\"^.public-announcement.delete({id:publicAnnouncement.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/admin/sys-admin/user-management/user-management-bonusPoint.html","<div><h2><span>积分明细</span></h2><br><div style=\"padding-left: 100px\"><span class=\"directoryIcon\"></span>&nbsp;&nbsp;<span class=\"weight600\">积分账户</span></div><br><dl class=\"dl-horizontal jh-entity-details dtWeight lineHeight34\"><dt><span>账户名:</span></dt><dd><span ng-if=\"!vm.user.realName\">{{vm.user.nickName}}</span> <span ng-if=\"vm.user.realName\">{{vm.user.nickName}}({{vm.user.realName}})</span></dd><dt><span>余额:</span></dt><dd ng-if=\"vm.bonusPoint\">{{vm.bonusPoint}}</dd><dd ng-if=\"!vm.bonusPoint\">0</dd></dl><br><div style=\"padding-left: 100px\"><span class=\"directoryIcon\"></span>&nbsp;&nbsp;<span class=\"weight600\">积分消费</span></div><br><div style=\"padding-left: 100px\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"reason\"><span>项目</span> <span></span></th><th jh-sort-by=\"operationDate\"><span>操作时间</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"bonusPointChange\"><span>积分</span> <span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"bonusPoint in vm.bonusPointlog track by bonusPoint.id\"><td>{{bonusPoint.reason}}</td><td>{{bonusPoint.operationDate | date:\'yyyy-MM-dd\'}}</td><td>{{bonusPoint.bonusPointChange}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div><button type=\"submit\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div>");
$templateCache.put("app/admin/sys-admin/user-management/user-management-detail.html","<div><h2><span>用户详情</span></h2><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"contact-box\"><div class=\"col-sm-4\"><div class=\"text-center\"><img alt=\"image\" width=\"100\" height=\"100\" class=\"img-circle m-t-xs img-responsive\" ng-src=\"{{vm.user.headImgUrl}}\" ng-if=\"vm.user.headImgUrl\"> <img alt=\"image\" width=\"100\" height=\"100\" class=\"img-circle m-t-xs img-responsive\" src=\"assets/images/logo_small.png\" ng-if=\"!vm.user.headImgUrl\"></div></div><div class=\"col-sm-8\"><h3><strong>{{vm.user.nickName}}</strong></h3><p ng-if=\"!vm.bonusPoint\"><i class=\"fa fa-money\"></i>&nbsp;&nbsp;0&nbsp;&nbsp;<a ui-sref=\"admin.sys-admin.user-management-bonusPoint({id:vm.user.id})\">查看积分明细</a></p><p ng-if=\"vm.bonusPoint\"><i class=\"fa fa-money\"></i>&nbsp;&nbsp;{{vm.bonusPoint}}&nbsp;&nbsp;<a ui-sref=\"admin.sys-admin.user-management-bonusPoint({id:vm.user.id})\">查看积分明细</a></p></div><div class=\"clearfix\"></div></div></div></div></div><div style=\"padding-left: 100px\"><span class=\"directoryIcon\"></span>&nbsp;&nbsp;<span class=\"weight600\">基础信息</span></div><br><dl class=\"dl-horizontal jh-entity-details dtWeight lineHeight34\"><dt><span>姓名：</span></dt><dd><span>{{vm.user.realName}}</span></dd><dt><span>昵称：</span></dt><dd>{{vm.user.nickName}}</dd><dt><span>手机：</span></dt><dd>{{vm.user.phoneNumber}}</dd><dt><span>地区：</span></dt><dd>{{vm.user.city}}</dd><dt><span>配送地址：</span></dt><dd>{{vm.user.address}}</dd></dl><button type=\"submit\" ui-sref=\"^.user-management\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\">Back</span></button></div>");
$templateCache.put("app/admin/sys-admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" data-translate=\"userManagement.home.createOrEditLabel\">Create or edit a User</h4></div><div class=\"modal-body\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><div class=\"col-md-9\"><div class=\"form-group col-md-4\"><label data-translate=\"global.field.id\">ID</label> <input type=\"text\" class=\"form-control\" name=\"id\" ng-model=\"vm.user.id\" readonly=\"\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\" data-translate=\"userManagement.login\">Login *</label> <input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"userManagement.fullName\">Full Name *</label> <input type=\"text\" class=\"form-control\" name=\"fullName\" ng-focus=\"vm.guessFullName();\" ng-model=\"vm.user.fullName\" ng-required=\"vm.user.fullName == null || vm.user.fullName == \'\'\" ng-maxlength=\"50\"><div ng-show=\"editForm.fullName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.fullName.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.fullName.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"col-md-4\" ng-if=\"vm.teacher == true || vm.consultant == true\"><label data-translate=\"\">教师名</label><div><ui-select multiple=\"\" ng-model=\"vm.place.value\" theme=\"bootstrap\" sortable=\"true\" close-on-select=\"false\" disabled=\"\"><ui-select-match>{{$item.fullName}}<span ng-if=\"$item.profession\">({{$item.profession}})</span> <span ng-bind=\"vm.place.value.fullName\"></span></ui-select-match><ui-select-choices repeat=\"place in vm.place.value track by place.id\" disabled=\"\"><h5><span ng-bind=\"place.id\"></span></h5></ui-select-choices></ui-select></div><div><button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.selectTeacher()\"><i class=\"fa fa-plus\"></i>&nbsp;选择教师</button></div></div><div class=\"form-group col-md-4\" ng-if=\"!vm.org && !vm.teacher && !vm.consultant&&vm.ROLE_ADMIN\"><label data-translate=\"\" for=\"place1\">单位</label><select class=\"form-control\" id=\"place1\" name=\"place\" ng-model=\"vm.user.orgId\" ng-options=\"user.id as user.name for user in vm.Organization\"><option value=\"\"></option></select></div><div class=\"form-group col-md-4\" ng-if=\"(vm.org || vm.teacher || vm.consultant)&&vm.ROLE_ADMIN\"><label data-translate=\"\" for=\"place2\">单位 *</label><select class=\"form-control\" id=\"place2\" name=\"place\" ng-model=\"vm.user.orgId\" ng-options=\"user.id as user.name for user in vm.organizationUsers\"><option value=\"\"></option></select></div><div class=\"form-group col-md-4\"><label data-translate=\"userManagement.gender\" for=\"gender\">Gender</label><select class=\"form-control\" name=\"gender\" ng-model=\"vm.user.gender\" id=\"gender\"><option value=\"\" data-translate=\"hseApp.Gender.null\"></option><option value=\"MALE\" data-translate=\"hseApp.Gender.MALE\">MALE</option><option value=\"FEMALE\" data-translate=\"hseApp.Gender.FEMALE\">FEMALE</option></select></div><div class=\"form-group col-md-4\"><label data-translate=\"userManagement.nationality\">Nationality</label> <input type=\"text\" class=\"form-control\" name=\"nationality\" ng-model=\"vm.user.nationality\" ng-maxlength=\"50\"><div ng-show=\"editForm.nationality.$invalid\"><p class=\"help-block\" ng-show=\"editForm.nationality.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"userManagement.idCardNumber\">certId *</label> <input type=\"text\" class=\"form-control\" name=\"certId\" ng-model=\"vm.user.certId\" ng-maxlength=\"50\"><div ng-show=\"editForm.certId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.certId.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-4\"><label data-translate=\"userManagement.mobilePhone\">MobilePhone</label> <input type=\"text\" class=\"form-control\" name=\"mobilePhone\" ng-model=\"vm.user.mobilePhone\" ng-maxlength=\"50\"><div ng-show=\"editForm.mobilePhone.$invalid\"><p class=\"help-block\" ng-show=\"editForm.mobilePhone.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-12\"><label for=\"activated\"><input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" name=\"activated\" ng-model=\"vm.user.activated\"> <span data-translate=\"userManagement.activated\">Activated</span></label></div></div><div class=\"col-md-3\"><div class=\"form-group col-md-12\"><label data-translate=\"userManagement.profiles\">Profiles</label><select class=\"form-control\" multiple=\"\" name=\"authority\" ng-model=\"vm.user.authorities\" size=\"8\" ng-change=\"vm.getAuthorities()\" ng-options=\"authorities.key as authorities.value for authorities in vm.authorities\"></select></div></div></div><div class=\"modal-footer\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></div></div></form>");
$templateCache.put("app/admin/sys-admin/user-management/user-management.html","<div><h2 data-translate=\"userManagement.home.title\">Users</h2><div class=\"row\"><div class=\"form-group col-md-3\"><input type=\"text\" class=\"form-control\" id=\"name\" placeholder=\"输入昵称/姓名进行查询\" ng-model=\"vm.condition.name\"></div><div class=\"form-group col-md-1\"><button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.search()\">检索</button></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"nickName\"><span>昵称</span> <span></span></th><th jh-sort-by=\"channel\"><span>来源</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"regTime\"><span>注册日期</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastLoginTime\"><span>最后活跃日期</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td>{{user.nickName}}</td><td><span ng-if=\"user.channel == 0\">注册</span> <span ng-if=\"user.channel == 1\">微信网页授权</span> <span ng-if=\"user.channel == 2\">第三方授权</span> <span ng-if=\"user.channel == 3\">日历小程序</span></td><td>{{user.regTime | date:\'yyyy-MM-dd\'}}</td><td>{{user.lastLoginTime | date:\'yyyy-MM-dd\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.user-management-detail({id:user.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\">查看详情</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div><table class=\"jh-table table table-striped\" id=\"download-table\" style=\"display: none\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"login\"><span data-translate=\"userManagement.login\">Login</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fullName\"><span data-translate=\"userManagement.fullName\">Full Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"gender\"><span data-translate=\"userManagement.gender\">Gender</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"nationality\"><span data-translate=\"userManagement.nationality\">Nationality</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"userType\"><span data-translate=\"userManagement.userType\">User Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"org\"><span data-translate=\"userManagement.org\">Org</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dept\"><span data-translate=\"userManagement.dept\">Dept</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"jobTitle\"><span data-translate=\"userManagement.jobTitle\">Job Title</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"jobTitle\"><span data-translate=\"userManagement.superior\">Superior</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span data-translate=\"userManagement.profiles\">Profiles</span></th></tr></thead><tbody><tr ng-repeat=\"user in vm.downloadUsers track by user.id\"><td>{{user.id}}</td><td>{{user.login}}</td><td>{{user.fullName}}</td><td data-translate=\"hseApp.Gender.{{user.gender == null ? \'null\' : user.gender}}\">{{user.gender}}</td><td>{{user.nationality}}</td><td data-translate=\"hseApp.UserType.{{user.userType == null ? \'null\' : user.userType}}\">{{user.userType}}</td><td>{{user.orgName}}</td><td>{{user.deptName}}</td><td>{{user.jobTitle}}</td><td>{{user.superiorName}}</td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ vm.authArray[authority] }}</span></div></td></tr></tbody></table></div>");
$templateCache.put("app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg-delete.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.wxCusServiceMsg.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"\">删除客服消息</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"\">你确认要删除关键字为{{vm.wxCusServiceMsg.keyWord}}的客服消息？</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"\">取消</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"\">删除</span></button></div></form>");
$templateCache.put("app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg-detail.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">新增或编辑客服消息</h2></div><div class=\"modal-body\"><div class=\"row text-label-right\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">* 客服消息类型</label><div class=\"input-group col-md-2\"><span ng-if=\"vm.wxCusServiceMsg.msgType == \'text\'\">文本</span> <span ng-if=\"vm.wxCusServiceMsg.msgType == \'image\'\">图片</span> <span ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\">图文链接</span> <span ng-if=\"vm.wxCusServiceMsg.msgType == \'miniprogrampage\'\">小程序卡片</span></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">* 关键字</label><div class=\"col-sm-6 input-group\">{{vm.wxCusServiceMsg.keyWord}}</div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'text\'\"><label class=\"col-sm-2 control-label\">* 文本内容</label><div class=\"col-sm-6 input-group\">{{vm.wxCusServiceMsg.content}}</div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'image\'\"><label class=\"col-md-2 control-label\">* 图片</label> <img ng-src=\"{{vm.wxCusServiceMsg.fileUrl}}\" alt=\"\"></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\"><label class=\"col-sm-2 control-label\">* 标题</label><div class=\"col-sm-6 input-group\">{{vm.wxCusServiceMsg.title}}</div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\"><label class=\"col-sm-2 control-label\">* 文本内容</label><div class=\"col-sm-6 input-group\">{{vm.wxCusServiceMsg.description}}</div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\"><label class=\"col-sm-2 control-label\">* 链接</label><div class=\"col-sm-6 input-group\">{{vm.wxCusServiceMsg.url}}</div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\"><label class=\"col-md-2 control-label\">* 图片</label> <img ng-src=\"{{vm.wxCusServiceMsg.thumbUrl}}\" width=\"80\" height=\"80\" alt=\"\"></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'miniprogrampage\'\"><label class=\"col-sm-2 control-label\">* 标题</label><div class=\"col-sm-6 input-group\">{{vm.wxCusServiceMsg.title}}</div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'miniprogrampage\'\"><label class=\"col-sm-2 control-label\">* 页面路径</label><div class=\"col-sm-6 input-group\">{{vm.wxCusServiceMsg.pagepath}}</div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'miniprogrampage\'\"><label class=\"col-md-2 control-label\">* 图片</label> <img ng-src=\"{{vm.wxCusServiceMsg.fileUrl}}\" width=\"520\" height=\"416\" alt=\"\"></div></div></div><button type=\"button\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span>返回</span></button></form>");
$templateCache.put("app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg-dialog.html","<form name=\"editForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.save()\" show-validation=\"\"><div class=\"modal-header\"><h2 class=\"modal-title\" id=\"mystudent\" data-translate=\"\">新增或编辑客服消息</h2></div><div class=\"modal-body\"><div class=\"row text-label-right\"><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\" for=\"msgType\">* 客服消息类型</label><div class=\"input-group col-md-2\"><select class=\"form-control\" id=\"msgType\" ng-model=\"vm.wxCusServiceMsg.msgType\" name=\"msgType\"><option value=\"text\">文本</option><option value=\"image\">图片</option><option value=\"link\">图文链接</option><option value=\"miniprogrampage\">小程序卡片</option></select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label lineHeight34\">* 关键字</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"keyWord\" placeholder=\"请输入关键字\" ng-model=\"vm.wxCusServiceMsg.keyWord\" name=\"keyWord\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\"></label><div class=\"col-sm-6 input-group\"><small>注：若要设置通用的回复，请设置关键字为“无”&nbsp;&nbsp;&nbsp;</small></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'text\'\"><label class=\"col-sm-2 control-label lineHeight34\">* 文本内容</label><div class=\"col-sm-6 input-group\"><textarea type=\"text\" class=\"form-control\" id=\"content\" placeholder=\"请输入文本内容\" ng-model=\"vm.wxCusServiceMsg.content\" name=\"content\" required=\"\"></textarea></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'image\'\"><label class=\"col-md-2 control-label\">* 图片</label><div class=\"col-sm-2 input-group\"><div ng-show=\"!vm.wxCusServiceMsg.fileUrl\"><div ng-show=\"vm.uploaderImg.queue.length == 0\"><div ng-show=\"vm.uploaderImg.isHTML5\"><div class=\"well my-drop-zone\" style=\"margin-bottom: 0\" nv-file-drop=\"\" uploader=\"vm.uploaderImg\" ng-click=\"vm.showImgDialog();\">拖动图片到此，<br>或点击选择图片</div></div><div ng-show=\"!vm.uploaderImg.isHTML5\"><input type=\"file\" id=\"browse-img\" nv-file-select=\"\" uploader=\"vm.uploaderImg\"></div></div><div class=\"well\" style=\"margin-bottom: 0\" ng-show=\"vm.uploaderImg.queue.length > 0\"><div class=\"row\"><div class=\"col-md-8\">{{vm.uploaderImg.queue[0].file.name}} <span ng-show=\"vm.uploaderImg.queue[0].file.size < 1024\">({{vm.uploaderImg.queue[0].file.size}}Bytes)</span> <span ng-show=\"vm.uploaderImg.queue[0].file.size >= 1024 && vm.uploaderImg.queue[0].file.size < 1048576\">({{(vm.uploaderImg.queue[0].file.size/1024).toFixed(2)}}KB)</span> <span ng-show=\"vm.uploaderImg.queue[0].file.size >= 1048576 && vm.uploaderImg.queue[0].file.size < 1073741824\">({{(vm.uploaderImg.queue[0].file.size/1048576).toFixed(2)}}MB)</span> <span ng-show=\"vm.uploaderImg.queue[0].file.size >= 1073741824\">({{(vm.uploaderImg.queue[0].file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.uploadImg();\">上传</button> <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.uploaderImg.clearQueue();\">取消</button></div><span class=\"progress\" ng-show=\"vm.uploadProgress >= 0\"><div style=\"width:{{vm.uploadProgress}}%\" ng-bind=\"vm.uploadProgress + \'%\'\"></div></span></div></div></div><div ng-show=\"vm.wxCusServiceMsg.fileUrl\"><div class=\"well\" style=\"margin-bottom: 0\"><div class=\"row\"><div class=\"col-md-8\"><img class=\"img-responsive\" width=\"400\" height=\"213\" ng-src=\"{{vm.wxCusServiceMsg.fileUrl}}\" alt=\"{{vm.wxCusServiceMsg.fileUrl}}\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearImg();\">删除</button></div></div></div></div></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\"><label class=\"col-sm-2 control-label lineHeight34\">* 标题</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"请输入图文标题\" ng-model=\"vm.wxCusServiceMsg.title\" name=\"title\" required=\"\"></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\"><label class=\"col-sm-2 control-label lineHeight34\">* 文本内容</label><div class=\"col-sm-6 input-group\"><textarea type=\"text\" class=\"form-control\" id=\"description\" placeholder=\"请输入文本内容\" ng-model=\"vm.wxCusServiceMsg.description\" name=\"description\" required=\"\"></textarea></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\"><label class=\"col-sm-2 control-label lineHeight34\">* 跳转链接</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"url\" placeholder=\"请输入跳转链接\" ng-model=\"vm.wxCusServiceMsg.url\" name=\"url\" required=\"\"></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'link\'\"><label class=\"col-md-2 control-label\">* 图片<br><small>(推荐尺寸80*80px)</small></label><div class=\"col-sm-2 input-group\"><div ng-show=\"!vm.wxCusServiceMsg.thumbUrl\"><div ng-show=\"vm.thumbImg.queue.length == 0\"><div ng-show=\"vm.thumbImg.isHTML5\"><div class=\"well my-drop-zone\" style=\"margin-bottom: 0\" nv-file-drop=\"\" uploader=\"vm.thumbImg\" ng-click=\"vm.showImgDialog1();\">拖动图片到此，<br>或点击选择图片</div></div><div ng-show=\"!vm.thumbImg.isHTML5\"><input type=\"file\" id=\"thumb-img\" nv-file-select=\"\" uploader=\"vm.thumbImg\"></div></div><div class=\"well\" style=\"margin-bottom: 0\" ng-show=\"vm.thumbImg.queue.length > 0\"><div class=\"row\"><div class=\"col-md-8\">{{vm.thumbImg.queue[0].file.name}} <span ng-show=\"vm.thumbImg.queue[0].file.size < 1024\">({{vm.thumbImg.queue[0].file.size}}Bytes)</span> <span ng-show=\"vm.thumbImg.queue[0].file.size >= 1024 && vm.thumbImg.queue[0].file.size < 1048576\">({{(vm.thumbImg.queue[0].file.size/1024).toFixed(2)}}KB)</span> <span ng-show=\"vm.thumbImg.queue[0].file.size >= 1048576 && vm.thumbImg.queue[0].file.size < 1073741824\">({{(vm.thumbImg.queue[0].file.size/1048576).toFixed(2)}}MB)</span> <span ng-show=\"vm.thumbImg.queue[0].file.size >= 1073741824\">({{(vm.thumbImg.queue[0].file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.uploadImg1();\">上传</button> <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.thumbImg.clearQueue();\">取消</button></div><span class=\"progress\" ng-show=\"vm.uploadProgress >= 0\"><div style=\"width:{{vm.uploadProgress}}%\" ng-bind=\"vm.uploadProgress + \'%\'\"></div></span></div></div></div><div ng-show=\"vm.wxCusServiceMsg.thumbUrl\"><div class=\"well\" style=\"margin-bottom: 0\"><div class=\"row\"><div class=\"col-md-8\"><img class=\"img-responsive\" width=\"400\" height=\"213\" ng-src=\"{{vm.wxCusServiceMsg.thumbUrl}}\" alt=\"{{vm.wxCusServiceMsg.thumbUrl}}\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearImg1();\">删除</button></div></div></div></div></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'miniprogrampage\'\"><label class=\"col-sm-2 control-label lineHeight34\">* 标题</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"请输入文本内容\" ng-model=\"vm.wxCusServiceMsg.title\" name=\"title\" required=\"\"></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'miniprogrampage\'\"><label class=\"col-sm-2 control-label lineHeight34\">* 页面路径</label><div class=\"col-sm-6 input-group\"><input type=\"text\" class=\"form-control\" id=\"pagepath\" placeholder=\"请输入小程序页面路径\" ng-init=\"vm.wxCusServiceMsg.pagepath ? vm.wxCusServiceMsg.pagepath : vm.wxCusServiceMsg.pagepath = \'pages/index/index\'\" ng-model=\"vm.wxCusServiceMsg.pagepath\" name=\"pagepath\" required=\"\"></div></div><div class=\"form-group\" ng-if=\"vm.wxCusServiceMsg.msgType == \'miniprogrampage\'\"><label class=\"col-md-2 control-label\">* 小程序卡片封面<br><small>(推荐尺寸520*416px)</small></label><div class=\"col-sm-2 input-group\"><div ng-show=\"!vm.wxCusServiceMsg.fileUrl\"><div ng-show=\"vm.miniprogrampageImg.queue.length == 0\"><div ng-show=\"vm.miniprogrampageImg.isHTML5\"><div class=\"well my-drop-zone\" style=\"margin-bottom: 0\" nv-file-drop=\"\" uploader=\"vm.miniprogrampageImg\" ng-click=\"vm.showImgDialog2();\">拖动图片到此，<br>或点击选择图片</div></div><div ng-show=\"!vm.miniprogrampageImg.isHTML5\"><input type=\"file\" id=\"miniprogrampage-img\" nv-file-select=\"\" uploader=\"vm.miniprogrampageImg\"></div></div><div class=\"well\" style=\"margin-bottom: 0\" ng-show=\"vm.miniprogrampageImg.queue.length > 0\"><div class=\"row\"><div class=\"col-md-8\">{{vm.miniprogrampageImg.queue[0].file.name}} <span ng-show=\"vm.miniprogrampageImg.queue[0].file.size < 1024\">({{vm.miniprogrampageImg.queue[0].file.size}}Bytes)</span> <span ng-show=\"vm.miniprogrampageImg.queue[0].file.size >= 1024 && vm.miniprogrampageImg.queue[0].file.size < 1048576\">({{(vm.miniprogrampageImg.queue[0].file.size/1024).toFixed(2)}}KB)</span> <span ng-show=\"vm.miniprogrampageImg.queue[0].file.size >= 1048576 && vm.miniprogrampageImg.queue[0].file.size < 1073741824\">({{(vm.miniprogrampageImg.queue[0].file.size/1048576).toFixed(2)}}MB)</span> <span ng-show=\"vm.miniprogrampageImg.queue[0].file.size >= 1073741824\">({{(vm.miniprogrampageImg.queue[0].file.size/1073741824).toFixed(2)}}GB)</span></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.uploadImg2();\">上传</button> <button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.miniprogrampageImg.clearQueue();\">取消</button></div><span class=\"progress\" ng-show=\"vm.uploadProgress >= 0\"><div style=\"width:{{vm.uploadProgress}}%\" ng-bind=\"vm.uploadProgress + \'%\'\"></div></span></div></div></div><div ng-show=\"vm.wxCusServiceMsg.fileUrl\"><div class=\"well\" style=\"margin-bottom: 0\"><div class=\"row\"><div class=\"col-md-8\"><img class=\"img-responsive\" width=\"400\" height=\"213\" ng-src=\"{{vm.wxCusServiceMsg.fileUrl}}\" alt=\"{{vm.wxCusServiceMsg.fileUrl}}\"></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.clearImg2();\">删除</button></div></div></div></div></div></div><div class=\"form-group\"><div class=\"col-md-2 control-label\"></div><button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"\">确认</span></button></div></div></div><button type=\"button\" onclick=\"history.go(-1)\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span>返回</span></button></form>");
$templateCache.put("app/admin/wxCusServiceMsg/wxCusServiceMsg/wxCusServiceMsg.html","<div><h2 data-translate=\"\">客服消息列表</h2><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"^.wxCusServiceMsg.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"\">新增客服消息</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"keyWord\"><span data-translate=\"\">回复关键字</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"msgType\"><span data-translate=\"\">类型</span><span class=\"glyphicon glyphicon-sort\"></span></th></tr></thead><tbody><tr ng-repeat=\"wxCusServiceMsg in vm.wxCusServiceMsg track by wxCusServiceMsg.id\"><td>{{wxCusServiceMsg.keyWord}}</td><td><span ng-if=\"wxCusServiceMsg.msgType == \'text\'\">文本</span> <span ng-if=\"wxCusServiceMsg.msgType == \'image\'\">图片</span> <span ng-if=\"wxCusServiceMsg.msgType == \'link\'\">图文链接</span> <span ng-if=\"wxCusServiceMsg.msgType == \'miniprogrampage\'\">小程序卡片</span></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"^.wxCusServiceMsg.detail({id:wxCusServiceMsg.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.view\">查看</span></button> <button type=\"submit\" ui-sref=\"^.wxCusServiceMsg.edit({id:wxCusServiceMsg.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\">修改</span></button> <button type=\"submit\" ui-sref=\"^.wxCusServiceMsg.delete({id:wxCusServiceMsg.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\">删除</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");}]);